import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Send, Menu, Plus, Mic, Radio, X, History, FolderIcon, Pin, Trash2, Star, TrendingUp, Search, Calendar, MessageSquare } from 'lucide-react';

import { 
  sendChatMessage, 
  sendToolResult, 
  parseAzureResponse,
  convertMessagesToAzureFormat,
    detectMemoryQuery,
  extractSearchQueryFromTopic, 
  topicNeedsSearch,
  cleanTopicForReadyMessage,
  getStoredUserName,
  saveUserName,
  needsUserName,
  parseDuration,
  validateDuration,
  isVaguePodcastRequest,
  generatePodcastDialogueWithDuration,
  isYouTubeURL,
  containsURL,
  getUserNameWithFallback,
  createSystemMessageWithVibe
} from './Azurechatbot';
import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
import VoiceRealtimeManager from './VoiceRealtimeManager'; // Your new file

import { signOut } from 'firebase/auth';
import { auth } from '../../../firebase/firebase';
import {arrayUnion } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import FitnessTool from './FitnessTool';
// YOUR EXISTING COMPONENT IMPORTS
import WeatherCard from './WeatherCard';
import PodcastNewsCard from './PodcastNewsCard.jsx';
import NewsCard from './NewsCard.jsx';
import HorizontalAndFeaturedCards from './HorizontalAndFeaturedCards';
import WeatherPodcastPlayer from './WeatherPodcastPlayer';
import BigCalendarPlanner from './BigCalendarPlanner.jsx';
import JournalPage from './JournalPage.jsx';
import InnerLoopPodcast from './InnerLoopPodcast.jsx';
import QuizFlashcardHub from './QuizFlashcardHub .jsx';
import VoiceModeModal from './VoiceModeModal';
import VoiceOrbModal from './VoiceOrbModal'; // ✅ NEW: Import Orb Modal
import VoiceTextIntegrationManager from './VoiceTextSeamlessIntegration';
import IntelligentMemoryExtractor from './IntelligentMemoryExtractor';
import LandingPage from './LandingPage.jsx';
import ChatReminderService from './ChatReminderService';
import { fixedIntelligentMemoryRecall } from './FixedMemoryRecallSystem';

import OnboardingModal from './OnboardingModal';

import './ChatMode.css';
// YOUR EXISTING SERVICE IMPORTS
import { performWebSearch, formatSearchDate, detectURL } from './webSearchHandler.js';
import { enrichSearchResultsWithImages } from './webExtract.js';
import { handleWeatherRequest, generateWeatherPodcastContent } from './weatherHandler';
import { 
  handleScheduleEvent, 
  handleGetSchedule, 
  loadCalendarFromStorage,
  updateEventCompletion,
  deleteEvent,
  handleUpdateEvent, 
  handleDeleteEvent,
  saveCalendarToStorage
} from './schedulerHandlers';

import JournalStorageService from '../testing/services/JournalStorageService';
import FirestorePersistentStorageService from '../testing/services/FirestorePersistentStorageService';
import { ConversationMemoryService } from './ConversationMemorySystem';
import SettingsModal from './SettingsModal';
import SmartMemoryService from './SmartMemoryService';
import TimeAwareFollowupEngine from './TimeAwareFollowupEngine';
import VibeDetectionEngine from './VibeDetectionEngine';
import GoalLifecycleService from './GoalLifecycleService';
import AnimatedScheduleDisplay from './AnimatedScheduleDisplay ';
import SmartNotificationService from './SmartNotificationService';

import './ChatMode.css';
import ProfessionalChatHistory from './ProfessionalChatHistory';
 import { generateSmartMemoryResponse }from './generateSmartMemoryResponse.js';
import VoiceCallSounds from './voiceCallSounds';
import { SecureAPI } from '../config.js';
import { 
  AZURE_OPENAI_ENDPOINT, 
  AZURE_OPENAI_API_KEY, 
  AZURE_OPENAI_DEPLOYMENT ,
 AZURE_SPEECH_KEY as AZURE_SPEECH_API_KEY 
} from '../azureConfigHelper';
import SurveyPopup from './SurveyPopup.jsx';

const ChatMode = () => {
  const [chatReminderActive, setChatReminderActive] = useState(false);
  const [callSounds] = useState(() => new VoiceCallSounds());
  const navigate = useNavigate();
  const [dismissedFollowUps, setDismissedFollowUps] = useState(new Set());
  const [isSending, setIsSending] = useState(false);
  const [allSessions, setAllSessions] = useState([]);
  const [voiceTypingMessageId, setVoiceTypingMessageId] = useState(null);
const voiceTypingIntervalRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [isMultiline, setIsMultiline] = useState(false);
const inlineInputRef = useRef(null);
const expandedInputRef = useRef(null);
const [isPodcastMode, setIsPodcastMode] = useState(false);
const [isGeneratingPodcast, setIsGeneratingPodcast] = useState(false);
const [activePodcast, setActivePodcast] = useState(null);
const [hasCheckedSurveyOnLoad, setHasCheckedSurveyOnLoad] = useState(false);
const [isHumeConnected, setIsHumeConnected] = useState(false);
const [humeStatus, setHumeStatus] = useState('disconnected');
const humeWsRef = useRef(null);
  const [showUserMenu, setShowUserMenu] = useState(false);
const [tasksByDate, setTasksByDate] = useState(() => loadCalendarFromStorage());
const [voiceStatus, setVoiceStatus] = useState(''); // NEW: For loading messages
const [isInitializingVoice, setIsInitializingVoice] = useState(false); // NEW
const [smartMemoryService, setSmartMemoryService] = useState(null);
const [shouldGenerateGreeting, setShouldGenerateGreeting] = useState(true);
const [timeAwareEngine, setTimeAwareEngine] = useState(null);
const [lastChatTimestamp, setLastChatTimestamp] = useState(null);
const [vibeEngine, setVibeEngine] = useState(null);
const [detectedVibe, setDetectedVibe] = useState(null);
const [goalService, setGoalService] = useState(null);
const [goalsDueToday, setGoalsDueToday] = useState([]);
const [copyPopup, setCopyPopup] = useState({ show: false, text: '', x: 0, y: 0, messageId: null });
const [copiedMessageId, setCopiedMessageId] = useState(null);
const [lastInteractionTime, setLastInteractionTime] = useState(null);
const [lastFollowUpTime, setLastFollowUpTime] = useState(0);
const [pendingFollowUp, setPendingFollowUp] = useState(null);
const [isLoadingGreeting, setIsLoadingGreeting] = useState(true);
const [expandedNoteSummaries, setExpandedNoteSummaries] = useState({});
const [viewingNoteTranscript, setViewingNoteTranscript] = useState(null);
const [currentSessionId, setCurrentSessionId] = useState(null);
const [lastUserMessage, setLastUserMessage] = useState('');
const [activeFlashcardSet, setActiveFlashcardSet] = useState(null);
const [activeQuizSet, setActiveQuizSet] = useState(null);
const [workspaceMode, setWorkspaceMode] = useState('');
const [notificationsBlocked, setNotificationsBlocked] = useState(false);
const [showInviteModal, setShowInviteModal] = useState(false);
const [collaborators, setCollaborators] = useState([]);
const [noteContent, setNoteContent] = useState('');
  const [musicPlaying, setMusicPlaying] = useState(false);
  const lastUserMessageRef = useRef('');
  const [isProcessingAzure, setIsProcessingAzure] = useState(false);
   const [isJournaling, setIsJournaling] = useState(false);
  const [journalConversation, setJournalConversation] = useState([]);
  const [expandedEvent, setExpandedEvent] = useState(null);
    const journalStorage = new JournalStorageService();
const [lastSearchQuery, setLastSearchQuery] = useState(null);
const [lastSearchTimestamp, setLastSearchTimestamp] = useState(null);
const [isSearching, setIsSearching] = useState(false);
const [isPodcastPlayerOpen, setIsPodcastPlayerOpen] = useState(false);
const [typingMessageId, setTypingMessageId] = useState(null);
const typingIntervalRef = useRef(null);
const [isTakingNotes, setIsTakingNotes] = useState(false);
const [currentNoteContent, setCurrentNoteContent] = useState([]);
const [isRecording, setIsRecording] = useState(false);
const [mediaRecorder, setMediaRecorder] = useState(null);
const [noteCardId, setNoteCardId] = useState(null);
const [messageHistory, setMessageHistory] = useState([]); // Add this
const [isFirstInteraction, setIsFirstInteraction] = useState(() => needsUserName());
const [showWeatherPodcastPlayer, setShowWeatherPodcastPlayer] = useState(false);
const [currentWeatherPodcast, setCurrentWeatherPodcast] = useState(null);
  const [memoryService, setMemoryService] = useState(null);
  const [userMemories, setUserMemories] = useState([]);
const [podcastToAutoPlay, setPodcastToAutoPlay] = useState(null);
const [userName, setUserName] = useState(null);
const [firestoreService, setFirestoreService] = useState(null);
const [autoStartStudyContent, setAutoStartStudyContent] = useState(null);
const [editingNickname, setEditingNickname] = useState(false);
const [nicknameInput, setNicknameInput] = useState('');
const [memoryLimit, setMemoryLimit] = useState(30); // days
const [isSavingNickname, setIsSavingNickname] = useState(false);
  const [showMemories, setShowMemories] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
const [showToolkitEditor, setShowToolkitEditor] = useState(false);
const [showVoiceModal, setShowVoiceModal] = useState(false);
const [showScrollButton, setShowScrollButton] = useState(false);
const [userScrolledUp, setUserScrolledUp] = useState(false);
const [showOnboarding, setShowOnboarding] = useState(false);
const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(false);
const [notificationService, setNotificationService] = useState(null);
const [hasGreetingPlayed, setHasGreetingPlayed] = useState(false);
const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
const [showSurvey, setShowSurvey] = useState(false);
const [surveyChecked, setSurveyChecked] = useState(false);

  const [currentVoice, setCurrentVoice] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isEviSpeaking, setIsEviSpeaking] = useState(false);
const [isDragging, setIsDragging] = useState(false);
const [draggedTool, setDraggedTool] = useState(null);
const [lastScheduleDisplayed, setLastScheduleDisplayed] = useState(null);
const [lastEventMentioned, setLastEventMentioned] = useState(null);
  const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);
  const [previouslyShownSuggestions, setPreviouslyShownSuggestions] = useState(new Set());
  const [suggestionFadeClass, setSuggestionFadeClass] = useState('fade-in');
  const [savedVoiceHost, setSavedVoiceHost] = useState(null);

  // Enhanced function to handle planner input with animations and feedback
  const [processingMessage, setProcessingMessage] = useState('');
  const [inlineMessages, setInlineMessages] = useState([]);
const [textareaHeight, setTextareaHeight] = useState('auto');

  const [inputValue, setInputValue] = useState('');
  const [currentMode, setCurrentMode] = useState('chat');
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [studyModesExpanded, setStudyModesExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth < 480);
  const [user, setUser] = useState(null);
  const [currentWeekOffset, setCurrentWeekOffset] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPlusOptions, setShowPlusOptions] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const messagesEndRef = useRef(null);
const isStudyMode = currentMode === 'flashcards' || currentMode === 'quizzes';
const [voiceManager, setVoiceManager] = useState(null);
const [isVoiceMode, setIsVoiceMode] = useState(false);
const [selectedVoiceHost, setSelectedVoiceHost] = useState(null);
const [voiceTranscript, setVoiceTranscript] = useState('');

const [voiceModeActive, setVoiceModeActive] = useState(false);
const [voiceSpeed, setVoiceSpeed] = useState(1.0); // 0.8x, 1.0x, 1.2x, 1.5x
const [micMuted, setMicMuted] = useState(false);
const [showOrbModal, setShowOrbModal] = useState(false); // ✅ NEW: Orb modal state
const [waveformData, setWaveformData] = useState({
  points: '',
  isActive: false,
  height: 0,
  leftAmplitude: 0,
  centerAmplitude: 0,
  rightAmplitude: 0
});
const [voiceTextManager, setVoiceTextManager] = useState(null);
const [memoryExtractor, setMemoryExtractor] = useState(null);
const [goalsMediumTerm, setGoalsMediumTerm] = useState([]); // 1-3 months
const [goalsLongTerm, setGoalsLongTerm] = useState([]); // 3+ months
const [goalsShortTerm, setGoalsShortTerm] = useState([]); // 1-7 days
const [memoriesShortTerm, setMemoriesShortTerm] = useState([]); // Temp (7 days)
const [memoriesLongTerm, setMemoriesLongTerm] = useState([]); // Permanent
const [isSavingToolkit, setIsSavingToolkit] = useState(false);
const [toolkitFadingOut, setToolkitFadingOut] = useState(false);
const [chatSessions, setChatSessions] = useState([]);
const [activeSessionId, setActiveSessionId] = useState(null);
const [hasExistingSession, setHasExistingSession] = useState(false);
const [isLoadingSession, setIsLoadingSession] = useState(false);

useEffect(() => {
  const loadSavedVoice = async () => {
    if (firestoreService?.isReady()) {
      try {
        const userData = await firestoreService.getUserData();
        const savedVoice = userData?.settings?.selectedVoice || null;
        setSavedVoiceHost(savedVoice);
        console.log('✅ Loaded saved voice:', savedVoice);
      } catch (error) {
        console.error('❌ Failed to load voice:', error);
      }
    }
  };

  if (firestoreService?.isReady()) {
    loadSavedVoice();
  }
}, [firestoreService]);

// ADD THIS USEEFFECT in ChatMode.jsx (near other useEffects)
useEffect(() => {
  const syncCalendarFromFirestore = async () => {
    if (firestoreService?.isReady?.()) {
      console.log('🔄 Syncing calendar from Firestore on mount...');
      
      const freshCalendar = await loadCalendarFromStorage(firestoreService);
      
      if (Object.keys(freshCalendar).length > 0) {
        setTasksByDate(freshCalendar);
        console.log('✅ Calendar synced:', Object.keys(freshCalendar).length, 'dates');
      }
    }
  };
  
  syncCalendarFromFirestore();
}, [firestoreService]);
useEffect(() => {
  if (firestoreService && memoryService && !goalService) {
    const service = new GoalLifecycleService(firestoreService, memoryService);
    setGoalService(service);
    console.log('✅ Goal service initialized');
  }
}, [firestoreService, memoryService]);


// Initialize on mount:
useEffect(() => {
  const initChatReminders = async () => {
    if (!userName) return;
    
    const initialized = await ChatReminderService.initialize();
    
    if (initialized) {
      console.log('✅ Chat reminder service ready');
    }
  };
  
  initChatReminders();
}, [userName]);
useEffect(() => {
  const checkGoalsToday = async () => {
    if (!goalService || !user?.uid) return;
    
    const due = await goalService.getGoalsDueForCheckIn(user.uid);
    if (due.length > 0) {
      setGoalsDueToday(due);
      console.log('📋 Goals due today:', due.length);
    }
  };

  checkGoalsToday();
}, [goalService, user]);
// ✅ FIXED: Check chatSessionCount instead of loginCount
useEffect(() => {
  const checkSurveyStatus = async () => {
    if (surveyChecked || !firestoreService?.isReady?.()) return;
    
    try {
      const settings = await firestoreService.getUserSettings();
      const chatSessionCount = settings?.chatSessionCount || 0;
      const surveyCompleted = settings?.surveyCompleted || false;
      
      console.log('📊 Survey check on load:', { 
        chatSessionCount, 
        surveyCompleted,
        shouldShow: chatSessionCount >= 2 && !surveyCompleted
      });
      
      // ✅ FIXED: Show survey only after user has completed 2+ chat sessions
      // AND hasn't completed the survey yet
      if (chatSessionCount >= 2 && !surveyCompleted) {
        console.log('✅ User has 2+ chat sessions - showing survey after delay');
        // Small delay to avoid showing immediately on page load
        setTimeout(() => {
          setShowSurvey(true);
        }, 3000); // 3 seconds after page load
      } else {
        console.log('⏭️ Survey not needed:', {
          reason: chatSessionCount < 2 
            ? `Only ${chatSessionCount} sessions (need 2)` 
            : 'Already completed'
        });
      }
      
      setSurveyChecked(true);
    } catch (error) {
      console.error('Error checking survey status:', error);
      setSurveyChecked(true);
    }
  };
  
  checkSurveyStatus();
}, [firestoreService, surveyChecked]);
// Add this useEffect to increment login count
useEffect(() => {
  const incrementLoginCount = async () => {
    if (!firestoreService?.isReady?.()) return;
    
    try {
      const settings = await firestoreService.getUserSettings();
      const currentCount = settings?.loginCount || 0;
      
      await firestoreService.updateUserData({
        'settings.loginCount': currentCount + 1,
        'settings.lastLoginAt': new Date().toISOString()
      });
      
      console.log('✅ Login count:', currentCount + 1);
    } catch (error) {
      console.error('Error incrementing login count:', error);
    }
  };
  
  incrementLoginCount();
}, [firestoreService]);
// ✅ ADD THIS EFFECT - Keep mute state synced between Orb and Chat
useEffect(() => {
  if (voiceManager && isVoiceMode && showOrbModal) {
    // Check every 500ms if voice manager's mute state differs
    const syncInterval = setInterval(() => {
      if (voiceManager.isMuted !== micMuted) {
        console.log('🔄 Auto-syncing mute state:', voiceManager.isMuted);
        setMicMuted(voiceManager.isMuted);
      }
    }, 500);

    return () => clearInterval(syncInterval);
  }
}, [voiceManager, isVoiceMode, showOrbModal, micMuted]);
useEffect(() => {
  const checkOnboardingStatus = async () => {
    try {
      // Wait for Firestore to be ready
      if (!firestoreService?.isReady()) return;
      
      // ✅ Check Firestore (source of truth)
      const settings = await firestoreService.getUserSettings();
      
      console.log('🔍 Onboarding check:', {
        hasCompletedOnboarding: settings?.hasCompletedOnboarding,
        selectedTools: settings?.selectedTools,
        referralSource: settings?.referralSource
      });

      // ✅ STRICT VALIDATION: All fields must be present
      const isComplete = settings?.hasCompletedOnboarding && 
                        settings?.selectedTools?.length > 0 &&
                        settings?.referralSource;

      if (!isComplete) {
        console.log('⚠️ Onboarding incomplete - showing modal');
        setShowOnboarding(true);
        setHasCompletedOnboarding(false);
        
        // ✅ Reset localStorage too
        localStorage.removeItem('preptune_onboarding_data');
      } else {
        console.log('✅ Onboarding complete');
        setHasCompletedOnboarding(true);
        setShowOnboarding(false);
        
        // ✅ Sync to localStorage
        localStorage.setItem('preptune_onboarding_data', JSON.stringify({
          selectedTools: settings.selectedTools,
          referralSource: settings.referralSource,
          completedAt: settings.onboardingCompletedAt,
          hasCompletedOnboarding: true
        }));
      }
    } catch (error) {
      console.error('Error checking onboarding:', error);
      // On error, show onboarding to be safe
      setShowOnboarding(true);
      setHasCompletedOnboarding(false);
    }
  };
  
  checkOnboardingStatus();
}, [firestoreService]);
const handleOnboardingComplete = async (selectedTools, referralSource, userName) => {
  try {
    console.log('✅ Onboarding completed:', { selectedTools, referralSource, userName });

    if (!selectedTools || selectedTools.length === 0 || !referralSource || !userName) {
      console.warn('⚠️ Invalid onboarding data');
      return;
    }

    if (firestoreService?.isReady?.()) {
      try {
        const trimmedName = userName.trim();
        
        // ✅ CREATE TOOLKIT SETTINGS FROM SELECTED TOOLS
        const toolkitSettings = defaultTools.map(tool => ({
          id: tool.id,
          name: tool.name,
          visible: selectedTools.includes(tool.id),
          description: tool.description,
        }));
        
        await firestoreService.updateUserData({
          // User profile data
          'settings.userName': trimmedName,
          
          // Onboarding data
          'settings.hasCompletedOnboarding': true,
          'settings.selectedTools': selectedTools, // Keep for legacy
          'settings.referralSource': referralSource,
          'settings.onboardingCompletedAt': new Date().toISOString(),
          
          // ✅ SAVE AS TOOLKIT SETTINGS IMMEDIATELY
          'settings.toolkitSettings': toolkitSettings,
          'settings.toolkitUpdatedAt': new Date().toISOString()
        });

        console.log('✅ All settings saved including toolkitSettings:', toolkitSettings);
        
        // Update local state
        setUserName(trimmedName);
        setIsFirstInteraction(false);
        
        const updatedTools = availableTools.map(tool => ({
          ...tool,
          visible: selectedTools.includes(tool.id)
        }));
        setAvailableTools(updatedTools);
        
      } catch (error) {
        console.error('❌ Failed to save to Firestore:', error);
        return;
      }
    }

    setHasCompletedOnboarding(true);
    setShowOnboarding(false);

  } catch (error) {
    console.error('❌ Onboarding error:', error);
    setShowOnboarding(false);
  }
};

// ✅ Load toolkit settings on mount (uses the prioritized logic)
useEffect(() => {
  if (firestoreService?.isReady?.() && hasCompletedOnboarding) {
    loadToolkitSettings();
  }
}, [firestoreService, hasCompletedOnboarding]);
// ✅ RELOAD USERNAME after onboarding closes
useEffect(() => {
  if (!showOnboarding && hasCompletedOnboarding) {
    console.log('🔄 Reloading username after onboarding...');
    loadUserName(); // ✅ Call loadUserName to sync with Firestore
  }
}, [showOnboarding, hasCompletedOnboarding]);

useEffect(() => {
  if (!vibeEngine && smartMemoryService) {
    const azureConfig = {
      endpoint: AZURE_OPENAI_ENDPOINT,
      deployment: AZURE_OPENAI_DEPLOYMENT,
      apiKey: AZURE_OPENAI_API_KEY
    };
    
    const engine = new VibeDetectionEngine(azureConfig);
    setVibeEngine(engine);
    console.log('✅ Vibe Detection Engine initialized');
  }
}, [vibeEngine, smartMemoryService]);

useEffect(() => {
  // Handle when user taps "View" on notification
  const handleNotificationView = (event) => {
    const { memoryId, type } = event.detail;

    console.log('📱 User opened app from notification:', { memoryId, type });

    // Navigate to relevant memory or open chat
    if (memoryId) {
      // Example: Load that memory's context
      if (memoryService) {
        memoryService.getAllMemories().then(memories => {
          const memory = memories.find(m => m.id === memoryId);
          if (memory) {
            console.log('📚 Found memory:', memory.memory);
            // You could auto-populate input or show context
            // setInputValue(`About ${memory.memory}`);
          }
        });
      }
    }

    // Make sure chat mode is active
    setCurrentMode('chat');
  };

  window.addEventListener('notification-view', handleNotificationView);

  return () => {
    window.removeEventListener('notification-view', handleNotificationView);
  };
}, [memoryService]);

// 5. CLEANUP ON UNMOUNT (Add to your existing cleanup useEffect)
useEffect(() => {
  return () => {
    if (notificationService) {
      notificationService.cleanup();
    }
  };
}, [notificationService]);
// Initialize smart memory service in your existing useEffect
useEffect(() => {
  if (smartMemoryService && firestoreService?.isReady && !timeAwareEngine) {
    const azureConfig = {
      endpoint: AZURE_OPENAI_ENDPOINT,
      deployment: AZURE_OPENAI_DEPLOYMENT,
      apiKey: AZURE_OPENAI_API_KEY
    };
    
    const engine = new TimeAwareFollowupEngine(azureConfig);
    setTimeAwareEngine(engine);
    console.log('✅ Time-Aware Follow-up Engine initialized');
  }
}, [smartMemoryService, firestoreService, timeAwareEngine]);
// 4. TRACK LAST MESSAGE TIME (add to messages useEffect)
useEffect(() => {
  // Update last chat timestamp when messages change
  if (messages.length > 0) {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage.type === 'user') {
      setLastChatTimestamp(lastMessage.timestamp);
    }
  }
}, [messages]);
useEffect(() => {
  const extractAndLoadMemories = async () => {
    if (!memoryExtractor || messages.length < 5) return;
    
    const lastMessage = messages[messages.length - 1];
    if (lastMessage.type === 'bot' && !lastMessage.isLoading) {
      console.log('🧠 Extracting new memories from conversation...');
      
      // ✅ Extract memories from chat
      await memoryExtractor.queueExtractionJob(messages, userName, {
        endpoint: AZURE_OPENAI_ENDPOINT,
        deployment: AZURE_OPENAI_DEPLOYMENT,
        apiKey: AZURE_OPENAI_API_KEY
      });

      // ✅ IMMEDIATELY reload memory context for next message
      if (memoryService?.isReady?.()) {
        try {
          console.log('🔄 Reloading memory context after extraction...');
          const updatedMemoryContext = await memoryService.getMemorySummaryForAI('');
          if (updatedMemoryContext) {
            console.log('✅ Memory context updated for next message');
          }
        } catch (e) {
          console.warn('⚠️ Memory reload skipped:', e.message);
        }
      }
    }
  };
  
  extractAndLoadMemories();
}, [messages, memoryExtractor, userName, memoryService]);
useEffect(() => {
  if (!timeAwareEngine && firestoreService?.isReady?.()) {
    const azureConfig = {
      endpoint: AZURE_OPENAI_ENDPOINT,
      deployment: AZURE_OPENAI_DEPLOYMENT,
      apiKey: AZURE_OPENAI_API_KEY
    };
    
    const engine = new TimeAwareFollowupEngine(azureConfig);
    setTimeAwareEngine(engine);
    console.log('✅ Time-Aware Followup Engine initialized');
  }
}, [firestoreService, timeAwareEngine]);

// ============================================
// 3. TRACK INTERACTION TIME
// ============================================

useEffect(() => {
  // Track every message (user or bot)
  if (messages.length > 0) {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage.timestamp) {
      setLastInteractionTime(lastMessage.timestamp);
    }
  }
}, [messages]);

// ============================================
// 4. GENERATE SMART FOLLOW-UPS (After AI responds)
// ============================================

/**
 * Generate and display time-aware follow-up
 */
const generateSmartEventFollowUp = async (userMessage) => {
  if (!timeAwareEngine || !memoryService || !userName) {
    console.log('⏭️ Skip follow-up: missing dependencies');
    return null;
  }

  try {
    console.log('⏰ Generating smart event follow-up...');
    
    // Get relevant memories WITH timestamps
    let relevantMemories = [];
    try {
      relevantMemories = await memoryService.getRecentMemories(20, 30);
    } catch (e) {
      console.warn('Could not load memories for follow-up:', e.message);
      relevantMemories = [];
    }

    if (!relevantMemories || relevantMemories.length === 0) {
      console.log('📭 No recent memories to follow up on');
      return null;
    }

    // ✅ NEW: Use smart event-based follow-up
    const followUp = await timeAwareEngine.generateSmartFollowUp(
      userName,
      userMessage,
      relevantMemories,
      lastInteractionTime,
      lastInteractionTime
    );

    if (followUp) {
      console.log('✅ Smart event follow-up generated:', followUp);
      return followUp;
    } else {
      console.log('📭 No event-based follow-up needed right now');
      return null;
    }

  } catch (error) {
    console.error('❌ Smart follow-up error:', error);
    return null;
  }
};


// ============================================
// 5. DISPLAY FOLLOW-UP NATURALLY
// ============================================
const handleManualCheck = async () => {
  if (notificationService) {
    await notificationService.checkForFollowUpOpportunities();
  }
};

// ============================================
// 8. CLEANUP ON UNMOUNT
// ============================================

useEffect(() => {
  return () => {
    // Clean up any pending follow-ups
    setPendingFollowUp(null);
  };
}, []);

const [voiceWaveformColor, setVoiceWaveformColor] = useState('#4a90e2');
const connectToHume = () => {
  return new Promise((resolve, reject) => {
    if (humeWsRef.current?.readyState === WebSocket.OPEN) {
      resolve(true);
      return;
    }

    try {
      const wsUrl = `wss://api.hume.ai/v0/evi/chat?api_key=${HUME_API_KEY}`;
      
      humeWsRef.current = new WebSocket(wsUrl);
      humeWsRef.current.binaryType = 'arraybuffer';

      humeWsRef.current.onopen = () => {
        console.log('✅ Connected to Hume');
        setIsHumeConnected(true);
        resolve(true);
      };

      humeWsRef.current.onmessage = (event) => {
        // Let VoiceRealtimeManager handle messages
      };

      humeWsRef.current.onerror = (error) => {
        console.error('❌ Hume error:', error);
        setIsHumeConnected(false);
        reject(new Error('Hume connection failed'));
      };

      humeWsRef.current.onclose = () => {
        console.log('🔌 Disconnected from Hume');
        setIsHumeConnected(false);
      };

    } catch (error) {
      reject(error);
    }
  });
};
const copyToClipboard = async (text, messageId = null) => {
  try {
    await navigator.clipboard.writeText(text);
    setCopiedMessageId(messageId);
    setTimeout(() => setCopiedMessageId(null), 2000); // Reset after 2 seconds
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};
const handleLongPress = (text, event, messageId) => {
  // Handle both mouse and touch events
  if (event.preventDefault) {
    event.preventDefault();
  }
  
  // Get the position from either mouse or touch event
  let clientX, clientY;
  if (event.touches && event.touches.length > 0) {
    // Touch event
    clientX = event.touches[0].clientX;
    clientY = event.touches[0].clientY;
  } else if (event.clientX !== undefined) {
    // Mouse event
    clientX = event.clientX;
    clientY = event.clientY;
  } else {
    // Fallback to target element bounds
    const rect = event.currentTarget?.getBoundingClientRect() || event.target?.getBoundingClientRect();
    if (rect) {
      clientX = rect.left + rect.width / 2;
      clientY = rect.top;
    } else {
      console.error('Could not determine position for copy popup');
      return;
    }
  }
  
  setCopyPopup({
    show: true,
    text: text,
    x: clientX,
    y: clientY - 10,
    messageId: messageId
  });
};
const FOLLOW_UP_COOLDOWN_MS = 60000; // 1 minute cooldown

const initializeVoiceMode = async (voiceHost) => {
  try {
    console.log(`🎙️ Starting voice mode with ${voiceHost}`);
    setIsInitializingVoice(true);
    setSelectedVoiceHost(voiceHost);
    setVoiceWaveformColor(voiceColors[voiceHost]);
    setVoiceStatus('Getting ready...');

    // ============================================
    // 1. ENSURE ALL SERVICES ARE READY
    // ============================================
    console.log('🔧 Checking services...');

    if (memoryService && !memoryService.isReady()) {
      console.log('⏳ Initializing memory service...');
      setVoiceStatus('Loading your memories...');
      await memoryService.initialize();
    }

    if (firestoreService && !firestoreService.isReady?.()) {
      console.log('⏳ Waiting for Firestore...');
      setVoiceStatus('Connecting to storage...');
      let attempts = 0;
      while (!firestoreService.isReady?.() && attempts < 30) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
    }

    console.log('✅ All services ready');

    // ============================================
    // 2. CREATE VOICE MANAGER
    // ============================================
    setVoiceStatus('Setting up voice connection...');

    const azureVoiceMap = {
      "Host 1": "en-US-AvaNeural",
      "Host 2": "en-US-AndrewNeural",
      "Host 3": "en-US-JaneNeural",
      "Host 4": "en-US-GuyNeural"
    };

    const selectedAzureVoice = azureVoiceMap[voiceHost] || "en-US-AvaMultilingualNeural";

    const manager = new VoiceRealtimeManager(
      null,
      null,
      selectedAzureVoice,
      handleVoiceTranscript,
      setWaveformData,
      setVoiceStatus,
      async (toolCallData) => {
        console.log('🔧 Voice tool call:', toolCallData.functionName);
        await handleVoiceToolCall(
          toolCallData,
          manager,
          memoryService,
          tasksByDate,
          setTasksByDate,
          setMessages,
          firestoreService,
          userName,
          null,
          null,
          null,
          journalStorage
        );
      },
      (response) => {
        console.log('📥 Voice response received');
      },
      memoryService,
      userName,
      tasksByDate,
      detectMemoryQuery,
      generateSmartMemoryResponse,
      analyzeFollowUpNaturally
    );

    // ============================================
    // 3. INITIALIZE VOICE MANAGER (don't start listening yet)
    // ============================================
    setVoiceStatus('Connecting to voice service...');
    await manager.initialize();
    setVoiceManager(manager);

    // ============================================
    // 4. UPDATE UI STATE (keep mic off)
    // ============================================
    setIsVoiceMode(true);
    setCurrentMode('chat');
    setShowVoiceModal(false);
    setIsInitializingVoice(false);
    setVoiceStatus('');

    console.log('🎙️ Voice mode initialized (mic still off)');

    // ✅ PLAY START SOUND
    console.log('🔊 Playing call start sound...');
    await callSounds.playStartSound();

    // ============================================
    // 5. GENERATE AND PLAY GREETING
    // ============================================

    const hasExistingConversation = messages.length > 2 &&
      messages.some(m => m.type === 'user' && m.content?.trim());

    if (hasExistingConversation) {
      // ============================================
      // SCENARIO A: TEXT → VOICE TRANSITION
      // ============================================
      console.log('🔄 Transitioning from text to voice...');
      setVoiceStatus('Continuing conversation...');

      try {
        const recentMessages = messages
          .filter(m => m.content?.trim())
          .slice(-5)
          .map(m => `${m.type === 'user' ? 'User' : 'Assistant'}: ${m.content}`)
          .join('\n');

        let greeting = `Hey! Let's continue where we left off.`;

        try {
          const data = await SecureAPI.callAzureOpenAI(
            [
              {
                role: 'system',
                content: `You were just having a TEXT conversation with ${userName || 'the user'}. They switched to VOICE mode but DON'T mention the switch.

**RECENT CONVERSATION:**
${recentMessages}

You are Preptune, a chill AI chat buddy. Continue the conversation naturally as if nothing changed. Do not mention voice, audio, or switching modes.

Keep the response to 2–3 sentences, stay on topic, and sound like a real person continuing the conversation smoothly.

Generate the natural continuation now.`
              },
              { role: 'user', content: 'Generate transition greeting' }
            ],
            {
              temperature: 0.8,
              max_tokens: 150
            }
          );

          const content = data?.choices?.[0]?.message?.content;
          if (typeof content === 'string' && content.trim()) {
            greeting = content.trim();
          }
        } catch (error) {
          console.error('🎙️ Transition greeting error:', error.message);
        }

        console.log('🎙️ Transition greeting:', greeting);

        const greetingMsgId = Date.now();
        setMessages(prev => [...prev, {
          id: greetingMsgId,
          type: 'bot',
          content: greeting,
          isVoiceMode: true,
          isTransition: true,
          isStreaming: true,
          timestamp: new Date().toISOString()
        }]);

        try {
          console.log('🎵 Playing transition greeting...');
          await manager.streamAudioChunks(greeting, manager.selectedVoice);
          console.log('✅ Transition greeting audio finished');
        } catch (ttsError) {
          console.error('⚠️ TTS error:', ttsError);
        }

        let waitAttempts = 0;
        while ((manager.isPlayingAudio || manager.audioQueue.length > 0) && waitAttempts < 50) {
          await new Promise(resolve => setTimeout(resolve, 100));
          waitAttempts++;
        }
        await new Promise(resolve => setTimeout(resolve, 500));

        setMessages(prev => prev.map(msg =>
          msg.id === greetingMsgId ? { ...msg, isStreaming: false } : msg
        ));
        await new Promise(resolve => setTimeout(resolve, 300));

      } catch (error) {
        console.error('❌ Transition error:', error);
        const fallback = `Hey! Good to hear your voice.`;

        const greetingMsgId = Date.now();
        setMessages(prev => [...prev, {
          id: greetingMsgId,
          type: 'bot',
          content: fallback,
          isVoiceMode: true,
          timestamp: new Date().toISOString()
        }]);

        try {
          await manager.streamAudioChunks(fallback, manager.selectedVoice);
          let waitAttempts = 0;
          while ((manager.isPlayingAudio || manager.audioQueue.length > 0) && waitAttempts < 50) {
            await new Promise(resolve => setTimeout(resolve, 100));
            waitAttempts++;
          }
        } catch (ttsError) {
          console.error('⚠️ TTS error:', ttsError);
        }
        await new Promise(resolve => setTimeout(resolve, 300));
      }

    } else {
      // ============================================
      // SCENARIO B: NEW VOICE SESSION
      // ============================================
      console.log('🎙️ NEW VOICE SESSION - Generating greeting...');
      setVoiceStatus('Preparing greeting...');

      let greeting = null;

      try {
        if (memoryService && !memoryService.isReady()) {
          try {
            await memoryService.initialize();
          } catch (initError) {
            console.warn('⚠️ Memory init failed:', initError.message);
          }
        }

        await manager.loadMemoriesForContext();

        const hour = new Date().getHours();
        const name = userName ? ` ${userName}` : '';
        const timeOfDay = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening';

        // ✅ Pull same memory context as chat mode
        let memorySummary = null;
        if (memoryService?.isReady?.()) {
          try {
            setVoiceStatus('Loading your memories...');
            const cachedMemories = await memoryService.getRecentMemories(20, 30);
            memorySummary = await memoryService.getMemorySummaryForAI('', cachedMemories);
            console.log(memorySummary ? '✅ Memory summary loaded for greeting' : '📭 No memories yet');
          } catch (e) {
            console.warn('⚠️ Memory load failed for greeting:', e.message);
          }
        }

        // ✅ Check for follow-up opportunity (same as chat mode)
        let followUpText = null;
        if (memoryService?.isReady?.() && analyzeFollowUpNaturally) {
          try {
            setVoiceStatus('Checking in on you...');
            const recentMemories = await memoryService.getRecentMemories(20, 30);
            if (recentMemories.length > 0) {
              const chatMessages = messages.map((msg, idx) => ({
                id: Date.now() + idx,
                type: msg.type,
                content: msg.content || '',
                timestamp: new Date().toISOString()
              }));

              const analysis = await analyzeFollowUpNaturally(
                userName, '', chatMessages, recentMemories, ''
              );
              if (analysis.shouldFollowUp && analysis.followUpText) {
                followUpText = analysis.followUpText;
                console.log('✅ Follow-up to weave in:', followUpText);
              }
            }
          } catch (e) {
            console.warn('⚠️ Follow-up check failed:', e.message);
          }
        }

        // ✅ FIXED: array first, options second — matches SecureAPI signature
        setVoiceStatus('Preparing greeting...');
        try {
          const data = await SecureAPI.callAzureOpenAI(
            [
              {
                role: 'system',
                content: `You are Preptune greeting ${userName || 'the user'} at the start of a voice call.

TIME: Good ${timeOfDay}${name}.

${memorySummary ? `WHAT YOU KNOW ABOUT THEM:\n${memorySummary}\n` : ''}${followUpText ? `NATURAL FOLLOW-UP TO WEAVE IN: "${followUpText}"\n` : ''}
Generate ONE natural greeting (2-3 sentences max, under 40 words total):

RULES:
- Start casually: "Good ${timeOfDay}", "Hey", "Morning" etc.
- If follow-up provided, weave it in naturally after the opening
- If you have relevant memories, reference ONE naturally if it fits — don't force it
- Sound like a real friend, not an AI assistant
- NO exclamation marks — use periods
- NO mentioning voice, audio, or call

GOOD EXAMPLES:
✅ "Good morning${name}, how's it going? By the way, how did that exam go?"
✅ "Hey${name}, how's your ${timeOfDay}? Did you end up finishing that project?"
✅ "Morning${name}. How are you today?"
✅ "Hey${name}, how's it going? Oh, how did that interview turn out?"

BAD EXAMPLES:
❌ "Hello. I'm Preptune, your AI voice assistant."
❌ "Good morning. I hope you're having a wonderful day."
❌ "Hey. I noticed from our previous conversations that..."

Generate the greeting now:`
              },
              { role: 'user', content: 'Generate greeting' }
            ],
            {
              temperature: 0.85,
              max_tokens: 80
            }
          );

          const raw = data?.choices?.[0]?.message?.content?.trim();
          if (raw && raw.length > 5) {
            greeting = raw.replace(/!/g, '.').trim();
            console.log('✅ Rich greeting generated:', greeting);
          }
        } catch (greetingError) {
          console.warn('⚠️ Rich greeting failed, using base greeting:', greetingError.message);
        }

      } catch (outerError) {
        console.error('❌ Greeting generation failed:', outerError.message);
      }

      // ✅ GUARANTEED FALLBACK
      if (!greeting) {
        const hour = new Date().getHours();
        const name = userName ? ` ${userName}` : '';
        if (hour < 12) {
          greeting = `Good morning${name}. How are you doing?`;
        } else if (hour < 17) {
          greeting = `Hey${name}, how's your afternoon?`;
        } else {
          greeting = `Hey${name}, how's it going?`;
        }
        console.log('🔄 Using fallback greeting:', greeting);
      }

      console.log('🎤 FINAL GREETING:', greeting);
      localStorage.setItem('preptune_last_voice_visit', new Date().toISOString());

      const greetingMsgId = Date.now();
      setMessages(prev => [...prev, {
        id: greetingMsgId,
        type: 'bot',
        content: greeting,
        isVoiceMode: true,
        isGreeting: true,
        isStreaming: true,
        timestamp: new Date().toISOString()
      }]);

      try {
        console.log('🎵 Playing greeting...');
        await manager.streamAudioChunks(greeting, manager.selectedVoice);
        console.log('✅ Greeting audio finished');
      } catch (ttsError) {
        console.error('⚠️ TTS error (continuing anyway):', ttsError);
      }

      console.log('⏳ Waiting for audio queue to drain...');
      let waitCount = 0;
      while ((manager.isPlayingAudio || manager.audioQueue.length > 0 || manager.isTTSProcessing) && waitCount < 100) {
        await new Promise(resolve => setTimeout(resolve, 100));
        waitCount++;
      }
      await new Promise(resolve => setTimeout(resolve, 500));
      console.log(`✅ Audio fully finished after ${waitCount * 100}ms`);

      setMessages(prev => prev.map(msg =>
        msg.id === greetingMsgId ? { ...msg, isStreaming: false } : msg
      ));
      await new Promise(resolve => setTimeout(resolve, 300));
    }

    // ============================================
    // 6. START LISTENING (after greeting is FULLY done)
    // ============================================
    console.log('🎤 Greeting complete - NOW starting microphone...');
    setVoiceStatus('Starting microphone...');

    try {
      await manager.startListening(0);
      console.log('✅ Microphone active');
      setHasGreetingPlayed(true);
      setVoiceStatus('');
      console.log('✅ Controls enabled');
    } catch (micError) {
      console.error('❌ Microphone start failed:', micError);
      setVoiceStatus('Microphone error');
      setHasGreetingPlayed(true);
    }

    // ============================================
    // 7. INITIALIZE VOICE-TEXT INTEGRATION
    // ============================================
    if (!voiceTextManager && memoryService) {
      console.log('🔧 Initializing Voice-Text manager...');

      const azureConfig = {
        endpoint: AZURE_OPENAI_ENDPOINT,
        deployment: AZURE_OPENAI_DEPLOYMENT,
        apiKey: AZURE_OPENAI_API_KEY
      };

      const vtManager = new VoiceTextIntegrationManager(
        manager,
        azureConfig,
        memoryService
      );

      setVoiceTextManager(vtManager);
      console.log('✅ Voice-Text manager ready');
    }

    console.log(`✅ Voice mode fully active with ${voiceHost}`);

  } catch (error) {
    console.error('❌ Voice initialization failed:', error);

    if (voiceManager) {
      try { voiceManager.disconnect(); } catch (e) { console.error('❌ Cleanup error:', e); }
    }

    setIsVoiceMode(false);
    setShowVoiceModal(false);
    setIsInitializingVoice(false);
    setVoiceStatus('');
    setHasGreetingPlayed(false);

    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Voice mode failed: ${error.message}. Please try again.`,
      isError: true,
      timestamp: new Date().toISOString()
    }]);
  }
};


const handleVoiceToolCall = async (
  toolCallData,
  voiceManager,
  memoryServiceRef = memoryService,
  tasksByDateRef = tasksByDate,
  setTasksByDateRef = setTasksByDate,
  setMessagesRef = setMessages,
  firestoreServiceRef = firestoreService,
  userNameRef = userName,
  azureEndpointRef = AZURE_OPENAI_ENDPOINT,
  azureDeploymentRef = AZURE_OPENAI_DEPLOYMENT,
  azureKeyRef = AZURE_OPENAI_API_KEY,
  journalStorageRef = journalStorage
) => {
  const { toolCallId, functionName, arguments: args, messageHistory } = toolCallData;

  try {
    console.log('🔧 Voice tool handler:', functionName);
    let toolResult = null;

    // ============================================
    // SAVE USER NAME
    // ============================================
    if (functionName === 'save_user_name') {
      console.log('💾 Saving name:', args.name);

      const capitalizedName = args.name.charAt(0).toUpperCase() + args.name.slice(1).toLowerCase();

      try {
        const success = await saveUserName(capitalizedName, firestoreServiceRef);
        
        if (success) {
          const { default: VoiceResponseGenerator } = 
            await import('./voiceResponseGenerator.js');
          
          const responseGen = new VoiceResponseGenerator(
            azureEndpointRef,
            azureDeploymentRef,
            azureKeyRef
          );

          const naturalResponse = await responseGen.generateToolResponse(
            'save_user_name',
            { name: capitalizedName },
            {}
          );

          toolResult = {
            success: true,
            name: capitalizedName,
            naturalResponse: naturalResponse
          };

          console.log('👤 Response:', naturalResponse);
        } else {
          throw new Error('Save failed');
        }
      } catch (error) {
        console.error('❌ Name save failed:', error);
        toolResult = {
          success: false,
          error: error.message
        };
      }
    }

    // ============================================
    // SCHEDULE EVENT (WITH RECURRING SUPPORT + DISPLAY)
    // ============================================
    else if (functionName === 'schedule_event') {
      console.log('📅 Voice scheduling:', args);

      try {
        const eventDate = parseRelativeDate(args.date || 'today');
        const dateKey = formatDateKey(eventDate);
        
        console.log('📅 Parsed date:', {
          input: args.date,
          output: eventDate.toISOString(),
          dateKey: dateKey
        });
        
        // ✅ Convert 24-hour time to 12-hour format
        let formattedTime = args.time || 'All day';
        
        if (formattedTime && formattedTime !== 'All day') {
          const timeMatch = formattedTime.match(/^(\d{1,2}):(\d{2})$/);
          if (timeMatch) {
            let hours = parseInt(timeMatch[1]);
            const minutes = timeMatch[2];
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            formattedTime = `${hours}:${minutes} ${ampm}`;
          }
        }
        
        // ✅ CHECK: Is this a recurring event?
        const fullDescription = `${args.title} ${args.description || ''}`.toLowerCase();
        const recurringPattern = parseRecurringPattern(fullDescription);
        
        let updatedCalendar;
        let instanceCount = 1;
        
        if (recurringPattern) {
          console.log('🔄 Voice: Detected recurring event:', recurringPattern);
          
          const recurrenceId = `recurring_${Date.now()}`;
          const baseEvent = {
            text: args.title,
            time: formattedTime,
            description: args.description || '',
            completed: false,
            isNew: true,
            isRecurring: true,
            recurrenceId: recurrenceId,
            recurrencePattern: recurringPattern,
            createdAt: new Date().toISOString(),
            addedVia: 'voice'
          };
          
          const instances = generateRecurringInstances(baseEvent, recurringPattern, eventDate, 8);
          instanceCount = instances.length;
          console.log(`✅ Generated ${instanceCount} recurring instances`);
          
          setTasksByDateRef(prev => {
            const updated = { ...prev };
            
            instances.forEach(({ dateKey: instDateKey, event }) => {
              updated[instDateKey] = [...(updated[instDateKey] || []), event];
            });
            
            updatedCalendar = updated;
            return updated;
          });
          
          if (firestoreServiceRef?.isReady?.()) {
            console.log('💾 Voice: Saving recurring events to Firestore...');
            await saveCalendarToStorage(updatedCalendar, firestoreServiceRef);
          }
          
        } else {
          // ✅ SINGLE EVENT
          const newEvent = {
            text: args.title,
            time: formattedTime,
            description: args.description || '',
            completed: false,
            isNew: true,
            createdAt: new Date().toISOString(),
            addedVia: 'voice'
          };
          
          setTasksByDateRef(prev => {
            const updated = {
              ...prev,
              [dateKey]: [...(prev[dateKey] || []), newEvent]
            };
            updatedCalendar = updated;
            return updated;
          });
          
          if (firestoreServiceRef?.isReady?.()) {
            await saveCalendarToStorage(updatedCalendar, firestoreServiceRef);
          }
        }
        
        // ✅ Generate natural response
        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'schedule_event',
          {
            title: args.title,
            date: eventDate.toLocaleDateString('en-US', { 
              weekday: 'short', 
              month: 'short', 
              day: 'numeric' 
            }),
            time: formattedTime,
            isRecurring: !!recurringPattern,
            instanceCount: instanceCount
          },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          title: args.title,
          isRecurring: !!recurringPattern,
          instanceCount: instanceCount,
          naturalResponse: naturalResponse,
          updatedCalendar: updatedCalendar,
          dateKey: dateKey,
          eventDate: eventDate
        };

        console.log('📅 Voice response:', naturalResponse);
        
      } catch (error) {
        console.error('❌ Voice schedule error:', error);
        toolResult = {
          success: false,
          error: error.message,
          naturalResponse: "Sorry, I couldn't schedule that event."
        };
      }
    }

    // ============================================
    // GET SCHEDULE (WITH DISPLAY)
    // ============================================
    else if (functionName === 'get_schedule') {
      console.log('📅 Voice: Getting schedule for:', args.date);

      try {
        const queryDate = parseRelativeDate(args.date || 'today');
        const dateKey = formatDateKey(queryDate);
        const events = tasksByDateRef[dateKey] || [];
        
        console.log(`📅 Found ${events.length} events for ${dateKey}`);
        
        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'get_schedule',
          {
            date: queryDate.toLocaleDateString('en-US', { 
              weekday: 'long', 
              month: 'long', 
              day: 'numeric' 
            }),
            events: events.map(e => ({
              title: e.text,
              time: e.time,
              completed: e.completed
            })),
            eventCount: events.length
          },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          eventCount: events.length,
          naturalResponse: naturalResponse,
          dateKey: dateKey,
          queryDate: queryDate
        };

        console.log('📅 Voice response:', naturalResponse);
        
      } catch (error) {
        console.error('❌ Voice get schedule error:', error);
        toolResult = {
          success: false,
          error: error.message,
          naturalResponse: "Sorry, I couldn't get your schedule."
        };
      }
    }

    // ============================================
    // UPDATE EVENT (WITH DISPLAY)
    // ============================================
    else if (functionName === 'update_event') {
      console.log('✏️ Voice: Updating event:', args.eventTitle);

      try {
        const found = findEventByTitle(tasksByDateRef, args.eventTitle);
        
        if (!found) {
          throw new Error(`Could not find event: "${args.eventTitle}"`);
        }
        
        const { dateKey: oldDateKey, eventIndex, event } = found;
        
        const newDateKey = args.newDate 
          ? formatDateKey(parseRelativeDate(args.newDate))
          : oldDateKey;
        
        let newTime = args.newTime || event.time;
        if (newTime && newTime !== 'All day') {
          const timeMatch = newTime.match(/^(\d{1,2}):(\d{2})$/);
          if (timeMatch) {
            let hours = parseInt(timeMatch[1]);
            const minutes = timeMatch[2];
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            newTime = `${hours}:${minutes} ${ampm}`;
          }
        }
        
        const updatedEvent = {
          ...event,
          text: args.newTitle || event.text,
          time: newTime,
          description: args.newDescription || event.description,
          isNew: true,
          updatedAt: new Date().toISOString()
        };
        
        let updatedCalendar;
        setTasksByDateRef(prev => {
          const updated = { ...prev };
          
          updated[oldDateKey] = prev[oldDateKey].filter((_, idx) => idx !== eventIndex);
          if (updated[oldDateKey].length === 0) delete updated[oldDateKey];
          
          updated[newDateKey] = [...(updated[newDateKey] || []), updatedEvent];
          
          updatedCalendar = updated;
          return updated;
        });
        
        if (firestoreServiceRef?.isReady?.()) {
          await saveCalendarToStorage(updatedCalendar, firestoreServiceRef);
        }
        
        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'update_event',
          {
            oldTitle: event.text,
            newTitle: args.newTitle || event.text,
            newTime: newTime,
            newDate: args.newDate
          },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          naturalResponse: naturalResponse,
          updatedCalendar: updatedCalendar,
          targetDateKey: newDateKey,
          targetDate: parseRelativeDate(args.newDate || 'today')
        };

        console.log('✏️ Voice response:', naturalResponse);
        
      } catch (error) {
        console.error('❌ Voice update error:', error);
        toolResult = {
          success: false,
          error: error.message,
          naturalResponse: `Could not find that event. Try being more specific.`
        };
      }
    }

    // ============================================
    // DELETE EVENT (NO DISPLAY NEEDED)
    // ============================================
    else if (functionName === 'delete_event') {
      console.log('🗑️ Voice: Deleting event:', args.eventTitle);

      try {
        const found = findEventByTitle(tasksByDateRef, args.eventTitle);
        
        if (!found) {
          throw new Error(`Could not find event: "${args.eventTitle}"`);
        }
        
        const { dateKey, eventIndex, event } = found;
        
        let updatedCalendar;
        setTasksByDateRef(prev => {
          const updated = { ...prev };
          updated[dateKey] = prev[dateKey].filter((_, idx) => idx !== eventIndex);
          
          if (updated[dateKey].length === 0) {
            delete updated[dateKey];
          }
          
          updatedCalendar = updated;
          return updated;
        });
        
        if (firestoreServiceRef?.isReady?.()) {
          await saveCalendarToStorage(updatedCalendar, firestoreServiceRef);
        }
        
        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'delete_event',
          { title: event.text },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          naturalResponse: naturalResponse
        };

        console.log('🗑️ Voice response:', naturalResponse);
        
      } catch (error) {
        console.error('❌ Voice delete error:', error);
        toolResult = {
          success: false,
          error: error.message,
          naturalResponse: `Could not find that event.`
        };
      }
    }

    // ============================================
    // SAVE JOURNAL ENTRY
    // ============================================
    else if (functionName === 'save_journal_entry') {
      console.log('📝 Saving journal:', args.title);

      const journalData = {
        title: args.title,
        header: args.title,
        summary: args.summary,
        insights: args.insights || '',
        conversation: messageHistory,
        timestamp: new Date().toISOString(),
        createdVia: 'voice'
      };

      try {
        const saved = await journalStorageRef.saveJournal(journalData);
        console.log('✅ Saved:', saved.id);

        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'save_journal_entry',
          { title: args.title },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          journal_id: saved.id,
          title: args.title,
          naturalResponse: naturalResponse
        };

        console.log('📝 Response:', naturalResponse);
      } catch (error) {
        console.error('❌ Save failed:', error);
        toolResult = {
          success: false,
          error: error.message
        };
      }
    }

    // ============================================
    // SAVE CONVERSATION MEMORY
    // ============================================
    else if (functionName === 'save_conversation_memory') {
      console.log('💾 Saving memory:', args.memory);

      try {
        if (!memoryServiceRef) {
          throw new Error('Memory service not available');
        }

        const isReady = await memoryServiceRef.initialize();
        if (!isReady) {
          throw new Error('Failed to initialize memory');
        }

        let expiresAt = null;
        if (args.expiresAt) {
          expiresAt = new Date(args.expiresAt);
        }

        const savedMemory = await memoryServiceRef.saveMemory({
          memory: args.memory,
          topic: args.topic,
          importance: args.importance || 'medium',
          tags: args.tags || [],
          context: args.context || '',
          expiresAt: expiresAt,
          source: 'voice'
        });

        console.log('✅ Memory saved:', savedMemory.memoryId);

        const { default: VoiceResponseGenerator } = 
          await import('./voiceResponseGenerator.js');
        
        const responseGen = new VoiceResponseGenerator(
          azureEndpointRef,
          azureDeploymentRef,
          azureKeyRef
        );

        const naturalResponse = await responseGen.generateToolResponse(
          'save_conversation_memory',
          { memory: args.memory },
          { userName: userNameRef }
        );

        toolResult = {
          success: true,
          memoryId: savedMemory.memoryId,
          memory: args.memory,
          naturalResponse: naturalResponse
        };

        console.log('💾 Response:', naturalResponse);
      } catch (error) {
        console.error('❌ Memory save failed:', error);
        toolResult = {
          success: false,
          error: error.message
        };
      }
    }

    // ============================================
    // SPEAK THE NATURAL RESPONSE + SHOW DISPLAY
    // ============================================
    if (toolResult?.naturalResponse && voiceManager) {
      console.log('🔊 Speaking response:', toolResult.naturalResponse);

      const botMsgId = Date.now();
      setMessagesRef(prev => [...prev, {
        id: botMsgId,
        type: 'bot',
        content: toolResult.naturalResponse,
        isVoiceMode: true,
        isToolResult: true,
        timestamp: new Date().toISOString()
      }]);

      // ✅ SHOW ANIMATED SCHEDULE DISPLAY (based on tool type)
      if (functionName === 'schedule_event' && toolResult.success) {
        setTimeout(() => {
          setMessagesRef(prev => [...prev, {
            id: Date.now() + 100,
            type: 'bot',
            scheduleDisplay: {
              date: toolResult.eventDate,
              dateKey: toolResult.dateKey,
              events: toolResult.updatedCalendar?.[toolResult.dateKey] || [],
              tasksByDate: toolResult.updatedCalendar || tasksByDateRef,
              setTasksByDate: setTasksByDateRef,
              firestoreService: firestoreServiceRef
            },
            timestamp: new Date().toISOString()
          }]);
        }, 800);
      }
      
      if (functionName === 'get_schedule' && toolResult.success && toolResult.eventCount > 0) {
        setTimeout(() => {
          setMessagesRef(prev => [...prev, {
            id: Date.now() + 100,
            type: 'bot',
            scheduleDisplay: {
              date: toolResult.queryDate,
              dateKey: toolResult.dateKey,
              events: tasksByDateRef[toolResult.dateKey] || [],
              tasksByDate: tasksByDateRef,
              setTasksByDate: setTasksByDateRef,
              firestoreService: firestoreServiceRef
            },
            timestamp: new Date().toISOString()
          }]);
        }, 800);
      }
      
      if (functionName === 'update_event' && toolResult.success) {
        setTimeout(() => {
          setMessagesRef(prev => [...prev, {
            id: Date.now() + 100,
            type: 'bot',
            scheduleDisplay: {
              date: toolResult.targetDate,
              dateKey: toolResult.targetDateKey,
              events: toolResult.updatedCalendar?.[toolResult.targetDateKey] || [],
              tasksByDate: toolResult.updatedCalendar || tasksByDateRef,
              setTasksByDate: setTasksByDateRef,
              firestoreService: firestoreServiceRef
            },
            timestamp: new Date().toISOString()
          }]);
        }, 800);
      }

      // ✅ PLAY AUDIO RESPONSE
      try {
        console.log('🎵 Playing tool response audio...');
        await voiceManager.streamAudioChunks(
          toolResult.naturalResponse,
          voiceManager.selectedVoice
        );
        console.log('✅ Audio played');
      } catch (ttsError) {
        console.error('⚠️ TTS error (continuing anyway):', ttsError);
      }

      voiceManager.messageHistory.push({
        role: 'assistant',
        content: toolResult.naturalResponse
      });

      console.log('✅ Tool complete, response spoken');
    }

  } catch (error) {
    console.error('❌ Tool handler error:', error);

    if (voiceManager) {
      const fallback = 'Something went wrong with that. Try again.';
      
      setMessagesRef(prev => [...prev, {
        id: Date.now(),
        type: 'bot',
        content: fallback,
        isVoiceMode: true,
        isFallback: true,
        timestamp: new Date().toISOString()
      }]);

      try {
        console.log('🎵 Playing fallback audio...');
        await voiceManager.streamAudioChunks(fallback, voiceManager.selectedVoice);
        console.log('✅ Fallback audio played');
      } catch (ttsError) {
        console.error('⚠️ TTS error:', ttsError);
      }
    }
  }
};

/**
 * Calculate waveform with LEFT, CENTER, RIGHT amplitudes
 * This creates a 3-point visualization that fills the container
 */
const calculateWaveform = (frequencyData) => {
  if (!frequencyData || frequencyData.length === 0) {
    return {
      leftAmplitude: 0,
      centerAmplitude: 0,
      rightAmplitude: 0,
      points: ''
    };
  }

  const length = frequencyData.length;

  // Split frequency data into 3 sections (left, center, right)
  const leftSection = frequencyData.slice(0, Math.floor(length / 3));
  const centerSection = frequencyData.slice(
    Math.floor(length / 3),
    Math.floor(2 * length / 3)
  );
  const rightSection = frequencyData.slice(Math.floor(2 * length / 3));

  // Calculate average amplitude for each section
  const leftAmplitude = leftSection.length > 0
    ? leftSection.reduce((a, b) => a + b, 0) / leftSection.length
    : 0;
  const centerAmplitude = centerSection.length > 0
    ? centerSection.reduce((a, b) => a + b, 0) / centerSection.length
    : 0;
  const rightAmplitude = rightSection.length > 0
    ? rightSection.reduce((a, b) => a + b, 0) / rightSection.length
    : 0;

  // Normalize to 0-1 range
  const maxAmplitude = Math.max(leftAmplitude, centerAmplitude, rightAmplitude, 1);
  const normalizedLeft = Math.pow(leftAmplitude / maxAmplitude, 1.2);
  const normalizedCenter = Math.pow(centerAmplitude / maxAmplitude, 1.2);
  const normalizedRight = Math.pow(rightAmplitude / maxAmplitude, 1.2);

  // Container dimensions
  const width = 240;
  const height = 60;
  const centerY = height / 2;
  const peakHeight = height / 2 - 6;

  // Calculate Y positions for each peak
  const leftX = width * 0.25;
  const leftY = centerY - (normalizedLeft * peakHeight);

  const centerX = width * 0.5;
  const centerY_peak = centerY - (normalizedCenter * peakHeight);

  const rightX = width * 0.75;
  const rightY = centerY - (normalizedRight * peakHeight);

  // Create smooth Catmull-Rom curve through 3 points
  const points = [
    `0,${centerY}`,
    `${leftX * 0.4},${centerY - (normalizedLeft * peakHeight * 0.3)}`,
    `${leftX},${leftY}`,
    `${leftX + (centerX - leftX) * 0.3},${leftY - (centerY_peak - leftY) * 0.2}`,
    `${leftX + (centerX - leftX) * 0.6},${(leftY + centerY_peak) / 2}`,
    `${centerX},${centerY_peak}`,
    `${centerX + (rightX - centerX) * 0.4},${(centerY_peak + rightY) / 2}`,
    `${rightX},${rightY}`,
    `${rightX + (width - rightX) * 0.4},${centerY - (normalizedRight * peakHeight * 0.3)}`,
    `${width},${centerY}`
  ];

  return {
    leftAmplitude: normalizedLeft,
    centerAmplitude: normalizedCenter,
    rightAmplitude: normalizedRight,
    points: points.join(' ')
  };
};

// ✅ Handle voice transcripts
const handleVoiceTranscript = (transcriptData) => {
  console.log('📝 Voice transcript:', transcriptData);

  // ✅ NEW: Display transcripts in chat
  if (transcriptData.showInChat) {
    if (transcriptData.type === 'user') {
      // ✅ User speaking
      if (transcriptData.isFinal) {
        // Final user message - add to chat
        const userMsgId = Date.now();
        setMessages(prev => {
          // Remove any interim user messages first
          const filtered = prev.filter(m => !(m.isVoiceInterim && m.type === 'user'));
          
          return [...filtered, {
            id: userMsgId,
            type: 'user',
            content: transcriptData.text,
            isVoiceMode: true,
            timestamp: new Date().toISOString()
          }];
        });

        scrollToBottom('smooth');
      } else {
        // Interim - show but mark as temporary
        setMessages(prev => {
          const filtered = prev.filter(m => !m.isVoiceInterim);
          
          return [...filtered, {
            id: Date.now(),
            type: 'user',
            content: transcriptData.text,
            isVoiceMode: true,
            isVoiceInterim: true,
            timestamp: new Date().toISOString()
          }];
        });
      }
    } 
    else if (transcriptData.type === 'assistant') {
      // ✅ AI speaking
      if (transcriptData.isLoading) {
        // Show loading state
        const loadingId = Date.now();
        setMessages(prev => {
          const filtered = prev.filter(m => !m.isVoiceStreaming && !m.isVoiceTyping);
          
          return [...filtered, {
            id: loadingId,
            type: 'bot',
            content: '',
            isVoiceMode: true,
            isLoadingAnimation: true,
            isVoiceStreaming: true,
            timestamp: new Date().toISOString()
          }];
        });
      } 
      else if (transcriptData.isStreaming) {
        // ✅ NEW: Real-time typing animation while AI speaks
        const fullText = transcriptData.text;
        
        // Clear previous typing interval if exists
        if (voiceTypingIntervalRef.current) {
          clearInterval(voiceTypingIntervalRef.current);
        }
        
        setMessages(prev => {
          const filtered = prev.filter(m => !m.isVoiceStreaming && !m.isVoiceTyping && !m.isLoadingAnimation);
          
          const msgId = Date.now();
          setVoiceTypingMessageId(msgId);
          
          return [...filtered, {
            id: msgId,
            type: 'bot',
            content: '', // Start empty
            fullContent: fullText, // Store full text
            isVoiceMode: true,
            isVoiceTyping: true, // ✅ Mark as actively typing
            timestamp: new Date().toISOString()
          }];
        });
        
        // ✅ Start typing animation
        let charIndex = 0;
        voiceTypingIntervalRef.current = setInterval(() => {
          if (charIndex <= fullText.length) {
            setMessages(prev => prev.map(msg => 
              msg.id === voiceTypingMessageId
                ? { ...msg, content: fullText.substring(0, charIndex) }
                : msg
            ));
            charIndex++;
          } else {
            clearInterval(voiceTypingIntervalRef.current);
            voiceTypingIntervalRef.current = null;
          }
        }, 15); // 15ms per character for smooth typing
        
        scrollToBottom('smooth');
      }
      else if (transcriptData.isFinal) {
        // ✅ Final AI message - stop typing, show complete
        if (voiceTypingIntervalRef.current) {
          clearInterval(voiceTypingIntervalRef.current);
          voiceTypingIntervalRef.current = null;
        }
        
        const botMsgId = Date.now();
        setMessages(prev => {
          // Remove all streaming/interim/typing messages
          const filtered = prev.filter(m => 
            !m.isVoiceStreaming && 
            !m.isVoiceInterim && 
            !m.isVoiceTyping &&
            !m.isLoadingAnimation
          );
          
          return [...filtered, {
            id: botMsgId,
            type: 'bot',
            content: transcriptData.text,
            isVoiceMode: true,
            timestamp: new Date().toISOString()
          }];
        });

        setVoiceTypingMessageId(null);
        scrollToBottom('smooth');
      }
    }
    else if (transcriptData.type === 'tool_call') {
      // ✅ Tool call detected - show in chat
      if (voiceTypingIntervalRef.current) {
        clearInterval(voiceTypingIntervalRef.current);
        voiceTypingIntervalRef.current = null;
      }
      
      const toolMsgId = Date.now();
      setMessages(prev => {
        const filtered = prev.filter(m => !m.isVoiceStreaming && !m.isVoiceTyping);
        
        return [...filtered, {
          id: toolMsgId,
          type: 'bot',
          content: `Processing: ${transcriptData.functionName}...`,
          isVoiceMode: true,
          isToolCall: true,
          timestamp: new Date().toISOString()
        }];
      });
    }
  }

  // ✅ Update waveform
  if (transcriptData.waveform) {
    setWaveformData(transcriptData.waveform);
  }
};

// ✅ Stop voice mode
const stopVoiceMode = async () => {
  try {
    console.log('🛑 Stopping voice mode...');
    
    // ✅ CRITICAL: Stop microphone completely
    if (voiceManager) {
      console.log('🎤 Disabling microphone...');
      
      try {
        // ✅ Stop listening first
        await voiceManager.stopListening();
        console.log('✅ Microphone stopped listening');
      } catch (listenError) {
        console.warn('⚠️ Error stopping listen:', listenError);
      }

      try {
        // ✅ Close audio context
        if (voiceManager.audioContext) {
          console.log('🔊 Closing audio context...');
          await voiceManager.audioContext.close();
          console.log('✅ Audio context closed');
        }
      } catch (audioError) {
        console.warn('⚠️ Error closing audio context:', audioError);
      }

      try {
        // ✅ Stop all audio tracks
        if (voiceManager.mediaStream) {
          console.log('📹 Stopping all media tracks...');
          voiceManager.mediaStream.getTracks().forEach(track => {
            console.log(`🔴 Stopping track: ${track.kind}`);
            track.stop();
          });
          voiceManager.mediaStream = null;
          console.log('✅ All media tracks stopped');
        }
      } catch (trackError) {
        console.warn('⚠️ Error stopping tracks:', trackError);
      }

      try {
        // ✅ Disconnect from speech recognizer
        if (voiceManager.recognizer) {
          console.log('🎙️ Stopping speech recognizer...');
          voiceManager.recognizer.stopContinuousRecognitionAsync();
          console.log('✅ Speech recognizer stopped');
        }
      } catch (recognizerError) {
        console.warn('⚠️ Error stopping recognizer:', recognizerError);
      }

      try {
        // ✅ Disconnect from synthesizer
        if (voiceManager.synthesizer) {
          console.log('🔊 Closing speech synthesizer...');
          voiceManager.synthesizer.close();
          console.log('✅ Speech synthesizer closed');
        }
      } catch (synthError) {
        console.warn('⚠️ Error closing synthesizer:', synthError);
      }

      try {
        // ✅ Disconnect websocket
        if (voiceManager.wsConnection) {
          console.log('🌐 Closing WebSocket...');
          voiceManager.wsConnection.close();
          voiceManager.wsConnection = null;
          console.log('✅ WebSocket closed');
        }
      } catch (wsError) {
        console.warn('⚠️ Error closing WebSocket:', wsError);
      }

      // ✅ Full disconnect
      voiceManager.disconnect();
      setVoiceManager(null);
      console.log('✅ Voice manager fully disconnected');
    }

    // ✅ Clear typing animation
    if (voiceTypingIntervalRef.current) {
      clearInterval(voiceTypingIntervalRef.current);
      voiceTypingIntervalRef.current = null;
    }
    setVoiceTypingMessageId(null);
    
    // ✅ Transition to text mode
    if (voiceTextManager) {
      await voiceTextManager.transitionToTextMode(setMessages);
    }
    
    // ✅ Reset all voice-related states
    setIsVoiceMode(false);
    setSelectedVoiceHost(null);
    setVoiceTranscript('');
    setVoiceStatus('');
    setMicMuted(false); // ✅ Reset mute state
    setHasGreetingPlayed(false); // ✅ Reset greeting flag for next session
    setWaveformData({
      points: '',
      isActive: false,
      height: 0,
      leftAmplitude: 0,
      centerAmplitude: 0,
      rightAmplitude: 0
    });
    
    console.log('✅ Voice mode fully stopped - microphone disabled');
    
    // ✅ PLAY END SOUND - When call ends
    console.log('🔊 Playing call end sound...');
    await callSounds.playEndSound();

  } catch (error) {
    console.error('❌ Error stopping voice mode:', error);
    
    // ✅ FORCE CLEANUP ON ERROR - Make sure mic is off
    try {
      console.log('🔴 Force shutting down microphone...');
      
      // Force stop all audio
      if (voiceManager?.mediaStream) {
        voiceManager.mediaStream.getTracks().forEach(track => {
          track.stop();
        });
      }

      // Force close audio context
      if (voiceManager?.audioContext) {
        await voiceManager.audioContext.close();
      }

      // Force stop recognizer
      if (voiceManager?.recognizer) {
        voiceManager.recognizer.stopContinuousRecognitionAsync();
      }

      console.log('✅ Microphone force-shutdown complete');
    } catch (forceError) {
      console.error('❌ Force shutdown error:', forceError);
    }
    
    // ✅ NEW: Reset greeting flag even on error
    setHasGreetingPlayed(false);

    // ✅ Reset ALL states regardless of error
    setIsVoiceMode(false);
    setSelectedVoiceHost(null);
    setVoiceTranscript('');
    setVoiceStatus('');
    setMicMuted(false);
    setWaveformData({ 
      points: '', 
      isActive: false, 
      height: 0,
      leftAmplitude: 0,
      centerAmplitude: 0,
      rightAmplitude: 0
    });
    
    if (voiceManager) {
      try {
        voiceManager.disconnect();
      } catch (disconnectError) {
        console.error('❌ Disconnect error:', disconnectError);
      }
      setVoiceManager(null);
    }
    
    console.log('✅ Force cleanup complete - voice mode disabled');
  }
};

useEffect(() => {
  return () => {
    // ✅ On component unmount, force stop voice
    if (isVoiceMode) {
      console.log('🔴 Component unmounting - force stopping voice');
      
      if (voiceManager?.mediaStream) {
        voiceManager.mediaStream.getTracks().forEach(track => track.stop());
      }
      
      if (voiceManager?.audioContext) {
        voiceManager.audioContext.close().catch(e => console.warn('Error closing audio:', e));
      }
      
      if (voiceManager?.recognizer) {
        voiceManager.recognizer.stopContinuousRecognitionAsync();
      }
      
      setIsVoiceMode(false);
      setVoiceManager(null);
      console.log('✅ Component unmount cleanup complete');
    }
  };
}, []);
// Voice color mapping for waveform visualization
const voiceColors = {
  "Host 1": "#EC4899",
  "Host 2": "#4a90e2",
  "Host 3": "#10b981",
  "Host 4": "#8b5cf6"
};




const extractAndSaveMemories = async () => {
  // ============================================
  // VALIDATION CHECKS
  // ============================================
  
  if (!memoryService) {
    console.warn('⚠️ Memory service not available');
    return { success: false, reason: 'no_service' };
  }

  if (!memoryService.isReady()) {
    console.warn('⚠️ Memory service not ready');
    return { success: false, reason: 'service_not_ready' };
  }

  if (!messages || messages.length === 0) {
    console.log('⏭️ No messages to extract from');
    return { success: false, reason: 'no_messages', extracted: 0, saved: 0 };
  }

  // ============================================
  // FILTER AND PREPARE MESSAGES
  // ============================================

  const recentMessages = messages
    .slice(-15) // Get last 15 messages for better context
    .filter(msg => msg && msg.content && msg.content.trim().length > 0)
    .map(msg => ({
      type: msg.type || 'unknown',
      content: msg.content.trim(),
      timestamp: msg.timestamp || new Date().toISOString()
    }));

  console.log(`📝 Preparing to extract from ${recentMessages.length} recent messages`);

  // ============================================
  // VALIDATION: Ensure we have enough content
  // ============================================

  if (recentMessages.length === 0) {
    console.log('⏭️ No valid messages with content');
    return { success: false, reason: 'no_valid_messages', extracted: 0, saved: 0 };
  }

  const totalContentLength = recentMessages
    .reduce((sum, msg) => sum + msg.content.length, 0);

  if (totalContentLength < 50) {
    console.log('⏭️ Conversation too short for meaningful extraction');
    return { success: false, reason: 'content_too_short', extracted: 0, saved: 0 };
  }

  // ============================================
  // EXTRACTION PHASE
  // ============================================

  try {
    console.log('🧠 Starting memory extraction from conversation...');
    console.log(`📊 Total content: ${totalContentLength} characters`);

    const extractedMemories = await memoryService.extractMemoriesFromConversation(
      recentMessages
    );

    console.log(`📌 Extraction complete: ${extractedMemories.length} memories found`);

    // ============================================
    // VALIDATION: Check extraction results
    // ============================================

    if (!extractedMemories || extractedMemories.length === 0) {
      console.log('⏭️ No meaningful memories extracted from conversation');
      return { 
        success: false, 
        reason: 'no_meaningful_facts',
        extracted: 0, 
        saved: 0,
        details: 'Conversation may have been too casual or lacked personal facts'
      };
    }

    // ============================================
    // DEDUPLICATION PHASE (Optional but recommended)
    // ============================================

    const deduplicatedMemories = memoryService.deduplicateMemories(extractedMemories);

    console.log(`🔄 After deduplication: ${deduplicatedMemories.length} unique memories`);

    if (deduplicatedMemories.length === 0) {
      console.log('⏭️ All extracted memories were duplicates');
      return { 
        success: false, 
        reason: 'all_duplicates',
        extracted: extractedMemories.length,
        saved: 0,
        details: 'All extracted facts were already saved'
      };
    }

    // ============================================
    // SAVING PHASE
    // ============================================

    console.log(`💾 Saving ${deduplicatedMemories.length} unique memories to Firestore...`);

    const savedMemoryIds = await memoryService.saveMemoriesToFirestore(
      deduplicatedMemories
    );

    console.log(`✅ Successfully saved ${savedMemoryIds.length} memories to Firestore`);

    // ============================================
    // SUMMARY LOGGING
    // ============================================

    const summary = {
      success: true,
      extracted: extractedMemories.length,
      deduplicated: deduplicatedMemories.length,
      saved: savedMemoryIds.length,
      memoryIds: savedMemoryIds,
      memoryDetails: deduplicatedMemories.map(mem => ({
        text: mem.memory.substring(0, 50) + '...',
        type: mem.type,
        importance: mem.importance,
        saved: savedMemoryIds.includes(mem.id)
      })),
      timestamp: new Date().toISOString()
    };

    console.log('📊 Extraction & Save Summary:', summary);

    return summary;

  } catch (error) {
    console.error('❌ Critical error during memory extraction:', error);
    console.error('📋 Error details:', {
      message: error.message,
      stack: error.stack,
      name: error.name
    });

    return {
      success: false,
      reason: 'extraction_error',
      error: error.message,
      extracted: 0,
      saved: 0,
      timestamp: new Date().toISOString()
    };
  }
};

useEffect(() => {
  // Debounce to avoid too frequent extraction
  const timer = setTimeout(() => {
    extractAndSaveMemories();
  }, 2000);

  return () => clearTimeout(timer);
}, [messages]);
const generateGreeting = (name) => {
  const timeOfDay = getTimeOfDay();
  
  const greetings = [
    `Hey ${name}, how's it going?`,
    `Good ${timeOfDay} ${name}, What's up?`,
    `Hey there ${name}, How are you doing?`,
    `${name}, Good to hear from you. What's on your mind?`,
    `What's up ${name}? How's your day going?`
  ];
  
  return greetings[Math.floor(Math.random() * greetings.length)];
};

const VOICE_CONFIGS = {
  "guide": {
    voice: {
      id: "33045fd9-8010-43f6-b6b0-da3fbf326c29" // female
    }
  },
  "therapist": {
    voice: {
      id: "41745808-6790-4be4-83db-363e20db7e71"  // male
    }
  },
  "guest1": {
    voice: {
      id: "5bb7de05-c8fe-426a-8fcc-ba4fc4ce9f9c"
    }
  },
  "guest2": {
    voice: {
      id: "c01854384-4e4e-48d4-90d1-b22f760a58b5"
    }
  }
};

// API keys
const HUME_API_KEY = "k1vLxi2js2VuUT0caKG9bGJXIZfQfNsGFYGI8wmnnfhEnCuf";

// Voice configurations 4 host in total
const voiceConfigs = {
  "Host 1": {
    voice: {
            id: "33045fd9-8010-43f6-b6b0-da3fbf326c29" //female
    }
  },
  "Host 2": {
    voice: {
      id: "41745808-6790-4be4-83db-363e20db7e71"  //man
    }
  },
  "Host 3": {
    voice: {
      id: "43e411b3-b2cc-40da-b742-4abf0e3557b2"//female - 15fdd52a-2cc5-4ad7-88ae-c2fa840fb2e4
    }
  },
  "Host 4": {
    voice: {
      id: "01854384-4e4e-48d4-90d1-b22f760a58b5"// man - b152864b-6720-496a-9d18-eaadb31516ee
    }
  }
};

const PODCAST_MUSIC_URLS = [
  '/music/intro-outro-1.mp3',
  '/music/intro-outro-2.mp3',
  '/music/intro-outro-3.mp3',
  '/music/intro-outro-4.mp3',
  '/music/intro-outro-5.mp3',
  '/music/intro-outro-6.mp3',
   '/music/intro-outro-7.mp3',
  '/music/intro-outro-8.mp3',
    '/music/intro-outro-9.mp3',
      '/music/intro-outro-11.mp3',
];

const MAX_WORDS = 300;

const handleInputChange = (e, isExpanded) => {
  const value = e.target.value;

  // Count words
  const wordCount = value.trim() === '' ? 0 : value.trim().split(/\s+/).length;

  // Block input if over 300 words
  if (wordCount > MAX_WORDS) {
    const trimmed = value.trim().split(/\s+/).slice(0, MAX_WORDS).join(' ');
    setInputValue(trimmed);
    return;
  }

  setInputValue(value);

  if (isExpanded) {
    const textarea = expandedInputRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      const scrollHeight = textarea.scrollHeight;
      const isMobileDevice = window.innerWidth < 769;
      const maxH = isMobileDevice ? 160
        : window.innerWidth >= 1440 ? 500
        : window.innerWidth >= 1200 ? 420
        : 300;
      const newHeight = Math.min(Math.max(scrollHeight, 44), maxH);
      textarea.style.height = `${newHeight}px`;
      setTextareaHeight(`${newHeight}px`);
    }
  }

  // ✅ FIX: Use word count (>= 3 words) instead of character length to trigger expansion.
  // This prevents expanding when the user has only typed a few characters with no spaces,
  // which was causing the cursor to visually disappear mid-typing.
  if (!isExpanded && wordCount >= 3 && !isMultiline) {
    setIsMultiline(true);
    const cursorPos = e.target.selectionStart;
    setTimeout(() => {
      const expandedTextarea = expandedInputRef.current;
      if (expandedTextarea) {
        expandedTextarea.focus();
        expandedTextarea.setSelectionRange(cursorPos, cursorPos);
        // Trigger height calculation immediately on expand
        expandedTextarea.style.height = 'auto';
        const isMobileDevice = window.innerWidth < 769;
        const maxH = isMobileDevice ? 160
          : window.innerWidth >= 1440 ? 500
          : window.innerWidth >= 1200 ? 420
          : 300;
        const newHeight = Math.min(Math.max(expandedTextarea.scrollHeight, 44), maxH);
        expandedTextarea.style.height = `${newHeight}px`;
        setTextareaHeight(`${newHeight}px`);
      }
    }, 0);
  } else if (isExpanded && value.length === 0) {
    setIsMultiline(false);
    setTextareaHeight('44px');
  }
};
useEffect(() => {
  if (inputValue === '') {
    setIsMultiline(false);
    if (expandedInputRef.current) {
      expandedInputRef.current.style.height = '24px';
      expandedInputRef.current.style.overflowY = 'hidden';
    }
  }
}, [inputValue]);

  // Handle voice selection
  const handleVoiceSelected = (voice) => {
    console.log('Voice selected:', voice.name);
    setCurrentVoice(voice);
    // You can save to localStorage or Firebase here
    localStorage.setItem('selectedVoice', JSON.stringify(voice));
  };

  // Start listening function (connects to your voice AI)
  const startListening = async () => {
    console.log('Starting voice conversation with:', currentVoice?.name);
    
    // Set connection states
    setIsConnected(true);
    setIsRecording(true);
    
    // TODO: Add your actual voice connection logic here
    // This might connect to Hume, Azure Speech, or your voice service
    // Example:
    // await connectToVoiceService(currentVoice.configId);
    
    try {
      // Your voice connection code goes here
      console.log('Voice connection started');
    } catch (error) {
      console.error('Failed to start voice:', error);
      setIsConnected(false);
      setIsRecording(false);
    }
  };
/**
 * Add this useEffect in ChatMode.jsx to handle notification taps
 * Shows the conversation thread when user opens app from notification
 */
useEffect(() => {
  const handleNotificationView = async (event) => {
    const { 
      memoryId, 
      replyDocId, 
      threadId,
      type,
      eventText,
      userReply,
      showConversation 
    } = event.detail;

    console.log('📱 User opened app from notification:', event.detail);

    // Switch to chat mode
    setCurrentMode('chat');

    if (showConversation && replyDocId) {
      // Load the conversation thread
      try {
        // Get the original reply
        const replyDoc = await firestoreService.getDocument(
          `users/${user.uid}/quickReplies/${replyDocId}`
        );

        // Get the AI response
        const responseDocs = await firestoreService.getCollection(
          `users/${user.uid}/aiResponses`,
          { where: ['replyDocId', '==', replyDocId] }
        );

        if (replyDoc && responseDocs.length > 0) {
          const reply = replyDoc.data();
          const aiResponse = responseDocs[0].data();

          // Display the conversation in chat
          const conversationMessages = [
            {
              id: Date.now() - 2,
              type: 'bot',
              content: reply.notificationBody,
              isNotificationThread: true,
              timestamp: reply.repliedAt?.toDate?.()?.toISOString() || new Date().toISOString()
            },
            {
              id: Date.now() - 1,
              type: 'user',
              content: reply.userMessage,
              isNotificationReply: true,
              timestamp: reply.repliedAt?.toDate?.()?.toISOString() || new Date().toISOString()
            },
            {
              id: Date.now(),
              type: 'bot',
              content: aiResponse.aiResponse,
              isNotificationThread: true,
              timestamp: aiResponse.createdAt?.toDate?.()?.toISOString() || new Date().toISOString()
            }
          ];

          // Add to existing messages or replace
          setMessages(prev => [...prev, ...conversationMessages]);

          // Scroll to bottom
          setTimeout(() => scrollToBottom('smooth'), 300);

          console.log('✅ Conversation thread loaded in app');
        }
      } catch (error) {
        console.error('❌ Failed to load conversation:', error);
        
        // Show error message
        setMessages(prev => [...prev, {
          id: Date.now(),
          type: 'bot',
          content: `I couldn't load that conversation. The original event was: "${eventText}"`,
          timestamp: new Date().toISOString()
        }]);
      }
    } else if (memoryId) {
      // Fallback: Just load the memory context
      if (memoryService) {
        memoryService.getAllMemories().then(memories => {
          const memory = memories.find(m => m.id === memoryId);
          if (memory) {
            console.log('📚 Found memory:', memory.memory);
            setMessages(prev => [...prev, {
              id: Date.now(),
              type: 'bot',
              content: `About your event: "${memory.memory}"`,
              timestamp: new Date().toISOString()
            }]);
          }
        });
      }
    }
  };

  window.addEventListener('notification-view', handleNotificationView);

  return () => {
    window.removeEventListener('notification-view', handleNotificationView);
  };
}, [memoryService, user, firestoreService]);

/**
 * Generate podcast dialogue with 4 hosts (2 start, 1 guest joins)
 */
const generatePodcastDialogue = async (
  topic, 
  searchResults = null, 
  includeGuest = false, 
  startingHosts = ["Host 1", "Host 2"],
  userName = null  // NEW: Add userName parameter
) => {
  const maxRetries = 2;
  let lastError;
  
  const speakerConfig = determineGuestSpeaker(startingHosts);
  const guestSpeaker = speakerConfig.guestSpeaker;
  
  // Get time context with personalization
  const timeOfDay = getTimeOfDay();
  const greeting = getTimeGreeting();
  const dateInfo = getCurrentDateInfo();
  
  console.log('\n📋 Podcast Context:');
  console.log(`   Date: ${dateInfo.formatted}`);
  console.log(`   Time: ${timeOfDay}`);
  console.log(`   Greeting: "${greeting}"`);
  console.log(`   User Name: ${userName || 'Anonymous'}`);  // NEW
  console.log(`   Guest Feature: ${includeGuest ? 'ENABLED ✓' : 'DISABLED ✗'}`);
  
  // time-aware context for AI
  let timeContext = `\n\n=== CURRENT CONTEXT ===\n`;
  timeContext += `Today is: ${dateInfo.formatted}\n`;
  timeContext += `Time of day: ${timeOfDay}\n`;
  timeContext += `Appropriate greeting: "${greeting}"\n`;
  
  // personalization context
  if (userName) {
    timeContext += `\n=== PERSONALIZATION ===\n`;
    timeContext += `Listener's name: ${userName}\n`;
    timeContext += `CRITICAL: In the very first exchange, greet them by name naturally:\n`;
    timeContext += `- If morning: "Good morning ${userName}, welcome back!" or "Hey ${userName}, good morning!"\n`;
    timeContext += `- If afternoon: "Hey ${userName}, good afternoon!" or "Welcome back ${userName}!"\n`;
    timeContext += `- If evening: "Good evening ${userName}!" or "Hey ${userName}, welcome back!"\n`;
    timeContext += `- If night: "Hey ${userName}, thanks for joining us!" or "Welcome ${userName}!"\n`;
    timeContext += `After the first greeting, use their name sparingly (maybe 1-2 more times throughout)\n\n`;
  }
  
  timeContext += `GREETING GUIDELINES:\n`;
  if (timeOfDay === 'morning') {
    timeContext += `- It's morning, natural intros: ${userName ? `"Hey ${userName}, good morning"` : '"Hey, good morning"'}\n`;
    timeContext += `- Energy should be upbeat but not overly energetic\n`;
  } else if (timeOfDay === 'afternoon') {
    timeContext += `- It's afternoon, casual intros: ${userName ? `"Hey ${userName}"` : '"Hey"'} or just jump to topic\n`;
    timeContext += `- Steady, focused energy\n`;
  } else if (timeOfDay === 'evening') {
    timeContext += `- It's evening, warm intros: ${userName ? `"Hey ${userName}, welcome back"` : '"Hey, welcome back"'}\n`;
    timeContext += `- Relaxed, conversational tone\n`;
  } else {
    timeContext += `- It's nighttime, casual intros: ${userName ? `"Hey ${userName}"` : '"Hey"'} or "Welcome"\n`;
    timeContext += `- Calm, focused tone\n`;
  }
  
  // search results context if provided
  let searchContext = '';
  if (searchResults && searchResults.length > 0) {
    searchContext += `\n\n=== NEWS SOURCES (Use these facts in dialogue) ===\n`;
    searchResults.forEach((result, idx) => {
      searchContext += `\n${idx + 1}. ${result.title}\n`;
      searchContext += `   Source: ${result.source}\n`;
      searchContext += `   Date: ${result.dateWithDayOfWeek}\n`;
      searchContext += `   Summary: ${result.snippet.substring(0, 180)}...\n`;
    });
    searchContext += `\n⚠️ CRITICAL: Mention specific dates when discussing each news item.\n`;
    searchContext += `Use the date format from "Date:" field above (e.g., "today Thursday, October 9th" or "yesterday Wednesday, October 8th")\n`;
  }
  
  // Build guest speaker context
  let guestContext = '';
  if (includeGuest) {
    guestContext += `\n\n=== GUEST SPEAKER FEATURE ===\n`;
    guestContext += `SPEAKER CONFIGURATION:\n`;
    guestContext += `- Starting hosts: ${speakerConfig.startingHosts[0]} and ${speakerConfig.startingHosts[1]}\n`;
    guestContext += `- Guest speaker who joins: ${guestSpeaker}\n\n`;
    
    guestContext += `This podcast has 4 total hosts. Two hosts (${speakerConfig.startingHosts[0]} and ${speakerConfig.startingHosts[1]}) start the conversation, then ${guestSpeaker} joins as the guest.\n\n`;
    
    guestContext += `GUEST INTRODUCTION RULES:\n`;
    guestContext += `- Guest (${guestSpeaker}) should be introduced around 40-50% through the conversation (after 15-20 exchanges)\n`;
    guestContext += `- Use "${guestSpeaker}" as the speaker label in JSON\n`;
    guestContext += `- Introduction pattern:\n`;
    guestContext += `  * ${speakerConfig.startingHosts[0]}: "There's more to discuss about [specific aspect]. I think we should bring in our guest."\n`;
    guestContext += `  * ${speakerConfig.startingHosts[1]}: "Absolutely. Let's bring in our guest. We're very pleased to have you on the show."\n`;
    guestContext += `  * ${guestSpeaker}: "Thank you for having me. About [topic]..."\n\n`;
    
    guestContext += `GUEST PARTICIPATION:\n`;
    guestContext += `- Guest (${guestSpeaker}) should contribute 8-12 exchanges total\n`;
    guestContext += `- Guest brings expert knowledge, different perspective, or specialized insight\n`;
    guestContext += `- Guest speaks in slightly longer, more detailed exchanges (2-4 sentences)\n`;
    guestContext += `- Guest should sound natural and engaging - USE THESE SPARINGLY (1-2 per exchange MAX):\n`;
    guestContext += `  * Excited realizations: "Oh wait, that's right!", "Wait, actually...", "Oh my God, yes!"\n`;
    guestContext += `  * Conversational fillers: "Like, honestly...", "Um, okay so...", "You know what..."\n`;
    guestContext += `  * Strong reactions: "Oh wow", "No way", "That's insane", "Seriously?"\n`;
    guestContext += `  * Agreement: "Yup, exactly", "Mhm, totally", "Right, right", "For sure"\n`;
    guestContext += `  * Thinking out loud: "Wait, let me think...", "Hmm, yeah...", "Like, actually..."\n`;
    guestContext += `  * Emphatic expressions: "Oh my God", "Wait, really?", "That's crazy"\n`;
    guestContext += `  * CRITICAL: Don't overuse! Mix plain statements with occasional reactions\n`;
    guestContext += `  * Most exchanges should be straightforward without excessive fillers\n`;
    guestContext += `- Hosts can ask guest questions: "What's your take on...", "How do you see...", "Can you explain..."\n`;
    guestContext += `- Guest can disagree respectfully or add nuance to hosts' points\n`;
    guestContext += `- Natural flow: Host question → Guest answer → Host reaction → Guest elaboration\n`;
    guestContext += `- IMPORTANT: All three speakers (${speakerConfig.startingHosts[0]}, ${speakerConfig.startingHosts[1]}, ${guestSpeaker}) should participate after guest joins\n\n`;
    
    guestContext += `GUEST OUTRO:\n`;
    guestContext += `- Before final wrap-up (3-4 exchanges from end):\n`;
    guestContext += `  * ${speakerConfig.startingHosts[0]} or ${speakerConfig.startingHosts[1]}: "This has been really insightful. Thanks for joining us."\n`;
    guestContext += `  * ${guestSpeaker}: "Thanks for having me. Great conversation."\n`;
    guestContext += `- Then the two starting hosts (${speakerConfig.startingHosts[0]} and ${speakerConfig.startingHosts[1]}) do final wrap-up\n\n`;
    
    guestContext += `CRITICAL: Only use these speaker labels: "${speakerConfig.startingHosts[0]}", "${speakerConfig.startingHosts[1]}", "${guestSpeaker}"\n`;
  }
  
  const validSpeakers = includeGuest 
    ? [speakerConfig.startingHosts[0], speakerConfig.startingHosts[1], guestSpeaker]
    : startingHosts;
  
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      console.log(`🎙️ Podcast generation attempt ${attempt + 1}/${maxRetries}`);
      
const data = await SecureAPI.callAzureOpenAI([
 {
                role: 'system',
                content: `You are a podcast script writer. Create an engaging conversation between ${validSpeakers.join(', ')}${includeGuest ? ` (where ${guestSpeaker} joins as a guest)` : ''}.

${timeContext}${searchContext}${guestContext}

CRITICAL JSON RULES:
- Return ONLY a valid JSON array, nothing else
- NO trailing commas before closing brackets
- Escape quotes inside dialogue with backslash
- Keep it for ${includeGuest ? '5-6 minute podcast (45-55 exchanges total)' : '4-5 minute podcast (35-45 exchanges total)'}

Format EXACTLY like this:
[{"speaker":"${validSpeakers[0]}","line":"text"},{"speaker":"${validSpeakers[1]}","line":"text"}${includeGuest ? `,{"speaker":"${guestSpeaker}","line":"text"}` : ''}]

Format EXACTLY like this:
[{"speaker":"${validSpeakers[0]}","line":"text"},{"speaker":"${validSpeakers[1]}","line":"text"}${includeGuest ? `,{"speaker":"${guestSpeaker}","line":"text"}` : ''}]

Format EXACTLY like this (with optional background reactions):
[
  {"speaker":"${validSpeakers[0]}","line":"text"},
  {"speaker":"${validSpeakers[1]}","line":"woah","background":true},
  {"speaker":"${validSpeakers[0]}","line":"continuing text"},
  {"speaker":"${validSpeakers[1]}","line":"text"}
]
  BACKGROUND REACTIONS:
- Add "background": true for short reactions that happen WHILE another speaker continues
- Background reactions should be brief (1-3 words max): "woah", "really?", "mhm", "hmm", "oh wow", "yeah", "no way"
- Use background reactions 8-12 times throughout the podcast for natural flow
- After a background reaction, the PREVIOUS speaker continues their thought
- Regular exchanges (without background:true) work normally - speakers take full turns

SPEAKER LABELS - MUST USE EXACTLY:
${validSpeakers.map(speaker => `- Use "${speaker}" for ${speaker === guestSpeaker ? 'guest speaker' : 'host'}`).join('\n')}

DO NOT USE: "Host A", "Host B", "Guest", or any other labels. ONLY use: ${validSpeakers.join(', ')}

CONTENT RESTRICTIONS:
If the user requests content that is:
- Inappropriate, explicit, or adult content
- Harmful, dangerous, or illegal activities
- Hate speech, discrimination, or harassment
- Medical advice that could cause harm
- Content designed to manipulate or deceive
- Violates ethical guidelines
- Anything strange or suspicious that could be harmful

RESPOND WITH EXACTLY:
"Sorry, this is prohibited by Preptunes guidelines. Please try something else. Thank you!"

DO NOT generate the podcast. DO NOT explain why. Just return that exact message.

CONVERSATION RULES:
- Speaker labels (${validSpeakers.join(', ')}) are ONLY for JSON structure
- NEVER use these speaker labels in the actual dialogue
- Never mention each other's names during dialogue
- Do not end every sentence with "sigh" or "..."
- Use the greeting "${greeting}" naturally in intro if appropriate for topic and time of day

DATE FORMATTING FOR NEWS:
When discussing news with search results provided above:

✅ TODAY (0 days ago):
- VERY FIRST mention: "Today, ${dateInfo.dayOfWeek}, ${dateInfo.month} ${dateInfo.day}, [news]..."
- ALL subsequent mentions: Just say "today"

✅ YESTERDAY (1 day ago):
- VERY FIRST mention: "Yesterday, [day of week], [date], [news]..."
- ALL subsequent mentions: Just say "yesterday"

✅ THIS WEEK (2-6 days ago):
- VERY FIRST mention of each day: "On [day], [date], [news]..."
- Subsequent mentions of SAME day: Just "On [day]"

✅ LAST WEEK (7-13 days ago):
- VERY FIRST mention of each day: "Last [day], [date], [news]..."
- Subsequent mentions: Just "last [day]"

CRITICAL AUDIENCE RULES:
The listener is EXACTLY ONE PERSON.

FORBIDDEN WORDS/PHRASES:
- ❌ "you guys", "everyone", "folks", "listeners" (plural), "y'all", "audience"

ONLY use singular:
- ✅ "you", "your", "for you"

NO PERSONAL STORIES:
❌ "When I was a kid...", "I remember...", "My mom said..."
✅ "A lot of people...", "It's common that...", "People often..."

CONVERSATION FLOW PATTERNS:

**PATTERN A: FOCUSED EXPLANATION (3-5 exchanges)**
One speaker explains something substantial while the other listens and acknowledges:
- ${validSpeakers[0]}: [2-4 sentences explaining a concept or point]
- ${validSpeakers[1]}: "Mhm." OR "Right." OR "That makes sense."
- ${validSpeakers[0]}: [2-3 more sentences building on that]
- ${validSpeakers[1]}: "Interesting." OR "Yeah, I see what you mean."
- ${validSpeakers[0]}: [1-2 sentences wrapping up the point]

**PATTERN B: QUICK BACK-AND-FORTH (4-6 exchanges)**
Rapid fire reactions and short responses:
- ${validSpeakers[0]}: [1 sentence]
- ${validSpeakers[1]}: "Wait, really?"
- ${validSpeakers[0]}: "Yeah."
- ${validSpeakers[1]}: "That's wild."
- ${validSpeakers[0]}: "Right?"
- ${validSpeakers[1]}: "What does that mean for..."

**PATTERN C: COLLABORATIVE BUILD (4-6 exchanges)**
Both speakers adding ideas, each speaking 2-3 sentences:
- ${validSpeakers[0]}: [2-3 sentences with an idea]
- ${validSpeakers[1]}: [2-3 sentences adding to it or pivoting]
- ${validSpeakers[0]}: [2-3 sentences building further]
- ${validSpeakers[1]}: [2 sentences with conclusion or transition]

**PATTERN D: QUESTION AND DEEP ANSWER (3-4 exchanges)**
One speaker asks, the other gives substantial answer:
- ${validSpeakers[0]}: "How does that actually work?"
- ${validSpeakers[1]}: [3-4 sentences explaining]
- ${validSpeakers[0]}: "Got it. And what about..."
- ${validSpeakers[1]}: [2-3 sentences answering]

${includeGuest ? `**PATTERN E: GUEST INTERACTION (4-6 exchanges)**
Hosts engage with guest speaker (${guestSpeaker}):
- ${validSpeakers[0]}: "What's your perspective on this?"
- ${guestSpeaker}: [3-4 sentences with expert insight]
- ${validSpeakers[1]}: "That's really interesting. Can you elaborate on..."
- ${guestSpeaker}: [2-3 sentences elaborating]
- ${validSpeakers[0]}: "Right, that makes sense."

**PATTERN F: THREE-WAY DISCUSSION (5-7 exchanges)**
All three speakers participating after guest joins:
- ${validSpeakers[0]}: [2-3 sentences with point]
- ${guestSpeaker}: [2-3 sentences responding]
- ${validSpeakers[1]}: [1-2 sentences adding perspective]
- ${guestSpeaker}: [2 sentences clarifying]
- ${validSpeakers[0]}: "That's a good point."
- ${validSpeakers[1]}: [2 sentences building on it]` : ''}

**CRITICAL: AVOID OVERUSING "SO"**
❌ DON'T start every sentence with "so":
- "So here's the thing..."
- "So that's interesting..."
- "So what about..."
- "So let me tell you..."

✅ USE VARIED SENTENCE STARTERS:
- "Here's the thing..."
- "That's interesting..."
- "What about..."
- "Let me tell you..."
- "Actually..."
- "You know what..."
- "The thing is..."
- "Now..."
- "Look..."
- "Well..."
- "But..."
- "And..."
- Or just start directly with the main point

LIMIT "SO" USAGE: Use "so" maximum 3-4 times in the ENTIRE podcast, only when it truly fits naturally.

**HOW TO USE THESE PATTERNS:**

✅ GOOD FLOW (varied rhythm):
- Start: PATTERN B (quick intro back-and-forth between ${validSpeakers[0]} and ${validSpeakers[1]})
- Then: PATTERN A (focused explanation)
- Then: PATTERN B (quick reactions)
- Then: PATTERN C (collaborative build)
${includeGuest ? `- Then: Guest introduction (${guestSpeaker} joins)
- Then: PATTERN E (guest interaction)
- Then: PATTERN F (three-way discussion with all speakers)
- Then: PATTERN D (Q&A with guest)` : '- Then: PATTERN D (Q&A)'}
- Then: PATTERN A (another focused section)
- Then: PATTERN B (quick back-and-forth)
- End: PATTERN B (quick outro by ${validSpeakers[0]} and ${validSpeakers[1]})

❌ BAD FLOW (too much ping-pong):
- PATTERN B
- PATTERN B
- PATTERN B
- PATTERN B
(This feels exhausting and never gets deep into topics)

**LINE LENGTH GUIDELINES:**

SHORT LINES (1 sentence): Use in Pattern B (quick back-and-forth)
- "Wait, really?"
- "That's interesting."
- "No way."

MEDIUM LINES (2-3 sentences): Use in Pattern C (collaborative build)
- "Here's the thing. A lot of people think it's simple, but it's actually pretty complex."
- "Right, and that's exactly why it matters. You can't just ignore that aspect."

LONGER LINES (3-5 sentences): Use in Pattern A and D (focused explanations)${includeGuest ? ` and Pattern E/F (guest insights)` : ''}
- "Let me break this down. When you're looking at this topic, there are really three main factors to consider. The first is timing, which affects everything else. The second is consistency, because you can't just do it once. And the third is actually understanding why you're doing it in the first place."

**CRITICAL BALANCE RULE:**
${includeGuest ? `- 30% should be Pattern A or D (focused, substantial exchanges)
- 25% should be Pattern C (collaborative building)
- 20% should be Pattern E/F (guest interaction and three-way discussion)
- 25% should be Pattern B (quick back-and-forth)` : `- 40% should be Pattern A or D (focused, substantial exchanges)
- 30% should be Pattern C (collaborative building)
- 30% should be Pattern B (quick back-and-forth)`}

This creates natural rhythm: dive deep, come up for air, dive deep again.

VARIED INTROS - VERY IMPORTANT:
Mix up your intro styles. Sometimes use a welcome, sometimes jump right into the topic:

OPTION 1: Welcome first, then topic
- ${validSpeakers[0]}: "Hey, welcome back."
- ${validSpeakers[1]}: "Today we're talking about [topic]."
- ${validSpeakers[0]}: "Right. And honestly, this is something a lot of people struggle with."

OPTION 2: Jump straight into topic (rephrase what user asked)
- ${validSpeakers[0]}: "[Topic]. That's something a lot of people struggle with."
- ${validSpeakers[1]}: "Yeah, it really is. Especially when things get tough."

OPTION 3: Casual welcome with immediate topic integration
- ${validSpeakers[0]}: "Hey, good to have you back. We're diving into [topic]."
- ${validSpeakers[1]}: "Yeah. This is a big one."

NATURAL REACTIONS - USE APPROPRIATELY:

✅ SURPRISE REACTIONS (use moderately):
- "Oh wow, really?"
- "Wait, really?"
- "That's surprising"
- "No way"
- "Seriously?"
- "That's interesting"

✅ AGREEMENT/ACKNOWLEDGMENT:
- "Mhm" (use 5-8 times total as brief acknowledgment)
- "Hmm mhm" (use 5-8 times total)
- "Right"
- "Yeah"
- "For sure"
- "Exactly"

✅ TRANSITIONAL:
- "You know what..."
- "And..."
- "But here's the thing..."
- "Now..."
- "Actually..."
- "Look..."
- "Well..."
- Limit "So..." to 3-4 uses in entire podcast

LAUGHING & REACTING TO HUMOR - USE SPARINGLY:
- Use "haha" at START of sentence only 1-2 times in entire podcast
- Most of the time just say "That's funny" or "That's hilarious" without laugh sound

SPEAKERS SHOULD EXPRESS:
- ✅ Surprise: "Oh wow, really?" "Wait, really?" "That's surprising"
- ✅ Doubt: "I'm not sure..." "Maybe..." "I don't know if..."
- ✅ Realization: "Oh, I see" "That makes sense" "Got it"
- ✅ Genuine curiosity: "Why is that?" "What causes that?"

AVOID PING-PONG EXHAUSTION:
❌ DON'T do this for too long:
- ${validSpeakers[0]}: "This is interesting."
- ${validSpeakers[1]}: "Yeah."
- ${validSpeakers[0]}: "Right?"
- ${validSpeakers[1]}: "Totally."
- ${validSpeakers[0]}: "Exactly."
- ${validSpeakers[1]}: "For sure."
(This is exhausting and says nothing)

✅ DO this instead - let one speaker talk for 2-4 sentences sometimes:
- ${validSpeakers[0]}: "This is interesting. When you look at the data, what you find is that people actually approach this completely differently than you'd expect. It's not about doing more, it's about doing the right things at the right time."
- ${validSpeakers[1]}: "Mhm, that makes sense."
- ${validSpeakers[0]}: "And that's the key part most people miss."
- ${validSpeakers[1]}: "Right, what would you recommend for someone who's starting out?"

ADDRESSING THE LISTENER:
When giving advice, weave it naturally:
- "If you're dealing with this, you'd probably want to..."
- "What we'd recommend for you is..."
- "You're gonna want to..."

Structure:
${includeGuest ? `- Intro: 3-4 exchanges (Pattern B - quick back-and-forth between ${validSpeakers[0]} and ${validSpeakers[1]})
- Pre-guest discussion: 15-18 exchanges (mix of Patterns A, C, D with ${validSpeakers[0]} and ${validSpeakers[1]})
- Guest introduction: 2-3 exchanges (${validSpeakers[0]} and ${validSpeakers[1]} introduce ${guestSpeaker})
- Guest segment: 12-15 exchanges (Pattern E and F - all three speakers: ${validSpeakers[0]}, ${validSpeakers[1]}, ${guestSpeaker})
- Guest departure: 2 exchanges (thank ${guestSpeaker})
- Final discussion: 8-10 exchanges (${validSpeakers[0]} and ${validSpeakers[1]})
- Outro: 3-4 exchanges (Pattern B - ${validSpeakers[0]} and ${validSpeakers[1]} wrap up)` : `- Intro: 3-4 exchanges (Pattern B - quick back-and-forth)
- Main discussion: 28-35 exchanges
  * Use Pattern A (focused) for 40% of main body
  * Use Pattern C (collaborative) for 30% of main body
  * Use Pattern B (quick) for 30% of main body
  * ROTATE between patterns - never use same pattern more than twice in a row
- Outro: 3-4 exchanges (Pattern B - quick wrap-up)`}

INTRO STYLE (choose based on topic and time):
${timeOfDay === 'morning' ? `- Morning topics: "${greeting}. [topic]" OR "Hey. Let's talk about [topic]"` : ''}
${timeOfDay === 'afternoon' ? `- Afternoon: "Hey" OR "${greeting}" OR jump straight to topic` : ''}
${timeOfDay === 'evening' ? `- Evening: "${greeting}" OR "Hey, welcome back" OR "[topic]"` : ''}
${timeOfDay === 'night' ? `- Night: "Hey" OR "Welcome" OR jump to topic - keep concise` : ''}

Tone: ${includeGuest ? `THREE SPEAKERS (${validSpeakers[0]}, ${validSpeakers[1]} start, then ${guestSpeaker} joins as guest) having a REAL conversation with natural rhythm - quick exchanges + deep dives + expert insights.` : `TWO SPEAKERS (${validSpeakers[0]}, ${validSpeakers[1]}) having a REAL conversation with natural rhythm - quick exchanges + deep dives.`}`
              },
              {
                role: 'user',
                content: `Create podcast dialogue about: ${topic}`
              }
   ], {
  temperature: 0.7,
  max_tokens: includeGuest ? 2000 : 1500
});
   
      if (!data.choices || !data.choices[0] || !data.choices[0].message) {
        console.error('❌ Invalid API response structure');
        throw new Error('Invalid API response');
      }
      
      const content = data.choices[0].message.content;
      console.log('📝 Parsing dialogue...');
      
      const dialogue = parseDialogueJSON(content);
      
      // Validate background reactions
for (const item of dialogue) {
  if (item.background === true) {
    const wordCount = item.line.trim().split(/\s+/).length;
    if (wordCount > 3) {
      console.warn(`⚠️ Background reaction too long: "${item.line}"`);
      delete item.background;
    }
  }
}

// Count background reactions
const backgroundCount = dialogue.filter(d => d.background === true).length;
if (backgroundCount > 0) {
  console.log(`🎭 Background reactions: ${backgroundCount}`);
}
      if (!Array.isArray(dialogue) || dialogue.length === 0) {
        throw new Error('Invalid dialogue format');
      }
      
      // Validate dialogue structure and speakers
      for (const item of dialogue) {
        if (!item.speaker || !item.line || typeof item.line !== 'string') {
          throw new Error('Invalid dialogue item structure');
        }
        // Ensure only valid speakers
        if (!validSpeakers.includes(item.speaker)) {
          console.warn(`⚠️ Unexpected speaker: ${item.speaker}, converting to ${validSpeakers[0]}`);
          item.speaker = validSpeakers[0];
        }
      }
      
      console.log(`✅ Generated ${dialogue.length} dialogue exchanges${includeGuest ? ` with guest speaker (${guestSpeaker})` : ''}`);
      
      // Show guest introduction point
      if (includeGuest) {
        const guestFirstAppearance = dialogue.findIndex(d => d.speaker === guestSpeaker);
        if (guestFirstAppearance !== -1) {
          console.log(`\n🎤 GUEST INTRODUCTION:`);
          console.log(`   ${guestSpeaker} enters at exchange #${guestFirstAppearance + 1}`);
          console.log(`   Preview: "${dialogue[guestFirstAppearance].line.substring(0, 60)}..."`);
        }
        
        // Count exchanges per speaker
        const speakerCounts = {};
        dialogue.forEach(d => {
          speakerCounts[d.speaker] = (speakerCounts[d.speaker] || 0) + 1;
        });
        
        console.log(`\n📊 SPEAKER PARTICIPATION:`);
        Object.entries(speakerCounts).forEach(([speaker, count]) => {
          const percentage = ((count / dialogue.length) * 100).toFixed(1);
          console.log(`   ${speaker}: ${count} exchanges (${percentage}%)`);
        });
      }
      
      return dialogue;
      
    } catch (error) {
      lastError = error;
      console.warn(`⚠️ Attempt ${attempt + 1} failed:`, error.message);
      
      if (attempt < maxRetries - 1) {
        console.log('⏳ Waiting 1 second before retry...');
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }
  }
  
  console.error('❌ All attempts failed');
  throw new Error(`Something went wrong!`);
};

/**
 * MAIN FUNCTION: Combine audio segments into final podcast
 * 
 * @param {Array} dialogue - Array of {speaker, line} objects
 * @param {Function} updateProgress - Callback for progress updates
 * @returns {Promise<string>} - Blob URL of final podcast audio
 * 
 * PROCESS:
 * 1. Create audio context (manages all audio operations)
 * 2. Split dialogue into batches for parallel processing
 * 3. Generate intro music while processing audio
 * 4. Process each batch in parallel (up to 25 at once)
 * 5. Trim silence from all segments
 * 6. Calculate total length and create output buffer
 * 7. Copy all segments with zero gaps
 * 8. Add crossfades for smooth transitions
 * 9. Encode to WAV and return URL
 */
const combineAudioSegments = async (dialogue, updateProgress,enableIntroMusic ) => {
  console.log(`🎙️ ULTRA-FAST podcast generation: ${dialogue.length} segments`);
  const startTime = performance.now();
  
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  
  try {
    updateProgress('Generating audio...', 'generating');
    
    // OPTIMIZATION: Larger batches = faster generation (25 segments at once)
    const BATCH_SIZE = 25;
    const batches = [];
    for (let i = 0; i < dialogue.length; i += BATCH_SIZE) {
      batches.push(dialogue.slice(i, i + BATCH_SIZE));
    }
    
    console.log(`⚡ Processing ${batches.length} batches of up to ${BATCH_SIZE} segments`);
    
    // PARALLEL: Start intro music generation immediately
    // ✅ Only generate intro if enabled
    const introMusicPromise = enableIntroMusic ? (async () => {
      try {
        const { intro } = selectRandomMusic();
        return await createIntroMusicClip(intro, audioContext);
      } catch (error) {
        console.warn('⚠️ Intro music failed, continuing without it');
        return null;
      }
    })() : Promise.resolve(null); // ✅ Return null if disabled
    
    
    // AGGRESSIVE PARALLEL PROCESSING: Generate all segments as fast as possible
    const allSegmentResults = [];
    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];
      const batchStartIndex = batchIndex * BATCH_SIZE;
      
      console.log(`⚡ Batch ${batchIndex + 1}/${batches.length}`);
      updateProgress(`Generating (${batchIndex + 1}/${batches.length})...`, 'generating');
      
      // Fire off all requests simultaneously - don't wait between them
      const batchResults = await Promise.all(
        batch.map((segment, indexInBatch) => {
          const globalIndex = batchStartIndex + indexInBatch;
          return generateAudioSegment(segment.speaker, segment.line)
            .then(blob => ({ index: globalIndex, blob, success: true }))
            .catch(error => {
              console.error(`❌ Segment ${globalIndex} failed:`, error.message);
              return { index: globalIndex, blob: null, success: false };
            });
        })
      );
      
      allSegmentResults.push(...batchResults);
    }
    
    const introMusicBuffer = await introMusicPromise;
    
    const validResults = allSegmentResults
      .filter(r => r.success && r.blob)
      .sort((a, b) => a.index - b.index);
    
    console.log(`✅ Generated ${validResults.length}/${dialogue.length} segments in ${Math.round(performance.now() - startTime)}ms`);
    
    if (validResults.length === 0) {
      throw new Error('No audio segments generated');
    }
    
    updateProgress('Processing audio...', 'finalizing');
    
    // PARALLEL: Convert all blobs to buffers at once
    const dialogueBuffers = await Promise.all(
      validResults.map(result => blobToAudioBuffer(result.blob, audioContext))
    );
    
    // CRITICAL: Trim silence from each segment to remove 2-3 second gaps
    console.log('✂️ Trimming silence from all segments...');
    const trimmedBuffers = dialogueBuffers.map(buffer => trimSilence(buffer, audioContext));
    
    // Calculate final length after trimming
    const introLength = introMusicBuffer?.length || 0;
    const dialogueLength = trimmedBuffers.reduce((sum, buf) => sum + buf.length, 0);
    const totalLength = introLength + dialogueLength;
    
    const sampleRate = audioContext.sampleRate;
    const numberOfChannels = 2;
    
    console.log(`🎵 Creating seamless ${(totalLength / sampleRate).toFixed(2)}s podcast`);
    
    const finalBuffer = audioContext.createBuffer(numberOfChannels, totalLength, sampleRate);
    
    let offset = 0;
    
    // Add intro music with fade-out
    if (introMusicBuffer) {
      copyBufferToOutput(introMusicBuffer, finalBuffer, offset);
      offset += introMusicBuffer.length;
      console.log(`✅ Added intro: ${(introMusicBuffer.length / sampleRate).toFixed(2)}s`);
    }
    
    // Add fade-in to dialogue start (smooth transition from intro)
    const fadeInSamples = Math.floor(0.1 * sampleRate); // 100ms fade-in
    
    // Copy all trimmed dialogue segments with zero gaps
    for (let i = 0; i < trimmedBuffers.length; i++) {
      const buffer = trimmedBuffers[i];
      copyBufferToOutput(buffer, finalBuffer, offset);
      
      // Apply fade-in only to very first dialogue segment
      if (i === 0 && introMusicBuffer) {
        applyFadeIn(finalBuffer, offset, fadeInSamples);
      }
      
      offset += buffer.length;
    }
    
    console.log(`✅ Combined ${trimmedBuffers.length} segments seamlessly (no gaps)`);
    
    updateProgress('Finalizing...', 'finalizing');
    const finalBlob = audioBufferToWavBlob(finalBuffer);
    const url = URL.createObjectURL(finalBlob);
    
    const totalTime = Math.round(performance.now() - startTime);
    const duration = (totalLength / sampleRate).toFixed(2);
    console.log(`🎉 DONE in ${(totalTime/1000).toFixed(1)}s | Duration: ${duration}s`);
    
    return url;
    
  } catch (error) {
    console.error('❌ Fatal error:', error);
    throw error;
  } finally {
    if (audioContext.state !== 'closed') {
      await audioContext.close();
    }
  }
};
/**
 * Generate audio for a single line using Hume AI
 */
const generateAudioForLine = async (speaker, text) => {
  if (!text || !speaker) {
    throw new Error('Missing speaker or text');
  }

  try {
    // Map speaker to voice config
    const voiceConfigs = {
      "Host 1": { id: "33045fd9-8010-43f6-b6b0-da3fbf326c29" },
      "Host 2": { id: "41745808-6790-4be4-83db-363e20db7e71" },
      "Host 3": { id: "43e411b3-b2cc-40da-b742-4abf0e3557b2" },
      "Host 4": { id: "01854384-4e4e-48d4-90d1-b22f760a58b5" }
    };

    const voiceConfig = voiceConfigs[speaker] || voiceConfigs["Host 1"];
    
    const response = await fetch('https://api.hume.ai/v0/tts', {
      method: 'POST',
      headers: {
        'X-Hume-Api-Key': process.env.REACT_APP_HUME_API_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        utterances: [
          {
            text: text,
            voice: voiceConfig,
            speed: 1.0
          }
        ],
        format: { type: 'mp3' }
      })
    });

    if (!response.ok) {
      throw new Error(`Hume API error: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.generations || data.generations.length === 0) {
      throw new Error('No audio data from Hume');
    }

    // Decode base64 to blob
    const audioBase64 = data.generations[0].audio;
    const binaryString = atob(audioBase64);
    const bytes = new Uint8Array(binaryString.length);
    
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: 'audio/mpeg' });

  } catch (error) {
    console.error(`❌ Audio generation failed for ${speaker}:`, error);
    throw error;
  }
};
/**
 * Convert AudioBuffer to WAV blob
 */
const audioBufferToWavBlob = (audioBuffer) => {
  const numberOfChannels = audioBuffer.numberOfChannels;
  const sampleRate = audioBuffer.sampleRate;
  const length = audioBuffer.length;

  // Interleave channels
  const interleaved = new Float32Array(length * numberOfChannels);
  for (let i = 0; i < length; i++) {
    for (let channel = 0; channel < numberOfChannels; channel++) {
      interleaved[i * numberOfChannels + channel] = 
        audioBuffer.getChannelData(channel)[i];
    }
  }

  // Convert to 16-bit PCM
  const pcmData = new Int16Array(interleaved.length);
  for (let i = 0; i < interleaved.length; i++) {
    const sample = Math.max(-1, Math.min(1, interleaved[i]));
    pcmData[i] = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
  }

  // Create WAV file
  const wavBuffer = new ArrayBuffer(44 + pcmData.length * 2);
  const view = new DataView(wavBuffer);

  const writeString = (offset, string) => {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  };

  // WAV header
  writeString(0, 'RIFF');
  view.setUint32(4, 36 + pcmData.length * 2, true);
  writeString(8, 'WAVE');
  writeString(12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numberOfChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numberOfChannels * 2, true);
  view.setUint16(32, numberOfChannels * 2, true);
  view.setUint16(34, 16, true);
  writeString(36, 'data');
  view.setUint32(40, pcmData.length * 2, true);

  const dataView = new Int16Array(wavBuffer, 44);
  dataView.set(pcmData);

  return new Blob([wavBuffer], { type: 'audio/wav' });
};
// ============================================
// STUDY HUB INTEGRATION - Quiz & Flashcards
// ============================================

const handleFlashcardGeneration = async (toolCallId, args, messageHistory) => {
  console.log('📚 Flashcard generation requested:', args);
  
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: `Creating ${args.count || 8} flashcards about "${args.topic}"...`,
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // Generate flashcards using Azure
    const systemPrompt = `Generate ${args.count || 8} educational flashcards about "${args.topic}".

Return ONLY valid JSON in this exact format:
{
  "title": "Topic Name",
  "description": "Brief description",
  "difficulty": "${args.difficulty || 'medium'}",
  "flashcards": [
    {
      "id": "f1",
      "question": "Question or term",
      "answer": "Answer or definition"
    }
  ]
}`;

const data = await SecureAPI.callAzureOpenAI([
  { role: 'system', content: systemPrompt },
  { role: 'user', content: `Create flashcards about: ${args.topic}` }
], {
  temperature: 0.7,
  max_tokens: 2000,
  response_format: { type: "json_object" }  // ✅ JSON mode supported
});
    const flashcardData = JSON.parse(data.choices[0].message.content);
    
    console.log('✅ Flashcards generated:', flashcardData);
    
    // Prepare data for Study Hub
    const studyHubData = {
      type: 'flashcard',
      id: `flashcards_${Date.now()}`,
      title: flashcardData.title || args.topic,
      description: flashcardData.description || 'AI-generated flashcards',
      difficulty: args.difficulty || 'medium',
      flashcards: flashcardData.flashcards,
      isCustom: true,
      createdAt: new Date().toISOString(),
      autoStart: true
    };
    
    // Save to Firestore if available
    if (firestoreService?.isReady()) {
      try {
        await firestoreService.saveCustomFlashcards(studyHubData);
        console.log('✅ Flashcards saved to Firestore');
      } catch (error) {
        console.error('⚠️ Firestore save failed:', error);
        // Continue anyway - local state will work
      }
    }
    
    // Remove loading message
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    
    // Add success message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Created ${studyHubData.flashcards.length} flashcards about "${studyHubData.title}"! Opening Study Hub...`,
      timestamp: new Date().toISOString()
    }]);
    
    // Send tool result to Azure
    try {
      await sendToolResult(
        messageHistory,
        toolCallId,
        'generate_flashcards',
        args,
        {
          success: true,
          count: studyHubData.flashcards.length,
          title: studyHubData.title
        }
      );
    } catch (azureError) {
      console.error('Failed to send result to Azure:', azureError);
      // Not critical - continue
    }
    
    // ✅ PASS DATA TO STUDY HUB AND SWITCH MODE
    setAutoStartStudyContent(studyHubData);
    setCurrentMode('study');
    
  } catch (error) {
    console.error('❌ Flashcard generation error:', error);
    
    // Remove loading message
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    
    // Show error message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Sorry, I had trouble creating flashcards. ${error.message}`,
      timestamp: new Date().toISOString()
    }]);
  }
};

const handleQuizGeneration = async (toolCallId, args, messageHistory) => {
  console.log('📝 Quiz generation requested:', args);
  
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: `Creating a ${args.count || 5}-question quiz about "${args.topic}"...`,
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // Generate quiz using Azure
    const systemPrompt = `Generate a quiz with ${args.count || 5} questions about "${args.topic}".
Mix of multiple choice and true/false questions.

CRITICAL: For true/false questions, correctAnswer MUST be "true" or "false" (lowercase).

Return ONLY valid JSON:
{
  "title": "Quiz Title",
  "description": "Brief description",
  "difficulty": "${args.difficulty || 'medium'}",
  "questions": [
    {
      "id": "q1",
      "type": "multiple_choice",
      "question": "Question text?",
      "options": ["A", "B", "C", "D"],
      "correctAnswer": "A",
      "explanation": "Why this is correct"
    },
    {
      "id": "q2",
      "type": "true_false",
      "question": "True or false question?",
      "correctAnswer": "true",
      "explanation": "Explanation"
    }
  ]
}`;

  const data = await SecureAPI.callAzureOpenAI([
  { role: 'system', content: systemPrompt },
  { role: 'user', content: `Create flashcards about: ${args.topic}` }
], {
  temperature: 0.7,
  max_tokens: 2000,
  response_format: { type: "json_object" }  // ✅ Still works!
});
    const quizData = JSON.parse(data.choices[0].message.content);
    
    console.log('✅ Quiz generated:', quizData);
    
    // Normalize true/false answers
    quizData.questions.forEach(q => {
      if (q.type === 'true_false') {
        q.correctAnswer = q.correctAnswer.toString().toLowerCase();
      }
    });
    
    // Prepare data for Study Hub
    const studyHubData = {
      type: 'quiz',
      id: `quiz_${Date.now()}`,
      title: quizData.title || args.topic,
      description: quizData.description || 'AI-generated quiz',
      difficulty: args.difficulty || 'medium',
      questions: quizData.questions,
      isCustom: true,
      createdAt: new Date().toISOString(),
      autoStart: true
    };
    
    // Save to Firestore if available
    if (firestoreService?.isReady()) {
      try {
        await firestoreService.saveCustomQuiz(studyHubData);
        console.log('✅ Quiz saved to Firestore');
      } catch (error) {
        console.error('⚠️ Firestore save failed:', error);
        // Continue anyway
      }
    }
    
    // Remove loading message
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    
    // Add success message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Created a ${studyHubData.questions.length}-question quiz about "${studyHubData.title}"! Opening Study Hub...`,
      timestamp: new Date().toISOString()
    }]);
    
    // Send tool result to Azure
    try {
      await sendToolResult(
        messageHistory,
        toolCallId,
        'generate_quiz',
        args,
        {
          success: true,
          count: studyHubData.questions.length,
          title: studyHubData.title
        }
      );
    } catch (azureError) {
      console.error('Failed to send result to Azure:', azureError);
      // Not critical
    }
    
    // ✅ PASS DATA TO STUDY HUB AND SWITCH MODE
    setAutoStartStudyContent(studyHubData);
    setCurrentMode('study');
    
  } catch (error) {
    console.error('❌ Quiz generation error:', error);
    
    // Remove loading message
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    
    // Show error message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Sorry, I had trouble creating the quiz. ${error.message}`,
      timestamp: new Date().toISOString()
    }]);
  }
};
/**
 * SILENCE TRIMMER: Remove leading and trailing silence from audio buffer
 * 
 * WHY: API-generated audio often has 0.5-2 seconds of silence at start/end
 * This creates awkward gaps between speakers. Trimming fixes this.
 * 
 * @param {AudioBuffer} buffer - Input audio buffer
 * @param {AudioContext} audioContext - Audio context for buffer creation
 * @returns {AudioBuffer} - Trimmed buffer with silence removed
 * 
 * ALGORITHM:
 * 1. Set silence threshold (0.01 = 1% of max volume)
 * 2. Find first sample above threshold (start point)
 * 3. Find last sample above threshold (end point)
 * 4. Create new buffer with only audio between start and end
 * 5. Keep minimum 50ms padding to avoid cuts
 */
const trimSilence = (buffer, audioContext) => {
  const threshold = 0.01; // 1% volume threshold
  const sampleRate = buffer.sampleRate;
  const channels = buffer.numberOfChannels;
  
  // Find first non-silent sample
  let start = 0;
  const channel0 = buffer.getChannelData(0);
  for (let i = 0; i < channel0.length; i++) {
    if (Math.abs(channel0[i]) > threshold) {
      start = Math.max(0, i - Math.floor(0.05 * sampleRate)); // Keep 50ms padding
      break;
    }
  }
  
  // Find last non-silent sample
  let end = channel0.length;
  for (let i = channel0.length - 1; i >= start; i--) {
    if (Math.abs(channel0[i]) > threshold) {
      end = Math.min(channel0.length, i + Math.floor(0.05 * sampleRate)); // Keep 50ms padding
      break;
    }
  }
  
  // Create trimmed buffer
  const trimmedLength = end - start;
  if (trimmedLength <= 0) return buffer; // No trimming needed
  
  const trimmedBuffer = audioContext.createBuffer(channels, trimmedLength, sampleRate);
  
  for (let ch = 0; ch < channels; ch++) {
    const sourceData = buffer.getChannelData(ch);
    const targetData = trimmedBuffer.getChannelData(ch);
    targetData.set(sourceData.slice(start, end));
  }
  
  const originalDuration = (buffer.length / sampleRate).toFixed(3);
  const trimmedDuration = (trimmedLength / sampleRate).toFixed(3);
  const saved = (originalDuration - trimmedDuration).toFixed(3);
  
  if (saved > 0.1) {
    console.log(`✂️ Trimmed ${saved}s silence (${originalDuration}s → ${trimmedDuration}s)`);
  }
  
  return trimmedBuffer;
};

/**
 * FADE-IN: Apply smooth fade-in to prevent audio pops
 * 
 * @param {AudioBuffer} buffer - Buffer to modify
 * @param {number} offset - Start position in buffer
 * @param {number} fadeInSamples - Number of samples to fade over
 */
const applyFadeIn = (buffer, offset, fadeInSamples) => {
  for (let ch = 0; ch < buffer.numberOfChannels; ch++) {
    const data = buffer.getChannelData(ch);
    for (let i = 0; i < fadeInSamples && (offset + i) < data.length; i++) {
      const gain = i / fadeInSamples; // Linear fade 0 to 1
      data[offset + i] *= gain;
    }
  }
};

/**
 * BUFFER COPY: Copy audio buffer to output with zero gaps
 * 
 * HOW IT WORKS:
 * - Uses typed array .set() for maximum speed
 * - Handles mono-to-stereo conversion automatically
 * - No loops for individual samples = much faster
 * - Direct memory copy = zero gaps guaranteed
 * 
 * @param {AudioBuffer} sourceBuffer - Source audio
 * @param {AudioBuffer} targetBuffer - Destination buffer
 * @param {number} offset - Position to write at
 */


/**
 * AUDIO GENERATION: Generate speech audio for one line
 * 
 * API: Hume.ai TTS (Text-to-Speech)
 * Speed: Guest = 1.0x (clear), Hosts = 1.05x (energetic)
 * 
 * @param {string} speaker - Speaker name (Host 1, Host 2, etc.)
 * @param {string} text - Text to speak
 * @returns {Promise<Blob>} - MP3 audio blob
 */


/**
 * INTRO MUSIC: Create 3-second intro with fade-out
 * 
 * TIMING:
 * - 0.0s - 0.15s: Full volume (25%)
 * - 0.15s - 3.0s: Fade out to silence
 * 
 * CURVE: Quadratic easing for natural sound
 */
const createIntroMusicClip = async (musicUrl, audioContext) => {
  try {
    const response = await fetch(musicUrl);
    if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
    
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    
    const clipDuration = 3;
    const fadeOutStart = 0.15;
    const fadeOutDuration = 2.85;
    const sampleRate = audioBuffer.sampleRate;
    const clipSamples = clipDuration * sampleRate;
    
    const clipBuffer = audioContext.createBuffer(
      audioBuffer.numberOfChannels,
      clipSamples,
      sampleRate
    );
    
    for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
      const sourceData = audioBuffer.getChannelData(channel);
      const targetData = clipBuffer.getChannelData(channel);
      
      for (let i = 0; i < clipSamples && i < sourceData.length; i++) {
        const timeInSeconds = i / sampleRate;
        let gain = 0.25; // 25% volume
        
        if (timeInSeconds > fadeOutStart) {
          const fadeProgress = (timeInSeconds - fadeOutStart) / fadeOutDuration;
          const easedProgress = fadeProgress * fadeProgress; // Quadratic
          gain = 0.25 * (1 - Math.min(easedProgress, 1));
        }
        
        targetData[i] = sourceData[i] * gain;
      }
    }
    
    console.log(`✅ Intro music: ${clipDuration}s`);
    return clipBuffer;
    
  } catch (error) {
    console.error('❌ Intro music failed:', error);
    return null;
  }
};

/**
 * BLOB TO BUFFER: Convert audio blob to AudioBuffer
 */
const blobToAudioBuffer = async (blob, audioContext) => {
  try {
    const arrayBuffer = await blob.arrayBuffer();
    return await audioContext.decodeAudioData(arrayBuffer);
  } catch (error) {
    console.error('❌ Decode failed:', error);
    throw error;
  }
};

/**
 * WAV ENCODER: Convert AudioBuffer to WAV file blob
 * 
 * FORMAT: 16-bit PCM WAV (standard quality)
 * WHY WAV: Universal compatibility, no compression loss
 * 
 * STRUCTURE:
 * - 44 bytes: WAV header
 * - Remaining: 16-bit PCM audio data
 */


/**
 * Copy audio buffer to output buffer at specified offset
 * Handles mono-to-stereo and stereo-to-stereo conversions
 */
const copyBufferToOutput = (sourceBuffer, targetBuffer, offset) => {
  const targetChannels = targetBuffer.numberOfChannels;
  const sourceChannels = sourceBuffer.numberOfChannels;
  
  for (let ch = 0; ch < targetChannels; ch++) {
    // If source is mono, duplicate to both stereo channels
    const sourceCh = Math.min(ch, sourceChannels - 1);
    const sourceData = sourceBuffer.getChannelData(sourceCh);
    const targetData = targetBuffer.getChannelData(ch);
    
    // Direct memory copy - fastest method, no gaps
    targetData.set(sourceData, offset);
  }
};

/**
 * Generate audio for a single dialogue line with intelligent speed adjustment
 */
const generateAudioSegment = async (speaker, text) => {
  const config = voiceConfigs[speaker];
  
  if (!config) {
    throw new Error(`No voice config found for speaker: ${speaker}`);
  }
  
  // Intelligent speed based on speaker role
  // Guest speakers: normal speed (1.0) for clarity
  // Host speakers: slightly faster (1.15) for energy
  const isGuest = speaker === "Host 3" || speaker === "Host 4";
  const audioSpeed = isGuest ? 1.0 : 1.15;
  
  try {
    console.log(`🎙️ Generating audio for ${speaker}:`, {
      textLength: text.length,
      speed: audioSpeed,
      voiceId: config.voice.id
    });
    
    // ✅ SECURE: Use SecureAPI instead of direct API call
    const audioBlob = await SecureAPI.callHumeTTS(
      text,
      config.voice.id,
      audioSpeed
    );
    
    console.log(`✅ Audio generated successfully for ${speaker}`);
    return audioBlob;
    
  } catch (error) {
    console.error(`❌ Audio generation failed for ${speaker}:`, error.message);
    throw error;
  }
};

/**
 * Step 3: Select random intro/outro music (never same for both)
 */
const selectRandomMusic = () => {
  const shuffled = [...PODCAST_MUSIC_URLS].sort(() => Math.random() - 0.5);
  return {
    intro: shuffled[0],
    outro: shuffled[1] // Guaranteed different from intro
  };
};
/**
 * Determine which hosts start and who becomes the guest
 * @param {Array<string>} startingHosts - Array of 2 hosts that start (e.g., ["Host 1", "Host 2"])
 * @returns {Object} Configuration with starting hosts and guest speaker
 */
// Smart JSON parser with automatic error recovery
const parseDialogueJSON = (text) => {
  // Step 1: Remove markdown code blocks
  let cleaned = text.trim()
    .replace(/```json\s*/gi, '')
    .replace(/```\s*/g, '');
  
  // Step 2: Try parsing as-is first (cleanest approach)
  try {
    const parsed = JSON.parse(cleaned);
    if (Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    console.log('Direct parse failed, attempting recovery...');
  }
  
  // Step 3: Extract JSON array if wrapped in text
  const arrayMatch = cleaned.match(/\[[\s\S]*\]/);
  if (arrayMatch) {
    try {
      return JSON.parse(arrayMatch[0]);
    } catch (e) {
      console.log('Array extraction parse failed, attempting cleanup...');
      cleaned = arrayMatch[0];
    }
  }
  
  // Step 4: Gentle cleanup (only if above failed)
  cleaned = cleaned
    // Remove trailing commas before closing brackets
    .replace(/,(\s*[}\]])/g, '$1')
    // Fix missing commas between objects
    .replace(/}(\s*){/g, '},$1{')
    // Normalize whitespace (but preserve spaces in strings)
    .replace(/\s+(?=(?:[^"]*"[^"]*")*[^"]*$)/g, ' ');
  
  // Step 5: Final parse attempt
  try {
    return JSON.parse(cleaned);
  } catch (e) {
    throw new Error(`Cannot parse JSON after cleanup: ${e.message}\n\nReceived: ${text.substring(0, 200)}...`);
  }
};
/**
 * Generate podcast dialogue with 4 hosts (2 start, 1 guest joins)
 */
const determineGuestSpeaker = (startingHosts) => {
  // All possible host combinations (2 starting hosts, 1 guest)
  const allCombinations = [
    { startingHosts: ["Host 1", "Host 2"], guestSpeaker: "Host 3" },
    { startingHosts: ["Host 1", "Host 2"], guestSpeaker: "Host 4" },
    { startingHosts: ["Host 1", "Host 3"], guestSpeaker: "Host 2" },
    { startingHosts: ["Host 1", "Host 3"], guestSpeaker: "Host 4" },
    { startingHosts: ["Host 1", "Host 4"], guestSpeaker: "Host 2" },
    { startingHosts: ["Host 1", "Host 4"], guestSpeaker: "Host 3" },
    { startingHosts: ["Host 2", "Host 3"], guestSpeaker: "Host 1" },
    { startingHosts: ["Host 2", "Host 3"], guestSpeaker: "Host 4" },
    { startingHosts: ["Host 2", "Host 4"], guestSpeaker: "Host 1" },
    { startingHosts: ["Host 2", "Host 4"], guestSpeaker: "Host 3" },
    { startingHosts: ["Host 3", "Host 4"], guestSpeaker: "Host 1" },
    { startingHosts: ["Host 3", "Host 4"], guestSpeaker: "Host 2" }
  ];
  
  // Get or initialize rotation index from in-memory storage
  if (!window.podcastHostRotation) {
    window.podcastHostRotation = 0;
  }
  
  // Get the current combination
  const currentCombination = allCombinations[window.podcastHostRotation % allCombinations.length];
  
  // Increment for next time
  window.podcastHostRotation = (window.podcastHostRotation + 1) % allCombinations.length;
  
  console.log(`🎭 Host Rotation #${window.podcastHostRotation}:`);
  console.log(`   Starting hosts: ${currentCombination.startingHosts.join(' & ')}`);
  console.log(`   Guest speaker: ${currentCombination.guestSpeaker}`);
  
  return currentCombination;
};

/**
 * Get current time of day for podcast context
 */
const getTimeOfDay = () => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
};

/**
 * Get greeting based on time of day
 */
const getTimeGreeting = () => {
  const timeOfDay = getTimeOfDay();
  
  switch (timeOfDay) {
    case 'morning': return 'Good morning';
    case 'afternoon': return 'Good afternoon';
    case 'evening': return 'Good evening';
    case 'night': return 'Good evening';
    default: return 'Hey';
  }
};

/**
 * Get current date information for podcast
 */
const getCurrentDateInfo = () => {
  const now = new Date();
  return {
    dayOfWeek: now.toLocaleDateString('en-US', { weekday: 'long' }),
    month: now.toLocaleDateString('en-US', { month: 'long' }),
    day: now.getDate(),
    year: now.getFullYear(),
    formatted: now.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    })
  };
};

const noteAnimationStyles = `
@keyframes waveAnim1 {
  0%, 100% { height: 20%; }
  50% { height: 100%; }
}

@keyframes waveAnim2 {
  0%, 100% { height: 40%; }
  50% { height: 80%; }
}

@keyframes waveAnim3 {
  0%, 100% { height: 60%; }
  50% { height: 100%; }
}

@keyframes waveAnim4 {
  0%, 100% { height: 40%; }
  50% { height: 90%; }
}

@keyframes waveAnim5 {
  0%, 100% { height: 30%; }
  50% { height: 70%; }
}
`;
useEffect(() => {
  const styleId = 'note-wave-animations';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = noteAnimationStyles;
    document.head.appendChild(style);
  }
}, []);

  // Tools
  const [availableTools, setAvailableTools] = useState([
    { 
      id: 'journal', 
      name: 'Journal', 
      visible: true,
      svg: (
                  <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.83892 12.4543s1.24988-3.08822-.21626-5.29004C8.15656 4.96245 4.58671 4.10885 4.39794 4.2436c-.18877.13476-1.11807 3.32546.34803 5.52727 1.4661 2.20183 5.09295 2.68343 5.09295 2.68343Zm0 0C10.3389 13.4543 12 15 12 18v2c0-2-.4304-3.4188 2.0696-5.9188m0 0s-.4894-2.7888 1.1206-4.35788c1.6101-1.56907 4.4903-1.54682 4.6701-1.28428.1798.26254.4317 2.84376-1.0809 4.31786-1.61 1.5691-4.7098 1.3243-4.7098 1.3243Z"/>
                  </svg>
      )
    },
    {
      id: 'podcast',
      name: 'Daily podcast',
      visible: true,
      svg: <Radio size={16} />
    },
        {
      id: 'planner',
      name: 'Smart Planner',
      visible: true,
      svg: (
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m10.827 5.465-.435-2.324m.435 2.324a5.338 5.338 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.338 5.338 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5-6.818 1.277Z"/>
        </svg>
      )
    },
    {
      id: 'study',
      name: 'Study tool',
      visible: true,
      svg: (
        <svg width="21" height="21" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 11H4m15.5 5a.5.5 0 0 0 .5-.5V8a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44l-1.436-2.12a1 1 0 0 0-.828-.44H8a1 1 0 0 0-1 1M4 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44L9.985 8.44A1 1 0 0 0 9.157 8H5a1 1 0 0 0-1 1Z"/>
        </svg>
      )
    },
  ]);

/**
 * Use LLM to intelligently determine if content should be checkable
 * @param {string} messageContent - The AI's response text
 * @param {string} userPrompt - What the user asked for
 * @returns {Promise<Object>} - { isCheckable, listType, reasoning }
 */
/**
 * Static smart list type analyzer - no LLM calls
 */
const analyzeListType = (messageContent, userPrompt) => {
  // Quick pattern check first
  const hasListItems = messageContent.match(/^[-*○●]\s+.+$/m) || 
                      messageContent.match(/^\d+\.\s+.+$/m);
  
  if (!hasListItems) {
    return { isCheckable: false, listType: 'none', reasoning: 'No list detected' };
  }

  // Checkable list indicators (strong signals)
  const checkablePatterns = {
    strong: [
      /\b(grocery|groceries|shopping|shop for|buy)\b/i,
      /\b(todo|to-do|task|checklist)\b/i,
      /\b(workout|exercise|training|routine)\b/i,
      /\b(pack|packing|bring)\b/i,
      /\b(ingredient|recipe|cook|bake)\b/i,
      /\b(clean|cleaning|chore)\b/i,
      /\b(prepare|preparation|prep)\b/i,
      /\b(step|steps|instruction|guide)\s+(to|for)\s+(make|do|complete|build|create)\b/i
    ],
    moderate: [
      /\b(need to|have to|must|should)\b/i,
      /\b(daily|weekly|routine)\b/i,
      /\b(schedule|agenda|plan)\b/i,
      /\b(complete|finish|done)\b/i
    ]
  };

  // Non-checkable indicators (informational)
  const nonCheckablePatterns = {
    strong: [
      /\b(recommend|recommendation|suggestion|suggest)\b/i,
      /\b(benefit|advantage|pro|con|reason|why)\b/i,
      /\b(example|instance|such as)\b/i,
      /\b(movie|film|book|song|music|show|watch|read|listen)\b/i,
      /\b(fact|information|about|explain|description)\b/i,
      /\b(type|kind|category|list of)\b/i,
      /\b(history|historical|timeline|event)\b/i,
      /\b(comparison|compare|versus|vs|difference)\b/i,
      /\b(feature|capability|option|include)\b/i
    ]
  };

  // Action verbs that indicate tasks
  const actionVerbs = [
    /\b(add|buy|get|purchase|order)\b/i,
    /\b(call|contact|email|message|reach)\b/i,
    /\b(check|verify|confirm|review)\b/i,
    /\b(prepare|make|create|build|assemble)\b/i,
    /\b(clean|wash|organize|sort)\b/i,
    /\b(pack|bring|take|carry)\b/i,
    /\b(schedule|book|reserve|arrange)\b/i
  ];

  const combined = (userPrompt + ' ' + messageContent).toLowerCase();

  // Score calculation
  let checkableScore = 0;
  let nonCheckableScore = 0;

  // Check strong checkable patterns (3 points each)
  checkablePatterns.strong.forEach(pattern => {
    if (pattern.test(combined)) checkableScore += 3;
  });

  // Check moderate checkable patterns (1 point each)
  checkablePatterns.moderate.forEach(pattern => {
    if (pattern.test(combined)) checkableScore += 1;
  });

  // Check action verbs (2 points each)
  actionVerbs.forEach(pattern => {
    if (pattern.test(combined)) checkableScore += 2;
  });

  // Check non-checkable patterns (3 points each)
  nonCheckablePatterns.strong.forEach(pattern => {
    if (pattern.test(combined)) nonCheckableScore += 3;
  });

  // Check for numbered lists with explanatory content
  const hasNumberedList = messageContent.match(/^\d+\.\s+/m);
  const hasLongItems = messageContent.match(/^\d+\.\s+.{80,}$/m);
  if (hasNumberedList && hasLongItems) {
    nonCheckableScore += 2; // Long explanatory items are likely informational
  }

  // Check for list item patterns
  const listItems = messageContent.match(/^[-*○●]\s+.+$/gm) || 
                   messageContent.match(/^\d+\.\s+.+$/gm) || [];
  
  // If items contain action verbs at the start, boost checkable score
  const itemsWithActionStart = listItems.filter(item => {
    const itemText = item.replace(/^[-*○●\d.]\s+/, '').toLowerCase();
    return actionVerbs.some(verb => itemText.match(new RegExp(`^${verb.source.slice(3, -4)}`)));
  }).length;
  
  if (itemsWithActionStart > listItems.length * 0.5) {
    checkableScore += 3; // More than half start with action verbs
  }

  // Determine result
  console.log('📊 Static Analysis - Checkable:', checkableScore, 'Non-checkable:', nonCheckableScore);

  const isCheckable = checkableScore > nonCheckableScore && checkableScore >= 3;
  const confidence = Math.abs(checkableScore - nonCheckableScore) / Math.max(checkableScore, nonCheckableScore, 1);

  return {
    isCheckable,
    listType: isCheckable ? 'checkbox' : (hasNumberedList ? 'numbered' : 'bullet'),
    confidence,
    reasoning: isCheckable 
      ? `Detected actionable list (score: ${checkableScore} vs ${nonCheckableScore})`
      : `Informational content (score: ${checkableScore} vs ${nonCheckableScore})`
  };
};


/**
 * Detect if content should be rendered as a table
 */
const detectTableContent = (text) => {
  const hasTableSyntax = text.includes('|') && text.includes('---');
  return hasTableSyntax;
};

/**
 * Parse markdown table into structured data
 */
const parseMarkdownTable = (text) => {
  const lines = text.trim().split('\n').filter(line => line.trim().length > 0);
  if (lines.length < 3) return null;
  
  const headerLine = lines[0];
  const headers = headerLine
    .split('|')
    .map(h => h.trim())
    .filter(h => h.length > 0 && !h.match(/^-+$/));
  
  if (headers.length === 0) return null;
  
  let dataStartIndex = 1;
  for (let i = 1; i < lines.length; i++) {
    if (lines[i].includes('---') || lines[i].match(/^\|[\s-|]+\|$/)) {
      dataStartIndex = i + 1;
      break;
    }
  }
  
  const rows = [];
  for (let i = dataStartIndex; i < lines.length; i++) {
    const line = lines[i];
    
    if (line.includes('---') || line.match(/^[-\s|]+$/)) {
      continue;
    }
    
    const cells = line
      .split('|')
      .map(c => c.trim())
      .filter(c => c.length > 0 && !c.match(/^-+$/));
    
    if (cells.length > 0 && cells.some(cell => cell.length > 0)) {
      rows.push(cells);
    }
  }
  
  if (rows.length === 0) return null;
  
  return { headers, rows };
};

/**
 * Smart Message Renderer Component - Static Detection
 */
const SmartMessageContent = ({ text, searchResults = null, userPrompt = '' }) => {
  const [listAnalysis, setListAnalysis] = React.useState(null);

  // Run static analysis once when component mounts or text changes
  React.useEffect(() => {
    const hasLists = text.match(/^[-*○●]\s+.+$/m) || text.match(/^\d+\.\s+.+$/m);
    
    if (hasLists && !listAnalysis) {
      // Static analysis - instant, no async needed
      const analysis = analyzeListType(text, userPrompt || '');
      setListAnalysis(analysis);
      console.log('📋 Static list analysis:', analysis);
    }
  }, [text, userPrompt, listAnalysis]);

  if (!text) return null;

  // Check for table and SPLIT content
  if (detectTableContent(text)) {
    const tableData = parseMarkdownTable(text);
    
    if (tableData) {
      const lines = text.split('\n');
      const tableStartIndex = lines.findIndex(line => line.includes('|'));
      const beforeTable = lines.slice(0, tableStartIndex).join('\n').trim();
      
      return (
        <>
          {beforeTable && (
            <div style={{ 
              marginBottom: '0.75rem',
              maxWidth: '100%',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              lineHeight: '1.6'
            }}>
              {beforeTable}
            </div>
          )}
          
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  {tableData.headers.map((header, idx) => (
                    <th key={idx}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.rows.map((row, rowIdx) => (
                  <tr key={rowIdx}>
                    {row.map((cell, cellIdx) => (
                      <td key={cellIdx}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      );
    }
  }

  // Process lists, headers, etc.
  const parts = text.split(/(\*\*.*?\*\*|\n|https?:\/\/[^\s]+)/g);
  
  let isInList = false;
  let listType = null;
  let listItems = [];
  let consecutiveNewlines = 0;
  
  const elements = [];
  let key = 0;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (!part) continue;
    
    // Track consecutive newlines to detect list end
    if (part === '\n') {
      consecutiveNewlines++;
    } else if (part.match(/^(?:\d+\.|\-|\*|[○●])\s/)) {
      consecutiveNewlines = 0; // Reset on list item
    }

    // Handle headers
    if (part.match(/^#{1,3}\s+/)) {
      const level = part.match(/^(#{1,3})/)[1].length;
      const headerText = part.replace(/^#{1,3}\s+/, '');
      const Tag = `h${level}`;
      elements.push(
        <Tag key={key++} style={{ marginTop: i > 0 ? '1rem' : 0 }}>
          {headerText}
        </Tag>
      );
      continue;
    }

    // Detect list start
    if (part.match(/^\d+\.\s/) && !isInList) {
      isInList = true;
      listType = 'ol';
      listItems = [];
    } else if ((part.match(/^[-*]\s/) || part.match(/^[○●]\s/)) && !isInList) {
      isInList = true;
      listType = 'ul';
      listItems = [];
    }

    // Process list items
    if (isInList) {
      const listMatch = part.match(/^(?:\d+\.|\-|\*|[○●])\s+(.+)/);
      if (listMatch) {
        listItems.push(listMatch[1]);
        continue;
      }
      
      // End of list only on double newline or non-list content
      const isListEnd = (consecutiveNewlines >= 2) || 
                       (part !== '\n' && !part.match(/^(?:\d+\.|\-|\*|[○●])/));
      
      if (isListEnd) {
        if (listItems.length > 0) {
          const shouldBeCheckable = listAnalysis?.isCheckable === true;
          
          if (shouldBeCheckable && listType === 'ul') {
            elements.push(
              <ul key={key++} className="checkbox-list">
                {listItems.map((item, idx) => (
                  <li 
                    key={idx}
                    onClick={(e) => {
                      e.currentTarget.classList.toggle('checked');
                    }}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            );
          } else {
            const ListTag = listType;
            elements.push(
              <ListTag key={key++}>
                {listItems.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ListTag>
            );
          }
        }
        isInList = false;
        listType = null;
        listItems = [];
        consecutiveNewlines = 0;
        
        if (part === '\n') {
          elements.push(<br key={key++} />);
        }
        continue;
      }
      
      // Single newline within list - skip it but stay in list
      if (part === '\n') {
        continue;
      }
    }

    // Handle bold text
    if (part.match(/^\*\*.*?\*\*$/)) {
      const boldText = part.replace(/\*\*/g, '');
      elements.push(<strong key={key++}>{boldText}</strong>);
      continue;
    }

    // Handle URLs
    if (part.match(/^https?:\/\//)) {
      let displayUrl = part;
      let linkUrl = part;
      
      if (searchResults) {
        const matchingResult = searchResults.find(r => 
          r.url === part || part.includes(r.url)
        );
        if (matchingResult?.title) {
          displayUrl = matchingResult.title;
        }
      }
      
      elements.push(
        <a 
          key={key++}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#3b82f6',
            textDecoration: 'underline',
            fontWeight: 500
          }}
        >
          {displayUrl}
        </a>
      );
      continue;
    }

    // Line breaks
    if (part === '\n') {
      elements.push(<br key={key++} />);
      continue;
    }

    // Regular text
    elements.push(<span key={key++}>{part}</span>);
  }

  // Handle remaining list items
  if (isInList && listItems.length > 0) {
    const shouldBeCheckable = listAnalysis?.isCheckable === true;
    
    if (shouldBeCheckable && listType === 'ul') {
      elements.push(
        <ul key={key++} className="checkbox-list">
          {listItems.map((item, idx) => (
            <li 
              key={idx}
              onClick={(e) => {
                e.currentTarget.classList.toggle('checked');
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      );
    } else {
      const ListTag = listType;
      elements.push(
        <ListTag key={key++}>
          {listItems.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ListTag>
      );
    }
  }

  return <>{elements}</>;
};
// Disconnect from Hume
const disconnectHume = () => {
  if (humeWsRef.current) {
    humeWsRef.current.close();
    setIsHumeConnected(false);
    setHumeStatus('disconnected');
  }
};

const handlePodcastGenerationFromNews = async (articles, messageId) => {
  // Convert articles to topic
  const topic = articles && articles.length > 0 
    ? `News summary: ${articles.map(a => a.title).join('; ').substring(0, 200)}`
    : 'News';
  
  const startingHosts = ["News Host 1", "News Host 2"];
  const includeGuest = true;
  
  console.log('🎙️ Generating podcast from news articles:', articles?.length, 'for message:', messageId);
  
  // Update the existing message to show generating state
  setMessages(prev => prev.map(msg => 
    msg.id === messageId 
      ? { ...msg, podcastState: 'generating' }
      : msg
  ));
  
  try {
    // Generate the podcast dialogue
    console.log('📝 Generating dialogue...');
    const dialogue = await generatePodcastDialogue(topic, articles, includeGuest, startingHosts);
    
    // Update progress
    setMessages(prev => 
      prev.map(msg => 
        msg.id === messageId 
          ? { ...msg, podcastState: 'generating' }
          : msg
      )
    );
    
    // Combine audio segments with progress updates
    console.log('🎵 Combining audio segments...');
    const updateProgress = (progressText, stage) => {
      console.log('Progress:', progressText, stage);
    };
    
    const audioUrl = await combineAudioSegments(dialogue, updateProgress, true);
    console.log('✅ Audio URL generated:', audioUrl ? 'Yes' : 'No');
    
    // Generate catchy episode title using SecureAPI
    let episodeTitle = 'Today\'s News';
    
    try {
      console.log('📰 Generating episode title...');
      
      // ✅ Using SecureAPI method
      const titleData = await SecureAPI.callAzureOpenAI([
        {
          role: 'system',
          content: 'You are a podcast title creator. Create catchy, engaging episode titles (3-6 words). Return ONLY the title, no quotes.'
        },
        {
          role: 'user',
          content: `Create a podcast title for these news topics: ${articles?.map(a => a.title).slice(0, 3).join(', ') || 'breaking news'}`
        }
      ], {
        temperature: 0.8,
        max_tokens: 30,
        response_format: { type: "json_object" }
      });
      
      episodeTitle = titleData.choices?.[0]?.message?.content?.trim() 
        || 'Today\'s News';
      console.log('✅ Episode title:', episodeTitle);
      
    } catch (titleError) {
      console.error('❌ Title generation failed:', titleError);
    }
    
    // Update message with podcast data and set state to 'ready'
    console.log('✅ Podcast ready! Updating message state to "ready"');
    setMessages(prev => 
      prev.map(msg => 
        msg.id === messageId 
          ? { 
              ...msg,
              dialogue: dialogue,
              audioUrl: audioUrl,
              podcastTitle: episodeTitle,
              podcastState: 'ready' // Ready to play!
            }
          : msg
      )
    );
    
  } catch (error) {
    console.error('❌ Podcast generation error:', error);
    console.error('Error stack:', error.stack);
    
    // Reset state on error so user can retry
    setMessages(prev => 
      prev.map(msg => 
        msg.id === messageId 
          ? { 
              ...msg,
              podcastState: 'idle' // Back to idle
            }
          : msg
      )
    );
  }
};


  // Updated function to handle journal routing with React Router

const handlePlusOptionSelect = (option) => {
  setShowPlusOptions(false);
  
  if (option.id === 'podcast') {
    setIsPodcastMode(true);
    setInputValue('');
    setTimeout(() => {
      if (inlineInputRef.current) {
        inlineInputRef.current.focus();
      }
    }, 100);
  } else if (option.id === 'landing') {
    handleModeSelect({ id: 'landing' });
  } else if (option.id === 'planner') {
    handleModeSelect({ id: 'planner' });
  } else if (option.id === 'study') {
    handleModeSelect({ id: 'study' });
  } else if (option.id === 'focus') {
    handleModeSelect({ id: 'focus' });
  } else if (option.id === 'test-notification') {
    handleTestNotification();
  } else if (option.id === 'Report Bug') {
    // ✅ Open email client to report bug
    window.location.href = 'mailto:support@preptune.com?subject=Bug Report';
  }
};
const handleTestNotification = async () => {
  if (!notificationService) {
    console.warn('⚠️ Notification service not initialized');
    
    // Show feedback message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: 'Notification service is not ready yet. Please wait a moment and try again.',
      timestamp: new Date().toISOString()
    }]);
    
    return;
  }

  console.log('🧪 Manual test notification triggered');
  
  // Show loading message
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: 'Checking for follow-ups...',
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);

  try {
    const result = await notificationService.sendTestNotification();
    
    // Remove loading message
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    
    // Show result based on type
    let feedbackMessage;
    
    if (result.type === 'real') {
      feedbackMessage = `✅ Found a real follow-up! Notification sent: "${result.message}"

Event: ${result.event.substring(0, 60)}...

Check your notifications!`;
    } else {
      feedbackMessage = `📭 No recent events need follow-up right now, so I sent a test notification instead. Check your notifications!`;
    }
    
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: feedbackMessage,
      timestamp: new Date().toISOString()
    }]);

  } catch (error) {
    console.error('❌ Test notification error:', error);
    
    // Remove loading and show error
    setMessages(prev => prev.filter(m => m.id !== loadingId));
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `❌ Error: ${error.message}`,
      timestamp: new Date().toISOString()
    }]);
  }
};

  // ========================================
  // INITIALIZATION
  // ========================================
  
useEffect(() => {
  initializeServices();
  loadUserName();
  // ❌ Don't call loadToolkitSettings here - Firestore not ready yet
}, []);

useEffect(() => {
  if (firestoreService?.isReady() && !memoryService) {
    const service = new ConversationMemoryService(firestoreService, user?.uid);
    
    // ✅ CORRECT: Directly set azureConfig property (not a method)
    service.azureConfig = {
      endpoint: AZURE_OPENAI_ENDPOINT,
      deployment: AZURE_OPENAI_DEPLOYMENT,
      apiKey: AZURE_OPENAI_API_KEY
    };
    
    // ✅ Debug log to verify
    console.log('🔧 Memory service Azure config set:', {
      hasEndpoint: !!service.azureConfig.endpoint,
      hasDeployment: !!service.azureConfig.deployment,
      hasKey: !!service.azureConfig.apiKey,
      endpoint: service.azureConfig.endpoint?.substring(0, 30) + '...',
      deployment: service.azureConfig.deployment
    });
    
    setMemoryService(service);
  }
}, [firestoreService, user?.uid, memoryService]);
useEffect(() => {
  const handleBeforeUnload = async (e) => {
    // ✅ Save the current chat before user leaves
    if (currentSessionId && messages.length > 0 && firestoreService?.isReady?.()) {
      console.log('💾 Saving chat before page close...');
      
      try {
        await firestoreService.saveConversation({
          id: currentSessionId,
          messages: messages,
          preview: messages[0]?.content || 'Chat',
          messageCount: messages.length,
          timestamp: new Date().toISOString(),
          lastUpdated: new Date().toISOString(),
          tag: autoTagChat({
            preview: messages[0]?.content || '',
            messages: messages
          })
        });
        console.log('✅ Chat saved before close');
      } catch (error) {
        console.error('⚠️ Failed to save before close:', error);
      }
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, [currentSessionId, messages, firestoreService]);

useEffect(() => {
  let inactivityTimer;
  let lastMessageCount = 0; // Track message count

  const resetTimer = () => {
    clearTimeout(inactivityTimer);
    
    // Only start timer if messages have changed
    if (messages.length !== lastMessageCount && messages.length >= 5) {
      lastMessageCount = messages.length;
      
      inactivityTimer = setTimeout(() => {
        if (memoryService?.isReady()) {
          console.log('💾 Auto-saving conversation summary (5min idle)...');
          
          memoryService.saveConversationSummary(messages).catch(err => {
            console.error('Failed to auto-save summary:', err);
          });
        }
      }, 5 * 60 * 1000); // 5 minutes
    }
  };

  // Reset timer when new messages arrive
  resetTimer();

  return () => {
    clearTimeout(inactivityTimer);
  };
}, [messages, memoryService]);
useEffect(() => {
  if (firestoreService?.isReady?.()) {
    console.log('✅ Firestore ready, loading toolkit settings');
    loadToolkitSettings();
  } else {
    console.log('⏳ Waiting for Firestore to be ready...');
  }
}, [firestoreService]); // ✅ Runs when firestoreService becomes available

useEffect(() => {
  // ✅ NEVER auto-restore previous chat on refresh
  // Always start with a fresh new chat
  
  if (firestoreService?.isReady?.() && !hasExistingSession) {
    console.log('🆕 Fresh session - NOT loading past chat');
    
    // Create a NEW session ID
    const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    
    // Reset everything to blank
    setMessages([]);
    setCurrentSessionId(newSessionId);
    setActiveSessionId(null);
    setCurrentMode('chat');
    setInputValue('');
    
    setHasExistingSession(true);
    
    console.log('✅ New blank chat ready:', newSessionId);
  }
}, [firestoreService, hasExistingSession]);
  const initializeServices = async () => {
    try {
      const firestore = new FirestorePersistentStorageService();
      await firestore.initialize();
      setFirestoreService(firestore);
      
      const memory = new ConversationMemoryService(firestore);
      setMemoryService(memory);
      
      const calendar = await loadCalendarFromStorage();
      
    } catch (error) {
      console.error('Failed to initialize services:', error);
    }
  };
  
const loadUserName = async () => {
  setIsLoadingGreeting(true); // Start loading
  
  try {
    const name = await getUserNameWithFallback(firestoreService);
    setUserName(name);
  } catch (error) {
    console.error('Failed to load username:', error);
  } finally {
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setIsLoadingGreeting(false);
    }, 300);
  }
};
const loadToolkitSettings = async () => {
  try {
    if (!firestoreService?.isReady?.()) {
      console.warn('⚠️ Firestore not ready, using defaults');
      setAvailableTools(defaultTools);
      return;
    }

    const userData = await firestoreService.getUserData();
    const savedToolSettings = userData?.settings?.toolkitSettings;

    // ✅ PRIORITY 1: Use toolkitSettings (most recent edits)
    if (savedToolSettings && Array.isArray(savedToolSettings) && savedToolSettings.length > 0) {
      const mergedTools = defaultTools.map(defaultTool => {
        const savedTool = savedToolSettings.find(t => t.id === defaultTool.id);
        return {
          ...defaultTool,
          visible: savedTool?.visible ?? true,
        };
      });
      
      setAvailableTools(mergedTools);
      console.log('✅ Toolkit settings loaded from toolkitSettings:', mergedTools);
      return; // ✅ EXIT HERE - don't check selectedTools
    }

    // ✅ PRIORITY 2: Migrate from selectedTools (first time only)
    const selectedTools = userData?.settings?.selectedTools;
    
    if (selectedTools && Array.isArray(selectedTools) && selectedTools.length > 0) {
      console.log('✅ Migrating from selectedTools:', selectedTools);
      
      const toolsFromOnboarding = defaultTools.map(tool => ({
        ...tool,
        visible: selectedTools.includes(tool.id)
      }));
      
      setAvailableTools(toolsFromOnboarding);
      
      // ✅ Save as toolkitSettings immediately (migration)
      const serializableTools = toolsFromOnboarding.map(tool => ({
        id: tool.id,
        name: tool.name,
        visible: tool.visible,
        description: tool.description,
      }));
      
      await firestoreService.updateUserData({
        'settings.toolkitSettings': serializableTools,
        'settings.toolkitUpdatedAt': new Date().toISOString()
      });
      
      console.log('✅ Migrated selectedTools → toolkitSettings');
    } else {
      // ✅ PRIORITY 3: No data at all, use defaults
      console.log('📭 No saved settings, using defaults');
      setAvailableTools(defaultTools);
    }
  } catch (error) {
    console.error('❌ Failed to load toolkit settings:', error);
    setAvailableTools(defaultTools);
  }
};
const handleToolVisibilityToggle = async (toolId) => {
  // Update local state immediately for instant UI feedback
  const updatedTools = availableTools.map(tool => 
    tool.id === toolId 
      ? { ...tool, visible: !tool.visible }
      : tool
  );
  
  setAvailableTools(updatedTools);

  // Save to Firestore (async, non-blocking)
  if (firestoreService?.isReady?.()) {
    const serializableTools = updatedTools.map(tool => ({
      id: tool.id,
      name: tool.name,
      visible: tool.visible,
      description: tool.description,
    }));

    try {
      await firestoreService.updateUserData({
        'settings.toolkitSettings': serializableTools,
        'settings.toolkitUpdatedAt': new Date().toISOString()
      });
      console.log('✅ Tool visibility updated in Firestore:', toolId);
    } catch (error) {
      console.error('❌ Failed to save tool visibility:', error);
      // UI is already updated, so continue
    }
  }
};
const defaultTools = [
  { 
    id: 'journal', 
    name: 'Journal', 
    description: 'Track your daily thoughts and mood',
    visible: false, // Start as hidden - user selects in onboarding
    svg: (
                   <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.83892 12.4543s1.24988-3.08822-.21626-5.29004C8.15656 4.96245 4.58671 4.10885 4.39794 4.2436c-.18877.13476-1.11807 3.32546.34803 5.52727 1.4661 2.20183 5.09295 2.68343 5.09295 2.68343Zm0 0C10.3389 13.4543 12 15 12 18v2c0-2-.4304-3.4188 2.0696-5.9188m0 0s-.4894-2.7888 1.1206-4.35788c1.6101-1.56907 4.4903-1.54682 4.6701-1.28428.1798.26254.4317 2.84376-1.0809 4.31786-1.61 1.5691-4.7098 1.3243-4.7098 1.3243Z"/>
                  </svg>
    ),
    bgColor: '#0bf58c37',
    borderColor: '#0bf58c5e'
  },
  { 
    id: 'podcast', 
    name: 'Podcast', 
    description: 'Get personalized audio briefings',
    visible: false,
    svg: (
                  <Radio size={16} />

    ),
    bgColor: '#8ea8ff36',
    borderColor: '#8ea8ff60'
  },
  { 
    id: 'planner', 
    name: 'Smart Planner',
    description: 'Organize your schedule effortlessly',
    visible: false,
    svg: (
                 <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m10.827 5.465-.435-2.324m.435 2.324a5.338 5.338 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.338 5.338 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5-6.818 1.277Z"/>
                  </svg>
    ),
    bgColor: '#95d8ff5e',
    borderColor: '#95d8ff8f'
  },
  { 
    id: 'study', 
    name: 'Study tool',
    description: 'Create flashcards and get instant help',
    visible: false,
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
        <path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>

    ),
    bgColor: '#ffded8bd',
    borderColor: '#ffded8de'
  },
];

  useEffect(() => {
  if (firestoreService && !memoryService) {
    const initMemory = async () => {
      const memory = await firestoreService.initializeMemoryService();
      setMemoryService(memory);
    };
    initMemory();
  }
}, [firestoreService, memoryService]);
/**
 * ✅ Auto-save current chat session to Firestore
 * Call this after EVERY message (user or bot)
 */
const autoSaveCurrentSession = async () => {
  if (!currentSessionId || messages.length === 0 || !firestoreService?.isReady?.()) {
    return; // Silent fail - don't block UI
  }

  try {
    console.log('💾 Auto-saving session:', {
      sessionId: currentSessionId,
      messageCount: messages.length,
      lastMessage: messages[messages.length - 1]?.content?.substring(0, 50)
    });

    await firestoreService.saveConversation({
      id: currentSessionId,
      messages: messages, // ← Save ALL current messages
      preview: messages[0]?.content || 'Chat',
      messageCount: messages.length,
      timestamp: new Date().toISOString(),
      lastUpdated: new Date().toISOString(),
      tag: autoTagChat({
        preview: messages[0]?.content || '',
        messages: messages
      })
    });

    console.log('✅ Session auto-saved');
  } catch (error) {
    console.error('⚠️ Auto-save failed (continuing anyway):', error);
    // Don't throw - let chat continue even if save fails
  }
};

  const handleGeneratePodcast = async () => {
    // Validate input
    if (!inputValue.trim()) {
      console.log('⚠️ Empty podcast request');
      return;
    }
    
    const topic = inputValue.trim();
    const userName = getStoredUserName() || 'Anonymous';
    
    console.log('🎙️ Starting podcast generation:', { topic, userName });
    
    // Check if request is too vague
    if (isVaguePodcastRequest(topic)) {
      const botMessageId = Date.now();
      setMessages(prev => [...prev, {
        id: botMessageId,
        type: 'bot',
        content: "I'd love to create your Inner Loop podcast! What topic would you like me to cover? For example:\n- Today's tech news\n- Business headlines\n- Sports updates\n- A specific topic you're interested in",
        timestamp: new Date().toISOString()
      }]);
      
      // Clear input and exit podcast mode
      setInputValue('');
      setIsPodcastMode(false);
      return;
    }
    
    // Set generating state
    setIsGeneratingPodcast(true);
    
    // Clear input and exit podcast mode
    const userMessage = inputValue;
    setInputValue('');
    setIsPodcastMode(false);
    setIsMultiline(false);
    setTextareaHeight('44px');
    
    // Add user message to chat
    const userMessageId = Date.now();
    setMessages(prev => [...prev, {
      id: userMessageId,
      type: 'user',
      content: userMessage,
      timestamp: new Date().toISOString()
    }]);
    
    // Parse duration from topic if specified
    let durationMinutes = parseDuration(topic);
    const validation = validateDuration(durationMinutes);
    const finalDuration = validation.minutes;
    
    // Add loading message
    const loadingMessageId = Date.now() + 1;
    setMessages(prev => [...prev, {
      id: loadingMessageId,
      type: 'bot',
      content: validation.message 
        ? validation.message + '\n\nCreating your Inner Loop podcast...'
        : `Creating your ${finalDuration}-minute Inner Loop podcast...`,
      isLoading: true,
      loadingStage: 'generating',
      timestamp: new Date().toISOString()
    }]);
    
    try {
      // Generate podcast dialogue
      const result = await generatePodcastDialogueWithDuration(
        topic, 
        null, // searchResults - null for direct requests
        userName,
        finalDuration,
        AZURE_OPENAI_ENDPOINT,
        AZURE_OPENAI_DEPLOYMENT,
        AZURE_OPENAI_API_KEY
      );
      
      const { dialogue, metadata } = result;
      
      console.log('✅ Dialogue generated:', { 
        wordCount: metadata.wordCount,
        estimatedDuration: metadata.estimatedDuration 
      });
      
      // Update loading message to audio generation
      setMessages(prev => 
        prev.map(msg => 
          msg.id === loadingMessageId 
            ? { 
                ...msg, 
                content: `Generating audio for your ${finalDuration}-minute Inner Loop episode...`, 
                loadingStage: 'processing' 
              }
            : msg
        )
      );
      
      // Progress update callback
      const updateProgress = (progressText, stage) => {
        setMessages(prev => 
          prev.map(msg => 
            msg.id === loadingMessageId 
              ? { ...msg, content: progressText, loadingStage: stage }
              : msg
          )
        );
      };
      
      // Generate audio
  const audioUrl = await combineAudioSegments(dialogue, updateProgress, true);
      
      console.log('✅ Audio generated:', audioUrl);
      
      // Clean up topic title (remove duration mentions)
      const episodeTitle = topic.replace(/\d+\s*min(?:ute)?s?/gi, '').trim();
      
  // Update message with final podcast
  setMessages(prev => 
    prev.map(msg => 
      msg.id === loadingMessageId 
        ? { 
            ...msg, 
            content: `Your ${finalDuration}-minute Inner Loop podcast "${episodeTitle}" is ready!`,
            dialogue,
            audioUrl,
            topic: episodeTitle,
            isPodcast: true,
            isLoading: false,
            searchResults: null,
            podcastTitle: episodeTitle,
            duration: finalDuration,
            metadata,
            timestamp: new Date().toISOString()
          }
        : msg
    )
  );
  
  console.log('🎉 Podcast generation complete!');
  
    } catch (error) {
      console.error('❌ Podcast generation error:', error);
      
      // Update message with error
      setMessages(prev => 
        prev.map(msg => 
          msg.id === loadingMessageId 
            ? { 
                ...msg, 
                content: 'Sorry, I had trouble generating that podcast. Please try again!', 
                isLoading: false,
                timestamp: new Date().toISOString()
              }
            : msg
        )
      );
    } finally {
      // Reset generating state
      setIsGeneratingPodcast(false);
    }
  };

/**
 * Load a specific chat session
 */
 const loadChatSession = (sessionId) => {
  const history = getChatHistory();
  return history.find(chat => chat.id === sessionId);
};

// ============================================
// FOLDER UI COMPONENT
// ============================================

const FolderIcon = ({ color }) => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
  </svg>
);


const autoTagChat = (chat) => {
  if (!chat.preview && !chat.messages) return null;
  
  const text = (chat.preview || '') + ' ' + 
               (chat.messages?.map(m => m.content).join(' ') || '');
  const lowerText = text.toLowerCase();
  
  // Define topic keywords
  const topics = {
    'Coding': ['code', 'javascript', 'python', 'function', 'debug', 'error', 'programming', 'react', 'html', 'css', 'algorithm', 'git', 'api'],
    'Writing': ['write', 'essay', 'article', 'blog', 'story', 'poem', 'draft', 'edit', 'proofread', 'grammar'],
    'Learning': ['learn', 'explain', 'teach', 'understand', 'tutorial', 'how to', 'what is', 'study', 'course'],
    'Business': ['business', 'marketing', 'strategy', 'sales', 'revenue', 'startup', 'company', 'customer', 'growth'],
    'Research': ['research', 'analyze', 'data', 'study', 'report', 'analysis', 'findings', 'statistics'],
    'Creative': ['design', 'art', 'creative', 'brainstorm', 'idea', 'concept', 'inspiration', 'logo', 'brand'],
    'Health': ['health', 'fitness', 'workout', 'exercise', 'diet', 'nutrition', 'medical', 'wellness'],
    'Travel': ['travel', 'trip', 'destination', 'vacation', 'hotel', 'flight', 'visit', 'tour'],
    'Food': ['recipe', 'cook', 'food', 'meal', 'ingredient', 'dish', 'bake', 'cuisine', 'restaurant'],
    'Finance': ['money', 'finance', 'budget', 'invest', 'stock', 'saving', 'expense', 'tax', 'crypto'],
    'Tech': ['technology', 'software', 'hardware', 'device', 'app', 'digital', 'computer', 'tech', 'ai', 'machine learning']
  };
  
  // Score each topic
  let bestTopic = null;
  let bestScore = 0;
  
  Object.entries(topics).forEach(([topic, keywords]) => {
    let score = 0;
    keywords.forEach(keyword => {
      const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
      const matches = lowerText.match(regex);
      if (matches) {
        score += matches.length;
      }
    });
    
    if (score > bestScore) {
      bestScore = score;
      bestTopic = topic;
    }
  });
  
  // Require minimum score to assign a tag
  return bestScore >= 2 ? bestTopic : 'General';
};

// Update chat with auto-tag
const updateChatWithTag = (chat) => {
  if (!chat.tag) {
    chat.tag = autoTagChat(chat);
  }
  return chat;
};

// ============================================
// TAG COLORS
// ============================================
const getTagColor = (tag) => {
  const colors = {
    'Coding': '#10b981',
    'Writing': '#8b5cf6',
    'Learning': '#3b82f6',
    'Business': '#f59e0b',
    'Research': '#06b6d4',
    'Creative': '#ec4899',
    'Health': '#84cc16',
    'Travel': '#f97316',
    'Food': '#ef4444',
    'Finance': '#14b8a6',
    'Tech': '#6366f1',
    'General': '#6b7280'
  };
  return colors[tag] || colors['General'];
};

const saveChatHistory = (history) => {
  try {
    localStorage.setItem('preptune_chat_history', JSON.stringify(history));
    return true;
  } catch (error) {
    console.error('Error saving chat history:', error);
    return false;
  }
};

const clearAllChatHistory = () => {
  try {
    localStorage.removeItem('preptune_chat_history');
    return true;
  } catch (error) {
    console.error('Error clearing chat history:', error);
    return false;
  }
};

const deleteChatSession = (sessionId) => {
  try {
    const history = getChatHistory();
    const filtered = history.filter(chat => chat.id !== sessionId);
    return saveChatHistory(filtered);
  } catch (error) {
    console.error('Error deleting chat session:', error);
    return false;
  }
};

const togglePinChat = (sessionId) => {
  try {
    const history = getChatHistory();
    const chat = history.find(c => c.id === sessionId);
    if (chat) {
      chat.pinned = !chat.pinned;
      return saveChatHistory(history);
    }
    return false;
  } catch (error) {
    console.error('Error pinning chat:', error);
    return false;
  }
};

const toggleFavoriteChat = (sessionId) => {
  try {
    const history = getChatHistory();
    const chat = history.find(c => c.id === sessionId);
    if (chat) {
      chat.favorited = !chat.favorited;
      return saveChatHistory(history);
    }
    return false;
  } catch (error) {
    console.error('Error favoriting chat:', error);
    return false;
  }
};


/**
 * ✅ ACCURATE WEEK OF MONTH CALCULATION
 * Handles January with 5 weeks correctly
 */
const getWeekOfMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  // Get first day of month
  const firstDay = new Date(year, month, 1);
  const firstDayOfWeek = firstDay.getDay(); // 0 = Sunday, 6 = Saturday

  // Calculate which week this day falls into
  // Add the day-of-month to the first day offset, then divide by 7
  const adjustedDate = day + firstDayOfWeek - 1;
  const weekNumber = Math.floor(adjustedDate / 7) + 1;

  return Math.min(weekNumber, 5); // Cap at 5 weeks max
};

/**
 * ✅ GET ALL WEEKS IN A MONTH (including Week 5 if exists)
 */
const getAllWeeksInMonth = (monthYear) => {
  // Parse "January 2026" format
  const [monthName, year] = monthYear.split(' ');
  const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
  const yearNum = parseInt(year);

  // Get last day of month
  const lastDay = new Date(yearNum, monthIndex + 1, 0).getDate();
  const lastDayWeek = getWeekOfMonth(new Date(yearNum, monthIndex, lastDay));

  const weeks = {};
  for (let i = 1; i <= lastDayWeek; i++) {
    weeks[`Week ${i}`] = [];
  }

  return weeks;
};

const ChatStatistics = ({ history }) => {
  const stats = useMemo(() => {
    const total = history.length;
    const totalMessages = history.reduce((sum, chat) => sum + (chat.messageCount || 0), 0);
    const avgMessages = total > 0 ? Math.round(totalMessages / total) : 0;
    const favorited = history.filter(c => c.favorited).length;
    
    // Most active month
    const monthCounts = {};
    history.forEach(chat => {
      const date = new Date(chat.timestamp);
      const monthYear = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      monthCounts[monthYear] = (monthCounts[monthYear] || 0) + 1;
    });
    
    const mostActive = Object.entries(monthCounts).sort((a, b) => b[1] - a[1])[0];
    
    return {
      total,
      totalMessages,
      avgMessages,
      favorited,
      mostActiveMonth: mostActive ? mostActive[0] : 'N/A',
      mostActiveCount: mostActive ? mostActive[1] : 0
    };
  }, [history]);
  
  return (
    <div className="chats-stats-container">
      <div className="chats-stats-grid">
        <div className="chats-stat-card">
          <MessageSquare size={18} className="chats-stat-icon" />
          <div className="chats-stat-content">
            <div className="chats-stat-value">{stats.total}</div>
            <div className="chats-stat-label">Total Chats</div>
          </div>
        </div>
        
        <div className="chats-stat-card">
          <TrendingUp size={18} className="chats-stat-icon" />
          <div className="chats-stat-content">
            <div className="chats-stat-value">{stats.totalMessages}</div>
            <div className="chats-stat-label">Messages</div>
          </div>
        </div>
        
        <div className="chats-stat-card">
          <Calendar size={18} className="chats-stat-icon" />
          <div className="chats-stat-content">
            <div className="chats-stat-value">{stats.avgMessages}</div>
            <div className="chats-stat-label">Avg/Chat</div>
          </div>
        </div>
        
        <div className="chats-stat-card">
          <Star size={18} className="chats-stat-icon" />
          <div className="chats-stat-content">
            <div className="chats-stat-value">{stats.favorited}</div>
            <div className="chats-stat-label">Favorites</div>
          </div>
        </div>
      </div>
      
      {stats.mostActiveMonth !== 'N/A' && (
        <div className="chats-stat-highlight">
          <TrendingUp size={16} />
          <span>Most active: <strong>{stats.mostActiveMonth}</strong> ({stats.mostActiveCount} chats)</span>
        </div>
      )}
    </div>
  );
};
/**
 * ✅ NEW: Get chat history from Firestore instead of localStorage
 */
const getChatHistory = async () => {
  try {
    if (!firestoreService?.isReady?.()) {
      console.log('⏳ Firestore not ready - returning empty');
      return [];
    }

    const sessions = await firestoreService.getAllChatSessions(100);

    if (!sessions || sessions.length === 0) {
      console.log('📭 No chat sessions found in Firestore');
      return [];
    }

    // ✅ CRITICAL: Deduplicate by ID at retrieval
    const uniqueSessions = Array.from(
      new Map(sessions.map(s => [s.id, s])).values()
    );

    if (uniqueSessions.length < sessions.length) {
      console.warn('⚠️ Removed duplicate sessions at retrieval:', {
        total: sessions.length,
        unique: uniqueSessions.length,
        duplicates: sessions.length - uniqueSessions.length
      });
    }

    console.log(`✅ Loaded ${uniqueSessions.length} unique chat sessions`);
    return uniqueSessions;
  } catch (error) {
    console.error('❌ Failed to load chat history from Firestore:', error);
    return [];
  }
};

/**
 * ✅ NEW: Delete from Firestore
 */
const deleteChatSessionFromFirestore = async (sessionId) => {
  try {
    if (!firestoreService?.isReady?.()) {
      console.warn('⚠️ Firestore not ready');
      return false;
    }

    await firestoreService.deleteChatSession(sessionId);
    console.log('✅ Chat session deleted from Firestore:', sessionId);
    return true;
  } catch (error) {
    console.error('❌ Failed to delete chat session:', error);
    return false;
  }
};

/**
 * ✅ NEW: Update chat metadata in Firestore
 */
const updateChatMetadataInFirestore = async (sessionId, metadata) => {
  try {
    if (!firestoreService?.isReady?.()) {
      console.warn('⚠️ Firestore not ready');
      return false;
    }

    await firestoreService.updateChatSessionMetadata(sessionId, metadata);
    console.log('✅ Chat metadata updated in Firestore:', sessionId);
    return true;
  } catch (error) {
    console.error('❌ Failed to update chat metadata:', error);
    return false;
  }
};

/**
 * ✅ NEW: Search chats from Firestore
 */
const searchChats = async (query, history) => {
  if (!query.trim()) return history;

  const lowerQuery = query.toLowerCase();
  return history.filter(chat => {
    // Search in preview
    if (chat.preview?.toLowerCase().includes(lowerQuery)) return true;

    // Search in messages
    if (chat.messages?.some(msg =>
      msg.content?.toLowerCase().includes(lowerQuery)
    )) return true;

    return false;
  });
};


const ChatHistoryFolderView = ({
  onSelectChat,
  openMonth = null,
  openWeek = null,
  firestoreService
}) => {
  // ============================================
  // STATE MANAGEMENT
  // ============================================
  const [expandedMonth, setExpandedMonth] = useState(openMonth);
  const [expandedWeek, setExpandedWeek] = useState(openWeek);
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('recent');
  const [filterBy, setFilterBy] = useState('all');
  const [showStats, setShowStats] = useState(false);
  const [organizedChats, setOrganizedChats] = useState({});
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [allChats, setAllChats] = useState([]);

  // ============================================
  // HELPER FUNCTIONS
  // ============================================
  
  const folderColors = [
    '#6b7280', '#3b82f6', '#10b981', '#f59e0b',
    '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'
  ];
  const getCurrentMonth = () => {
  const now = new Date();
  return now.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  });
};


  const getCurrentWeekOfMonth = () => {
    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const offsetDate = now.getDate() + firstDayOfWeek - 1;
    return Math.floor(offsetDate / 7) + 1;
  };

  const currentWeekNumber = getCurrentWeekOfMonth();

  const getTagColor = (tag) => {
    const colors = {
      'Coding': '#10b981',
      'Writing': '#8b5cf6',
      'Learning': '#3b82f6',
      'Business': '#f59e0b',
      'Research': '#06b6d4',
      'Creative': '#ec4899',
      'Health': '#84cc16',
      'Travel': '#f97316',
      'Food': '#ef4444',
      'Finance': '#14b8a6',
      'Tech': '#6366f1',
      'General': '#6b7280'
    };
    return colors[tag] || colors['General'];
  };

  // ============================================
  // DATA LOADING
  // ============================================
useEffect(() => {
  const loadChats = async () => {
    try {
      console.log('🔄 Starting chat history load...');
      console.log('   Firestore ready?', firestoreService?.isReady?.());
      
      setIsLoading(true);
      
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Chat history load timeout')), 15000)
      );

      const loadPromise = (async () => {
        if (!firestoreService?.isReady?.()) {
          throw new Error('Firestore not ready');
        }
        return await firestoreService.getAllChatSessions(100);
      })();
      
      const sessions = await Promise.race([loadPromise, timeoutPromise]);
      
      console.log('📊 Chat history loaded:', sessions.length, 'sessions');
      
      setAllChats(sessions);
      
      // ✅ FIXED: Pass sessions to organize function
      const organized = organizeChatsIntoFolders(sessions);
      setOrganizedChats(organized);

      console.log('✅ Chat history fully loaded');
      
    } catch (error) {
      console.error('❌ Failed to load chat history:', error);
      console.error('   Error message:', error.message);
      
      setAllChats([]);
      setOrganizedChats({});
    } finally {
      setIsLoading(false);
    }
  };
  
  if (firestoreService?.isReady?.()) {
    console.log('✅ Firestore ready - loading chats');
    loadChats();
  } else {
    console.log('⏳ Firestore not ready yet');
    setIsLoading(false);
  }
}, [refreshKey, firestoreService]);
  // ============================================
  // ORGANIZE CHATS INTO FOLDERS
  // ============================================
const organizeChatsIntoFolders = (history) => {
  const organized = {};
  
  console.log('📊 Organizing chats into folders:', history.length, 'sessions');

  history.forEach(chat => {
    try {
      const date = new Date(chat.lastUpdated || chat.timestamp);
      
      // Validate date
      if (isNaN(date.getTime())) {
        console.warn('⚠️ Invalid date for chat:', chat.id);
        return;
      }
      
      const monthYear = date.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
      });

      const weekNum = getWeekOfMonth(date);
      const weekLabel = `Week ${weekNum}`;

      if (!organized[monthYear]) {
        organized[monthYear] = {};
      }

      if (!organized[monthYear][weekLabel]) {
        organized[monthYear][weekLabel] = [];
      }

      organized[monthYear][weekLabel].push(chat);
    } catch (error) {
      console.error('❌ Error organizing chat:', chat.id, error);
    }
  });

  console.log('✅ Organized into months:', Object.keys(organized));
  return organized;
};

  const getWeekOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    const firstDay = new Date(year, month, 1);
    const firstDayOfWeek = firstDay.getDay();

    const adjustedDate = day + firstDayOfWeek - 1;
    const weekNumber = Math.floor(adjustedDate / 7) + 1;

    return Math.min(weekNumber, 5);
  };

  const getAllWeeksInMonth = (monthYear) => {
    const [monthName, year] = monthYear.split(' ');
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
    const yearNum = parseInt(year);

    const lastDay = new Date(yearNum, monthIndex + 1, 0).getDate();
    const lastDayWeek = getWeekOfMonth(new Date(yearNum, monthIndex, lastDay));

    const weeks = {};
    for (let i = 1; i <= lastDayWeek; i++) {
      weeks[`Week ${i}`] = [];
    }

    return weeks;
  };

  // ============================================
  // FILTER AND SORT
  // ============================================
  
  const filteredAndSortedChats = useMemo(() => {
    let chats = [...allChats];

    // Apply search
    if (searchQuery.trim()) {
      const lowerQuery = searchQuery.toLowerCase();
      chats = chats.filter(chat => {
        if (chat.preview?.toLowerCase().includes(lowerQuery)) return true;
        if (chat.messages?.some(msg =>
          msg.content?.toLowerCase().includes(lowerQuery)
        )) return true;
        return false;
      });
    }

    // Apply filter
    if (filterBy === 'pinned') {
      chats = chats.filter(c => c.pinned);
    } else if (filterBy === 'favorited') {
      chats = chats.filter(c => c.favorited);
    }

    // Apply sort
    chats.sort((a, b) => {
      if (a.pinned && !b.pinned) return -1;
      if (!a.pinned && b.pinned) return 1;

      switch (sortBy) {
        case 'recent':
          return new Date(b.lastUpdated || b.timestamp) - new Date(a.lastUpdated || a.timestamp);
        case 'oldest':
          return new Date(a.lastUpdated || a.timestamp) - new Date(b.lastUpdated || b.timestamp);
        case 'messages':
          return (b.messageCount || 0) - (a.messageCount || 0);
        case 'alphabetical':
          return (a.preview || '').localeCompare(b.preview || '');
        default:
          return 0;
      }
    });

    return chats;
  }, [allChats, searchQuery, sortBy, filterBy]);

  // ============================================
  // ACTIONS
  // ============================================
  
  const handleClearAll = async () => {
    try {
      setIsLoading(true);

      const deletePromises = allChats.map(chat =>
        firestoreService.deleteChatSession(chat.id).catch(e => {
          console.error(`Failed to delete ${chat.id}:`, e);
          return null;
        })
      );

      await Promise.all(deletePromises);

      console.log('✅ All chats cleared from Firestore');

      setOrganizedChats({});
      setAllChats([]);
      setExpandedMonth(null);
      setExpandedWeek(null);
      setRefreshKey(k => k + 1);
    } catch (error) {
      console.error('❌ Failed to clear chats:', error);
    } finally {
      setIsLoading(false);
      setShowClearConfirm(false);
    }
  };

  const handleDeleteChat = async (e, chatId) => {
    e.stopPropagation();
    try {
      setIsLoading(true);
      
      await firestoreService.deleteChatSession(chatId);

      setAllChats(prev => prev.filter(c => c.id !== chatId));
      const organized = organizeChatsIntoFolders(allChats.filter(c => c.id !== chatId));
      setOrganizedChats(organized);

      console.log('✅ Chat deleted:', chatId);
    } catch (error) {
      console.error('❌ Failed to delete chat:', error);
    } finally {
      setIsLoading(false);
      setDeleteConfirm(null);
    }
  };

  const handleTogglePin = async (e, chatId) => {
    e.stopPropagation();
    try {
      const chat = allChats.find(c => c.id === chatId);
      if (!chat) return;

      const newPinnedState = !chat.pinned;

      await firestoreService.updateChatSessionMetadata(chatId, {
        pinned: newPinnedState
      });

      setAllChats(prev =>
        prev.map(c =>
          c.id === chatId ? { ...c, pinned: newPinnedState } : c
        )
      );

      const organized = organizeChatsIntoFolders(allChats);
      setOrganizedChats(organized);

      console.log('✅ Chat pinned status updated:', { chatId, pinned: newPinnedState });
    } catch (error) {
      console.error('❌ Failed to toggle pin:', error);
    }
  };

  const handleToggleFavorite = async (e, chatId) => {
    e.stopPropagation();
    try {
      const chat = allChats.find(c => c.id === chatId);
      if (!chat) return;

      const newFavoritedState = !chat.favorited;

      await firestoreService.updateChatSessionMetadata(chatId, {
        favorited: newFavoritedState
      });

      setAllChats(prev =>
        prev.map(c =>
          c.id === chatId ? { ...c, favorited: newFavoritedState } : c
        )
      );

      const organized = organizeChatsIntoFolders(allChats);
      setOrganizedChats(organized);

      console.log('✅ Chat favorite status updated:', { chatId, favorited: newFavoritedState });
    } catch (error) {
      console.error('❌ Failed to toggle favorite:', error);
    }
  };

  // ============================================
  // LOADING STATE
  // ============================================
  
  if (isLoading) {
    return (
      <div className="chats-history-chat-history-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e5e7eb',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p style={{ color: '#6b7280', fontSize: '14px' }}>Loading chat history...</p>
        </div>
      </div>
    );
  }

  // ============================================
  // WEEK VIEW (Individual Chat List)
  // ============================================
  
  if (expandedMonth && expandedWeek && !searchQuery) {
    const chats = organizedChats[expandedMonth]?.[expandedWeek] || [];
    const sortedChats = [...chats].sort((a, b) => {
      if (a.pinned && !b.pinned) return -1;
      if (!a.pinned && b.pinned) return 1;
      return new Date(b.lastUpdated || b.timestamp) - new Date(a.lastUpdated || a.timestamp);
    });

    return (
      <>
        <style>{styles}</style>
        <div className="chats-history-chat-history-container">
          <div className="chats-history-chat-history-inner">
            <button
              onClick={() => setExpandedWeek(null)}
              className="chats-history-back-button"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
            </button>

            <div className="chats-history-section-header">
              <h2 className="chats-history-section-title">{expandedMonth} - {expandedWeek}</h2>
            </div>

            <div className="chats-history-chat-list-container">
              {sortedChats.length === 0 ? (
                <div className="chats-history-empty-state">
                  <p style={{ color: '#9ca3af' }}>No chats in this week</p>
                </div>
              ) : (
                sortedChats.map((chat) => (
                  <div
                    key={chat.id}
                    className={`chats-history-chat-item-card ${chat.pinned ? 'chats-pinned' : ''}`}
                  >
                    <div
                      className="chats-history-chat-item-inner"
                      onClick={() => onSelectChat(chat)}
                    >
                      <div className="chats-preview-header">
                        {chat.pinned && (
                          <div className="chats-pinned-badge">
                            <Pin size={12} /> Pinned
                          </div>
                        )}
                        {chat.tag && (
                          <div
                            className="chats-tag-badge"
                            style={{
                              background: getTagColor(chat.tag),
                              color: 'white'
                            }}
                          >
                            {chat.tag}
                          </div>
                        )}
                      </div>
                      <div className="chats-history-chat-preview">{chat.preview}</div>
                      <div className="chats-history-chat-meta">
                        <span className="chats-history-chat-date">
                          {new Date(chat.lastUpdated || chat.timestamp).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric'
                          })}
                        </span>
                        <span className="chats-history-meta-divider">•</span>
                        <span className="chats-history-chat-messages">{chat.messageCount || 0} messages</span>
                      </div>
                    </div>

                    <div className="chats-action-buttons">
                      <button
                        onClick={(e) => handleTogglePin(e, chat.id)}
                        className={`chats-icon-btn ${chat.pinned ? 'active' : ''}`}
                        title={chat.pinned ? "Unpin" : "Pin"}
                      >
                        <Pin size={16} />
                      </button>
                      <button
                        onClick={(e) => handleToggleFavorite(e, chat.id)}
                        className={`chats-icon-btn ${chat.favorited ? 'active' : ''}`}
                        title={chat.favorited ? "Unfavorite" : "Favorite"}
                      >
                        <Star size={16} fill={chat.favorited ? "currentColor" : "none"} />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteConfirm(chat.id);
                        }}
                        className="chats-icon-btn delete"
                        title="Delete chat"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {deleteConfirm && (
            <div className="chats-history-modal-overlay" onClick={() => setDeleteConfirm(null)}>
              <div className="chats-history-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="chats-history-modal-header">
                  <h3 className="chats-history-modal-title">Delete Chat?</h3>
                  <p className="chats-history-modal-description">
                    This will permanently delete this chat. This action cannot be undone.
                  </p>
                </div>

                <div className="chats-history-modal-actions">
                  <button
                    onClick={() => setDeleteConfirm(null)}
                    className="chats-history-modal-button chats-history-cancel-btn"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => handleDeleteChat(e, deleteConfirm)}
                    className="chats-history-modal-button chats-history-confirm-btn"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  // ============================================
  // MONTH VIEW (Week Folders)
  // ============================================
  
  if (expandedMonth && !expandedWeek && !searchQuery) {
    const weeks = organizedChats[expandedMonth] || {};
    const now = new Date();
    const currentMonthYear = now.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
    const isCurrentMonth = expandedMonth === currentMonthYear;

    const allWeeks = getAllWeeksInMonth(expandedMonth);
    
    Object.keys(weeks).forEach(weekLabel => {
      if (allWeeks[weekLabel]) {
        allWeeks[weekLabel] = weeks[weekLabel];
      }
    });

    return (
      <>
        <style>{styles}</style>
        <div className="chats-history-chat-history-container">
          <div className="chats-history-chat-history-inner">
            <button
              onClick={() => setExpandedMonth(null)}
              className="chats-history-back-button"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
            </button>

            <div className="chats-history-section-header">
              <h2 className="chats-history-section-title">{expandedMonth}</h2>
            </div>

            <div className="chats-history-folders-grid">
              {Object.entries(allWeeks).map(([weekLabel, chats], idx) => {
                const color = folderColors[idx % folderColors.length];
                const weekNum = parseInt(weekLabel.split(' ')[1]);
                const isCurrentWeek = isCurrentMonth && weekNum === currentWeekNumber;

                return (
                  <div
                    key={`${expandedMonth}-${weekLabel}`}
                    onClick={() => {
                      if (chats && chats.length > 0) {
                        setExpandedWeek(weekLabel);
                      }
                    }}
                    className={`chats-history-folder-card ${
                      isCurrentWeek ? 'chats-history-current-highlight' : ''
                    } ${!chats || chats.length === 0 ? 'disabled' : ''}`}
                    style={{
                      opacity: !chats || chats.length === 0 ? 0.5 : 1,
                      pointerEvents: !chats || chats.length === 0 ? 'none' : 'auto',
                      cursor: !chats || chats.length === 0 ? 'default' : 'pointer'
                    }}
                  >
                    <div className="chats-history-folder-card-inner">
                      {isCurrentWeek && (
                        <div className="chats-history-current-badge">Current Week</div>
                      )}
                      <div className="chats-history-folder-icon-wrapper">
                        <FolderIcon color={color} />
                      </div>
                      <div className="chats-history-folder-info">
                        <div className="chats-history-folder-name">{weekLabel}</div>
                        <div className="chats-history-folder-count">
                          {chats && chats.length > 0
                            ? `${chats.length} chat${chats.length !== 1 ? 's' : ''}`
                            : 'No chats'}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }

  // ============================================
  // MAIN VIEW (Month Folders or Search Results)
  // ============================================
  
  const showingSearchResults = searchQuery.trim().length > 0;

  return (
    <>
      <style>{styles}</style>
      <div className="chats-history-chat-history-container">
        <div className="chats-history-chat-history-inner">
          <div className="chats-history-header-section">
            <h2 className="chats-history-main-title">Chat History</h2>
            <div className="chats-header-actions">
              <button
                onClick={() => setShowStats(!showStats)}
                className="chats-stats-toggle"
                title="View statistics"
              >
                <TrendingUp size={14} />
                Stats
              </button>
              {allChats.length > 0 && (
                <button
                  onClick={() => setShowClearConfirm(true)}
                  className="chats-history-clear-button"
                >
                  <Trash2 size={14} />
                  Clear All
                </button>
              )}
            </div>
          </div>

          {showStats && allChats.length > 0 && (
            <ChatStatistics history={allChats} />
          )}

          {allChats.length > 0 && (
            <div className="chats-search-section">
              <div className="chats-search-bar">
                <Search size={18} className="chats-search-icon" />
                <input
                  type="text"
                  placeholder="Search chats..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="chats-search-input"
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="chats-search-clear"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>

              <div className="chats-filters">
                <div className="chats-custom-dropdown">
                  <button
                    className="chats-dropdown-button"
                    onClick={() => {
                      setShowSortDropdown(!showSortDropdown);
                      setShowFilterDropdown(false);
                    }}
                  >
                    {sortBy === 'recent' ? 'Most Recent' : 
                     sortBy === 'oldest' ? 'Oldest First' :
                     sortBy === 'messages' ? 'Most Messages' : 'A-Z'}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>

                  {showSortDropdown && (
                    <div className="chats-dropdown-menu">
                      {['recent', 'oldest', 'messages', 'alphabetical'].map(option => (
                        <div
                          key={option}
                          className={`chats-dropdown-item ${sortBy === option ? 'active' : ''}`}
                          onClick={() => {
                            setSortBy(option);
                            setShowSortDropdown(false);
                          }}
                        >
                          {option === 'recent' ? 'Most Recent' :
                           option === 'oldest' ? 'Oldest First' :
                           option === 'messages' ? 'Most Messages' : 'A-Z'}
                          {sortBy === option && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="chats-custom-dropdown">
                  <button
                    className="chats-dropdown-button"
                    onClick={() => {
                      setShowFilterDropdown(!showFilterDropdown);
                      setShowSortDropdown(false);
                    }}
                  >
                    {filterBy === 'all' ? 'All Chats' :
                     filterBy === 'pinned' ? 'Pinned' : 'Favorites'}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>

                  {showFilterDropdown && (
                    <div className="chats-dropdown-menu">
                      {['all', 'pinned', 'favorited'].map(option => (
                        <div
                          key={option}
                          className={`chats-dropdown-item ${filterBy === option ? 'active' : ''}`}
                          onClick={() => {
                            setFilterBy(option);
                            setShowFilterDropdown(false);
                          }}
                        >
                          {option === 'all' ? 'All Chats' :
                           option === 'pinned' ? 'Pinned' : 'Favorites'}
                          {filterBy === option && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
                    <div className="chats-history-divider" />

{showingSearchResults ? (
  <div className="chats-search-results">
    <div className="chats-results-header">
      <h3 className="chats-results-title">
        {filteredAndSortedChats.length} result{filteredAndSortedChats.length !== 1 ? 's' : ''}
        {searchQuery && ` for "${searchQuery}"`}
      </h3>
    </div>

    {filteredAndSortedChats.length === 0 ? (
      <div className="chats-history-empty-state">
        <div className="chats-history-empty-icon">🔍</div>
        <p className="chats-history-empty-text">No chats found</p>
      </div>
    ) : (
      <div className="chats-history-chat-list-container">
        {filteredAndSortedChats.map((chat) => (
          <div
            key={`chat-${chat.id}`}
            className={`chats-history-chat-item-card ${chat.pinned ? 'chats-pinned' : ''}`}
          >
            <div
              className="chats-history-chat-item-inner"
              onClick={() => {
                console.log('🔐 Clicked chat:', chat.id);
                onSelectChat(chat);
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="chats-preview-header">
                {chat.pinned && (
                  <div className="chats-pinned-badge">
                    <Pin size={12} /> Pinned
                  </div>
                )}
                {chat.tag && (
                  <div
                    className="chats-tag-badge"
                    style={{
                      background: getTagColor(chat.tag),
                      color: 'white'
                    }}
                  >
                    {chat.tag}
                  </div>
                )}
              </div>
              <div className="chats-history-chat-preview">{chat.preview || 'No preview'}</div>
              <div className="chats-history-chat-meta">
                <span className="chats-history-chat-date">
                  {new Date(chat.lastUpdated || chat.timestamp).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                </span>
                <span className="chats-history-meta-divider">•</span>
                <span className="chats-history-chat-messages">
                  {chat.messageCount || chat.messages?.length || 0} messages
                </span>
              </div>
            </div>

            <div className="chats-action-buttons">
              <button
                onClick={(e) => handleTogglePin(e, chat.id)}
                className={`chats-icon-btn ${chat.pinned ? 'active' : ''}`}
                title={chat.pinned ? "Unpin" : "Pin"}
              >
                <Pin size={16} />
              </button>
              <button
                onClick={(e) => handleToggleFavorite(e, chat.id)}
                className={`chats-icon-btn ${chat.favorited ? 'active' : ''}`}
                title={chat.favorited ? "Unfavorite" : "Favorite"}
              >
                <Star size={16} fill={chat.favorited ? "currentColor" : "none"} />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteConfirm(chat.id);
                }}
                className="chats-icon-btn delete"
                title="Delete chat"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
) : (
  <>
    {allChats.length === 0 ? (
      <div className="chats-history-empty-state">
        <div className="chats-history-empty-icon">💬</div>
        <p className="chats-history-empty-text">No chat history yet.</p>
        <p className="chats-history-empty-subtext">Start a conversation to see it here!</p>
      </div>
    ) : (
      <div className="chats-history-folders-grid">
{Object.entries(organizedChats).map(([monthYear, weeks], idx) => {
  const color = folderColors[idx % folderColors.length];
  const totalChats = Object.values(weeks).flat().length;
  const isCurrentMonth = monthYear === getCurrentMonth(); // ✅ ADD THIS

  return (
    <div
      key={`month-${monthYear}`}
      onClick={() => setExpandedMonth(monthYear)}
      className={`chats-history-folder-card ${
        isCurrentMonth ? 'chats-history-current-month-highlight' : ''
      }`} // ✅ ADD CONDITIONAL CLASS
    >
      <div className="chats-history-folder-card-inner">
        {isCurrentMonth && ( // ✅ ADD THIS BADGE
          <div className="chats-history-current-month-badge">Current Month</div>
        )}
        <div className="chats-history-folder-icon-wrapper">
          <FolderIcon color={color} />
        </div>
        <div className="chats-history-folder-info">
          <div className="chats-history-folder-name">{monthYear}</div>
          <div className="chats-history-folder-count">
            {totalChats} chat{totalChats !== 1 ? 's' : ''}
          </div>
        </div>
      </div>
    </div>
  );
})}
      </div>
    )}
  </>
)}
        </div>

        {showClearConfirm && (
          <div className="chats-history-modal-overlay" onClick={() => setShowClearConfirm(false)}>
            <div className="chats-history-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="chats-history-modal-header">
                <h3 className="chats-history-modal-title">Clear All Chat History?</h3>
                <p className="chats-history-modal-description">
                  This will permanently delete all your chat history. This action cannot be undone.
                </p>
              </div>

              <div className="chats-history-modal-actions">
                <button
                  onClick={() => setShowClearConfirm(false)}
                  className="chats-history-modal-button chats-history-cancel-btn"
                >
                  Cancel
                </button>
                <button
                  onClick={handleClearAll}
                  className="chats-history-modal-button chats-history-confirm-btn"
                >
                  Clear All
                </button>
              </div>
            </div>
          </div>
        )}

        {deleteConfirm && (
          <div className="chats-history-modal-overlay" onClick={() => setDeleteConfirm(null)}>
            <div className="chats-history-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="chats-history-modal-header">
                <h3 className="chats-history-modal-title">Delete Chat?</h3>
                <p className="chats-history-modal-description">
                  This will permanently delete this chat. This action cannot be undone.
                </p>
              </div>

              <div className="chats-history-modal-actions">
                <button
                  onClick={() => setDeleteConfirm(null)}
                  className="chats-history-modal-button chats-history-cancel-btn"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => handleDeleteChat(e, deleteConfirm)}
                  className="chats-history-modal-button chats-history-confirm-btn"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
  const styles = `
  * { 
    box-sizing: border-box; 
    margin: 0;
    padding: 0;
  }
      /* Current Month Highlight */
  .chats-history-folder-card.chats-history-current-month-highlight {
    border: 2px solid #3b82f6;
    background: rgba(59, 130, 246, 0.08);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }

  .chats-history-folder-card.chats-history-current-month-highlight .chats-history-folder-card-inner {
    background: rgba(255, 255, 255, 0.95);
  }

  .chats-history-current-month-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #3b82f6;
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 10;
  }
  .chats-history-folder-card.chats-history-current-month-highlight {
    border: 2px solid #3b82f6;
    background: rgba(59, 130, 246, 0.08);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }

  .chats-history-folder-card.chats-history-current-month-highlight .chats-history-folder-card-inner {
    background: rgba(255, 255, 255, 0.95);
  }

  .chats-history-current-month-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #3b82f6;
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .chats-history-chat-history-container {
    min-height: 100vh;
    background: linear-gradient(170deg, #e3e3e3d8 0%, #fefefecf 60%, #e0e7fcb2 100%);
    padding: 80px 16px 16px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }

  .chats-history-chat-history-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .chats-history-header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .chats-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .chats-stats-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #1f1f1fff;
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }


  .chats-history-main-title {
    font-size: 20px;
    font-weight: 500;
    color: #1f2937;
  }

  .chats-history-clear-button {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #ef4444;
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(239, 68, 68, 0.3);
    transition: all 0.2s ease;
  }

  .chats-history-clear-button:hover {
    background: #dc2626;
    box-shadow: 0 3px 6px rgba(220, 38, 38, 0.4);
    transform: translateY(-1px);
  }

  /* Statistics */
  .chats-stats-container {
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(20px);
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.8);
  }

  .chats-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
  }

  .chats-stat-card {
    background: white;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .chats-stat-icon {
    color: #1f2937;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  .chats-stat-content {
    flex: 1;
  }

  .chats-stat-value {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    line-height: 1;
    margin-bottom: 4px;
  }

  .chats-stat-label {
    font-size: 11px;
    color: #6b7280;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .chats-stat-highlight {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #1f1f1fff;
    color: white;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
  }

  .chats-stat-highlight strong {
    font-weight: 600;
  }

  /* Search Section */
  .chats-search-section {
    margin-bottom: 20px;
  }

  .chats-search-bar {
    position: relative;
    margin-bottom: 12px;
  }

  .chats-search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
  }

  .chats-search-input {
    width: 100%;
    padding: 12px 40px 12px 44px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    transition: all 0.2s ease;
  }

  .chats-search-input:focus {
    outline: none;
    border-color: #3b82f6;
    background: white;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .chats-search-clear {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
  }

  .chats-search-clear:hover {
    background: #f3f4f6;
    color: #1f2937;
  }

  .chats-filters {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  /* Custom Dropdown */
  .chats-custom-dropdown {
    position: relative;
  }

  .chats-dropdown-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    font-size: 13px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    cursor: pointer;
    transition: all 0.2s ease;
    color: #1f2937;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    white-space: nowrap;
  }

  .chats-dropdown-button:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: #d1d5db;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  }

  .chats-dropdown-button svg {
    transition: transform 0.2s ease;
  }

  .chats-dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    min-width: 160px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    padding: 6px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    z-index: 100;
    animation: dropdownFadeIn 0.2s ease;
  }

  @keyframes dropdownFadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .chats-dropdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.15s ease;
    user-select: none;
  }

  .chats-dropdown-item:hover {
    background: rgba(31, 41, 55, 0.1);
    color: #1f2937;
  }

  .chats-dropdown-item.active {
    background: rgba(0, 0, 0, 0.1);
    color: black;
    font-weight: 600;
  }

  .chats-dropdown-item.active:hover {
    background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
  }

  .chats-dropdown-item svg {
    flex-shrink: 0;
  }

  .chats-search-results {
    margin-bottom: 20px;
  }

  .chats-results-header {
    margin-bottom: 16px;
  }

  .chats-results-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
  }

  .chats-history-divider {
    height: 1px;
    width: 100%;
    background: #e5e7eb;
    margin-bottom: 24px;
  }

  .chats-history-back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(236, 236, 236, 0.92);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    color: #000000ff;
    padding: 10px 10px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;
  }

  .chats-history-section-header {
    margin-bottom: 24px;
  }

  .chats-history-section-title {
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 8px;
  }

  .chats-history-folders-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
  }

  .chats-history-folder-card {
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(20px);
    border-radius: 16px;
    padding: 5px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .chats-history-folder-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border-color: rgba(255, 255, 255, 0.9);
  }

  .chats-history-folder-card.chats-history-current-highlight {
    border: 2px solid #3b82f6;
    background: rgba(59, 130, 246, 0.1);
  }

  .chats-history-folder-card-inner {
    background: white;
    border-radius: 12px;
    padding: 20px;
    position: relative;
  }

  .chats-history-current-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #3b82f6;
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .chats-history-folder-icon-wrapper {
    width: 48px;
    height: 48px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  .chats-history-folder-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .chats-history-folder-name {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
  }

  .chats-history-folder-count {
    font-size: 13px;
    color: #6b7280;
  }

  .chats-history-chat-list-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .chats-history-chat-item-card {
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(20px);
    border-radius: 12px;
    padding: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .chats-history-chat-item-card.chats-pinned {
    border: 1px solid #1f29374d;
    background: rgba(31, 41, 55, 0.04);
  }

  .chats-history-chat-item-card:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .chats-history-chat-item-card:hover .chats-action-buttons {
    opacity: 1;
  }

  .chats-history-chat-item-inner {
    background: white;
    border-radius: 9px;
    padding: 16px;
    flex: 1;
    position: relative;
  }

  .chats-preview-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .chats-tag-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .chats-pinned-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #1f2937;
    color: white;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .chats-action-buttons {
    display: flex;
    gap: 4px;
    padding-right: 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .chats-icon-btn {
    background: white;
    border: 1px solid #e5e7eb;
    color: #6b7280;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }

  .chats-icon-btn:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
    transform: scale(1.1);
  }

  .chats-icon-btn.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }

  .chats-icon-btn.delete {
    color: #ef4444;
  }

  .chats-icon-btn.delete:hover {
    background: #fee2e2;
    border-color: #fecaca;
  }

  .chats-history-chat-preview {
    font-size: 15px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 8px;
    line-height: 1.5;
        text-align:left;
  }

  .chats-history-chat-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #9ca3af;
  }

  .chats-history-chat-date {
    color: #6b7280;
  }

  .chats-history-meta-divider {
    color: #d1d5db;
  }

  .chats-history-chat-messages {
    color: #6b7280;
  }

  .chats-history-empty-state {
    text-align: center;
    padding: 80px 20px;
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.7);
  }

  .chats-history-empty-icon {
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  .chats-history-empty-text {
    font-size: 16px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 8px;
  }

  .chats-history-empty-subtext {
    font-size: 14px;
    color: #9ca3af;
  }

  .chats-history-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    padding: 20px;
  }

  .chats-history-modal-content {
    background: white;
    border-radius: 20px;
    padding: 28px;
    max-width: 440px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .chats-history-modal-header {
    margin-bottom: 24px;
  }

  .chats-history-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 12px;
  }

  .chats-history-modal-description {
    font-size: 14px;
    color: #6b7280;
    line-height: 1.6;
  }

  .chats-history-modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }

  .chats-history-modal-button {
    padding: 10px 20px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
  }

  .chats-history-cancel-btn {
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #e5e7eb;
  }

  .chats-history-cancel-btn:hover {
    background: #e5e7eb;
  }

  .chats-history-confirm-btn {
    background: #dc2626;
    color: white;
  }

  .chats-history-confirm-btn:hover {
    background: #b91c1c;
  }

  @media (max-width: 768px) {
    .chats-history-chat-history-container {
      padding: 70px 12px 12px;
    }

    .chats-history-folders-grid {
      grid-template-columns: 1fr;
    }

    .chats-stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .chats-history-main-title {
      font-size: 18px;
    }

    .chats-history-section-title {
      font-size: 20px;
    }

    .chats-history-folder-icon-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      margin-bottom: 10px;
    }

    .chats-history-folder-card-inner {
      padding: 16px;
    }

    .chats-history-folder-name {
      font-size: 13px;
      text-align: left;
    }

    .chats-history-folder-count {
      font-size: 12px;
      text-align: left;
    }

    .chats-action-buttons {
      opacity: 1;
    }

    .chats-filters {
      width: 100%;
    }

    .chats-filter-select {
      flex: 1;
    }
  }
`;

useEffect(() => {
  const loadSessions = async () => {
    if (currentMode === 'chats' && firestoreService?.isReady?.()) {
      try {
        console.log('📂 Loading sessions...');
        const sessions = await firestoreService.getAllChatSessions(100);
        
        // ✅ Sanitize sessions - ensure they have dates
        const sanitizedSessions = (sessions || []).map(session => {
          // If no date field, use current time as default
          if (!session.lastUpdated && !session.timestamp && !session.savedAt) {
            console.warn('⚠️ Session missing date, adding default:', session.id);
            return {
              ...session,
              lastUpdated: new Date().toISOString(),
              savedAt: new Date().toISOString()
            };
          }
          return session;
        });

        setAllSessions(sanitizedSessions);
        console.log('✅ Loaded', sanitizedSessions.length, 'sessions');
      } catch (error) {
        console.error('❌ Failed to load sessions:', error);
        setAllSessions([]);
      }
    }
  };

  loadSessions();
}, [currentMode, firestoreService]); // ← Dependencies
 // ✅ FUNCTION: Load a chat session
  const loadChatSessionFromHistory = async (sessionId) => {
    try {
      console.log('📂 Loading session:', sessionId);
      setIsLoadingSession(true);

      // ✅ If already open, just switch modes
      if (currentSessionId === sessionId && messages.length > 0) {
        console.log('✅ Session already loaded');
        setCurrentMode('chat');
        setIsLoadingSession(false);
        return true;
      }

      // ✅ Save current session before switching
      if (currentSessionId && messages.length > 0) {
        try {
          console.log('💾 Auto-saving current session...');
          await firestoreService.saveConversation({
            id: currentSessionId,
            messages: messages,
            preview: messages[0]?.content || 'Chat',
            messageCount: messages.length,
            timestamp: new Date().toISOString(),
            lastUpdated: new Date().toISOString(),
            tag: autoTagChat({
              preview: messages[0]?.content || '',
              messages: messages
            })
          });
          console.log('✅ Current session saved');
        } catch (error) {
          console.error('⚠️ Failed to save current session:', error);
        }
      }

      // ✅ TRY 1: Get from memory (fastest)
      console.log('🔍 Looking for session in memory...');
      let session = null;

      if (allSessions && allSessions.length > 0) {
        session = allSessions.find(s => s.id === sessionId);
        if (session) {
          console.log('✅ Found in allSessions (memory)');
        }
      }

      // ✅ TRY 2: Get from Firestore (slower)
      if (!session) {
        console.log('🔍 Looking for session in Firestore...');
        session = await firestoreService.getSavedChatSession(sessionId);

        if (session) {
          console.log('✅ Found in Firestore');
        }
      }

      // ✅ Handle not found
      if (!session) {
        console.error('❌ Session not found anywhere:', sessionId);
        setMessages([{
          id: Date.now(),
          type: 'bot',
          content: '⚠️ This chat session could not be found.',
          timestamp: new Date().toISOString()
        }]);
        setIsLoadingSession(false);
        return false;
      }

      // ✅ Validate and load messages
      if (!session.messages || !Array.isArray(session.messages)) {
        console.error('❌ Invalid session structure');
        setMessages([{
          id: Date.now(),
          type: 'bot',
          content: '⚠️ This chat session has no messages.',
          timestamp: new Date().toISOString()
        }]);
        setIsLoadingSession(false);
        return false;
      }

      const validMessages = session.messages.filter(msg =>
        msg && msg.content && typeof msg.content === 'string' && msg.content.trim()
      );

      if (validMessages.length === 0) {
        console.error('❌ No valid messages');
        setMessages([{
          id: Date.now(),
          type: 'bot',
          content: '⚠️ This chat has no valid messages.',
          timestamp: new Date().toISOString()
        }]);
        setIsLoadingSession(false);
        return false;
      }

      // ✅ Load the session
      console.log('✅ Loading', validMessages.length, 'messages');
      setMessages(validMessages);
      setCurrentSessionId(sessionId);
      setCurrentMode('chat');

      setTimeout(() => scrollToBottom('smooth'), 300);

      console.log('✅ Session loaded successfully');
      setIsLoadingSession(false);
      return true;

    } catch (error) {
      console.error('❌ Error loading session:', error);
      setMessages([{
        id: Date.now(),
        type: 'bot',
        content: `❌ Failed to load: ${error.message}`,
        timestamp: new Date().toISOString()
      }]);
      setCurrentMode('chat');
      setIsLoadingSession(false);
      return false;
    }
  };
useEffect(() => {
  const checkSurveyOnLoad = async () => {
    try {
      if (!firestoreService?.isReady?.()) {
        console.log('⏳ Firestore not ready yet');
        return;
      }

      console.log('🔍 Checking survey status on app load...');

      const settings = await firestoreService.getUserSettings();
      const surveyCompleted = settings?.surveyCompleted || false;
      const chatSessionCount = settings?.chatSessionCount || 0;

      console.log('📊 Current state:', {
        surveyCompleted,
        chatSessionCount,
        shouldShowSurvey: !surveyCompleted && chatSessionCount === 2 // ✅ Changed from >= to ===
      });

      // ✅ FIXED: Show survey ONLY if exactly 2 sessions completed (before 3rd)
      if (!surveyCompleted && chatSessionCount === 2) {
        console.log('📋 Survey needed - showing on app load (after 2 completed sessions)');
        setShowSurvey(true);
      }

    } catch (error) {
      console.error('Error checking survey on load:', error);
    }
  };

  if (firestoreService?.isReady?.() && !hasCheckedSurveyOnLoad) {
    checkSurveyOnLoad();
    setHasCheckedSurveyOnLoad(true);
  }
}, [firestoreService, hasCheckedSurveyOnLoad]);
const newChatHandler = async () => {
  if (isHumeConnected) {
    disconnectHume();
  }

  if (currentMode === 'chat') {
    console.log('✨ Starting new chat process...');

    // ✅ ONLY CHECK SURVEY IF CURRENT CHAT HAS MESSAGES
    const hasCurrentChatMessages = messages && messages.length > 0;

    if (hasCurrentChatMessages && firestoreService?.isReady?.()) {
      try {
        const settings = await firestoreService.getUserSettings();
        const surveyCompleted = settings?.surveyCompleted || false;
        const chatSessionCount = settings?.chatSessionCount || 0;
        
        console.log('📊 Survey check before new chat:', {
          chatSessionCount,
          surveyCompleted,
          currentSessionHasMessages: hasCurrentChatMessages,
          shouldShowSurvey: !surveyCompleted && chatSessionCount === 2 // ✅ Changed from >= to ===
        });

        // ✅ FIXED: Show survey if user has completed exactly 2 sessions
        // This means they're starting their 3rd session, so survey appears BEFORE they chat
        if (!surveyCompleted && chatSessionCount === 2) {
          console.log('📊 Survey needed - user completed 2 sessions, starting 3rd', { 
            chatSessionCount,
            surveyCompleted
          });
          setShowSurvey(true);
          
if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}
          return; // ✅ Don't start new chat yet - wait for survey
        }

        console.log('📈 No survey needed - proceeding with new chat:', {
          chatSessionCount,
          surveyCompleted
        });
      } catch (error) {
        console.error('Error checking survey:', error);
      }
    }

    // ✅ SAVE CURRENT SESSION (only if it has messages)
    if (currentSessionId && messages.length > 0) {
      try {
        const now = new Date().toISOString();
        
        await firestoreService.saveConversation({
          id: currentSessionId,
          messages: messages,
          preview: messages[0]?.content || 'Chat',
          messageCount: messages.length,
          timestamp: now,
          lastUpdated: now,
          tag: autoTagChat({
            preview: messages[0]?.content || '',
            messages: messages
          })
        });

        // ✅ INCREMENT SESSION COUNT (this counts the completed session)
        const settings = await firestoreService.getUserSettings();
        const currentCount = settings?.chatSessionCount || 0;
        await firestoreService.updateUserData({
          'settings.chatSessionCount': currentCount + 1,
          'settings.lastChatCreated': now
        });

        console.log('💾 Session saved and counted, total sessions:', currentCount + 1);
      } catch (error) {
        console.error('Failed to save session:', error);
      }
    }

    // ✅ RESET TO BLANK CHAT
    setMessages([]);
    setActiveSessionId(null);
    setCurrentSessionId(null);
    setInputValue('');
    setIsProcessingAzure(false);
    setIsTakingNotes(false);
    setIsJournaling(false);
    setDetectedVibe(null);
    setShowPlusOptions(false);
    setIsMultiline(false);
    setTextareaHeight('44px');

if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}

    console.log('✅ New blank chat session started');
  } else {
    console.log('🔀 Navigating to chat');
    setCurrentMode('chat');
if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}
  }
};
const handleSurveyClose = async () => {
  console.log('✅ Survey closed - starting new chat');
  setShowSurvey(false);
  
  // ✅ Now that survey is done, proceed with new chat
  // Reset messages and start fresh
  setMessages([]);
  setActiveSessionId(null);
  setCurrentSessionId(null);
  setInputValue('');
  
if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}
};
const renderChatsMode = () => {

  return (
    <ProfessionalChatHistory
      onSelectChat={(sessionId) => {
        console.log('📂 User selected chat:', sessionId);
        // ✅ Pass allSessions to the load function
        loadChatSessionFromHistory(sessionId);
      }}
      firestoreService={firestoreService}
      currentSessionId={currentSessionId}
    />
  );
};

const displayMessageWithTyping = (messageId, fullContent, additionalData = {}) => {
  let currentIndex = 0;
  const charsPerInterval = 43; // Add multiple characters at once for speed
  const typingSpeed = 10; // Much faster interval (10ms)
  
  setTypingMessageId(messageId);
  
  typingIntervalRef.current = setInterval(() => {
    currentIndex += charsPerInterval; // Increment by multiple characters
    
    setMessages(prev => prev.map(msg => {
      if (msg.id === messageId) {
        if (currentIndex >= fullContent.length) {
          // Typing complete
          clearInterval(typingIntervalRef.current);
          setTypingMessageId(null);
          return {
            ...msg,
            content: fullContent,
            isLoading: false,
            isTyping: false,
            ...additionalData
          };
        }
        // Still typing
        return {
          ...msg,
          content: fullContent.substring(0, currentIndex),
          isLoading: false,
          isTyping: true
        };
      }
      return msg;
    }));
    
    if (currentIndex >= fullContent.length) {
      clearInterval(typingIntervalRef.current);
      setTypingMessageId(null);
    }
  }, typingSpeed);
};


  // Icon components with proper JSX
  const JournalIcon = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
  /**
   * Handle journal saving
   */
  
const handleJournalSave = async (toolCallId, args, messageHistory) => {
  console.log('💾 Saving journal entry:', args);
  
  const savingMessageId = Date.now();
  setMessages(prev => [...prev, {
    id: savingMessageId,
    type: 'bot',
    content: 'Saving your journal🍁',
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // Build conversation from messages
    const journalingStartIndex = messages.findIndex(msg => 
      msg.type === 'bot' && 
      (msg.content?.includes('📝') || 
       msg.content?.toLowerCase().includes('taking notes') ||
       msg.content?.toLowerCase().includes('what would you like to journal'))
    );
    
    const conversationForJournal = messages
      .slice(journalingStartIndex >= 0 ? journalingStartIndex : 0)
      .filter(msg => {
        return !msg.isLoading && 
               !msg.isPodcast && 
               !msg.isJournalSaved &&
               msg.content && 
               msg.content.trim() &&
               !msg.content.includes('💾 Saving your journal');
      });
    
    console.log('✅ Journal conversation:', conversationForJournal.length, 'messages');
    
    // Prepare journal data with ACTUAL conversation
    const journalData = {
      title: args.title,
      header: args.title,
      summary: args.summary,
      insights: args.insights || '',
      conversation: conversationForJournal,
      sessionStartTime: conversationForJournal[0]?.timestamp || new Date().toISOString(),
      question: conversationForJournal[0]?.content || ''
    };
    
    // Save to journal storage
    const savedJournal = await journalStorage.saveJournal(journalData);
    console.log('✅ Journal saved successfully:', savedJournal.id);
    
    // Send success result to Azure
    const toolResult = {
      success: true,
      journal_id: savedJournal.id,
      title: savedJournal.title,
      message: `Your journal entry "${savedJournal.title}" has been saved successfully.`
    };
    
    try {
      await sendToolResult(
        messageHistory,
        toolCallId,
        'save_journal_entry',
        args,
        toolResult
      );
    } catch (azureError) {
      console.error('Failed to send result to Azure:', azureError);
    }
    
    // Update message with success state
    setMessages(prev => 
      prev.map(msg => 
        msg.id === savingMessageId 
          ? { 
              ...msg, 
              content: `Your journal "${savedJournal.title}" has been saved!`,
              isLoading: false,
              isJournalSaved: true,
              journalData: savedJournal,
              showJournalButton: true
            }
          : msg
      )
    );
    
    // Reset journaling state
    setIsJournaling(false);
    setJournalConversation([]);
    
  } catch (error) {
    console.error('❌ Journal saving error:', error);
    
    setMessages(prev => 
      prev.map(msg => 
        msg.id === savingMessageId 
          ? { 
              ...msg, 
              content: 'Something went wrong saving your journal. Please try again!',
              isLoading: false
            }
          : msg
      )
    );
    
    try {
      await sendToolResult(
        messageHistory,
        toolCallId,
        'save_journal_entry',
        args,
        { success: false, error: 'Failed to save journal' }
      );
    } catch (azureError) {
      console.error('Failed to send error to Azure:', azureError);
    }
  }
};
/**
 * Check if user is explicitly requesting a podcast/audio summary
 */
const isExplicitPodcastRequest = (message) => {
  if (!message) return false;
  
  const lowerMessage = message.toLowerCase();
  
  const podcastKeywords = [
    'create a podcast',
    'make a podcast',
    'generate a podcast',
    'podcast about',
    'turn this into a podcast',
    'turn it into a podcast',
    'convert to podcast',
    'convert this to podcast',
    'audio summary',
    'summarize into audio',
    'make an audio',
    'create an audio summary',
    'podcast summary',
    'audio version',
    'podcast version',
    'convert to audio',
    'turn into audio'
  ];
  
  return podcastKeywords.some(keyword => lowerMessage.includes(keyword));
};


  const BellIcon = () => (
    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m10.827 5.465-.435-2.324m.435 2.324a5.338 5.338 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.338 5.338 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5-6.818 1.277Z"/>
    </svg>
  );

  const FocusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
    const PodcastIcon = () => (
<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M20 16v-4a8 8 0 1 0-16 0v4m16 0v2a2 2 0 0 1-2 2h-2v-6h2a2 2 0 0 1 2 2ZM4 16v2a2 2 0 0 0 2 2h2v-6H6a2 2 0 0 0-2 2Z"/>
</svg>

  );

  const CollabIcon = () => (
    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>
    </svg>
  );

const plusOptions = [
  {
    id: 'Report Bug',
    name: 'Report Bug',
    icon: <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.0618 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
  },
];
  // Original handlePodcastGeneration with duration - for tool calls from Azure
  const handlePodcastGeneration = async (toolCallId, args, messageHistory) => {
    if (!args || !args.topic) {
      console.error('Invalid args passed to handlePodcastGeneration');
      return;
    }
  
    const topic = args.topic;
    
    // CRITICAL: Check if request is vague
    if (isVaguePodcastRequest(topic)) {
      console.log('⚠️ Vague podcast request, should have asked for clarification first');
      
      // This shouldn't happen if AI follows instructions, but handle gracefully
      setMessages(prev => [...prev, {
        id: Date.now(),
        type: 'bot',
        content: "I'd love to create your Inner Loop podcast! What topic would you like me to cover? For example:\n- Today's tech news\n- Business headlines\n- Sports updates\n- A specific topic you're interested in",
        timestamp: new Date().toISOString()
      }]);
      return;
    }
    
    const userName = args.user_name || getStoredUserName();
    const searchResults = args.searchResults || null;
    
    // Parse and validate duration
    let durationMinutes = args.duration_minutes;
    if (!durationMinutes) {
      durationMinutes = parseDuration(topic);
    }
    
    const validation = validateDuration(durationMinutes);
    const finalDuration = validation.minutes;
    
    console.log('🎙️ Podcast request:', {
      topic,
      requestedDuration: durationMinutes,
      finalDuration,
      userName: userName || 'Anonymous'
    });
    
    const loadingMessageId = Date.now();
    setMessages(prev => [...prev, {
      id: loadingMessageId,
      type: 'bot',
      content: validation.message 
        ? validation.message + '\n\nCreating your Inner Loop podcast...'
        : `Creating your ${finalDuration}-minute Inner Loop podcast...`,
      isLoading: true,
      loadingStage: 'generating'
    }]);
    
    try {
      // Generate dialogue
      const result = await generatePodcastDialogueWithDuration(
        topic, 
        searchResults, 
        userName,
        finalDuration,
        AZURE_OPENAI_ENDPOINT,
        AZURE_OPENAI_DEPLOYMENT,
        AZURE_OPENAI_API_KEY
      );
      
      const { dialogue, metadata } = result;
      
      setMessages(prev => 
        prev.map(msg => 
          msg.id === loadingMessageId 
            ? { 
                ...msg, 
                content: `Generating audio for your ${finalDuration}-minute Inner Loop episode...`, 
                loadingStage: 'processing' 
              }
            : msg
        )
      );
      
      const updateProgress = (progressText, stage) => {
        setMessages(prev => 
          prev.map(msg => 
            msg.id === loadingMessageId 
              ? { ...msg, content: progressText, loadingStage: stage }
              : msg
          )
        );
      };
      
  const audioUrl = await combineAudioSegments(dialogue, updateProgress, true);
  
      const episodeTitle = topic.replace(/\d+\s*min(?:ute)?s?/gi, '').trim();
      
      const toolResult = {
        podcast_title: episodeTitle,
        duration_minutes: finalDuration,
        estimated_duration: metadata.estimatedDuration,
        word_count: metadata.wordCount,
        guest_configuration: metadata.guestConfiguration,
        message: `Created ${finalDuration}-minute Inner Loop podcast: "${episodeTitle}"`,
        success: true
      };
      
      try {
        await sendToolResult(messageHistory, toolCallId, 'generate_podcast_dialogue', args, toolResult);
      } catch (azureError) {
        console.error('Failed to send result to Azure:', azureError);
      }
      
  setMessages(prev => 
    prev.map(msg => 
      msg.id === loadingMessageId 
        ? { 
            ...msg, 
            content: `Your ${finalDuration}-minute Inner Loop podcast "${episodeTitle}" is ready!`,
            dialogue,
            audioUrl,
            topic: episodeTitle,
            isPodcast: true,
            isLoading: false,
            searchResults,
            podcastTitle: episodeTitle,
            duration: finalDuration,
            metadata
          }
        : msg
    )
  );
  
    } catch (error) {
      console.error('Podcast error:', error);
      setMessages(prev => 
        prev.map(msg => 
          msg.id === loadingMessageId 
            ? { ...msg, content: 'Generation failed. Try again!', isLoading: false }
            : msg
        )
      );
    }
  };
  

useEffect(() => {
  if (firestoreService && memoryService && !goalService) {
    const service = new GoalLifecycleService(firestoreService, memoryService);
    setGoalService(service);
    
    // ✅ Load separated goals
    loadTimeframeSeparatedGoals(service);
  }
}, [firestoreService, memoryService]);

/**
 * Load goals separated by timeframe
 */
const loadTimeframeSeparatedGoals = async (goalServiceRef) => {
  if (!goalServiceRef || !user?.uid) return;
  
  try {
    // Get all goals
    const allGoals = await goalServiceRef.getAllGoals(user.uid);
    
    if (!allGoals) {
      console.log('No goals found');
      return;
    }

    // ✅ Separate by timeframe
    const now = new Date();
    
    const shortTerm = allGoals.filter(goal => {
      const daysUntilDue = goalServiceRef.calculateDaysUntilDue(goal);
      return daysUntilDue >= 0 && daysUntilDue <= 7; // 1-7 days
    });

    const mediumTerm = allGoals.filter(goal => {
      const daysUntilDue = goalServiceRef.calculateDaysUntilDue(goal);
      const daysInMonths = 30;
      return daysUntilDue > 7 && daysUntilDue <= (3 * daysInMonths); // 1-3 months
    });

    const longTerm = allGoals.filter(goal => {
      const daysUntilDue = goalServiceRef.calculateDaysUntilDue(goal);
      return daysUntilDue > (3 * 30); // 3+ months or no deadline
    });

    setGoalsShortTerm(shortTerm);
    setGoalsMediumTerm(mediumTerm);
    setGoalsLongTerm(longTerm);

    console.log('✅ Goals separated:', {
      shortTerm: shortTerm.length,
      mediumTerm: mediumTerm.length,
      longTerm: longTerm.length
    });

  } catch (error) {
    console.error('Error loading separated goals:', error);
  }
};

// ============================================
// 3. LOAD SEPARATED MEMORIES
// ============================================

useEffect(() => {
  if (memoryService && user?.uid) {
    loadTimeframeSeparatedMemories();
  }
}, [memoryService, user?.uid]);
useEffect(() => {
  const loadTimeframeSeparatedMemories = async () => {
    if (!memoryService || !memoryService.isReady()) return;

    try {
      console.log('🧠 Loading separated memories...');
      
      // ✅ Use new methods with timeframe filters
      const shortTerm = await memoryService.getShortTermMemories(10);
      const longTerm = await memoryService.getLongTermMemories(20);

      setMemoriesShortTerm(shortTerm || []);
      setMemoriesLongTerm(longTerm || []);

      console.log('✅ Memories separated:', {
        shortTerm: shortTerm?.length || 0,
        longTerm: longTerm?.length || 0
      });

      // ✅ Display summary
      if (shortTerm?.length > 0) {
        console.log('📌 Short-term memories (7 days):');
        shortTerm.forEach(m => {
          const expiresAt = m.expiresAt?.toDate();
          console.log(`   - ${m.memory} (expires: ${expiresAt?.toLocaleDateString()})`);
        });
      }

      if (longTerm?.length > 0) {
        console.log('📚 Long-term memories (permanent):');
        longTerm.slice(0, 3).forEach(m => {
          console.log(`   - ${m.memory}`);
        });
      }

    } catch (error) {
      console.error('Error loading separated memories:', error);
    }
  };

  loadTimeframeSeparatedMemories();
  
  // ✅ IMPORTANT: Cleanup expired memories on load
  if (memoryService?.isReady()) {
    memoryService.cleanupExpiredMemories().then(count => {
      if (count > 0) {
        console.log(`🗑️ Cleaned up ${count} expired memories`);
        // Reload memories after cleanup
        loadTimeframeSeparatedMemories();
      }
    });
  }
}, [memoryService, user?.uid]);

const loadTimeframeSeparatedMemories = async () => {
  if (!memoryService || !memoryService.isReady()) return;

  try {
    // ✅ Get long-term memories
    const longTerm = await firestoreService.getAllActiveMemories(); // or use collection query
    
    // ✅ Get short-term memories (expiring soon)
    const shortTerm = await firestoreService.getShortTermMemories();

    setMemoriesLongTerm(longTerm || []);
    setMemoriesShortTerm(shortTerm || []);

    console.log('✅ Memories separated:', {
      shortTerm: shortTerm?.length || 0,
      longTerm: longTerm?.length || 0
    });

  } catch (error) {
    console.error('Error loading separated memories:', error);
  }
};

{/* (UseEffect Notif..)
useEffect(() => {
  const initializeNotifications = async () => {
    // ✅ Wait for all required services
    if (!firestoreService?.isReady?.() || !memoryService || !AZURE_OPENAI_ENDPOINT) {
      return;
    }

    // Only initialize once
    if (notificationService) return;

    try {
      console.log('🔔 Initializing notification service...');

      const azureConfig = {
        endpoint: AZURE_OPENAI_ENDPOINT,
        deployment: AZURE_OPENAI_DEPLOYMENT,
        apiKey: AZURE_OPENAI_API_KEY
      };

      const service = new SmartNotificationService(
        azureConfig,
        firestoreService,
        memoryService
      );

      await service.initialize();
      setNotificationService(service);

      console.log('✅ Notification service ready');

    } catch (error) {
      console.error('❌ Notification service init failed:', error);
    }
  };

  initializeNotifications();
}, [firestoreService, memoryService, AZURE_OPENAI_ENDPOINT, notificationService]);
 */}

useEffect(() => {
  if (!memoryService?.isReady()) return;

  // Check if cleanup ran today
  const lastCleanup = localStorage.getItem('preptune_last_memory_cleanup');
  const today = new Date().toDateString();

  if (lastCleanup !== today) {
    console.log('🗑️ Running daily memory cleanup...');
    
    memoryService.cleanupExpiredMemories().then(count => {
      console.log(`✅ Cleaned up ${count} expired memories`);
      localStorage.setItem('preptune_last_memory_cleanup', today);
      
      // Reload memories if any were cleaned
      if (count > 0) {
        loadTimeframeSeparatedMemories();
      }
    });
  }
}, [memoryService]);

useEffect(() => {
  if (!timeAwareEngine && AZURE_OPENAI_ENDPOINT && AZURE_OPENAI_API_KEY) {
    const engine = new TimeAwareFollowupEngine({
      endpoint: AZURE_OPENAI_ENDPOINT,
      deployment: AZURE_OPENAI_DEPLOYMENT,
      apiKey: AZURE_OPENAI_API_KEY
    });
    setTimeAwareEngine(engine);
    console.log('✅ TimeAwareFollowupEngine initialized');
  }
}, [AZURE_OPENAI_ENDPOINT, AZURE_OPENAI_API_KEY]);
// ============================================
// LOG AVAILABLE TOOLS CHANGES
// ============================================
useEffect(() => {
  const enabledTools = availableTools
    .filter(tool => tool.visible)
    .map(tool => tool.id);
  
  console.log('🔧 AVAILABLE TOOLS UPDATED:', {
    allTools: availableTools.map(t => ({ id: t.id, visible: t.visible })),
    enabledTools: enabledTools,
    timestamp: new Date().toLocaleTimeString()
  });
}, [availableTools]);

// ============================================
// UPDATE: When starting a new chat
// Generate a proper sessionId
// ============================================

const startNewChat = () => {
  // ✅ Generate unique session ID
  const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  
  setCurrentSessionId(newSessionId);
  setMessages([]);
  setCurrentMode('chat');
  
  console.log('✅ New chat session started:', newSessionId);
};
const handleChatIconClick = () => {
  if (currentMode === 'chat') {
    if (messages.length === 0) {
      console.log('📍 Already on greeting screen');
      return;
    }

    // ✅ SAVE before reset
    if (currentSessionId && messages.length > 0) {
      try {
        firestoreService.saveConversation({
          id: currentSessionId,
          messages: messages,
          preview: messages[0]?.content || 'Chat',
          messageCount: messages.length,
          timestamp: new Date().toISOString(),
          lastUpdated: new Date().toISOString(),
          tag: autoTagChat({
            preview: messages[0]?.content || '',
            messages: messages
          })
        }).then(() => {
          console.log('✅ Session saved before reset');
        }).catch(err => {
          console.error('⚠️ Save failed on reset:', err);
        });
      } catch (error) {
        console.error('Failed to save session before reset:', error);
      }
    }

    // Reset chat
    setMessages([]);
    setActiveSessionId(null);
    setCurrentSessionId(null);
    setInputValue('');

    console.log('✅ Chat reset to greeting screen');
  } else {
    setCurrentMode('chat');
if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}
  }
};

useEffect(() => {
  const interval = setInterval(() => {
    if (currentSessionId && messages.length > 0) {
      autoSaveCurrentSession(); // ← Save every 30 seconds
    }
  }, 30000);
  return () => clearInterval(interval);
}, [currentSessionId, messages]);


const parseRelativeDate = (dateString) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  if (!dateString) return today;
  
  const lower = dateString.toLowerCase().trim();
  
  // TODAY
  if (lower === 'today' || lower === '') return today;
  
  // TOMORROW
  if (lower === 'tomorrow') {
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return tomorrow;
  }
  
  // NEXT [DAY]
  const nextDayMatch = lower.match(/next (monday|tuesday|wednesday|thursday|friday|saturday|sunday)/i);
  if (nextDayMatch) {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const targetDay = days.indexOf(nextDayMatch[1].toLowerCase());
    const currentDay = today.getDay();
    let daysToAdd = targetDay - currentDay;
    if (daysToAdd <= 0) daysToAdd += 7;
    
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + daysToAdd);
    return nextDate;
  }
  
  // Try to parse as date
  const parsed = new Date(dateString);
  if (!isNaN(parsed.getTime())) {
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }
  
  return today;
};

const findEventByTitle = (tasksByDate, eventTitle) => {
  const lowerTitle = eventTitle.toLowerCase().trim();
  
  // Try exact match first
  for (const [dateKey, events] of Object.entries(tasksByDate)) {
    const exactIndex = events.findIndex(e => 
      e.text.toLowerCase().trim() === lowerTitle
    );
    
    if (exactIndex !== -1) {
      return {
        dateKey,
        eventIndex: exactIndex,
        event: events[exactIndex]
      };
    }
  }
  
  // Try partial match
  for (const [dateKey, events] of Object.entries(tasksByDate)) {
    const partialIndex = events.findIndex(e => 
      e.text.toLowerCase().includes(lowerTitle) || 
      lowerTitle.includes(e.text.toLowerCase())
    );
    
    if (partialIndex !== -1) {
      return {
        dateKey,
        eventIndex: partialIndex,
        event: events[partialIndex]
      };
    }
  }
  
  return null;
};

// Cache for memories to avoid repeated fetches
const memoryCache = {
  memories: [],
  lastFetchTime: null,
  lastMemoryIds: new Set(), // ✅ Track memory IDs to detect new ones
  isDirty: false // Flag if new memories were added
};

// ============================================
// NEW HELPER: Check if new memories exist (no fetch)
// ============================================
const hasNewMemoriesAdded = (currentMemoryIds) => {
  // ✅ Compare current IDs with cached IDs
  const newIds = currentMemoryIds.filter(id => !memoryCache.lastMemoryIds.has(id));
  
  if (newIds.length > 0) {
    console.log(`✅ ${newIds.length} new memories detected`);
    memoryCache.isDirty = true;
    return true;
  }
  
  return false;
};
const monitorMemoryChanges = async (memoryService) => {
  if (!memoryService?.isReady?.()) {
    return;
  }

  try {
    const currentMemories = await memoryService.getRecentMemories(50, 30);
    const currentIds = currentMemories.map(m => m.id);
    
    // ✅ Check if new memories were added
    if (hasNewMemoriesAdded(currentIds)) {
      console.log('🔔 New memories detected - will refresh cache on next message');
      memoryCache.isDirty = true;
    }
  } catch (error) {
    console.warn('⚠️ Memory change monitoring failed:', error);
  }
};
// ============================================
// NEW HELPER: Fetch memories ONCE per session
// ============================================
const ensureMemoriesCached = async (memoryService) => {
  if (!memoryService?.isReady?.()) {
    return [];
  }

  const now = Date.now();
  const cacheTTL = 5 * 60 * 1000; // 5-minute cache
  
  // ✅ Return cached if still fresh
  if (memoryCache.lastFetchTime && (now - memoryCache.lastFetchTime) < cacheTTL && !memoryCache.isDirty) {
    console.log('✅ Using cached memories');
    return memoryCache.memories;
  }

  try {
    console.log('🔄 Refreshing memory cache...');
    
    const memories = await memoryService.getRecentMemories(50, 30);
    
    // ✅ Update cache with new memories
    memoryCache.memories = memories;
    memoryCache.lastFetchTime = now;
    memoryCache.lastMemoryIds = new Set(memories.map(m => m.id));
    memoryCache.isDirty = false;
    
    console.log(`✅ Cached ${memories.length} memories`);
    
    return memories;
  } catch (error) {
    console.warn('⚠️ Failed to cache memories:', error);
    return memoryCache.memories; // Return stale cache if fetch fails
  }
};

useEffect(() => {
  if (!memoryService?.isReady?.()) {
    return;
  }

  // ✅ Check for new memories every 30 seconds (background)
  const monitorInterval = setInterval(() => {
    monitorMemoryChanges(memoryService);
  }, 30 * 1000); // 30 seconds

  return () => clearInterval(monitorInterval);
}, [memoryService]);
useEffect(() => {
  const loadUsername = async () => {
    if (firestoreService?.isReady()) {
      console.log('🔄 Firestore ready - pre-loading username...');
      
      try {
        const name = await getStoredUserName(firestoreService);
        
        if (name) {
          console.log('✅ Username pre-loaded:', name);
          setUserName(name);
        } else {
          console.log('📭 No username saved yet');
        }

        // ✅ ADD THIS
        const userData = await firestoreService.getUserData();
        if (userData?.dismissedFollowUps?.length > 0) {
          setDismissedFollowUps(new Set(userData.dismissedFollowUps));
          console.log('✅ Loaded dismissed follow-ups:', userData.dismissedFollowUps);
        }

      } catch (error) {
        console.error('❌ Failed to pre-load username:', error);
      }
    }
  };
  
  loadUsername();
}, [firestoreService]);
const handleSendMessage = async () => {
  // ============================================
  // SECTION 0: ENSURE SERVICES ARE READY
  // ============================================
  
  if (memoryService && !memoryService.isReady() && !memoryService._initialized) {
    console.log('🔧 First message from existing user - initializing memory service...');
    try {
      await memoryService.initialize();
      console.log('✅ Memory service ready for existing user');
    } catch (error) {
      console.warn('⚠️ Could not initialize memory service:', error);
    }
  }

  // ============================================
  // SECTION 1: VALIDATION & SPAM PREVENTION
  // ============================================
  if (!inputValue.trim()) return;
  
  if (isSending) {
    console.log('⏭️ Already sending a message, ignoring duplicate');
    return;
  }

  const userMessage = inputValue.trim();
  
  setIsSending(true);
  setInputValue('');
  setShowPlusOptions(false);
  setIsMultiline(false);
  setTextareaHeight('44px');

  let userMsg = null;
  let loadingMsgId = null;

  try {
    // ✅ Ensure we have a session ID
    if (!currentSessionId) {
      const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
      setCurrentSessionId(newSessionId);
      console.log('🆕 New session created:', newSessionId);
    }

    // ============================================
    // SECTION 2: GOAL DETECTION (background)
    // ============================================
    if (goalService && user?.uid) {
      try {
        const detectedGoal = goalService.detectGoal(userMessage);
        
        if (detectedGoal) {
          console.log('🎯 Goal detected, saving...');
          const timeframe = classifyGoalTimeframe(detectedGoal);
          
          await goalService.saveGoal(userMessage, detectedGoal, user.uid, timeframe);
          await loadTimeframeSeparatedGoals(goalService);
        }
      } catch (error) {
        console.error('⚠️ Goal detection error:', error);
      }
    }

    // ============================================
    // SECTION 2.5: MEMORY REFERENCE DETECTION
    // ============================================
    if (memoryService) {
      if (!memoryService.isReady()) {
        console.log('⏳ Memory service not ready - initializing now...');
        try {
          await memoryService.initialize();
          console.log('✅ Memory service initialized successfully');
        } catch (initError) {
          console.warn('⚠️ Memory service initialization failed:', initError);
        }
      }

      if (memoryService.isReady()) {
        try {
          console.log('🔍 Checking for memory references...');
          
          const recentMemoriesList = await ensureMemoriesCached(memoryService);
          
          const referencedMemoryIds = await memoryService.detectAndUpdateMemoryReferences(
            userMessage,
            messages,
            recentMemoriesList
          );
          
          if (referencedMemoryIds && referencedMemoryIds.length > 0) {
            console.log(`✅ Updated ${referencedMemoryIds.length} memory reference(s)`);
            memoryCache.isDirty = true;
          }
        } catch (refError) {
          console.warn('⚠️ Memory reference detection error:', refError);
        }
      }
    }

    // ============================================
    // SECTION 3: MODE-SPECIFIC EARLY RETURNS
    // ============================================

    // ✅ VOICE MODE
    if (isVoiceMode && voiceTextManager) {
      if (voiceManager && (voiceManager.isAISpeaking || voiceManager.isPlayingAudio)) {
        console.log('⏸️ User sent text - stopping AI audio immediately');
        voiceManager.interruptCurrentAudio();
        voiceManager.isAISpeaking = false;
        voiceManager.isPlayingAudio = false;
      }

      try {
        const messageHistory = convertMessagesToAzureFormat(messages);
        await voiceTextManager.handleTextDuringVoiceMode(
          userMessage,
          messageHistory,
          setMessages
        );
      } catch (error) {
        console.error('❌ Voice mode error:', error);
      }
      setIsSending(false);
      return;
    }

    // ✅ PLANNER MODE
    if (currentMode === 'planner') {
      handlePlannerInput();
      setIsSending(false);
      return;
    }

    // ✅ OTHER MODES
    if (currentMode !== 'chat') {
      const newMessage = {
        id: Date.now(),
        type: 'user',
        content: userMessage,
        timestamp: new Date().toISOString()
      };

      setMessages(prev => [...prev, newMessage]);

      setTimeout(() => {
        const botResponseId = Date.now() + 1;
        const botResponse = {
          id: botResponseId,
          type: 'bot',
          content: '',
          isTyping: true,
          timestamp: new Date().toISOString()
        };
        setMessages(prev => [...prev, botResponse]);
        
        displayMessageWithTyping(botResponseId, getBotResponse(userMessage));
      }, 1000);
      
      setIsSending(false);
      return;
    }

    // ============================================
    // SECTION 4: ADD USER MESSAGE TO STATE
    // ============================================

    userMsg = {
      id: Date.now(),
      type: 'user',
      content: userMessage,
      timestamp: new Date().toISOString()
    };

    setMessages(prev => [...prev, userMsg]);

    lastUserMessageRef.current = userMessage;
    setLastUserMessage(userMessage);

    // ============================================
    // SECTION 4.5: SCHEDULE CHAT REMINDERS
    // ============================================
    if (userName) {
      try {
        const ChatReminderService = (await import('./ChatReminderService')).default;
        await ChatReminderService.rescheduleReminders(userName);
        console.log('✅ Chat reminders reset - will notify in 2, 5, 7 days');
      } catch (reminderError) {
        console.warn('⚠️ Chat reminder scheduling failed:', reminderError);
      }
    }

// ============================================
// SECTION 5: MEMORY QUERY DETECTION & HANDLING
// ============================================

const isSimpleMessage = userMessage.trim().split(/\s+/).length <= 3;

if (!isSimpleMessage && memoryService?.isReady?.()) {
  console.log('🧠 Analyzing if this is a memory query...');

  try {
    // ✅ Run intent analysis and dismissal check IN PARALLEL
    const [intentAnalysis, dismissCheckResponse] = await Promise.all([
      SecureAPI.callAzureOpenAI([
        {
          role: 'system',
          content: `Analyze this message. Is the user asking about something from the past 
(a memory, a past conversation, something we discussed before, whether they spoke recently)?

IMPORTANT: These ARE memory queries:
- "did we speak yesterday?" → YES
- "did we talk recently?" → YES  
- "when did we last chat?" → YES
- "last time we talked" → YES
- "what did I say about X" → YES
- "do you remember when I said" → YES

These are NOT memory queries:
- "how are you?" → NO
- "help me with X" → NO
- "what is X?" → NO

Return ONLY valid JSON:
{
  "isMemoryQuery": true or false,
  "confidence": 0.0-1.0,
  "reason": "brief explanation",
  "wantsDetails": true or false,
  "wantsReconstruction": true or false
}`
        },
        { role: 'user', content: userMessage }
      ], { temperature: 0.3, max_tokens: 150 }),

      SecureAPI.callAzureOpenAI([
        {
          role: 'system',
          content: `Did the user just dismiss, reject, or express annoyance at a follow-up question that was asked?
      
Return ONLY valid JSON:
{
  "isDismissal": true or false,
  "dismissedTopic": "what topic they dismissed, or null"
}`
        },
        {
          role: 'user',
          content: `Recent conversation:\n${[...messages, userMsg].slice(-4).map(m => `${m.type === 'user' ? 'User' : 'AI'}: ${m.content}`).join('\n')}\n\nUser just said: "${userMessage}"`
        }
      ], { temperature: 0.2, max_tokens: 50 })
    ]);

    // ✅ Handle dismissal result
    try {
      const dismissText = dismissCheckResponse.choices[0].message.content.trim();
      const dismissResult = JSON.parse(dismissText.match(/\{[\s\S]*\}/)[0]);
      if (dismissResult.isDismissal && dismissResult.dismissedTopic) {
        setDismissedFollowUps(prev => new Set([...prev, dismissResult.dismissedTopic]));
        await firestoreService.saveUserData({
          dismissedFollowUps: arrayUnion(dismissResult.dismissedTopic)
        });
        console.log('🚫 User dismissed follow-up about:', dismissResult.dismissedTopic);
      }
    } catch (dismissError) {
      console.warn('⚠️ Dismissal check failed:', dismissError);
    }

    // ✅ Handle intent result
    let intentText = intentAnalysis.choices[0].message.content.trim();
    intentText = intentText.replace(/```json\n?|\n?```/g, '');

    console.log('📊 Raw intent response:', intentText.substring(0, 150));

    let intention;
    try {
      let cleanedText = intentText
        .replace(/,(\s*[}\]])/g, '$1')
        .replace(/:\s*'([^']*)'(?=\s*[,}\]])/g, ': "$1"')
        .replace(/\/\*[\s\S]*?\*\//g, '')
        .replace(/\/\/.*/g, '')
        .trim();

      intention = JSON.parse(cleanedText);
      console.log('✅ Intent parsed:', {
        isMemoryQuery: intention.isMemoryQuery,
        confidence: intention.confidence,
        wantsDetails: intention.wantsDetails,
        wantsReconstruction: intention.wantsReconstruction
      });
    } catch (parseError) {
      console.warn('⚠️ Intent parse failed, defaulting to NOT a memory query');
      intention = {
        isMemoryQuery: false,
        confidence: 0.5,
        reason: 'parse_error',
        wantsDetails: false,
        wantsReconstruction: false
      };
    }

    if (intention.isMemoryQuery && intention.confidence > 0.35) {
      console.log('🧠 Memory query confirmed - calling intelligentMemoryRecall...');

      const memoryLoadingId = Date.now() + 1;
      setMessages(prev => [...prev, {
        id: memoryLoadingId,
        type: 'bot',
        content: '',
        isLoadingAnimation: true,
        timestamp: new Date().toISOString()
      }]);

      try {
        const recallResult = await memoryService.intelligentMemoryRecall(userMessage);
        setMessages(prev => prev.filter(msg => msg.id !== memoryLoadingId));

        console.log('📊 Recall result:', {
          found: recallResult.found,
          action: recallResult.action,
          totalFound: recallResult.totalFound
        });

        if (recallResult.found && recallResult.reconstructedConversation) {
          const reconstructed = recallResult.reconstructedConversation;
          const fullResponse = `${recallResult.response}\n\n${reconstructed.narrative}`;
          const botMsgId = Date.now() + 1;
          const botMsg = {
            id: botMsgId, type: 'bot', content: fullResponse,
            isMemoryRecall: true, isDetailedReconstruction: true,
            memoriesUsed: recallResult.memories, reconstructionData: reconstructed,
            timestamp: new Date().toISOString()
          };
          setMessages(prev => [...prev, botMsg]);
          displayMessageWithTyping(botMsgId, fullResponse);
          const allMessages = [...messages, userMsg, botMsg];
          if (currentSessionId && firestoreService?.isReady?.()) {
            try { await firestoreService.saveConversation({ id: currentSessionId, messages: allMessages, preview: allMessages[0]?.content || 'Chat', messageCount: allMessages.length, timestamp: new Date().toISOString(), lastUpdated: new Date().toISOString(), tag: 'memory_reconstruction' }); } catch (e) { console.warn('⚠️ Failed to save:', e); }
          }
          scrollToBottom('smooth'); setIsSending(false); setIsProcessingAzure(false); return;
        }

        if (recallResult.found && recallResult.response) {
          const botMsgId = Date.now() + 1;
          const botMsg = {
            id: botMsgId, type: 'bot', content: recallResult.response,
            isMemoryRecall: true, memoriesUsed: recallResult.memories,
            timestamp: new Date().toISOString()
          };
          setMessages(prev => [...prev, botMsg]);
          displayMessageWithTyping(botMsgId, recallResult.response);
          const allMessages = [...messages, userMsg, botMsg];
          if (currentSessionId && firestoreService?.isReady?.()) {
            try { await firestoreService.saveConversation({ id: currentSessionId, messages: allMessages, preview: allMessages[0]?.content || 'Chat', messageCount: allMessages.length, timestamp: new Date().toISOString(), lastUpdated: new Date().toISOString(), tag: 'memory_recall' }); } catch (e) { console.warn('⚠️ Failed to save:', e); }
          }
          scrollToBottom('smooth'); setIsSending(false); setIsProcessingAzure(false); return;
        }

        if (recallResult.action === 'no_match') {
          const noMatchContent = recallResult.response || "Hmm, I don't think we talked about that recently. What were you thinking of?";
          const noMatchMsg = { id: Date.now() + 1, type: 'bot', content: noMatchContent, isMemoryRecall: true, timestamp: new Date().toISOString() };
          setMessages(prev => [...prev, noMatchMsg]);
          displayMessageWithTyping(noMatchMsg.id, noMatchContent);
          const allMessages = [...messages, userMsg, noMatchMsg];
          if (currentSessionId && firestoreService?.isReady?.()) {
            try { await firestoreService.saveConversation({ id: currentSessionId, messages: allMessages, preview: allMessages[0]?.content || 'Chat', messageCount: allMessages.length, timestamp: new Date().toISOString(), lastUpdated: new Date().toISOString(), tag: 'memory_no_match' }); } catch (e) { console.warn('⚠️ Failed to save:', e); }
          }
          scrollToBottom('smooth'); setIsSending(false); setIsProcessingAzure(false); return;
        }

        if (recallResult.foundTooMany) {
          const refineBotId = Date.now() + 1;
          const refineMsg = { id: refineBotId, type: 'bot', content: recallResult.refinementSuggestion || `I found ${recallResult.totalMemories} memories about that. Can you be more specific?`, isMemoryQuery: true, needsFollowUp: true, refineSearch: true, timestamp: new Date().toISOString() };
          setMessages(prev => [...prev, refineMsg]);
          displayMessageWithTyping(refineBotId, refineMsg.content);
          scrollToBottom('smooth'); setIsSending(false); setIsProcessingAzure(false); return;
        }

        if (recallResult.needsExpansion) {
          const expansionBotId = Date.now() + 1;
          const expandMsg = { id: expansionBotId, type: 'bot', content: recallResult.expandQuestion || "I didn't find anything from that timeframe. Want me to search even further back?", isMemoryQuery: true, needsFollowUp: true, expandTimeframe: true, timestamp: new Date().toISOString() };
          setMessages(prev => [...prev, expandMsg]);
          displayMessageWithTyping(expansionBotId, expandMsg.content);
          scrollToBottom('smooth'); setIsSending(false); setIsProcessingAzure(false); return;
        }

      } catch (recallError) {
        setMessages(prev => prev.filter(msg => msg.id !== memoryLoadingId));
        console.error('❌ Memory recall error:', recallError);
      }

    } else {
      console.log('⏭️ Not a memory query (confidence: ' + intention.confidence + ') - proceeding to normal chat');
    }

  } catch (intentError) {
    console.error('❌ Intent analysis error:', intentError);
  }
}

// ============================================
// SECTION 6: BACKGROUND TASKS
// ============================================

if (vibeEngine) {
  vibeEngine.detectUserVibe(userMessage)
    .then(vibe => { setDetectedVibe(vibe); console.log('⚡ Current vibe:', vibe.vibe); })
    .catch(e => console.warn('⚠️ Vibe detection error:', e));
}

if (memoryService?.isReady?.()) {
  memoryService.saveMemory({
    memory: userMessage,
    topic: 'general',
    conversationMessages: messages.slice(-10)
  }).then(result => {
    if (result?.needsClarification && result?.clarificationQuestion) {
      const recentMessages = messages.slice(-6);
      const alreadyAsked = recentMessages.some(m => m.isClarification && m.pendingMemoryText && m.pendingMemoryText.toLowerCase() === result.pendingMemoryText?.toLowerCase());
      if (!alreadyAsked) {
        const clarifyMsgId = Date.now();
        setMessages(prev => [...prev, { id: clarifyMsgId, type: 'bot', content: result.clarificationQuestion, isClarification: true, pendingMemoryText: result.pendingMemoryText, timestamp: new Date().toISOString() }]);
        displayMessageWithTyping(clarifyMsgId, result.clarificationQuestion);
        const allMessages = [...messages, userMsg, { id: clarifyMsgId, type: 'bot', content: result.clarificationQuestion, isClarification: true, timestamp: new Date().toISOString() }];
        if (currentSessionId && firestoreService?.isReady?.()) {
          firestoreService.saveConversation({ id: currentSessionId, messages: allMessages, preview: allMessages[0]?.content || 'Chat', messageCount: allMessages.length, timestamp: new Date().toISOString(), lastUpdated: new Date().toISOString(), tag: 'memory_clarification' }).catch(e => console.warn('⚠️ Failed to save:', e));
        }
      }
    }
    if (result?.memoryId && !result?.needsClarification) {
      console.log('✅ Memory saved:', result.memoryId);
      if (result?.updated) { memoryCache.isDirty = true; }
    }
  }).catch(e => console.warn('⚠️ Memory save skipped:', e.message));

  memoryService.smartCleanupExpiredMemories()
    .then(result => { if (result.deleted > 0 || result.extended > 0) console.log('🧠 Memory maintenance:', result); })
    .catch(e => console.warn('⚠️ Memory cleanup skipped:', e.message));
}

// ============================================
// SECTION 7: SHOW LOADING STATE
// ============================================

loadingMsgId = Date.now() + 1;
setMessages(prev => [...prev, {
  id: loadingMsgId,
  type: 'bot',
  content: '',
  isLoadingAnimation: true,
  timestamp: new Date().toISOString()
}]);

setIsProcessingAzure(true);

// ============================================
// SECTION 8: GET AZURE RESPONSE
// ✅ Skip redundant username/memory load - already built in systemMessageWithFullContext
// ============================================

const updatedMessages = [...messages, userMsg];
const messageHistory = convertMessagesToAzureFormat(updatedMessages);

const enabledToolIds = availableTools
  .filter(tool => tool.visible === true)
  .map(tool => tool.id);

console.log('📋 Enabled tools:', enabledToolIds);

let memoryContext = null;
let followUpContext = null;

if (memoryService?.isReady?.()) {
  try {
    const cachedMemories = await ensureMemoriesCached(memoryService);
    memoryContext = await memoryService.getMemorySummaryForAI(userMessage, cachedMemories);
    if (memoryContext) console.log('✅ Memory context loaded');
    else console.log('📭 No memory context available');

    if (timeAwareEngine && userName) {
      try {
        const now = Date.now();
        const timeSinceLastFollowUp = now - lastFollowUpTime;
        if (timeSinceLastFollowUp >= FOLLOW_UP_COOLDOWN_MS) {
          const relevantMemories = await memoryService.getRecentMemories(20, 30);
          if (relevantMemories.length > 0) {
            const analysis = await analyzeFollowUpNaturally(userName, userMessage, updatedMessages, relevantMemories, '');
            if (analysis.shouldFollowUp && analysis.followUpText && !dismissedFollowUps.has(analysis.dismissKey)) {
              setLastFollowUpTime(Date.now());
              followUpContext = `\n\n🎯 NATURAL FOLLOW-UP OPPORTUNITY:\n"${analysis.followUpText}"\nWeave this naturally into your response.`;
            }
          }
        }
      } catch (followUpError) {
        console.warn('⚠️ Follow-up pre-check error:', followUpError);
      }
    }
  } catch (memError) {
    console.warn('⚠️ Memory context fetch failed:', memError);
  }
}

const currentVibeContext = vibeEngine?.getCurrentVibe?.() || detectedVibe?.vibe || 'neutral';
const finalUserName = userName || await getStoredUserName(firestoreService);
console.log('👤 Username for this message:', finalUserName || 'Not set');

let systemMessageWithFullContext = createSystemMessageWithTimeframes(
  finalUserName, currentVibeContext, enabledToolIds, timeAwareEngine, lastInteractionTime
);

if (memoryContext) {
  if (typeof systemMessageWithFullContext === 'string') {
    systemMessageWithFullContext = { role: 'system', content: systemMessageWithFullContext + '\n\n' + memoryContext };
  } else {
    systemMessageWithFullContext.content = `${systemMessageWithFullContext.content}\n\n${memoryContext}`;
  }
  console.log('✅ Memory context injected into system message');
} else {
  if (typeof systemMessageWithFullContext === 'string') {
    systemMessageWithFullContext = { role: 'system', content: systemMessageWithFullContext };
  }
}

if (followUpContext) {
  systemMessageWithFullContext.content = `${systemMessageWithFullContext.content}${followUpContext}`;
}

console.log('🔄 Calling Azure API...');
const response = await sendChatMessage(
  messageHistory,
  userMessage,
  tasksByDate,
  memoryService,
  systemMessageWithFullContext,  // ✅ Already has memory context - sendChatMessage skips redundant load
  enabledToolIds,
  lastScheduleDisplayed,
  firestoreService
);
    const parsed = parseAzureResponse(response);

    setMessages(prev => prev.filter(msg => msg.id !== loadingMsgId));

    // ============================================
    // SECTION 9: HANDLE RESPONSE
    // ============================================

    if (parsed.type === 'tool_call') {
      console.log('🔧 Tool call detected:', parsed.toolName);
      await handleToolCall(parsed, messageHistory, userMessage);
    } 
    else if (parsed.type === 'message') {
      const botMessageId = Date.now();
      const botMessage = {
        id: botMessageId,
        type: 'bot',
        content: parsed.content,
        timestamp: new Date().toISOString(),
        isTyping: false
      };

      setMessages(prev => [...prev, botMessage]);
      displayMessageWithTyping(botMessageId, parsed.content);

      // ============================================
      // SECTION 10: POST-RESPONSE TASKS
      // ============================================

      if (parsed.content.includes('📝') || parsed.content.toLowerCase().includes('taking notes')) {
        setIsTakingNotes(true);
        setCurrentNoteContent([]);
      }

      if (isJournaling) {
        setJournalConversation(prev => [...prev, botMessage]);
      }

      // ============================================
      // SECTION 11: SAVE TO FIRESTORE
      // ============================================

      const allMessages = [...updatedMessages, botMessage];
      
      if (currentSessionId && firestoreService?.isReady?.()) {
        try {
          console.log('💾 Saving session');

          await firestoreService.saveConversation({
            id: currentSessionId,
            messages: allMessages,
            preview: allMessages[0]?.content || 'Chat',
            messageCount: allMessages.length,
            timestamp: new Date().toISOString(),
            lastUpdated: new Date().toISOString(),
            tag: autoTagChat({
              preview: allMessages[0]?.content || '',
              messages: allMessages
            })
          });

          console.log('✅ Session saved');
        } catch (error) {
          console.error('⚠️ Failed to save session:', error);
        }
      }
    }

  } catch (error) {
    console.error('❌ Error in handleSendMessage:', error);

    if (loadingMsgId) {
      setMessages(prev => prev.filter(msg => msg.id !== loadingMsgId));
    }

    const errorId = Date.now();
    const errorMessage = {
      id: errorId,
      type: 'bot',
      content: '',
      isTyping: false,
      timestamp: new Date().toISOString()
    };

    setMessages(prev => [...prev, errorMessage]);
    displayMessageWithTyping(
      errorId,
      `Sorry, I encountered an error: ${error.message}. Please try again!`
    );

    if (userMsg) {
      const allMessages = [...messages, userMsg];
      if (currentSessionId && firestoreService?.isReady?.()) {
        try {
          await firestoreService.saveConversation({
            id: currentSessionId,
            messages: allMessages,
            preview: allMessages[0]?.content || 'Chat',
            messageCount: allMessages.length,
            timestamp: new Date().toISOString(),
            lastUpdated: new Date().toISOString(),
            tag: 'error'
          });
        } catch (saveError) {
          console.warn('⚠️ Failed to save error state:', saveError);
        }
      }
    }

  } finally {
    setIsProcessingAzure(false);
    setIsSending(false);
    scrollToBottom('smooth');
  }
};

// ============================================
// ✅ CLEAN: handleNewChat Function
// ============================================
useEffect(() => {
  // Listen for notification replies
  const handleNotificationReply = (event) => {
    const { userReply, aiResponse, eventText, replyDocId } = event.detail;
    
    console.log('🔔 Loading notification reply into chat...');
    
    // Add to chat
    const newMessages = [
      {
        id: Date.now(),
        type: 'bot',
        content: `About your ${eventText}:`,
        isNotificationContext: true,
        timestamp: new Date().toISOString()
      },
      {
        id: Date.now() + 1,
        type: 'user',
        content: userReply,
        isNotificationReply: true,
        timestamp: new Date().toISOString()
      },
      {
        id: Date.now() + 2,
        type: 'bot',
        content: aiResponse,
        isNotificationReply: true,
        timestamp: new Date().toISOString()
      }
    ];
    
    setMessages(prev => [...prev, ...newMessages]);
    setCurrentMode('chat');
    
    // Scroll to bottom
    setTimeout(() => scrollToBottom('smooth'), 300);
  };
  
  window.addEventListener('notification-reply', handleNotificationReply);
  
  return () => {
    window.removeEventListener('notification-reply', handleNotificationReply);
  };
}, []);


/**
 * Use LLM to naturally analyze if follow-up should happen
 * NOT based on static patterns
 */
const analyzeFollowUpNaturally = async (
  userName,
  lastUserMessage,
  conversationMessages,
  recentMemories,
  lastBotResponse
) => {
  try {
    const now = new Date();
    const dayOfWeek = now.toLocaleDateString('en-US', { weekday: 'long' });
    const fullDate = now.toLocaleDateString('en-US', { 
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' 
    });
    const timeOfDay = now.toLocaleTimeString('en-US', { 
      hour: 'numeric', minute: '2-digit', hour12: true 
    });

    const recentChat = conversationMessages
      .slice(-8)
      .map(m => `${m.type === 'user' ? 'User' : 'AI'}: ${m.content}`)
      .join('\n');

    // Pass memories WITH their exact save timestamps so LLM can reason about timing
    const memoryList = recentMemories
      .slice(0, 15)
      .map(m => {
        const savedAt = m.savedAt?.toDate ? m.savedAt.toDate() : new Date(m.savedAt);
        return `- "${m.memory}" [saved: ${savedAt.toLocaleDateString('en-US', { 
          weekday: 'long', month: 'short', day: 'numeric', 
          hour: 'numeric', minute: '2-digit', hour12: true 
        })}]`;
      })
      .join('\n');

    const data = await SecureAPI.callAzureOpenAI([
      {
        role: 'system',
        content: `You are deciding whether to naturally follow up on something from a user's memory in a conversation.

RIGHT NOW: ${timeOfDay} on ${fullDate}

You will be given memories with the exact date/time they were saved. Use this to reason carefully about timing.

═══════════════════════════════════════
HOW TO REASON ABOUT TIMING
═══════════════════════════════════════

For ONE-TIME events (e.g. "I have a class today at 5pm"):
- Saved today, current time is BEFORE 5pm → Valid to ask "you ready for your 5pm class?"
- Saved today, current time is AFTER 5pm → Valid to ask "how did your 5pm class go?"
- Saved yesterday → That specific instance is past. Don't assume it repeats. 
  Instead ask something open like "do you have class today?" if it's a weekday, 
  or drop it entirely if it seems like a one-time thing.

For RECURRING events (e.g. "I have class every Wednesday at 5pm"):
- Only ask on Wednesday or the day before
- Tuesday evening → "You've got class tomorrow at 5, right?"
- Wednesday before 5pm → "You ready for your 5pm class?"
- Wednesday after 5pm → "How was class today?"
- Thursday through Tuesday → Don't mention it, too far away

For AMBIGUOUS events (e.g. "I have a class this week"):
- Only follow up if it's still within that week
- If the week has passed, drop it entirely

For GOALS/ONGOING things (e.g. "I want to learn Python"):
- These don't expire — bring up naturally when relevant
- Don't force it on every greeting

For PREP/READINESS (e.g. "big presentation tomorrow"):
- Saved yesterday, today is the day → Perfect time to ask "you ready for it?"
- Saved 2+ days ago and the day has passed → Ask how it went

═══════════════════════════════════════
WHEN IS A FOLLOW-UP NATURAL?
═══════════════════════════════════════

✅ GOOD times:
- User says a simple greeting ("hey", "hi", "what's up") — great opening
- User mentions something related to the memory topic
- The event is happening today or very soon
- The event just passed and user hasn't mentioned it

❌ BAD times:
- User is deep in a different topic
- The memory is too old and no longer relevant
- You already asked about this in the last few messages
- The event clearly passed days ago with no follow-up needed

═══════════════════════════════════════
TONE
═══════════════════════════════════════
Sound like a friend naturally remembering, not a calendar app.
One sentence, casual, specific.
No "I remember you mentioned..." — just bring it up.

Return ONLY valid JSON:
{
  "shouldFollowUp": true or false,
  "confidence": 0.0-1.0,
  "reasoning": "explain your timing logic step by step",
  "eventType": "one_time|recurring|ongoing|ambiguous",
  "timingVerdict": "before_event|day_of_before|day_of_after|just_passed|too_old|not_applicable",
  "followUpText": "natural 1-sentence follow-up, or null",
  "dismissKey": "short identifier for this topic e.g. 'wednesday_class' or 'python_goal', for deduplication"
}`
      },
      {
        role: 'user',
        content: `Recent conversation:
${recentChat}

User just said: "${lastUserMessage}"

What I remember about them (with save timestamps):
${memoryList || '(no memories)'}

Current time: ${timeOfDay} on ${fullDate} (${dayOfWeek})

Should I follow up on anything right now?`
      }
    ], {
      temperature: 0.4,
      max_tokens: 350
    });

    let jsonText = data.choices[0].message.content.trim();
    jsonText = jsonText.replace(/```json\n?|\n?```/g, '');
    const analysis = JSON.parse(jsonText);

    console.log('📊 Follow-up decision:', {
      shouldFollowUp: analysis.shouldFollowUp,
      confidence: analysis.confidence,
      eventType: analysis.eventType,
      timingVerdict: analysis.timingVerdict,
      reasoning: analysis.reasoning,
      followUpText: analysis.followUpText
    });

    const shouldActuallyFollowUp =
      analysis.shouldFollowUp &&
      analysis.confidence > 0.65 &&
      analysis.followUpText &&
      analysis.timingVerdict !== 'too_old';

    return {
      shouldFollowUp: shouldActuallyFollowUp,
      followUpText: shouldActuallyFollowUp ? analysis.followUpText : null,
      confidence: analysis.confidence,
      reasoning: analysis.reasoning,
      eventType: analysis.eventType,
      timingVerdict: analysis.timingVerdict,
      dismissKey: analysis.dismissKey,
      contextTarget: analysis.dismissKey
    };

  } catch (error) {
    console.error('❌ Follow-up analysis error:', error.message);
    return { shouldFollowUp: false, reason: 'error' };
  }
};

// ✅ Helper function to extract context from conversation
function extractContextFromConversation(messages, currentMessage) {
  const contextClues = [];
  
  // Extract from last few messages
  const recentMessages = messages.slice(-5);
  
  for (const msg of recentMessages) {
    const content = msg.content?.toLowerCase() || '';
    
    // Topics mentioned
    if (content.includes('exam') || content.includes('test')) {
      contextClues.push('discussing exams/tests');
    }
    if (content.includes('work') || content.includes('job')) {
      contextClues.push('talking about work');
    }
    if (content.includes('project')) {
      contextClues.push('discussing project');
    }
    if (content.includes('soccer') || content.includes('game') || content.includes('match')) {
      contextClues.push('talking about sports/games');
    }
    if (content.includes('learn') || content.includes('study')) {
      contextClues.push('discussing learning/studying');
    }
  }
  
  // Deduplicate
  return [...new Set(contextClues)];
}

// ============================================
// HELPER: Classify Goal Timeframe
// ============================================

const classifyGoalTimeframe = (detectedGoal) => {
  const keywords = {
    shortTerm: [
      'tomorrow', 'today', 'tonight', 'this week', 'soon', 'asap', 
      'urgent', 'deadline', 'by end of week'
    ],
    mediumTerm: [
      'next month', 'this month', 'this quarter', 'by end of month',
      'in a few weeks', 'couple months', 'by end of quarter'
    ],
    longTerm: [
      'next year', 'always', 'habit', 'eventually', 'long term', 
      'goal', 'dream', 'career', 'forever'
    ]
  };

  const goalText = (detectedGoal.title || '').toLowerCase();

  // Check keywords
  if (keywords.shortTerm.some(kw => goalText.includes(kw))) {
    return 'SHORT_TERM';
  }
  if (keywords.mediumTerm.some(kw => goalText.includes(kw))) {
    return 'MEDIUM_TERM';
  }
  if (keywords.longTerm.some(kw => goalText.includes(kw))) {
    return 'LONG_TERM';
  }

  // Default: medium term (safest guess)
  return 'MEDIUM_TERM';
};

// ============================================
// HELPER: Build System Message with Timeframes
// ============================================
const createSystemMessageWithTimeframes = (userName, vibeContext, enabledTools = []) => {
  let systemMessage = `You are Preptune, a chat buddy who remembers what matters and helps you grow.`;

  if (userName) {
    systemMessage += `\n\nYou're chatting with ${userName}.`;
  }
 // ============================================
  // 🌍 GET USER'S TIMEZONE & CURRENT DATE/TIME
  // ============================================
  const now = new Date();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  const dateInfo = {
    dayOfWeek: now.toLocaleDateString('en-US', { weekday: 'long', timeZone: timezone }),
    month: now.toLocaleDateString('en-US', { month: 'long', timeZone: timezone }),
    day: now.getDate(),
    year: now.getFullYear(),
    time: now.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true,
      timeZone: timezone 
    }),
    fullDate: now.toLocaleDateString('en-US', { 
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: timezone
    })
  };
  
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const weekOfMonth = Math.ceil((now.getDate() + firstDayOfMonth.getDay()) / 7);
  
  systemMessage += `\n\n⏰ **CURRENT DATE & TIME:**`;
  systemMessage += `\n- Today is: ${dateInfo.fullDate}`;
  systemMessage += `\n- Current time: ${dateInfo.time}`;
  systemMessage += `\n- Timezone: ${timezone}`;
  systemMessage += `\n- Week ${weekOfMonth} of ${dateInfo.month}`;
  systemMessage += `\n- Use this to understand context when user asks about "today", "this week", etc.`;

  // ============================================
  // TIME AWARENESS
  // ============================================
  if (timeAwareEngine && lastInteractionTime) {
    const timeInfo = timeAwareEngine.getTimeSinceLastMessage(lastInteractionTime);
    
    if (timeInfo) {
      systemMessage += `\n\n⏰ TIME AWARENESS:`;
      systemMessage += `\n- Time since last chat: ${timeAwareEngine.formatTimeElapsed(timeInfo)}`;
      systemMessage += `\n- Category: ${timeInfo.category}`;
      
      switch (timeInfo.category) {
        case 'nextDay':
          systemMessage += `\n- They might have completed things they mentioned yesterday - ask how it went`;
          break;
        case 'thisWeek':
          systemMessage += `\n- Check on progress naturally`;
          break;
        case 'sameSession':
          systemMessage += `\n- Continuing same conversation, pick up where you left off`;
          break;
        case 'sameDay':
          systemMessage += `\n- Same day but later, reference what happened earlier`;
          break;
        case 'minutes':
        case 'recentChat':
          systemMessage += `\n- Very recent conversation, just respond naturally`;
          break;
      }
    }
  }

  systemMessage += `\n\n**NATURAL TIME-AWARE FOLLOW-UPS:**`;
systemMessage += `\n- If a memory mentions "tomorrow" and was saved yesterday → Ask "How'd that go?"`;
systemMessage += `\n- If it's morning and user had evening plans yesterday → "Good morning! How was [event]?"`;
systemMessage += `\n- If user returns after days → "Welcome back! Catch me up on what happened"`;
systemMessage += `\n- BE SPECIFIC: Don't say "how was your day" - say "how was the soccer game"`;
  // ============================================
  // ✅ SHORT-TERM MEMORIES (EXPIRING SOON - HIGH PRIORITY)
  // ============================================
  if (memoriesShortTerm && memoriesShortTerm.length > 0) {
    systemMessage += `\n\n⚡ **SHORT-TERM MEMORIES (Next 7 days - URGENT):**\n`;
    
    memoriesShortTerm.slice(0, 5).forEach(mem => {
      const expiresAt = mem.expiresAt?.toDate();
      const daysLeft = expiresAt ? Math.ceil((expiresAt - new Date()) / (1000 * 60 * 60 * 24)) : 'N/A';
      
      systemMessage += `- ${mem.memory} (expires in ${daysLeft} days)\n`;
    });
    
    systemMessage += `→ PRIORITY: These are time-sensitive events/tasks\n`;
    systemMessage += `→ Ask about these actively if relevant\n`;
  }

  // ============================================
  // SHORT-TERM GOALS (THIS WEEK)
  // ============================================
  if (goalsShortTerm && goalsShortTerm.length > 0) {
    systemMessage += `\n\n⚡ **SHORT-TERM GOALS (This Week - URGENT):**\n`;
    goalsShortTerm.slice(0, 3).forEach(goal => {
      systemMessage += `- [${goal.type?.toUpperCase() || 'GOAL'}] ${goal.title}\n`;
    });
    systemMessage += `→ Ask about these actively, show concern and support\n`;
  }

  // ============================================
  // MEDIUM-TERM GOALS (1-3 MONTHS)
  // ============================================
  if (goalsMediumTerm && goalsMediumTerm.length > 0) {
    systemMessage += `\n\n📌 **MEDIUM-TERM GOALS (Next 1-3 Months):**\n`;
    goalsMediumTerm.slice(0, 3).forEach(goal => {
      systemMessage += `- [${goal.type}] ${goal.title}\n`;
    });
    systemMessage += `→ Check in naturally on progress\n`;
  }

  // ============================================
  // LONG-TERM GOALS (3+ MONTHS)
  // ============================================
  if (goalsLongTerm && goalsLongTerm.length > 0) {
    systemMessage += `\n\n🔄 **LONG-TERM GOALS (Ongoing/Habits):**\n`;
    goalsLongTerm.slice(0, 3).forEach(goal => {
      if (goal.type === 'HABIT') {
        systemMessage += `- [HABIT] ${goal.title} (${goal.frequency || 'regular'})\n`;
      } else {
        systemMessage += `- [${goal.type}] ${goal.title}\n`;
      }
    });
    systemMessage += `→ Mention only if naturally relevant\n`;
  }

  // ============================================
  // ✅ LONG-TERM MEMORIES (PERMANENT KNOWLEDGE)
  // ============================================
  if (memoriesLongTerm && memoriesLongTerm.length > 0) {
    systemMessage += `\n\n📚 **LONG-TERM MEMORIES (Things to Remember):**\n`;
    memoriesLongTerm.slice(0, 10).forEach(mem => {
      systemMessage += `- ${mem.memory}\n`;
    });
    systemMessage += `→ Reference naturally when relevant\n`;
  }

  // ============================================
  // APPROACH INSTRUCTIONS
  // ============================================
  systemMessage += `\n\n**YOUR APPROACH:**\n`;
  systemMessage += `1. ⚡ Short-term memories/goals = Ask actively about progress\n`;
  systemMessage += `2. 📌 Medium-term = Check in naturally\n`;
  systemMessage += `3. 🔄 Long-term habits = Mention only if relevant\n`;
  systemMessage += `4. 📚 Long-term memories = Reference naturally when it fits\n`;
  systemMessage += `5. Keep conversation natural - don't force mentions\n`;
  systemMessage += `6. Show genuine interest and celebration\n`;

 // TOOL AVAILABILITY
  systemMessage += `\n\n🔧 ENABLED TOOLS:\n`;
  systemMessage += enabledTools.includes('study') 
    ? '✅ Study Tool (flashcards, quizzes)\n' 
    : '❌ Study Tool - NOT enabled\n';
  systemMessage += enabledTools.includes('podcast') 
    ? '✅ Podcast Tool\n' 
    : '❌ Podcast Tool - NOT enabled\n';
  systemMessage += enabledTools.includes('journal') 
    ? '✅ Journal Tool\n' 
    : '❌ Journal Tool - NOT enabled\n';
  systemMessage += enabledTools.includes('planner') 
    ? '✅ Schedule Tool\n' 
    : '❌ Schedule Tool - NOT enabled\n';

  systemMessage += `\n⚠️ ONLY use enabled tools (✅). For disabled tools (❌), tell user to enable them in toolkit settings.\n`;

  // ============================================
  // VIBE CONTEXT
  // ============================================
  if (vibeContext) {
    systemMessage += `\n${vibeContext}`;
  }

  systemMessage += `\n==========================================\n`;

  return systemMessage;
};

/**
 * Check if user has enabled a specific tool
 */
const isToolEnabled = (toolId) => {
  const tool = availableTools.find(t => t.id === toolId);
  return tool?.visible === true;
};

/**
 * Get disabled tool message
 */
const getDisabledToolMessage = (toolName) => {
  return `I can't ${toolName.toLowerCase()} because you haven't enabled the ${getToolDisplayName(toolName)} yet. You can enable it by clicking the toolkit icon in the sidebar and selecting it from your tools.

If you need help with this, please contact our support team: support@preptune.com`;
};

/**
 * Map tool function names to display names
 */
const getToolDisplayName = (toolName) => {
  const toolMap = {
    'quiz': 'Study Tool',
    'flashcard': 'Study Tool',
    'flashcards': 'Study Tool',
    'podcast': 'Podcast Tool',
    'journal': 'Journal Tool',
    'schedule': 'Schedule Tool',
    'planner': 'Schedule Tool'
  };
  
  const lower = toolName.toLowerCase();
  return toolMap[lower] || toolName;
};
/**
 * Generate a natural, human-sounding calendar response
 */
const generateNaturalCalendarResponse = async (
  operation,
  eventDetails,
  userName
) => {
  try {
    let context;

    // ============================================
    // CASE 1: CREATE EVENT
    // ============================================
    if (operation === 'create') {
      if (eventDetails.isRecurring) {
        // ✅ RECURRING EVENT
        context = `
A recurring event was added to the calendar.

Details:
- Title: ${eventDetails.title}
- Pattern: ${eventDetails.date} (e.g., "every Friday", "monthly on the 15th", "every weekday")
- Time: ${eventDetails.time}
- Total instances created: ${eventDetails.instanceCount}

Respond naturally about the recurring event being set up.
Mention the pattern briefly and confirm it's done.
Keep it short and conversational (1-2 sentences max).
`;
      } else {
        // ✅ SINGLE EVENT
        context = `
An event was added to the calendar.

Details:
- Title: ${eventDetails.title}
- Date: ${eventDetails.date}
- Time: ${eventDetails.time}

Respond like a real assistant would after doing this for someone.
Keep it short, natural, and relaxed (1-2 sentences max).
`;
      }
    } 
    
    // ============================================
    // CASE 2: UPDATE EVENT
    // ============================================
    else if (operation === 'update') {
      context = `
A calendar event was updated.

Event: ${eventDetails.oldTitle}
Changes: ${eventDetails.changes.join(', ')}

Confirm the update in a natural, conversational way.
Just acknowledge what changed (1 sentence).
`;
    } 
    
    // ============================================
    // CASE 3: DELETE EVENT
    // ============================================
    else if (operation === 'delete') {
      context = `
An event was removed from the calendar.

Event: ${eventDetails.title}

Acknowledge it briefly and casually (1 sentence).
`;
    }
    
    // ============================================
    // CASE 4: GET SCHEDULE (NEW)
    // ============================================
    else if (operation === 'get') {
      if (eventDetails.eventCount === 0) {
        context = `
User asked about their schedule for ${eventDetails.date}.
They have no events scheduled for that date.

Respond naturally that they don't have anything scheduled.
Keep it brief (1 sentence).
`;
      } else if (eventDetails.eventCount === 1) {
        context = `
User asked about their schedule for ${eventDetails.date}.
They have 1 event: "${eventDetails.events[0]?.title || 'untitled'}" at ${eventDetails.events[0]?.time || 'no time'}.

Respond naturally mentioning this one event.
Keep it brief (1-2 sentences).
`;
      } else {
        const eventsList = eventDetails.events
          ?.slice(0, 3)
          .map(e => `"${e.title}" at ${e.time}`)
          .join(', ') || 'multiple events';
        
        context = `
User asked about their schedule for ${eventDetails.date}.
They have ${eventDetails.eventCount} events scheduled: ${eventsList}${eventDetails.eventCount > 3 ? ', and more' : ''}.

Respond naturally mentioning how many events they have.
Keep it brief (1-2 sentences).
`;
      }
    }

    // ============================================
    // CALL AZURE API
    // ============================================
const data = await SecureAPI.callAzureOpenAI([
  {
              role: 'system',
              content: `
You are Preptune, a calm, friendly AI assistant helping with calendar management.

How you speak:
- Sound like a real person, not a system
- 1–2 sentences max (this is critical - be brief!)
- Casual, warm, and clear
- Use contractions (I've, you're, it's, that's)
- No emojis
- No exclamation points unless it genuinely fits
- If a name is provided, you may use it naturally, but do not force it
- Don't repeat information that's obvious from context

Examples of good responses:

For CREATING events:
- "All set. I added it to your calendar for tomorrow afternoon."
- "Got it. You're all set for Monday at 3pm."
- "Done. Set up that reminder every Friday at 6pm for the next 2 weeks."
- "Cool. Scheduled it for the 15th of every month."

For UPDATING events:
- "Yep, that's updated now."
- "Changed it to 5pm."
- "Moved to next Tuesday."

For DELETING events:
- "That one's removed, you're good."
- "Deleted it."
- "Gone."

For GETTING schedule:
- "You've got nothing scheduled for tomorrow."
- "Just one thing: team meeting at 2pm."
- "You have 3 events tomorrow: standup at 9am, lunch at 12pm, and client call at 3pm."

Avoid:
- Robotic or overly formal language
- Long explanations
- Repeating the user's request back to them
- Phrases like "I have successfully..." or "The event has been..."
`
            },
            {
              role: 'user',
              content: `${context}${userName ? `\n\nUser name: ${userName}` : ''}`
            }
  ], {
  temperature: 0.5,
  max_tokens: 280
});
    const naturalResponse = data?.choices?.[0]?.message?.content?.trim();
    
    if (!naturalResponse) {
      console.error('❌ No response from Azure');
      return null;
    }
    
    console.log('✅ Natural response:', naturalResponse);
    return naturalResponse;
    
  } catch (error) {
    console.error('❌ Natural calendar response failed:', error);
    return null;
  }
};

// ============================================
// USAGE EXAMPLES
// ============================================

/*
// Example 1: Single event
const response1 = await generateNaturalCalendarResponse(
  'create',
  {
    title: 'Team Meeting',
    date: 'tomorrow',
    time: '2:00 PM',
    isRecurring: false
  },
  'John'
);
// Returns: "All set. I added it to your calendar for tomorrow afternoon."

// Example 2: Recurring event
const response2 = await generateNaturalCalendarResponse(
  'create',
  {
    title: 'Call Mom',
    date: 'every Friday',
    time: '6:00 PM',
    isRecurring: true,
    instanceCount: 8
  },
  'Sarah'
);
// Returns: "Done. Set up that reminder every Friday at 6pm for the next 8 weeks."

// Example 3: Monthly recurring
const response3 = await generateNaturalCalendarResponse(
  'create',
  {
    title: 'Pay Rent',
    date: 'monthly on the 1st',
    time: '9:00 AM',
    isRecurring: true,
    instanceCount: 12
  },
  'Alex'
);
// Returns: "Cool. Scheduled it for the 1st of every month."

// Example 4: Update event
const response4 = await generateNaturalCalendarResponse(
  'update',
  {
    oldTitle: 'Doctor Appointment',
    changes: ['time to 5:00 PM']
  },
  'Maria'
);
// Returns: "Yep, changed it to 5pm."

// Example 5: Delete event
const response5 = await generateNaturalCalendarResponse(
  'delete',
  {
    title: 'Gym Session'
  },
  'Chris'
);
// Returns: "That one's removed, you're good."

// Example 6: Get schedule - empty
const response6 = await generateNaturalCalendarResponse(
  'get',
  {
    date: 'tomorrow',
    eventCount: 0,
    events: []
  },
  'Jordan'
);
// Returns: "You've got nothing scheduled for tomorrow."

// Example 7: Get schedule - multiple events
const response7 = await generateNaturalCalendarResponse(
  'get',
  {
    date: 'Monday',
    eventCount: 3,
    events: [
      { title: 'Standup', time: '9:00 AM' },
      { title: 'Lunch', time: '12:00 PM' },
      { title: 'Client Call', time: '3:00 PM' }
    ]
  },
  'Taylor'
);
// Returns: "You have 3 events Monday: standup at 9am, lunch at 12pm, and client call at 3pm."
*/

// ============================================
// FALLBACK RESPONSES (if Azure fails)
// ============================================

const getStaticFallback = (operation, eventDetails) => {
  if (operation === 'create') {
    if (eventDetails.isRecurring) {
      return `Set up "${eventDetails.title}" ${eventDetails.date} at ${eventDetails.time}. Created ${eventDetails.instanceCount} instances.`;
    }
    return `Added "${eventDetails.title}" to ${eventDetails.date} at ${eventDetails.time}.`;
  }
  
  if (operation === 'update') {
    return `Updated "${eventDetails.oldTitle}": ${eventDetails.changes.join(', ')}.`;
  }
  
  if (operation === 'delete') {
    return `Removed "${eventDetails.title}".`;
  }
  
  if (operation === 'get') {
    if (eventDetails.eventCount === 0) {
      return `No events scheduled for ${eventDetails.date}.`;
    }
    return `You have ${eventDetails.eventCount} event${eventDetails.eventCount > 1 ? 's' : ''} on ${eventDetails.date}.`;
  }
  
  return 'Done.';
};
// ============================================
// COMPLETE RECURRING EVENTS SYSTEM
// Handles: Daily, Weekly, Monthly, Yearly + All Edge Cases
// ============================================

// ============================================
// MASTER FUNCTION: Parse ANY Recurring Pattern
// ============================================

/**
 * Parse natural language into structured recurring pattern
 * Handles 100% of use cases
 */
const parseRecurringPattern = (description) => {
  const text = description.toLowerCase().trim();
  
  // ============================================
  // CASE 1: DAILY PATTERNS
  // ============================================
  
  // "every day" or "daily"
  if (text.includes('every day') || text.includes('daily')) {
    return {
      type: 'daily',
      interval: 1,
      description: 'every day'
    };
  }
  
  // "every 2 days", "every 3 days"
  const everyNDays = text.match(/every (\d+) days?/i);
  if (everyNDays) {
    const interval = parseInt(everyNDays[1]);
    return {
      type: 'daily',
      interval: interval,
      description: `every ${interval} days`
    };
  }
  
  // "every weekday" (Monday-Friday)
  if (text.includes('every weekday') || text.includes('weekdays') || text.includes('monday through friday')) {
    return {
      type: 'weekdays',
      daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
      description: 'every weekday'
    };
  }
  
  // "every weekend" (Saturday-Sunday)
  if (text.includes('every weekend') || text.includes('weekends')) {
    return {
      type: 'weekends',
      daysOfWeek: [0, 6], // Sat-Sun
      description: 'every weekend'
    };
  }
  
  // ============================================
  // CASE 2: WEEKLY PATTERNS
  // ============================================
  
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  
  // "every Monday", "every Friday"
  const everyDay = days.find(day => 
    text.includes(`every ${day}`) || 
    text.match(new RegExp(`\\b${day}s?\\b`))
  );
  
  if (everyDay) {
    return {
      type: 'weekly',
      dayOfWeek: days.indexOf(everyDay),
      dayName: everyDay,
      interval: 1,
      description: `every ${everyDay}`
    };
  }
  
  // "every 2 weeks on Monday", "biweekly"
  const everyNWeeks = text.match(/every (\d+) weeks?/i) || (text.includes('biweekly') ? ['', '2'] : null);
  if (everyNWeeks) {
    const interval = parseInt(everyNWeeks[1]);
    const onDay = days.find(day => text.includes(day));
    
    if (onDay) {
      return {
        type: 'weekly',
        dayOfWeek: days.indexOf(onDay),
        dayName: onDay,
        interval: interval,
        description: `every ${interval} weeks on ${onDay}`
      };
    }
  }
  
  // "every Monday and Wednesday" (multiple days per week)
  const multipleDays = [];
  days.forEach(day => {
    if (text.includes(day)) {
      multipleDays.push({ day, index: days.indexOf(day) });
    }
  });
  
  if (multipleDays.length > 1) {
    return {
      type: 'multiple_weekly',
      daysOfWeek: multipleDays.map(d => d.index),
      dayNames: multipleDays.map(d => d.day),
      description: `every ${multipleDays.map(d => d.day).join(' and ')}`
    };
  }
  
  // ============================================
  // CASE 3: MONTHLY PATTERNS
  // ============================================
  
  // "every month on the 15th"
  const monthlyDate = text.match(/every month on the (\d+)(st|nd|rd|th)?/i);
  if (monthlyDate) {
    const dayOfMonth = parseInt(monthlyDate[1]);
    return {
      type: 'monthly',
      dayOfMonth: dayOfMonth,
      interval: 1,
      description: `every month on the ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`
    };
  }
  
  // "monthly on the 1st"
  const monthlyShort = text.match(/monthly on the (\d+)(st|nd|rd|th)?/i);
  if (monthlyShort) {
    const dayOfMonth = parseInt(monthlyShort[1]);
    return {
      type: 'monthly',
      dayOfMonth: dayOfMonth,
      interval: 1,
      description: `monthly on the ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`
    };
  }
  
  // "every 3 months"
  const everyNMonths = text.match(/every (\d+) months?/i);
  if (everyNMonths) {
    const interval = parseInt(everyNMonths[1]);
    return {
      type: 'monthly',
      dayOfMonth: 1, // Default to 1st
      interval: interval,
      description: `every ${interval} months`
    };
  }
  
  // "first Monday of every month"
  const firstDayOfMonth = text.match(/(first|second|third|fourth|last) (monday|tuesday|wednesday|thursday|friday|saturday|sunday) of (every|each) month/i);
  if (firstDayOfMonth) {
    const ordinal = firstDayOfMonth[1].toLowerCase();
    const dayName = firstDayOfMonth[2].toLowerCase();
    
    return {
      type: 'monthly_ordinal',
      dayOfWeek: days.indexOf(dayName),
      dayName: dayName,
      ordinal: ordinal, // 'first', 'second', 'third', 'fourth', 'last'
      interval: 1,
      description: `${ordinal} ${dayName} of every month`
    };
  }
  
  // "monthly" or "once a month"
  if (text.includes('monthly') || text.includes('once a month')) {
    return {
      type: 'monthly',
      dayOfMonth: 1,
      interval: 1,
      description: 'monthly (1st of month)'
    };
  }
  
  // "quarterly" (every 3 months)
  if (text.includes('quarterly') || text.includes('every quarter')) {
    return {
      type: 'monthly',
      dayOfMonth: 1,
      interval: 3,
      description: 'quarterly'
    };
  }
  
  // ============================================
  // CASE 4: YEARLY PATTERNS
  // ============================================
  
  // "every year on March 15th"
  const yearlyDate = text.match(/every year on ([a-z]+) (\d+)(st|nd|rd|th)?/i);
  if (yearlyDate) {
    const monthName = yearlyDate[1].toLowerCase();
    const dayOfMonth = parseInt(yearlyDate[2]);
    const monthIndex = getMonthIndex(monthName);
    
    if (monthIndex !== -1) {
      return {
        type: 'yearly',
        month: monthIndex,
        monthName: monthName,
        dayOfMonth: dayOfMonth,
        description: `every year on ${monthName} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`
      };
    }
  }
  
  // "annually on December 25th"
  const annuallyDate = text.match(/annually on ([a-z]+) (\d+)(st|nd|rd|th)?/i);
  if (annuallyDate) {
    const monthName = annuallyDate[1].toLowerCase();
    const dayOfMonth = parseInt(annuallyDate[2]);
    const monthIndex = getMonthIndex(monthName);
    
    if (monthIndex !== -1) {
      return {
        type: 'yearly',
        month: monthIndex,
        monthName: monthName,
        dayOfMonth: dayOfMonth,
        description: `annually on ${monthName} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`
      };
    }
  }
  
  // "yearly" or "annually"
  if (text.includes('yearly') || text.includes('annually') || text.includes('every year')) {
    return {
      type: 'yearly',
      month: 0, // January
      dayOfMonth: 1,
      description: 'yearly (January 1st)'
    };
  }
  
  // ============================================
  // CASE 5: DURATION PARSING
  // ============================================
  
  // Extract duration limits
  let durationWeeks = null;
  let durationMonths = null;
  let durationYears = null;
  let endDate = null;
  
  // "for 2 weeks"
  const forWeeks = text.match(/for (\d+) weeks?/i);
  if (forWeeks) {
    durationWeeks = parseInt(forWeeks[1]);
  }
  
  // "for 3 months"
  const forMonths = text.match(/for (\d+) months?/i);
  if (forMonths) {
    durationMonths = parseInt(forMonths[1]);
  }
  
  // "for 1 year" or "for 2 years"
  const forYears = text.match(/for (\d+) years?/i);
  if (forYears) {
    durationYears = parseInt(forYears[1]);
  }
  
  // "until December 31st"
  const untilDate = text.match(/until ([a-z]+ \d+)/i);
  if (untilDate) {
    endDate = new Date(untilDate[1]);
  }
  
  // No pattern found
  return null;
};

// ============================================
// HELPER FUNCTIONS
// ============================================

const getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

const getMonthIndex = (monthName) => {
  const months = ['january', 'february', 'march', 'april', 'may', 'june', 
                  'july', 'august', 'september', 'october', 'november', 'december'];
  return months.indexOf(monthName.toLowerCase());
};

const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// ============================================
// MASTER FUNCTION: Generate Recurring Instances
// ============================================

/**
 * Generate ALL instances for a recurring event
 * Handles daily, weekly, monthly, yearly + all edge cases
 */
const generateRecurringInstances = (baseEvent, pattern, startDate, defaultWeeks = 52) => {
  const instances = [];
  const current = new Date(startDate);
  current.setHours(0, 0, 0, 0);
  
  // Calculate end date
  let endDate;
  
  if (pattern.durationWeeks) {
    endDate = new Date(current);
    endDate.setDate(endDate.getDate() + (pattern.durationWeeks * 7));
  } else if (pattern.durationMonths) {
    endDate = new Date(current);
    endDate.setMonth(endDate.getMonth() + pattern.durationMonths);
  } else if (pattern.durationYears) {
    endDate = new Date(current);
    endDate.setFullYear(endDate.getFullYear() + pattern.durationYears);
  } else if (pattern.endDate) {
    endDate = new Date(pattern.endDate);
  } else {
    // Default based on type
    endDate = new Date(current);
    if (pattern.type === 'yearly') {
      endDate.setFullYear(endDate.getFullYear() + 5); // 5 years ahead
    } else if (pattern.type === 'monthly' || pattern.type === 'monthly_ordinal') {
      endDate.setMonth(endDate.getMonth() + 12); // 1 year ahead
    } else {
      endDate.setDate(endDate.getDate() + (defaultWeeks * 7)); // Default weeks
    }
  }
  
  console.log('📅 Generating instances:', {
    type: pattern.type,
    from: current.toLocaleDateString(),
    to: endDate.toLocaleDateString(),
    description: pattern.description
  });
  
  // ============================================
  // GENERATE INSTANCES BY TYPE
  // ============================================
  
  if (pattern.type === 'daily') {
    // Daily: Every N days
    while (current <= endDate) {
      instances.push(createInstance(baseEvent, current, pattern));
      current.setDate(current.getDate() + pattern.interval);
    }
  }
  
  else if (pattern.type === 'weekdays') {
    // Weekdays: Monday-Friday
    while (current <= endDate) {
      const dayOfWeek = current.getDay();
      if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Mon-Fri
        instances.push(createInstance(baseEvent, current, pattern));
      }
      current.setDate(current.getDate() + 1);
    }
  }
  
  else if (pattern.type === 'weekends') {
    // Weekends: Saturday-Sunday
    while (current <= endDate) {
      const dayOfWeek = current.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) { // Sat-Sun
        instances.push(createInstance(baseEvent, current, pattern));
      }
      current.setDate(current.getDate() + 1);
    }
  }
  
  else if (pattern.type === 'weekly') {
    // Weekly: Every N weeks on specific day
    while (current <= endDate) {
      if (current.getDay() === pattern.dayOfWeek) {
        instances.push(createInstance(baseEvent, current, pattern));
        current.setDate(current.getDate() + (7 * pattern.interval));
      } else {
        current.setDate(current.getDate() + 1);
      }
    }
  }
  
  else if (pattern.type === 'multiple_weekly') {
    // Multiple days per week (e.g., "every Monday and Wednesday")
    while (current <= endDate) {
      if (pattern.daysOfWeek.includes(current.getDay())) {
        instances.push(createInstance(baseEvent, current, pattern));
      }
      current.setDate(current.getDate() + 1);
    }
  }
  
  else if (pattern.type === 'monthly') {
    // Monthly: Same day of month every N months
    while (current <= endDate) {
      if (current.getDate() === pattern.dayOfMonth) {
        instances.push(createInstance(baseEvent, current, pattern));
        current.setMonth(current.getMonth() + pattern.interval);
      } else {
        current.setDate(current.getDate() + 1);
      }
    }
  }
  
  else if (pattern.type === 'monthly_ordinal') {
    // Monthly: First/Second/Third/Fourth/Last [Day] of month
    while (current <= endDate) {
      const targetDate = getOrdinalDayOfMonth(
        current.getFullYear(),
        current.getMonth(),
        pattern.dayOfWeek,
        pattern.ordinal
      );
      
      if (targetDate && formatDateKey(current) === formatDateKey(targetDate)) {
        instances.push(createInstance(baseEvent, current, pattern));
        current.setMonth(current.getMonth() + pattern.interval);
      } else {
        current.setDate(current.getDate() + 1);
      }
    }
  }
  
  else if (pattern.type === 'yearly') {
    // Yearly: Same date every year
    while (current <= endDate) {
      if (current.getMonth() === pattern.month && current.getDate() === pattern.dayOfMonth) {
        instances.push(createInstance(baseEvent, current, pattern));
        current.setFullYear(current.getFullYear() + 1);
      } else {
        current.setDate(current.getDate() + 1);
      }
    }
  }
  
  console.log(`✅ Generated ${instances.length} instances`);
  return instances;
};

// ============================================
// HELPER: Create Instance Object
// ============================================

const createInstance = (baseEvent, date, pattern) => {
  const dateKey = formatDateKey(date);
  
  return {
    dateKey,
    event: {
      ...baseEvent,
      isRecurring: true,
      recurrenceId: baseEvent.recurrenceId,
      recurrencePattern: pattern,
      instanceDate: dateKey,
      displayDate: date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      })
    }
  };
};

// ============================================
// HELPER: Get Nth Day of Month
// ============================================

/**
 * Get the Nth occurrence of a day in a month
 * Example: "first Monday", "last Friday"
 */
const getOrdinalDayOfMonth = (year, month, dayOfWeek, ordinal) => {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  
  if (ordinal === 'last') {
    // Find last occurrence
    let date = new Date(lastDay);
    while (date.getDay() !== dayOfWeek) {
      date.setDate(date.getDate() - 1);
    }
    return date;
  } else {
    // Find nth occurrence (first, second, third, fourth)
    const ordinalMap = { first: 1, second: 2, third: 3, fourth: 4 };
    const targetOccurrence = ordinalMap[ordinal] || 1;
    
    let occurrences = 0;
    let date = new Date(firstDay);
    
    while (date <= lastDay) {
      if (date.getDay() === dayOfWeek) {
        occurrences++;
        if (occurrences === targetOccurrence) {
          return date;
        }
      }
      date.setDate(date.getDate() + 1);
    }
  }
  
  return null;
};

/**
   * Handle tool call from Azure (podcast generation or journal saving or quiz or flashcards)
   */

const handleToolCall = async (toolCallData, messageHistory,lastUserMessage) => {
  // Import date formatters INSIDE the function where they're used
  const { formatSearchDate, formatDateWithDayOfWeek } = await import('./webSearchHandler.js');
  
 const { toolCallId, functionName, arguments: args } = toolCallData;

  console.log('🔧 Tool call received:', functionName);

  // ============================================
  // ✅ STEP 1: CHECK TOOL PERMISSIONS FIRST (BEFORE ANYTHING ELSE)
  // ============================================
  let requiredTool = null;
  
  if (functionName === 'generate_quiz' || functionName === 'generate_flashcards') {
    requiredTool = 'study';
  } else if (functionName === 'generate_podcast_dialogue') {
    requiredTool = 'podcast';
  } else if (functionName === 'save_journal_entry') {
    requiredTool = 'journal';
  } else if (functionName.includes('schedule') || functionName.includes('event')) {
    requiredTool = 'planner';
  }

  // ✅ CRITICAL: Block IMMEDIATELY if tool not enabled
  if (requiredTool && !isToolEnabled(requiredTool)) {
    console.warn(`⚠️ BLOCKED: Tool ${functionName} called but ${requiredTool} not enabled`);
    
    const errorMessage = getDisabledToolMessage(
      requiredTool === 'study' ? 'Study Tool' :
      requiredTool === 'podcast' ? 'Podcast Tool' :
      requiredTool === 'journal' ? 'Journal Tool' : 'Schedule Tool'
    );
    
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: errorMessage,
      timestamp: new Date().toISOString()
    }]);
    
    return; // ✅ EXIT IMMEDIATELY - Don't execute anything else
  }
if (functionName === 'generate_flashcards') {
  await handleFlashcardGeneration(toolCallId, args, messageHistory);
  return;
}

if (functionName === 'generate_quiz') {
  await handleQuizGeneration(toolCallId, args, messageHistory);
  return;
}

     // ✅ NEW: Clear user name tool
    if (functionName === 'clear_user_name') {
      console.log('🗑️ AI clearing user name');
      
      // Clear from Firestore
      if (firestoreService?.isReady()) {
        await firestoreService.saveUserSettings({
          userName: null
        });
      }
      
      // Update React state
      setUserName(null);
      setIsFirstInteraction(true);
      
      // Send result back to AI
      const result = {
        success: true,
        message: "Username cleared successfully"
      };
      
      const response = await sendToolResult(
        messageHistory,
        toolCallId,
        'clear_user_name',
        args,
        result
      );
      
      // AI's natural response
      const parsed = parseAzureResponse(response);
      if (parsed.type === 'message') {
        setMessages(prev => [...prev, {
          id: Date.now(),
          type: 'bot',
          content: parsed.content,
          timestamp: new Date().toISOString()
        }]);
      }
      
      return;
    }

if (functionName === 'save_user_name') {
  console.log('💾 AI is saving user name:', args.name);
  
  // Capitalize first letter
  const capitalizedName = args.name.charAt(0).toUpperCase() + args.name.slice(1).toLowerCase();
  
  // ✅ Save to Firestore (not just localStorage)
  let toolResult;
  try {
    const success = await saveUserName(capitalizedName, firestoreService);
    
    if (success) {
      setUserName(capitalizedName);
      setIsFirstInteraction(false);
      
      toolResult = {
        success: true,
        name: capitalizedName,
        message: `Saved user name: ${capitalizedName}`
      };
      
      console.log('✅ Name saved to Firestore:', capitalizedName);
    } else {
      throw new Error('Failed to save to Firestore');
    }
  } catch (error) {
    console.error('❌ Failed to save name:', error);
    
    toolResult = {
      success: false,
      error: 'Failed to save name',
      message: 'Could not save your name. Please try again.'
    };
  }
  
  // Send result back to Azure
  const response = await sendToolResult(
    messageHistory,
    toolCallId,
    'save_user_name',
    args,
    toolResult
  );
  
  if (response?.choices?.[0]?.message?.content) {
    const botMessageId = Date.now();
    const botMessage = {
      id: botMessageId,
      type: 'bot',
      content: response.choices[0].message.content,
      timestamp: new Date().toISOString()
    };
    
    setMessages(prev => [...prev, botMessage]);
    displayMessageWithTyping(botMessageId, response.choices[0].message.content);
  }
  
  return;
}

// PRIORITY 2: Handle podcast generation
if (functionName === 'generate_podcast_dialogue') {
  const topic = args.topic;
  
  console.log('🎙️ Podcast generation requested:', topic);
  
  // ✅ Call the generation handler directly
  await handlePodcastGeneration(toolCallId, args, messageHistory);
  
  return; // Exit - podcast generation is complete
}
     // ✅ MEMORY SAVING HANDLER
    if (functionName === 'save_conversation_memory') {
      try {
        if (!memoryService) {
          console.warn('⚠️ Memory service not available - skipping save');
          
          // Continue conversation even if memory fails
          const toolResult = {
            success: false,
            message: 'Memory service not available'
          };
          
          const azureResponse = await sendToolResult(
            messageHistory,
            toolCallId,
            'save_conversation_memory',
            args,
            toolResult,
            tasksByDate,
            memoryService
          );
          
          if (azureResponse) {
            const parsed = parseAzureResponse(azureResponse);
            if (parsed.type === 'message') {
              const botMessage = {
                id: Date.now(),
                type: 'bot',
                content: parsed.content,
                timestamp: new Date().toISOString()
              };
              setMessages(prev => [...prev, botMessage]);
              displayMessageWithTyping(botMessage.id, parsed.content);
            }
          }
          
          return;
        }
        
        console.log('💾 Saving memory:', args.memory);
        
        // Calculate expiry date if provided
        let expiresAt = null;
        if (args.expiresAt) {
          expiresAt = new Date(args.expiresAt);
          console.log('⏰ Memory expires at:', expiresAt);
        }
        
        // Save the memory
        const savedMemory = await memoryService.saveMemory({
          memory: args.memory,
          topic: args.topic,
          importance: args.importance || 'medium',
          tags: args.tags || [],
          context: args.context || '',
          expiresAt: expiresAt
        });
        
        console.log('✅ Memory saved successfully:', savedMemory.memoryId);
        
        // Send success to Azure
        const toolResult = {
          success: true,
          memoryId: savedMemory.memoryId,
          message: `Memory saved: ${args.memory}`
        };
        
        const azureResponse = await sendToolResult(
          messageHistory,
          toolCallId,
          'save_conversation_memory',
          args,
          toolResult,
          tasksByDate,
          memoryService
        );
        
        // Continue conversation
        if (azureResponse) {
          const parsed = parseAzureResponse(azureResponse);
          
          if (parsed.type === 'message') {
            const botMessage = {
              id: Date.now(),
              type: 'bot',
              content: parsed.content,
              timestamp: new Date().toISOString()
            };
            
            setMessages(prev => [...prev, botMessage]);
            displayMessageWithTyping(botMessage.id, parsed.content);
          }
        }
        
      } catch (error) {
        console.error('❌ Failed to save memory:', error);
        
        // Don't break the conversation - just log and continue
        const toolResult = {
          success: false,
          error: error.message
        };
        
        const azureResponse = await sendToolResult(
          messageHistory,
          toolCallId,
          'save_conversation_memory',
          args,
          toolResult,
          tasksByDate,
          memoryService
        );
        
        if (azureResponse) {
          const parsed = parseAzureResponse(azureResponse);
          if (parsed.type === 'message') {
            const botMessage = {
              id: Date.now(),
              type: 'bot',
              content: parsed.content,
              timestamp: new Date().toISOString()
            };
            setMessages(prev => [...prev, botMessage]);
            displayMessageWithTyping(botMessage.id, parsed.content);
          }
        }
      }
      
      return;
    }
    // PRIORITY 3: Handle web search
  if (functionName === 'web_search') {
    console.log('🔍 Web search request:', args.query);
    console.log('📝 Last user message:', lastUserMessage);
    
    const loadingId = Date.now();
    const isURLSearch = containsURL(args.query);
    const isYouTube = isYouTubeURL(args.query);
    
    // Check if user explicitly wants podcast
    const wantsPodcast = lastUserMessage && isExplicitPodcastRequest(lastUserMessage);
    console.log('🎙️ User wants podcast?', wantsPodcast);
    
    setMessages(prev => [...prev, {
      id: loadingId,
      type: 'bot',
      content: isYouTube 
        ? 'Analyzing that YouTube video...' 
        : isURLSearch 
          ? 'Fetching and analyzing that URL...' 
          : 'Searching for the latest news...',
      isLoading: true
    }]);
    
    try {
      // Perform search
      const searchResults = await performWebSearch(args.query, args.count || 10);
      
      console.log('📊 Search results received:', {
        hasResults: !!searchResults,
        resultsArray: searchResults?.results?.length || 0,
        isURLContent: searchResults?.isURLContent || false,
        isYouTube,
        error: searchResults?.error || null
      });
      
      // Remove loading message
      setMessages(prev => prev.filter(m => m.id !== loadingId));
      
      // Check for errors
      if (!searchResults || searchResults.error || !searchResults.results?.length) {
        const errorMessage = isYouTube
          ? "I couldn't access that YouTube video. The video might be private or age-restricted."
          : searchResults?.error || "I couldn't fetch that content.";
          
        setMessages(prev => [...prev, {
          id: Date.now(),
          type: 'bot',
          content: errorMessage,
          timestamp: new Date().toISOString()
        }]);
        return;
      }
      
      // Format dates
      const formattedResults = searchResults.results.map(result => ({
        ...result,
        dateFormatted: formatSearchDate(result.datePublished || new Date().toISOString()),
        dateWithDayOfWeek: new Date(result.datePublished || new Date()).toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long', 
          day: 'numeric',
          year: 'numeric'
        })
      }));
      
      // ✅ CRITICAL FIX: Only store for podcast if user EXPLICITLY requested it
      if (isURLSearch && wantsPodcast) {
        console.log('✅ User explicitly wants podcast - storing content');
        storeFetchedContentForPodcast(args.query, { results: formattedResults }, lastUserMessage);
      } else if (isURLSearch) {
        console.log('ℹ️ URL search but no podcast request - just providing summary');
      }
      
      // Handle URL content (YouTube or regular URL)
      if (searchResults.isURLContent || isYouTube) {
        console.log('📄 URL content - providing summary WITHOUT podcast suggestion');
        
        // Build context for AI
        const contentContext = isYouTube 
          ? `YouTube Video: ${formattedResults[0]?.title}\nCreator: ${formattedResults[0]?.author || 'Unknown'}\nDescription: ${formattedResults[0]?.content || formattedResults[0]?.snippet || ''}`
          : `URL Content:\nTitle: ${formattedResults[0]?.title}\nContent: ${formattedResults[0]?.content || formattedResults[0]?.snippet || ''}`;
        
        const response = await sendToolResult(
          messageHistory,
          toolCallId,
          'web_search',
          args,
          { 
            results: formattedResults,
            isURLContent: true,
            isYouTube,
            fullContent: contentContext,
            skipPodcastSuggestion: true  // ✅ Tell AI: Don't suggest podcast
          }
        );
        
        // Display AI response WITHOUT podcast suggestion
        if (response?.choices?.[0]?.message?.content) {
          const botMessageId = Date.now();
          let content = response.choices[0].message.content;
          
          // ✅ CRITICAL: Strip out any podcast mentions AI might add
          content = content.replace(/🎙️.*podcast.*button.*\n?/gi, '');
          content = content.replace(/Want.*podcast.*\?/gi, '');
          content = content.replace(/[Jj]ust (say|hit|click).*podcast.*/gi, '');
          content = content.replace(/[Ii]f you want.*podcast.*/gi, '');
          content = content.replace(/[Hh]it the.*button.*above.*/gi, '');
          content = content.trim();
          
          setMessages(prev => [...prev, {
            id: botMessageId,
            type: 'bot',
            content: content,
            isURLSummary: true,
            isYouTube,
            hasPodcastSuggestion: false, // ✅ Never suggest
            timestamp: new Date().toISOString()
          }]);
          
          displayMessageWithTyping(botMessageId, content);
        } else {
          // Fallback - NO podcast mention
          const fallbackContent = isYouTube
            ? `This YouTube video is titled "${formattedResults[0]?.title}". ${formattedResults[0]?.snippet || formattedResults[0]?.content?.substring(0, 300) || 'No description available'}`
            : `Here's what I found:\n\n${formattedResults[0]?.snippet || formattedResults[0]?.content?.substring(0, 300) || 'No content available'}`;
          
          setMessages(prev => [...prev, {
            id: Date.now(),
            type: 'bot',
            content: fallbackContent,
            isURLSummary: true,
            isYouTube,
            hasPodcastSuggestion: false, // ✅ Never suggest
            timestamp: new Date().toISOString()
          }]);
        }
        return;
      }
      
      // Regular news search - display NewsCard
      console.log('📰 Regular news search - displaying NewsCard');
      
      const response = await sendToolResult(
        messageHistory,
        toolCallId,
        'web_search',
        args,
        { 
          results: formattedResults,
          searchQuery: args.query,
          totalResults: formattedResults.length
        }
      );
      
      // Display NewsCard + AI's response
      if (response?.choices?.[0]?.message?.content) {
        const botMessageId = Date.now();
        const aiResponse = response.choices[0].message.content;
        
        console.log('✅ Displaying NewsCard with AI response');
        
        setMessages(prev => [...prev, {
          id: botMessageId,
          type: 'bot',
          content: aiResponse,
          searchResults: formattedResults,
          searchQuery: args.query,
          podcastState: 'idle',
          audioUrl: null,
          dialogue: null,
          podcastTitle: null,
          timestamp: new Date().toISOString()
        }]);
        
        displayMessageWithTyping(botMessageId, aiResponse);
      } else {
        // Fallback
        setMessages(prev => [...prev, {
          id: Date.now(),
          type: 'bot',
          content: `Found ${formattedResults.length} recent articles about "${args.query}".`,
          searchResults: formattedResults,
          searchQuery: args.query,
          podcastState: 'idle',
          audioUrl: null,
          dialogue: null,
          podcastTitle: null,
          timestamp: new Date().toISOString()
        }]);
      }
      
    } catch (error) {
      console.error('❌ Web search error:', error);
      console.error('Error stack:', error.stack);
      
      setMessages(prev => prev.filter(m => m.id !== loadingId));
      
      setMessages(prev => [...prev, {
        id: Date.now(),
        type: 'bot',
        content: `Sorry, I had trouble ${isURLSearch ? 'fetching that URL' : 'searching'}. ${error.message || 'Please try again!'}`,
        timestamp: new Date().toISOString()
      }]);
    }
    
    return;
  }
// PRIORITY 4: Handle other tools
if (functionName === 'save_journal_entry') {
  await handleJournalSave(toolCallId, args, messageHistory, tasksByDate);
  return;
}else if (functionName === 'schedule_event') {
  console.log('📅 Schedule event tool called:', args);
  
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: `📅 Adding "${args.title}" to your calendar...`,
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // ✅ Parse date with improved logic
    const eventDate = parseRelativeDate(args.date || 'today');
    const dateKey = formatDateKey(eventDate);
    
    console.log('📅 Parsed date:', {
      input: args.date,
      output: eventDate.toISOString(),
      dateKey: dateKey
    });
    
    // ✅ Convert 24-hour time to 12-hour format
    let formattedTime = args.time || 'All day';
    
    if (formattedTime && formattedTime !== 'All day') {
      const timeMatch = formattedTime.match(/^(\d{1,2}):(\d{2})$/);
      if (timeMatch) {
        let hours = parseInt(timeMatch[1]);
        const minutes = timeMatch[2];
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        formattedTime = `${hours}:${minutes} ${ampm}`;
        console.log('✅ Converted time:', `${args.time} → ${formattedTime}`);
      }
    }
    
    // ✅ CHECK: Is this a recurring event request?
    const fullDescription = `${args.title} ${args.description || ''}`.toLowerCase();
    const recurringPattern = parseRecurringPattern(fullDescription);
    
    if (recurringPattern) {
      console.log('🔄 Detected recurring event:', recurringPattern);
      
      // ✅ Generate recurring instances
      const recurrenceId = `recurring_${Date.now()}`;
      const baseEvent = {
        text: args.title,
        time: formattedTime,
        description: args.description || '',
        completed: false,
        isNew: true,
        isRecurring: true,
        recurrenceId: recurrenceId,
        recurrencePattern: recurringPattern,
        createdAt: new Date().toISOString()
      };
      
      const instances = generateRecurringInstances(baseEvent, recurringPattern, eventDate, 8);
      console.log(`✅ Generated ${instances.length} recurring instances`);
      
      // Update calendar with ALL instances
      let updatedCalendar;
      setTasksByDate(prev => {
        const updated = { ...prev };
        
        instances.forEach(({ dateKey: instDateKey, event }) => {
          updated[instDateKey] = [...(updated[instDateKey] || []), event];
        });
        
        updatedCalendar = updated;
        return updated;
      });
      
      // ✅ CRITICAL: AWAIT Firestore save
      if (firestoreService?.isReady?.()) {
        console.log('💾 Saving recurring events to Firestore...');
        await saveCalendarToStorage(updatedCalendar, firestoreService);
        console.log('✅ Firestore save complete');
      }
      
      // Remove loading
      setMessages(prev => prev.filter(msg => msg.id !== loadingId));
      
      // Natural success message
      const dayName = recurringPattern.dayName || 'day';
      const naturalResponse = await generateNaturalCalendarResponse(
        'create',
        { 
          title: args.title, 
          date: `every ${dayName}`, 
          time: formattedTime,
          isRecurring: true,
          instanceCount: instances.length
        },
        userName
      );
      
      setMessages(prev => [...prev, {
        id: Date.now(),
        type: 'bot',
        content: naturalResponse || `Set up recurring event: "${args.title}" every ${dayName} at ${formattedTime}. Created ${instances.length} instances for the next 8 weeks.`,
        timestamp: new Date().toISOString()
      }]);
      
      // ✅ Show AnimatedScheduleDisplay for first instance
      setTimeout(() => {
        const firstInstance = instances[0];
        if (firstInstance) {
          const firstDate = parseRelativeDate(firstInstance.dateKey);
          
          setMessages(prev => [...prev, {
            id: Date.now() + 1,
            type: 'bot',
            scheduleDisplay: {
              date: firstDate,
              dateKey: firstInstance.dateKey,
              events: updatedCalendar[firstInstance.dateKey] || [],
              tasksByDate: updatedCalendar,
              setTasksByDate: setTasksByDate,
              firestoreService: firestoreService
            },
            timestamp: new Date().toISOString()
          }]);
        }
      }, 400);
      
      // Send tool result
      await sendToolResult(
        messageHistory,
        toolCallId,
        'schedule_event',
        args,
        { 
          success: true,
          isRecurring: true,
          instanceCount: instances.length,
          message: `Created ${instances.length} instances of "${args.title}"`
        }
      );
      
    } else {
      // ✅ SINGLE EVENT
      const newEvent = {
        text: args.title,
        time: formattedTime,
        description: args.description || '',
        completed: false,
        isNew: true,
        createdAt: new Date().toISOString()
      };
      
      let updatedCalendar;
      setTasksByDate(prev => {
        const updated = {
          ...prev,
          [dateKey]: [...(prev[dateKey] || []), newEvent]
        };
        updatedCalendar = updated;
        return updated;
      });
      
      // ✅ CRITICAL: AWAIT Firestore save
      if (firestoreService?.isReady?.()) {
        console.log('💾 Saving event to Firestore...');
        await saveCalendarToStorage(updatedCalendar, firestoreService);
        console.log('✅ Firestore save complete');
      }
      
      // Remove loading
      setMessages(prev => prev.filter(msg => msg.id !== loadingId));
      
      // Natural success message
      const naturalResponse = await generateNaturalCalendarResponse(
        'create',
        { title: args.title, date: eventDate.toLocaleDateString(), time: formattedTime },
        userName
      );
      
      setMessages(prev => [...prev, {
        id: Date.now(),
        type: 'bot',
        content: naturalResponse || `Added "${args.title}" to ${eventDate.toLocaleDateString('en-US', { 
          weekday: 'long', 
          month: 'long', 
          day: 'numeric' 
        })} at ${formattedTime}`,
        timestamp: new Date().toISOString()
      }]);
      
      // ✅ Show AnimatedScheduleDisplay for single event
      setTimeout(() => {
        setMessages(prev => [...prev, {
          id: Date.now() + 1,
          type: 'bot',
          scheduleDisplay: {
            date: eventDate,
            dateKey: dateKey,
            events: updatedCalendar[dateKey] || [],
            tasksByDate: updatedCalendar,
            setTasksByDate: setTasksByDate,
            firestoreService: firestoreService
          },
          timestamp: new Date().toISOString()
        }]);
      }, 400);
      
      // Send tool result
      await sendToolResult(
        messageHistory,
        toolCallId,
        'schedule_event',
        args,
        { 
          success: true,
          isRecurring: false,
          message: `Event "${args.title}" scheduled`
        }
      );
    }
    
  } catch (error) {
    console.error('❌ Schedule error:', error);
    setMessages(prev => prev.filter(msg => msg.id !== loadingId));
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Sorry, couldn't add the event: ${error.message}`,
      timestamp: new Date().toISOString()
    }]);
  }
  
  return;
}

 // In your handleToolCall function, find the get_schedule section and add:
else if (functionName === 'get_schedule') {
  await handleGetSchedule(
    toolCallId, 
    args, 
    messageHistory, 
    setMessages, 
    tasksByDate,
    setTasksByDate,
    firestoreService
  );
  
  // ✅ ADD THIS: Track what events were displayed
  const queryDate = parseRelativeDate(args.date || 'today');
  const dateKey = formatDateKey(queryDate);
  const events = tasksByDate[dateKey] || [];
  
  if (events.length > 0) {
    setLastScheduleDisplayed(events);
    setLastEventMentioned(events[0]?.text); // First event as default
  }
  
  return;
}else if (functionName === 'update_event') {
  console.log('✏️ Update event tool called:', args);
  
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: '✏️ Updating event...',
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // Find the event
    const found = findEventByTitle(tasksByDate, args.eventTitle);
    
    if (!found) {
      throw new Error(`Could not find event: "${args.eventTitle}"`);
    }
    
    const { dateKey, eventIndex, event } = found;
    const oldDateKey = dateKey;
    
    // ✅ FIX: Declare variables OUTSIDE the callback
    const newDateKey = args.newDate 
      ? formatDateKey(parseRelativeDate(args.newDate))
      : dateKey;
    
    const updatedEvent = {
      ...event,
      text: args.newTitle || event.text,
      time: args.newTime || event.time,
      description: args.newDescription || event.description,
      isNew: true,
      updatedAt: new Date().toISOString()
    };
    
    // Update calendar state
    setTasksByDate(prev => {
      const updated = { ...prev };
      
      // Remove from old location
      updated[oldDateKey] = prev[oldDateKey].filter((_, idx) => idx !== eventIndex);
      if (updated[oldDateKey].length === 0) delete updated[oldDateKey];
      
      // Add to new location
      updated[newDateKey] = [...(updated[newDateKey] || []), updatedEvent];
      
      saveCalendarToStorage(updated, firestoreService);
      return updated;
    });
    
    // Remove loading
    setMessages(prev => prev.filter(msg => msg.id !== loadingId));
    
    // Show success
    const changes = [];
    if (args.newTitle) changes.push(`title to "${args.newTitle}"`);
    if (args.newTime) changes.push(`time to ${args.newTime}`);
    if (args.newDate) changes.push(`date to ${parseRelativeDate(args.newDate).toLocaleDateString()}`);

    const naturalResponse = await generateNaturalCalendarResponse(
      'update',
      { oldTitle: event.text, changes },
      userName
    );

    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: naturalResponse || `Updated "${event.text}"${changes.length ? ': ' + changes.join(', ') : ''}`,
      timestamp: new Date().toISOString()
    }]);
    
    // ✅ NEW: Show AnimatedScheduleDisplay for the updated date
    setTimeout(() => {
      const targetDate = args.newDate ? parseRelativeDate(args.newDate) : parseRelativeDate('today');
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        type: 'bot',
        scheduleDisplay: {
          date: targetDate || new Date(), // ✅ Add fallback
          dateKey: newDateKey,  // ✅ Now in scope
          events: [updatedEvent],  // ✅ Now in scope
          tasksByDate: { [newDateKey]: [updatedEvent] },  // ✅ Now in scope
          setTasksByDate: setTasksByDate,
          firestoreService: firestoreService
        },
        timestamp: new Date().toISOString()
      }]);
    }, 400);
    
    // Send tool result
    await sendToolResult(
      messageHistory,
      toolCallId,
      'update_event',
      args,
      { success: true, changes: changes }
    );
    
  } catch (error) {
    console.error('❌ Update error:', error);
    setMessages(prev => prev.filter(msg => msg.id !== loadingId));
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `${error.message}. Try being more specific with the event name.`,
      timestamp: new Date().toISOString()
    }]);
  }
  
  return;
}
else if (functionName === 'delete_event') {
  console.log('🗑️ Delete event tool called:', args);
  
  const loadingId = Date.now();
  setMessages(prev => [...prev, {
    id: loadingId,
    type: 'bot',
    content: '🗑️ Removing event...',
    isLoading: true,
    timestamp: new Date().toISOString()
  }]);
  
  try {
    // Find the event
    const found = findEventByTitle(tasksByDate, args.eventTitle);
    
    if (!found) {
      throw new Error(`Could not find event: "${args.eventTitle}"`);
    }
    
    const { dateKey, eventIndex, event } = found;
    
    // Delete event
    setTasksByDate(prev => {
      const updated = { ...prev };
      updated[dateKey] = prev[dateKey].filter((_, idx) => idx !== eventIndex);
      
      if (updated[dateKey].length === 0) {
        delete updated[dateKey];
      }
      
      saveCalendarToStorage(updated, firestoreService);
      return updated;
    });
    
    // Remove loading
    setMessages(prev => prev.filter(msg => msg.id !== loadingId));
    
    // Show success
const naturalResponse = await generateNaturalCalendarResponse(
  'delete',
  { title: event.text },
  userName
);

setMessages(prev => [...prev, {
  id: Date.now(),
  type: 'bot',
  content: naturalResponse || `Removed "${event.text}"`,
  timestamp: new Date().toISOString()
}]);
    
    // Send tool result
    await sendToolResult(
      messageHistory,
      toolCallId,
      'delete_event',
      args,
      { success: true }
    );
    
  } catch (error) {
    console.error('❌ Delete error:', error);
    setMessages(prev => prev.filter(msg => msg.id !== loadingId));
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'bot',
      content: `Couldn't find "${args.eventTitle}"`,
      timestamp: new Date().toISOString()
    }]);
  }
  
  return;
}
};

const storeFetchedContentForPodcast = (url, searchResults, userMessage) => {
  if (!searchResults?.results || searchResults.results.length === 0) {
    return false;
  }
  
  const content = searchResults.results[0];
  const isYouTube = isYouTubeURL(url);
  
  // Only store if user explicitly wants podcast
  const wantsPodcast = userMessage && isExplicitPodcastRequest(userMessage);
  
  if (!wantsPodcast) {
    console.log('ℹ️ Not storing for podcast - user just wants to know about the content');
    return false;
  }
  
  // Store in window for persistence
  window.lastFetchedContent = {
    url,
    title: content.title,
    snippet: content.snippet,
    content: content.content || content.snippet,
    isYouTube,
    timestamp: Date.now()
  };
  
  console.log('💾 Stored URL content for podcast:', {
    url,
    isYouTube,
    title: content.title
  });
  
  return true;
};
const getMemoriesForContext = async () => {
  if (!smartMemoryService || !memoryService) {
    return null;
  }

  try {
    const memories = await memoryService.getRecentMemories(30, 30);
    return memories;
  } catch (error) {
    console.error('Error getting memories:', error);
    return null;
  }
};
const handleKeyPress = (e) => {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
    
    // Block send if at word limit
    const wordCount = inputValue.trim() === '' ? 0 : inputValue.trim().split(/\s+/).length;
    if (wordCount >= MAX_WORDS) return;

    if (isPodcastMode) {
      handleGeneratePodcast();
    } else if (showPlusOptions && plusOptions.length > 0) {
      handlePlusOptionSelect(plusOptions[0]);
    } else {
      handleSendMessage();
    }
  }
  if (e.key === 'Escape') {
    if (isPodcastMode) {
      setIsPodcastMode(false);
      setInputValue('');
    }
    setShowPlusOptions(false);
  }
};
// New function to handle planner input with animations
const handlePlannerInput = () => {
    const input = inputValue.trim();
    if (!input) return;

    setIsProcessing(true);
    setInputValue('');
    setProcessingMessage('Working on it...');

    // Add animation class to input area
    const inputArea = document.querySelector('.nexus-input-area');
    if (inputArea) {
      inputArea.classList.add('processing');
    }

    setTimeout(() => {
      const today = new Date();
      
      // Create new task
      const newTask = {
        text: input,
        completed: false,
        isNew: true
      };

      // Use just the day number as the key to match the calendar display
      const dateKey = today.getDate();
      
      console.log('Adding task with key:', dateKey, 'Task:', newTask);
      
      // Add to today's tasks using the day number as key
      setTasksByDate(prev => {
        const updated = {
          ...prev,
          [dateKey]: [...(prev[dateKey] || []), newTask]
        };
        console.log('Updated tasksByDate:', updated);
        return updated;
      });

      // Update processing message to success
      setProcessingMessage('Added to your schedule!');

      // Trigger day highlight animation
      const todayElement = document.querySelector('.nexus-calendar-day.is-today');
      if (todayElement) {
        todayElement.classList.add('pulse-highlight');
        setTimeout(() => {
          todayElement.classList.remove('pulse-highlight');
        }, 800);
      }

      // Clear processing state and message after success feedback
      setTimeout(() => {
        setIsProcessing(false);
        setProcessingMessage('');
        if (inputArea) {
          inputArea.classList.remove('processing');
        }

        // Remove new task animation after it plays
        setTimeout(() => {
          setTasksByDate(prev => ({
            ...prev,
            [dateKey]: (prev[dateKey] || []).map(task => ({
              ...task,
              isNew: false
            }))
          }));
        }, 600);
      }, 1000);
    }, 1500);
  };
  
  const getBotResponse = (userInput) => {
    const responses = [
      "I understand how you're feeling. Would you like to talk more about that?",
      "That's interesting! Tell me more about your thoughts on this.",
      "I'm here to listen. What's on your mind?",
      "Thanks for sharing that with me. How does that make you feel?",
      "I appreciate you opening up. What would help you most right now?"
    ];
    return responses[Math.floor(Math.random() * responses.length)];
  };
  const isPodcastConfirmation = (message) => {
  const lower = message.toLowerCase().trim();
  const confirmationPhrases = [
    'yes', 'yeah', 'yep', 'sure', 'ok', 'okay',
    'create podcast', 'make podcast', 'generate podcast',
    'podcast', "let's do it", 'sounds good', 'go ahead'
  ];
  
  return confirmationPhrases.some(phrase => lower === phrase || lower.includes(phrase));
};

/**
 * Extract YouTube video ID from URL
 */
 const extractYouTubeId = (url) => {
  if (!url) return null;
  
  try {
    // Handle youtu.be short links
    const shortMatch = url.match(/youtu\.be\/([^?&#]+)/);
    if (shortMatch) {
      return decodeURIComponent(shortMatch[1]);
    }
    
    // Handle youtube.com/watch?v= links
    const longMatch = url.match(/[?&]v=([^&#]+)/);
    if (longMatch) {
      return decodeURIComponent(longMatch[1]);
    }
    
    // Handle youtube.com/embed/ links
    const embedMatch = url.match(/youtube\.com\/embed\/([^?&#]+)/);
    if (embedMatch) {
      return decodeURIComponent(embedMatch[1]);
    }
    
    return null;
  } catch (error) {
    console.error('❌ YouTube ID extraction error:', error);
    return null;
  }
};
const confirmSignOut = async () => {
  try {
    await signOut(auth);
    console.log('User signed out successfully');
    navigate('/login');
  } catch (error) {
    console.error('Sign out error:', error);
  }
  setShowSignOutConfirm(false);
};
const isToday = (date) => {
  const today = new Date();
  const checkDate = new Date(date);
  
  return checkDate.getDate() === today.getDate() &&
         checkDate.getMonth() === today.getMonth() &&
         checkDate.getFullYear() === today.getFullYear();
};
const renderSidebar = () => {
  const memoryUsage = getMemoryUsageInfo();
  // Filter visible tools
  const visibleTools = availableTools.filter(tool => tool.visible);
  
  // ✅ Get user profile from your existing state
  const userProfile = {
    name: userName,
    nickname: userName,
    email: auth.currentUser?.email || 'user@email.com',
    photoUrl: auth.currentUser?.photoURL || null
  };

  // ✅ GENERATE COLOR-BASED AVATAR
  const getAvatarColor = (name) => {
    const colors = [
      { bg: '#3B82F6', text: '#FFFFFF' }, // Blue
      { bg: '#10B981', text: '#FFFFFF' }, // Green
      { bg: '#EF4444', text: '#FFFFFF' }, // Red
      { bg: '#F59E0B', text: '#FFFFFF' }, // Orange
      { bg: '#8B5CF6', text: '#FFFFFF' }, // Purple
      { bg: '#EC4899', text: '#FFFFFF' }, // Pink
      { bg: '#06B6D4', text: '#FFFFFF' }, // Cyan
      { bg: '#F97316', text: '#FFFFFF' }, // Deep Orange
    ];
    
    const firstChar = (name || 'U').charAt(0).toUpperCase();
    const colorIndex = firstChar.charCodeAt(0) % colors.length;
    return colors[colorIndex];
  };

  const getInitial = (name) => {
    return (name || 'U').charAt(0).toUpperCase();
  };

  const avatarColor = getAvatarColor(userProfile.nickname || userProfile.name);
    
  return (
    <div className={`nexus-sidebar ${sidebarOpen ? 'open' : ''}`}>
      <div className="nexus-sidebar-header">
        <div className="nexus-logo">
          <img src="/image/logo.png" alt="Preptune Logo" className="preptune-logo" />
          <span className="nexus-logo-text">Preptune</span>
        </div>
        <div 
          className="nexus-close-btn" 
          onClick={() => {
            console.log('Close button clicked'); // Debug log
            setSidebarOpen(false);
          }}
        >
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
          </svg>
        </div>
      </div>

      <div className="nexus-sidebar-content">
        {/* NEW CHAT BUTTON */}
        <div 
          className={`nexus-sidebar-item ${currentMode === 'chat' ? 'active' : ''}`}
          onClick={async () => {
            if (isHumeConnected) {
              disconnectHume();
            }

            if (currentMode === 'chat') {
              console.log('✨ Starting new chat process...');

              const hasCurrentChatMessages = messages && messages.length > 0;

              if (hasCurrentChatMessages && firestoreService?.isReady?.()) {
                try {
                  const settings = await firestoreService.getUserSettings();
                  const surveyCompleted = settings?.surveyCompleted || false;
                  const chatSessionCount = settings?.chatSessionCount || 0;
                  
                  const shouldShowSurvey = !surveyCompleted && chatSessionCount >= 2;
                  
                  if (shouldShowSurvey) {
                    console.log('📊 Survey needed before 3rd chat session:', { 
                      chatSessionCount,
                      surveyCompleted,
                      currentSessionHasMessages: hasCurrentChatMessages
                    });
                    setShowSurvey(true);
                    setSidebarOpen(false);
                    return;
                  }

                  console.log('📈 Chat session progress:', {
                    chatSessionCount,
                    surveyCompleted,
                    currentSessionHasMessages: hasCurrentChatMessages
                  });
                } catch (error) {
                  console.error('Error checking survey:', error);
                }
              }

              if (currentSessionId && messages.length > 0) {
                try {
                  const now = new Date().toISOString();
                  
                  await firestoreService.saveConversation({
                    id: currentSessionId,
                    messages: messages,
                    preview: messages[0]?.content || 'Chat',
                    messageCount: messages.length,
                    timestamp: now,
                    lastUpdated: now,
                    tag: autoTagChat({
                      preview: messages[0]?.content || '',
                      messages: messages
                    })
                  });

                  const settings = await firestoreService.getUserSettings();
                  const currentCount = settings?.chatSessionCount || 0;
                  await firestoreService.updateUserData({
                    'settings.chatSessionCount': currentCount + 1,
                    'settings.lastChatCreated': now
                  });

                  console.log('💾 Session saved and counted, total sessions:', currentCount + 1);
                } catch (error) {
                  console.error('Failed to save session:', error);
                }
              }

              setMessages([]);
              setActiveSessionId(null);
              setCurrentSessionId(null);
              setInputValue('');
              setIsProcessingAzure(false);
              setIsTakingNotes(false);
              setIsJournaling(false);
              setDetectedVibe(null);
              setShowPlusOptions(false);
              setIsMultiline(false);
              setTextareaHeight('44px');

              setSidebarOpen(false);

              console.log('✅ New blank chat session started');
            } else {
              console.log('🔀 Navigating to chat');
              setCurrentMode('chat');
              setSidebarOpen(false);
            }
          }}
          title="New Chat"
        >
          <div className="nexus-icon-container new-chat">
            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
            </svg>
          </div>
          <span className="nexus-sidebar-name">New chat</span>
        </div>

        {/* CHATS HISTORY BUTTON */}
        <div 
          className={`nexus-sidebar-item ${currentMode === 'chats' ? 'active' : ''}`}
          onClick={() => {
            setCurrentMode('chats');
            setSidebarOpen(false);
          }}
          title="Chats"
        >
          <div className="nexus-icon-container chats">
            <History className="nexus-icon" size={12} />
          </div>
          <span className="nexus-sidebar-name">Chats</span>
        </div>

        {/* TOOLS SECTION HEADER */}
        <span className="nexus-sidebar-sub-name">Tools</span>

        {/* RENDER ONLY VISIBLE TOOLS */}
        {visibleTools.map(tool => {
          // JOURNAL TOOL
          if (tool.id === 'journal') {
            return (
              <div 
                key="journal"
                className={`nexus-sidebar-item ${currentMode === 'journal' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'journal' });
                  setSidebarOpen(false);
                }}
                title="Journal"
              >
                <div className="nexus-icon-container journal">
                  <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.83892 12.4543s1.24988-3.08822-.21626-5.29004C8.15656 4.96245 4.58671 4.10885 4.39794 4.2436c-.18877.13476-1.11807 3.32546.34803 5.52727 1.4661 2.20183 5.09295 2.68343 5.09295 2.68343Zm0 0C10.3389 13.4543 12 15 12 18v2c0-2-.4304-3.4188 2.0696-5.9188m0 0s-.4894-2.7888 1.1206-4.35788c1.6101-1.56907 4.4903-1.54682 4.6701-1.28428.1798.26254.4317 2.84376-1.0809 4.31786-1.61 1.5691-4.7098 1.3243-4.7098 1.3243Z"/>
                  </svg>
                </div>
                <span className="nexus-sidebar-name">Journal</span>
              </div>
            );
          }

          // PODCAST TOOL
          if (tool.id === 'podcast') {
            return (
              <div
                key="podcast"
                className={`nexus-sidebar-item ${currentMode === 'podcast' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'podcast' });
                  setSidebarOpen(false);
                }}
                title="Daily Podcast"
              >
                <div className="nexus-icon-container podcast">
                  <Radio size={12} />
                </div>
                <span className="nexus-sidebar-name">Daily podcast</span>
              </div>
            );
          }

          // STUDY TOOL
          if (tool.id === 'study') {
            return (
              <div
                key="study"
                className={`nexus-sidebar-item ${currentMode === 'study' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'study' });
                  setSidebarOpen(false);
                }}
                title="Study Tool"
              >
                <div className="nexus-icon-container study">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                    <path d="M6 12v5c3 3 9 3 12 0v-5"/>
                  </svg>
                </div>
                <span className="nexus-sidebar-name">Study tool</span>
              </div>
            );
          }

          // PLANNER TOOL
          if (tool.id === 'planner') {
            return (
              <div
                key="planner"
                className={`nexus-sidebar-item ${currentMode === 'planner' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'planner' });
                  setSidebarOpen(false);
                }}
                title="Smart Planner"
              >
                <div className="nexus-icon-container planner">
                  <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m10.827 5.465-.435-2.324m.435 2.324a5.338 5.338 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.338 5.338 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5-6.818 1.277Z"/>
                  </svg>
                </div>
                <span className="nexus-sidebar-name">Smart Planner</span>
              </div>
            );
          }

          if (tool.id === 'landing') {
            return (
              <div
                key="landing"
                className={`nexus-sidebar-item ${currentMode === 'landing' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'landing' });
                  setSidebarOpen(false);
                }}
                title="Fitness Tool"
              >
                <div className="nexus-icon-container landing">
                  <svg className="w-6 h-6" width="15" height="15" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v18m-9-9h18"/>
                  </svg>
                </div>
                <span className="nexus-sidebar-name">landing</span>
              </div>
            );
          }

          if (tool.id === 'fitness') {
            return (
              <div
                key="fitness"
                className={`nexus-sidebar-item ${currentMode === 'fitness' ? 'active' : ''}`}
                onClick={() => {
                  handleModeSelect({ id: 'fitness' });
                  setSidebarOpen(false);
                }}
                title="Fitness Tool"
              >
                <div className="nexus-icon-container fitness">
                  <svg className="w-6 h-6" width="15" height="15" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v18m-9-9h18"/>
                  </svg>
                </div>
                <span className="nexus-sidebar-name">Fitness</span>
              </div>
            );
          }

          return null;
        })}

        {/* EDIT TOOLKIT BUTTON */}
        <div 
          className="nexus-sidebar-item"
          onClick={() => {
            setShowToolkitEditor(true);
            setSidebarOpen(false);
          }}
          title="Edit Toolkit"
          style={{
            backgroundColor: '#52525210',
            color: '#000',
            padding: '2px 12px',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer',
            marginBottom: '35px',
            marginTop: '15px',
            boxShadow: '0 2px 1px rgba(0, 0, 0, 0.14)',
            transition: 'all 0.2s'
          }}
        >
          <div className="nexus-icon-container toolkit">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
              style={{ color: '#00000079' }}>
              <path d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
            </svg>
          </div>
          <span className="nexus-sidebar-name" style={{ color: '#0000008f' }}>
            Edit toolkit
          </span>
        </div>
      </div>

      {/* USER PROFILE SECTION AT BOTTOM */}
      <div className="nexus-sidebar-footer">
        <div className={`nexus-user-profile-section ${showUserMenu ? 'menu-open' : ''}`}>
          <div 
            className="nexus-user-profile-button"
            onClick={() => setShowUserMenu(!showUserMenu)}
            title={userProfile?.name || 'User'}
          >
            {userProfile?.photoUrl ? (
              <img 
                src={userProfile.photoUrl} 
                alt={userProfile.name || 'User'} 
                className="nexus-user-avatar"
              />
            ) : (
              <div 
                className="nexus-user-avatar nexus-user-avatar-initial"
                style={{
                  backgroundColor: avatarColor.bg,
                  color: avatarColor.text,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '600',
                  fontSize: '14px'
                }}
              >
                {getInitial(userProfile?.nickname || userProfile?.name)}
              </div>
            )}
            
            <div className="nexus-user-info">
              <div className="nexus-user-name">{userProfile?.nickname || userProfile?.name || 'User'}</div>
              <div className="nexus-user-email">{userProfile?.email || 'user@email.com'}</div>
            </div>
            
            <button className="nexus-user-menu-btn">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          {/* USER MENU POPUP */}
          {showUserMenu && !sidebarCollapsed && (
            <div className="nexus-user-menu-popup">
              {/* Join Community Section */}
              <a
                href="https://discord.gg/rxuFJuB9hv"
                target="_blank"
                rel="noopener noreferrer"
                className="nexus-menu-item nexus-menu-link"
                onClick={() => setShowUserMenu(false)}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.942 5.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.586 11.586 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3 17.392 17.392 0 0 0-2.868 11.662 15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.638 10.638 0 0 1-1.706-.83c.143-.106.283-.217.418-.331a11.664 11.664 0 0 0 10.118 0c.137.114.277.225.418.331-.544.328-1.116.606-1.71.832a12.58 12.58 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM8.678 14.813a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.929 1.929 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z" fill="currentColor"/>
                </svg>
                <span>Join Discord</span>
              </a>

              {/* Settings Option */}
              <div
                className="nexus-menu-item"
                onClick={() => {
                  setShowSettings(true);
                  setShowUserMenu(false);
                  setSidebarOpen(false);
                }}
              >
<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="1.5" d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
</svg>

                <span>Settings</span>
              </div>

              {/* Sign Out Option */}
              <div
                className="nexus-menu-item nexus-menu-danger"
                onClick={() => {
                  setShowSignOutConfirm(true);
                  setShowUserMenu(false);
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Sign out</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const renderGlobalMobileNav = () => (
  <div className="nexus-mobile-floating-nav">
    {/* Menu button - LEFT SIDE */}
    <button 
      className="nexus-mobile-nav-btn"
      onClick={() => {
        console.log('Menu button clicked, opening sidebar');
        setSidebarOpen(true);
      }}
      aria-label="Open menu"
    >
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" d="M5 7h14M5 12h14M5 17h10"/>
      </svg>
    </button>
    
    {/* New Chat button - RIGHT SIDE */}
    <button 
      className="nexus-mobile-nav-btn"
      onClick={async () => {
        console.log('New Chat button clicked from global nav');
        
        if (isHumeConnected) {
          disconnectHume();
        }

        // Always go to chat mode first
        if (currentMode !== 'chat') {
          console.log('🔀 Navigating to chat from', currentMode);
          setCurrentMode('chat');
          return;
        }

        // If already in chat mode, start new chat
        console.log('✨ Starting new chat process...');

        const hasCurrentChatMessages = messages && messages.length > 0;

        if (hasCurrentChatMessages && firestoreService?.isReady?.()) {
          try {
            const settings = await firestoreService.getUserSettings();
            const surveyCompleted = settings?.surveyCompleted || false;
            const chatSessionCount = settings?.chatSessionCount || 0;
            
            const shouldShowSurvey = !surveyCompleted && chatSessionCount >= 2;
            
            if (shouldShowSurvey) {
              console.log('📊 Survey needed before 3rd chat session:', { 
                chatSessionCount,
                surveyCompleted,
                currentSessionHasMessages: hasCurrentChatMessages
              });
              setShowSurvey(true);
              return;
            }

            console.log('📈 Chat session progress:', {
              chatSessionCount,
              surveyCompleted,
              currentSessionHasMessages: hasCurrentChatMessages
            });
          } catch (error) {
            console.error('Error checking survey:', error);
          }
        }

        if (currentSessionId && messages.length > 0) {
          try {
            const now = new Date().toISOString();
            
            await firestoreService.saveConversation({
              id: currentSessionId,
              messages: messages,
              preview: messages[0]?.content || 'Chat',
              messageCount: messages.length,
              timestamp: now,
              lastUpdated: now,
              tag: autoTagChat({
                preview: messages[0]?.content || '',
                messages: messages
              })
            });

            const settings = await firestoreService.getUserSettings();
            const currentCount = settings?.chatSessionCount || 0;
            await firestoreService.updateUserData({
              'settings.chatSessionCount': currentCount + 1,
              'settings.lastChatCreated': now
            });

            console.log('💾 Session saved and counted, total sessions:', currentCount + 1);
          } catch (error) {
            console.error('Failed to save session:', error);
          }
        }

        setMessages([]);
        setActiveSessionId(null);
        setCurrentSessionId(null);
        setInputValue('');
        setIsProcessingAzure(false);
        setIsTakingNotes(false);
        setIsJournaling(false);
        setDetectedVibe(null);
        setShowPlusOptions(false);
        setIsMultiline(false);
        setTextareaHeight('44px');

        console.log('✅ New blank chat session started');
      }}
      aria-label="New chat"
    >
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
      </svg>
    </button>
  </div>
);
// ============================================
// SPEED CYCLE HOOK
// ============================================
const VoiceWaveformIndicator = ({ isVoiceMode, waveformData }) => {
  // Only show when voice mode is ACTIVE (not during initialization)
  if (!isVoiceMode) return null;

  return (
    <div style={{
      width: '100%',
      maxWidth: '600px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      pointerEvents: 'none'
    }}>
      {/* PHASE 1: Spreading animation (initial idle state) */}
      {!waveformData.isActive && waveformData.points === '' && (
        <div style={{ width: '100%', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="100%" height="24" viewBox="0 0 600 24" preserveAspectRatio="xMidYMid meet" style={{ display: 'block' }}>
            {/* Left line spreading from center */}
            <line x1="300" y1="12" x2="300" y2="12" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))', animation: 'spreadLineLeft 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' }} />
            {/* Right line spreading from center */}
            <line x1="300" y1="12" x2="300" y2="12" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))', animation: 'spreadLineRight 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' }} />
          </svg>
        </div>
      )}

      {/* PHASE 2: Active waveform (when speaking/listening) - MORE SENSITIVE */}
      {waveformData.isActive && waveformData.points && (
        <svg 
          width="100%" 
          height="100%" 
          viewBox="0 0 600 24" 
          preserveAspectRatio="xMidYMid meet" 
          style={{ display: 'block' }}
        >
          <polyline 
            points={waveformData.points} 
            fill="none" 
            stroke="#3b82f6" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{ 
              filter: 'drop-shadow(0 0 6px rgba(59, 130, 246, 0.7))',
              transition: 'all 0.03s ease-out' // ✅ FASTER response (was 0.1s or not specified)
            }} 
          />
        </svg>
      )}

      {/* PHASE 3: Contracting animation (back to idle) */}
      {!waveformData.isActive && waveformData.points !== '' && (
        <div style={{ width: '100%', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="100%" height="24" viewBox="0 0 600 24" preserveAspectRatio="xMidYMid meet" style={{ display: 'block' }}>
            {/* Left line contracting to center */}
            <line x1="0" y1="12" x2="300" y2="12" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))', animation: 'contractLineLeft 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' }} />
            {/* Right line contracting to center */}
            <line x1="300" y1="12" x2="600" y2="12" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))', animation: 'contractLineRight 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' }} />
          </svg>
        </div>
      )}
    </div>
  );
};

useEffect(() => {
  return () => {
    // ✅ Cleanup when component unmounts
    console.log('🧹 ChatMode unmounting - cleanup voice mode');
    if (isVoiceMode) {
      stopVoiceMode();
    }
  };
}, []);
const messagesContainerRef = useRef(null);
useEffect(() => {
  // Only auto-scroll if user hasn't manually scrolled up
  if (messages.length > 0 && !userScrolledUp) {
    setTimeout(() => scrollToBottom('smooth'), 100);
  }
}, [messages, userScrolledUp]);
// ============================================


// 3.  AUTO-SCROLL FUNCTION
const scrollToBottom = (behavior = 'smooth') => {
  if (messagesEndRef.current) {
    messagesEndRef.current.scrollIntoView({ 
      behavior: behavior,
      block: 'end',
      inline: 'nearest'
    });
    // Reset the scroll state after scrolling
    setTimeout(() => setUserScrolledUp(false), 100);
  }
};
useEffect(() => {
  if (messages.length === 0) return;
  
  // Check scroll state at the time of message change
  const messagesContainer = messagesContainerRef.current;
  if (!messagesContainer) return;
  
  const { scrollTop, scrollHeight, clientHeight } = messagesContainer;
  const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
  
  // Only auto-scroll if user is within 200px of bottom (not manually scrolled up)
  const isNearBottom = distanceFromBottom < 200;
  
  if (isNearBottom) {
    // Multiple scroll attempts to ensure it reaches bottom
    setTimeout(() => scrollToBottom('auto'), 0);
    setTimeout(() => scrollToBottom('smooth'), 100);
    setTimeout(() => scrollToBottom('smooth'), 300);
  }
}, [messages]);

const AnimatedGreeting = ({ text, isLoading, userName }) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const previousTextRef = useRef(text);

  useEffect(() => {
    // Only reset animation flag if text actually changed
    if (text !== previousTextRef.current) {
      previousTextRef.current = text;
      setHasAnimated(false);
    }
  }, [text]);

  useEffect(() => {
    // Mark as animated after animation completes
    if (!hasAnimated && text) {
      const animationDuration = text.length * 40 + 100; // 40ms per char + 100ms buffer
      const timer = setTimeout(() => {
        setHasAnimated(true);
      }, animationDuration);
      
      return () => clearTimeout(timer);
    }
  }, [text, hasAnimated]);

  // Keep showing skeleton until userName is loaded
  if (isLoading || !userName) {
    return (
      <span className="nexus-greeting-skeleton">
        <span className="nexus-skeleton-shimmer"></span>
      </span>
    );
  }
  
  if (!text) return null;
  
  // If already animated, show text immediately without animation
  if (hasAnimated) {
    return (
      <span className="nexus-greeting-text nexus-greeting-static">
        {text}
      </span>
    );
  }
  
  // First render - animate each character
  return (
    <span className="nexus-greeting-text">
      {text.split('').map((char, index) => (
        <span 
          key={index} 
          className="nexus-greeting-char"
          style={{ animationDelay: `${index * 0.04}s` }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </span>
  );
};
const renderChatMode = () => (
  <>
    {/* Desktop Menu Button - ALWAYS visible */}
    {!isMobile && messages.length === 0 && (
      <button
        className="nexus-mobile-nav-btn"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
        title="Menu"
        style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 100,
        }}
      >
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" d="M5 7h14M5 12h14M5 17h10"/>
        </svg>
      </button>
    )}

    {/* Desktop Settings Button - ALWAYS visible */}
{!isMobile && messages.length === 0 && (
        <button
        className="nexus-mobile-nav-btn"
        onClick={() => setShowSettings(true)}
        aria-label="Settings"
        title="Settings"
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 100,
        }}
      >
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"/>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
        </svg>
      </button>
    )}

{messages.length === 0 ? (
  // ========================================
  // EMPTY STATE - WELCOME SCREEN
  // ========================================
  <div className="nexus-chat-empty">
    <div className="nexus-welcome-section">
      <div className="nexus-greeting-badge">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707"/>
        </svg>
        <AnimatedGreeting
          text={greetingText}
          isLoading={isLoadingGreeting}
          userName={userName}
        />
      </div>
      {/* Desktop nav for empty state */}
{!isMobile && (
  <>
    <button className="nexus-mobile-nav-btn" onClick={() => setSidebarOpen(true)}
      style={{ position: 'fixed', top: '20px', left: '20px', zIndex: 100 }}>
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" d="M5 7h14M5 12h14M5 17h10"/>
      </svg>
    </button>
    <button className="nexus-mobile-nav-btn" onClick={() => setShowSettings(true)}
      style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 100 }}>
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      </svg>
    </button>
  </>
)}

{/* Mobile nav for empty state */}
{isMobile && (
  <div className="nexus-mobile-floating-nav">
    <button className="nexus-mobile-nav-btn" onClick={() => setSidebarOpen(true)}>
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" d="M5 7h14M5 12h14M5 17h10"/>
      </svg>
    </button>
    <button className="nexus-mobile-nav-btn" onClick={() => setShowSettings(true)}>
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      </svg>
    </button>
  </div>
)}

      <HorizontalAndFeaturedCards
        onCardClick={handleSuggestionClick}
        availableTools={availableTools}
        onEnableTool={handleToolVisibilityToggle}
        onNavigateToTool={(toolId) => setCurrentMode(toolId)}
      />

      <SettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        preptuneId={firestoreService?.preptuneUserId}
        userName={userName}
        onNicknameUpdate={(newName) => {
          setUserName(newName);
          localStorage.setItem('preptune_cached_username', newName);
        }}
        selectedVoiceHost={savedVoiceHost}
        onVoiceUpdate={(newVoice) => {
          setSavedVoiceHost(newVoice);
        }}
        firestoreService={firestoreService}
      />


    </div>
  </div>

) : (
  // ========================================
  // MESSAGES STATE - CHAT INTERFACE
  // ========================================
  <>
    {/* All screen sizes: Menu left + New Chat right */}
    {renderGlobalMobileNav()}

    {/* Messages container */}
    <div
      ref={messagesContainerRef}
      className="nexus-chat-messages"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: isMobile ? '90px 20px 20px 20px' : '40px 20px 20px 20px',
        paddingBottom: isMobile ? '180px' : '160px',
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
        scrollBehavior: 'smooth',
      }}
    >
      {messages.map((message) => (
        <React.Fragment key={message.id}>

          {/* PODCAST NEWS CARD */}
          {message.isPodcast && message.searchResults && message.searchResults.length > 0 && (
            <div className="nexus-message bot">
              <div className="nexus-bot-avatar"></div>
              <div className="nexus-message-bubble"></div>
            </div>
          )}

          {/* PRESENTATION AI FOLLOW-UP */}
          {message.isPresentation && !message.presentationData?.isGenerating &&
            message.content && message.content.trim() && (
            <div className="nexus-message bot">
              <div className="nexus-bot-avatar"></div>
              <div className="nexus-message-bubble">{message.content}</div>
            </div>
          )}

          {/* SCHEDULE DISPLAY */}
          {message.scheduleDisplay && (
            <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'flex-start' }}>
              <div className="nexus-bot-avatar" style={{ marginTop: '8px' }}></div>
              <AnimatedScheduleDisplay
                date={message.scheduleDisplay.date}
                dateKey={message.scheduleDisplay.dateKey}
                events={message.scheduleDisplay.events}
                tasksByDate={message.scheduleDisplay.tasksByDate}
                setTasksByDate={message.scheduleDisplay.setTasksByDate}
                firestoreService={message.scheduleDisplay.firestoreService}
              />
            </div>
          )}

          {/* REGULAR MESSAGES */}
          {!message.isFlashcard && !message.isLoadingAnimation && !message.isWeather &&
           !message.isQuiz && !message.isNoteTaking && !message.scheduleDisplay && (
            <div className={`nexus-message ${message.type}`}>
              {message.type === 'user' && <div className="nexus-user-avatar"></div>}
              {message.type === 'bot' && <div className="nexus-bot-avatar"></div>}

              <div
                className="nexus-message-bubble"
                onMouseDown={message.type === 'user' ? (e) => {
                  const timeout = setTimeout(() => handleLongPress(message.content, e, message.id), 500);
                  e.currentTarget.dataset.pressTimeout = timeout;
                } : undefined}
                onMouseUp={message.type === 'user' ? (e) => {
                  clearTimeout(e.currentTarget.dataset.pressTimeout);
                } : undefined}
                onMouseLeave={message.type === 'user' ? (e) => {
                  clearTimeout(e.currentTarget.dataset.pressTimeout);
                } : undefined}
                onTouchStart={message.type === 'user' ? (e) => {
                  const timeout = setTimeout(() => handleLongPress(message.content, e.touches[0], message.id), 500);
                  e.currentTarget.dataset.pressTimeout = timeout;
                } : undefined}
                onTouchEnd={message.type === 'user' ? (e) => {
                  clearTimeout(e.currentTarget.dataset.pressTimeout);
                } : undefined}
              >
                {message.isLoading ? (
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '500', color: '#111827', marginBottom: '8px' }}>
                      {message.content}
                    </div>
                    <div style={{ width: '100%', height: '3px', background: '#f3f4f6', borderRadius: '2px', overflow: 'hidden', position: 'relative' }}>
                      <div style={{ position: 'absolute', height: '100%', width: '40%', background: '#111827', borderRadius: '2px', animation: 'slideProgress 2s ease-in-out infinite' }} />
                    </div>
                  </div>
                ) : (
                  <>
                    {message.searchResults && message.searchResults.length > 0 && !message.isURLSummary ? (
                      message.podcastState === 'playing' ? (
                        <PodcastNewsCard
                          searchResults={message.searchResults}
                          audioUrl={message.audioUrl}
                          onClose={() => setMessages(msgs => msgs.map(m =>
                            m.id === message.id ? { ...m, podcastState: 'ready' } : m
                          ))}
                          podcastTitle={message.podcastTitle || "Daily News Briefing"}
                        />
                      ) : (
                        <NewsCard
                          searchResults={message.searchResults}
                          audioUrl={message.audioUrl}
                          onGeneratePodcast={async (results) => {
                            await handlePodcastGenerationFromNews(results, message.id);
                          }}
                          podcastState={message.podcastState || 'idle'}
                          onOpenPlayer={() => setMessages(msgs => msgs.map(m =>
                            m.id === message.id ? { ...m, podcastState: 'playing' } : m
                          ))}
                        />
                      )
                    ) : (
                      <div style={{ position: 'relative' }}>
                        <SmartMessageContent
                          text={message.content}
                          searchResults={message.searchResults}
                          userPrompt={lastUserMessage}
                        />
                        {message.type === 'bot' && !message.isLoading && (
                          <button
                            onClick={() => copyToClipboard(message.content, message.id)}
                            className="copy-message-btn"
                            title="Copy message"
                          >
                            {copiedMessageId === message.id ? (
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                            ) : (
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                              </svg>
                            )}
                          </button>
                        )}
                      </div>
                    )}

                    {/* PODCAST BUTTON */}
                    {message.isPodcast && message.audioUrl && !message.searchResults && (
                      <button
                        onClick={() => {
                          setPodcastToAutoPlay({
                            audioUrl: message.audioUrl,
                            dialogue: message.dialogue,
                            title: message.podcastTitle || message.topic,
                            duration: message.duration,
                            metadata: message.metadata,
                            type: 'chat-generated',
                            shouldGenerate: false,
                            autoPlay: true,
                            showTranscript: true
                          });
                          setCurrentMode('podcast');
                        }}
                        className="view-action-button"
                      >
                        <Radio size={14} />
                        Listen to Podcast
                      </button>
                    )}

                    {/* VIEW JOURNAL BUTTON */}
                    {message.showJournalButton && (
                      <button onClick={() => setCurrentMode('journal')} className="view-action-button">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.83892 12.4543s1.24988-3.08822-.21626-5.29004C8.15656 4.96245 4.58671 4.10885 4.39794 4.2436c-.18877.13476-1.11807 3.32546.34803 5.52727 1.4661 2.20183 5.09295 2.68343 5.09295 2.68343Zm0 0C10.3389 13.4543 12 15 12 18v2c0-2-.4304-3.4188 2.0696-5.9188m0 0s-.4894-2.7888 1.1206-4.35788c1.6101-1.56907 4.4903-1.54682 4.6701-1.28428.1798.26254.4317 2.84376-1.0809 4.31786-1.61 1.5691-4.7098 1.3243-4.7098 1.3243Z"/>
                        </svg>
                        View Journal
                      </button>
                    )}

                    {/* VIEW NOTES BUTTON */}
                    {message.showNotesButton && (
                      <button onClick={() => setCurrentMode('notes')} className="view-action-button">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"/>
                        </svg>
                        View Notes
                      </button>
                    )}

                    {/* VIEW CALENDAR BUTTON */}
                    {message.showCalendarButton && (
                      <button onClick={() => setCurrentMode('planner')} className="view-action-button">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 5.365V3m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593 0 1.193-.538 1.193H5.538c-.538 0-.538-.6-.538-1.193 0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 12 5.365Zm-8.134 5.368a8.458 8.458 0 0 1 2.252-5.714m14.016 5.714a8.458 8.458 0 0 0-2.252-5.714M8.54 17.901a3.48 3.48 0 0 0 6.92 0H8.54Z"/>
                        </svg>
                        View Calendar
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          {/* AI FOLLOW-UP OUTSIDE NEWSCARD */}
          {message.searchResults && message.searchResults.length > 0 && !message.isURLSummary && message.content && message.content.trim() && (
            <div className="nexus-message bot">
              <div className="nexus-bot-avatar"></div>
              <div className="nexus-message-bubble">
                <SmartMessageContent
                  text={message.content}
                  searchResults={message.searchResults}
                  userPrompt={lastUserMessage}
                />
              </div>
            </div>
          )}

          {/* LOADING ANIMATION */}
          {message.isLoadingAnimation && (
            <div className="nexus-message bot">
              <div className="nexus-bot-avatar"></div>
              <div className="breathing-ring"></div>
            </div>
          )}

          {/* WEATHER FOLLOW-UP */}
          {message.isWeather && message.weatherData && message.content && message.content.trim() && (
            <div className="nexus-message bot">
              <div className="nexus-bot-avatar"></div>
              <div className="nexus-message-bubble">{message.content}</div>
            </div>
          )}

          {/* WEATHER PODCAST PLAYER */}
          {showWeatherPodcastPlayer && currentWeatherPodcast && (
            <WeatherPodcastPlayer
              weatherData={currentWeatherPodcast.weatherData}
              dialogue={currentWeatherPodcast.dialogue}
              audioUrl={currentWeatherPodcast.audioUrl}
              onClose={() => {
                setShowWeatherPodcastPlayer(false);
                setCurrentWeatherPodcast(null);
              }}
            />
          )}

          {/* STUDY HUB BUTTON */}
          {message.showStudyButton && (
            <button
              onClick={() => setCurrentMode('study')}
              className="view-action-button"
            >
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 11H4m15.5 5a.5.5 0 0 0 .5-.5V8a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44l-1.436-2.12a1 1 0 0 0-.828-.44H8a1 1 0 0 0-1 1M4 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44L9.985 8.44A1 1 0 0 0 9.157 8H5a1 1 0 0 0-1 1Z"/>
              </svg>
              Go to Study Hub
            </button>
          )}

        </React.Fragment>
      ))}

      {/* Scroll anchor */}
      <div ref={messagesEndRef} style={{ height: '1px', marginTop: '20px', pointerEvents: 'none' }} />
    </div>

    {/* Scroll to bottom button */}
    {showScrollButton && messages.length > 0 && (
      <button
        onClick={() => scrollToBottom('smooth')}
        style={{
          position: 'fixed',
          bottom: isMobile ? '120px' : '160px',
          right: '20px',
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          color: 'black',
          background: 'rgba(255, 255, 255, 0.95)',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100,
          transition: 'all 0.2s ease',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          opacity: showScrollButton ? 1 : 0,
          pointerEvents: showScrollButton ? 'auto' : 'none',
          transform: showScrollButton ? 'scale(1)' : 'scale(0.8)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        }}
      >
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
        </svg>
      </button>
    )}

    {/* Settings modal available in chat too */}
    <SettingsModal
      isOpen={showSettings}
      onClose={() => setShowSettings(false)}
      preptuneId={firestoreService?.preptuneUserId}
      userName={userName}
      onNicknameUpdate={(newName) => {
        setUserName(newName);
        localStorage.setItem('preptune_cached_username', newName);
      }}
      selectedVoiceHost={savedVoiceHost}
      onVoiceUpdate={(newVoice) => {
        setSavedVoiceHost(newVoice);
      }}
      firestoreService={firestoreService}
    />
  </>
)}
    {/* ========================================
        INPUT AREA - FIXED AT BOTTOM
        ======================================== */}
    <div 
      className="nexus-input-area" 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: isMobile ? '1rem' : '1.5rem 2rem 2rem 2rem',
        zIndex: 10,
        background: 'linear-gradient(to top, var(--primary-bg) 0%, var(--primary-bg) 70%, transparent 100%)'
      }}
    >
      {/* PODCAST MODE BANNER */}
      {isPodcastMode && (
        <div style={{
          background: 'linear-gradient(135deg, #e7e7e7ff 0%, #e6e6e6ff 100%)',
          color: 'white',
          position:'relative',
          padding: '5px 14px',
          borderRadius: '12px',
          display: 'flex',
          border: '1px solid #58585885',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '12px',
          boxShadow: '0 4px 10px #5858585e'
        }}>
          <span style={{ fontWeight: '400', fontSize: '14px', color: 'black' }}>Podcast Mode</span>
          <button
            onClick={() => {
              setIsPodcastMode(false);
              setInputValue('');
            }}
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: 'none',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: 'black'
            }}
          >
            <X size={14} />
          </button>
        </div>
      )}

      {/* JOURNALING MODE BANNER */}
      {isJournaling && (
        <div style={{
          background: 'linear-gradient(135deg, #e7e7e7ff 0%, #e6e6e6ff 100%)',
          position:'relative',
          padding: '5px 14px',
          borderRadius: '12px',
          display: 'flex',
          border: '1px solid #58585885',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '12px',
          boxShadow: '0 4px 10px #5858585e'
        }}>
          <span style={{ fontWeight: '400', fontSize: '14px', color: 'black' }}>Journaling Mode Active</span>
          <button
            onClick={() => {
              setIsJournaling(false);
              setInputValue('');
            }}
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: 'none',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: 'black'
            }}
          >
            <X size={14} />
          </button>
        </div>
      )}

{/* ✅ EXPANDING INPUT WRAPPER */}
<div className={`nexus-expanding-input-wrapper ${isMultiline ? 'has-multiline' : ''}`}>

  {/* ✅ VOICE CONTROLS - Only show AFTER greeting plays */}
  {isVoiceMode && voiceManager && (
    <div className="voice-controls-container">
      <div className="voice-controls-group">
        <button
          className={`voice-mute-btn ${micMuted ? 'muted' : 'active'}`}
          onClick={() => {
            setMicMuted(!micMuted);
            voiceManager.toggleMicrophone(!micMuted);
          }}
          title={micMuted ? 'Unmute microphone' : 'Mute microphone'}
        >
          {micMuted ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="1" y1="1" x2="23" y2="23"></line>
              <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>
              <path d="M17 16.95A7 7 0 0 1 5 12m14 0a7 7 0 0 1-13.46 3"></path>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
              <line x1="12" y1="19" x2="12" y2="23"></line>
              <line x1="8" y1="23" x2="16" y2="23"></line>
            </svg>
          )}
        </button>

        <button
          className="nexus-ask-preptune-btn orb-toggle"
          onClick={() => setShowOrbModal(true)}
          title="Open Orb Mode"
        >
          <span className="mic-label">Switch View</span>
        </button>
      </div>
    </div>
  )}

  {/* ✅ Only show waveform AFTER greeting */}
  {isVoiceMode && voiceManager &&  (
    <VoiceWaveformIndicator
      isVoiceMode={isVoiceMode}
      waveformData={waveformData}
      voiceSpeed={voiceSpeed}
      setVoiceSpeed={setVoiceSpeed}
      micMuted={micMuted}
      setMicMuted={setMicMuted}
      onEndCall={stopVoiceMode}
    />
  )}

  {/* ✅ WORD COUNT BAR - shows when typing */}
{(() => {
  const wordCount = inputValue.trim() === '' ? 0 : inputValue.trim().split(/\s+/).length;
  const nearLimit = wordCount >= 250 && wordCount < 300;
  const atLimit = wordCount >= 300;
  return (nearLimit || atLimit) ? (
    <div className={`nexus-word-limit-bar ${atLimit ? 'danger' : 'warning'}`}>
      {atLimit ? `⚠ 300 word limit reached` : `${wordCount} / 300 words`}
    </div>
  ) : null;
})()}
  {/* Expandable textarea container */}
<div className={`nexus-textarea-container ${isMultiline ? 'active' : ''}`}>
  
  {/* Word count bar INSIDE the container, above textarea */}
  {(() => {
    const wordCount = inputValue.trim() === '' ? 0 : inputValue.trim().split(/\s+/).length;
    const status = wordCount >= 300 ? 'danger' : wordCount >= 250 ? 'warning' : 'safe';
    return inputValue.trim().length > 0 ? (
      <div className={`nexus-word-limit-bar ${status}`}>
        <span>
          {status === 'danger'
            ? '⚠ 300 word limit reached'
            : status === 'warning'
            ? 'Approaching word limit'
            : ''}
        </span>
        <span>{wordCount} / 300</span>
      </div>
    ) : null;
  })()}

  <textarea
    ref={expandedInputRef}
    value={inputValue}
    onChange={(e) => handleInputChange(e, true)}
    onKeyDown={handleKeyPress}
    onPaste={(e) => {
      setTimeout(() => {
        const pastedValue = expandedInputRef.current?.value || '';
        const wordCount = pastedValue.trim() === '' ? 0 : pastedValue.trim().split(/\s+/).length;
        if (wordCount > MAX_WORDS) {
          const trimmed = pastedValue.trim().split(/\s+/).slice(0, MAX_WORDS).join(' ');
          setInputValue(trimmed);
        } else {
          setInputValue(pastedValue);
        }
        const textarea = expandedInputRef.current;
        if (textarea) {
          textarea.style.height = 'auto';
          const isMobileDevice = window.innerWidth < 769;
          const maxH = isMobileDevice ? 160 : window.innerWidth >= 1200 ? 320 : 240;
          const newHeight = Math.min(Math.max(textarea.scrollHeight, 44), maxH);
          textarea.style.height = `${newHeight}px`;
          setTextareaHeight(`${newHeight}px`);
        }
      }, 0);
    }}
    placeholder={isPodcastMode ? "Enter your podcast topic..." : "Chat with Preptune"}
    className="nexus-text-input-expanded"
    style={{ height: textareaHeight }}
  />
</div>

  <div className="nexus-input-container">
    {/* Plus button - LEFT SIDE */}
    <button
      className={`nexus-plus-btn ${showPlusOptions ? "rotated" : ""}`}
      onClick={() => setShowPlusOptions(!showPlusOptions)}
      disabled={isPodcastMode}
    >
      <Plus className="nexus-icon-sm" />
    </button>

    {/* Inline input - MIDDLE */}
<input
  ref={inlineInputRef}
  type="text"
  value={inputValue}
  onChange={(e) => handleInputChange(e, false)}
  onKeyDown={handleKeyPress}
  onPaste={(e) => {
    setTimeout(() => {
      const pastedValue = inlineInputRef.current?.value || '';
      const wordCount = pastedValue.trim() === '' ? 0 : pastedValue.trim().split(/\s+/).length;
      
      // Trim if over limit
      if (wordCount > MAX_WORDS) {
        const trimmed = pastedValue.trim().split(/\s+/).slice(0, MAX_WORDS).join(' ');
        setInputValue(trimmed);
      } else {
        setInputValue(pastedValue);
      }

      // Auto expand if 3+ words
      if (pastedValue.trim().split(/\s+/).length >= 3 && !isMultiline) {
        setIsMultiline(true);
        setTimeout(() => {
          const expandedTextarea = expandedInputRef.current;
          if (expandedTextarea) {
            expandedTextarea.focus();
            const len = expandedTextarea.value.length;
            expandedTextarea.setSelectionRange(len, len);
            // Trigger height recalculation
            expandedTextarea.style.height = 'auto';
            const isMobileDevice = window.innerWidth < 769;
            const maxH = isMobileDevice ? 160 : window.innerWidth >= 1200 ? 320 : 240;
            const newHeight = Math.min(Math.max(expandedTextarea.scrollHeight, 44), maxH);
            expandedTextarea.style.height = `${newHeight}px`;
            setTextareaHeight(`${newHeight}px`);
          }
        }, 0);
      }
    }, 0);
  }}
  placeholder={isPodcastMode ? "Enter your podcast topic..." : "Chat with Preptune"}
  className="nexus-text-input-inline"
  style={{
    opacity: isMultiline ? 0 : 1,
    pointerEvents: isMultiline ? 'none' : 'auto'
  }}
/>

    <div className="nexus-input-actions">
      {/* Voice Mode Button */}
      <button
        className="nexus-ask-preptune-btn"
        onClick={async () => {
          if (isVoiceMode && hasGreetingPlayed) {
            setVoiceStatus('Ending call...');
            await stopVoiceMode();
          } else if (!isInitializingVoice && !isVoiceMode) {
            const voiceToUse = savedVoiceHost || 'Host 1';
            await initializeVoiceMode(voiceToUse);
          }
        }}
        disabled={isInitializingVoice || (isVoiceMode && !hasGreetingPlayed)}
        style={
          isVoiceMode && hasGreetingPlayed ? {
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            color: 'white',
            boxShadow: '0 0 20px rgba(239, 68, 68, 0.4)',
          } : (isInitializingVoice || (isVoiceMode && !hasGreetingPlayed)) ? {
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            cursor: 'wait',
            boxShadow: '0 0 15px rgba(59, 130, 246, 0.4)',
            opacity: 0.8,
            pointerEvents: 'none'
          } : {}
        }
        title={
          isVoiceMode && hasGreetingPlayed
            ? 'End Call'
            : isInitializingVoice
            ? 'Initializing...'
            : isVoiceMode && !hasGreetingPlayed
            ? 'Loading greeting...'
            : 'Start Voice Mode'
        }
      >
        {isInitializingVoice || (isVoiceMode && !hasGreetingPlayed) ? (
          <>
            <div className="spinner-small" style={{
              width: '14px',
              height: '14px',
              border: '2px solid rgba(255,255,255,0.3)',
              borderTopColor: 'white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
            {isInitializingVoice ? (voiceStatus || 'Starting call...') : 'Loading...'}
          </>
        ) : isVoiceMode && hasGreetingPlayed ? (
          <>
            <svg className="w-6 h-6" width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
              <path d="M7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Z"/>
            </svg>
            End Call
          </>
        ) : (
          <>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
            </svg>
            Voice Mode
          </>
        )}
      </button>

      {/* Send button */}
<button
  onClick={isPodcastMode ? handleGeneratePodcast : handleSendMessage}
  className="nexus-send-button-redesigned"
  disabled={
    !inputValue.trim() ||
    isGeneratingPodcast ||
    isSending ||
    (inputValue.trim().split(/\s+/).length >= MAX_WORDS)
  }
>
  {(isGeneratingPodcast || isSending) ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: 'spin 0.8s linear infinite' }}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="rgba(0,0,0,0.15)"
        strokeWidth="2.5"
      />
      <path
        d="M12 3a9 9 0 0 1 9 9"
        stroke="#555555"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 15 7-7 7 7"/>
    </svg>
  )}
</button>
    </div>
  </div>

  {/* Input disclaimer */}
  <div className="nexus-input-disclaimer">
    {isPodcastMode
      ? "Enter a topic and preptune will create a podcast with audio"
      : isVoiceMode
      ? "Voice mode active - speak naturally"
      : isInitializingVoice
      ? "Starting call..."
      : "Preptune is ready to chat and catch up"
    }
  </div>
</div>

      {/* Plus options popup */}
      {showPlusOptions && (
        <div className="nexus-plus-popup">
          {plusOptions.map((option) => (
            <div 
              key={option.id} 
              className="nexus-mode-option"
              onClick={() => handlePlusOptionSelect(option)}
            >
              {option.icon}
              <span className="nexus-mode-label">{option.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
    
    {copyPopup.show && (
      <>
        <div 
          className="copy-popup-overlay"
          onClick={() => setCopyPopup({ ...copyPopup, show: false })}
        />
        <div 
          className="copy-popup"
          style={{
            position: 'fixed',
            left: `${copyPopup.x}px`,
            top: `${copyPopup.y}px`,
            transform: 'translate(-50%, -100%)',
            zIndex: 1000
          }}
        >
          <button
            onClick={() => {
              copyToClipboard(copyPopup.text, copyPopup.messageId);
              setCopyPopup({ ...copyPopup, show: false });
            }}
            className="copy-popup-btn"
          >
            {copiedMessageId === copyPopup.messageId ? (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Copied!
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copy
              </>
            )}
          </button>
        </div>
      </>
    )}
  </>
);

 const renderPlannerMode = () => {
   return (
     <BigCalendarPlanner
       tasksByDate={tasksByDate}
       setTasksByDate={setTasksByDate}
       firestoreService={firestoreService}
     />
   );
 };
const renderJournalMode = () => (
  <JournalPage firestoreService={firestoreService} />
);
const renderLandingMode = () => (
  <LandingPage/>
);

  
const renderPodcastMode = () => (
  <InnerLoopPodcast 
    activePodcast={podcastToAutoPlay}
    onClose={() => setPodcastToAutoPlay(null)}
    combineAudioSegments={combineAudioSegments}  // ✅ PASS THIS
    autoPlayPodcast={podcastToAutoPlay}           // ✅ AND THIS
    onPodcastStarted={() => setPodcastToAutoPlay(null)}
  />
);

  
  const renderStudyMode = () => (
    <QuizFlashcardHub
      activeFlashcardSet={activeFlashcardSet}
      activeQuizSet={activeQuizSet}
      autoStartContent={autoStartStudyContent}
    />
  );
  
  // ========================================
  // YOUR HELPER FUNCTIONS
  // ========================================
const greetingText = useMemo(() => {
  const hour = new Date().getHours();
  
  // ✅ CRITICAL: Never show name on first interaction or if name is null
  if (!userName || isFirstInteraction || userName.trim() === '') {
    // Generic greeting without name
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  }
  
  // ✅ Debug log to verify name source
  console.log('🎯 Showing greeting with custom name:', userName);
  
  // ✅ Only show personalized greeting after name is saved
  if (hour < 12) return `Good Morning, ${userName}`;
  if (hour < 18) return `Good Afternoon, ${userName}`;
  return `Good Evening, ${userName}`;
}, [userName, isFirstInteraction]); // Only recalculate when userName or isFirstInteraction changes


// ✅ FIXED: Load username - proper waiting for Firestore ready
useEffect(() => {
  let isMounted = true;
  let checkInterval;
  
const loadUserName = async () => {
  // ✅ REMOVED localStorage - load ONLY from Firestore
  setIsLoadingGreeting(true);
  
  try {
    // Wait for Firestore to be ready
    if (!firestoreService?.isReady?.()) {
      console.log('⏳ Waiting for Firestore...');
      let attempts = 0;
      while (!firestoreService?.isReady?.() && attempts < 30) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
    }
    
    // ✅ Get settings from Firestore ONLY
    const settings = await firestoreService.getUserSettings();
    
    if (settings?.userName) {
      console.log('✅ Username loaded from Firestore:', settings.userName);
      setUserName(settings.userName);
      setIsFirstInteraction(false);
    } else {
      // No username in Firestore - needs to be set
      console.log('⚠️ No username in Firestore - AI will ask for name');
      setUserName(null);
      setIsFirstInteraction(true);
    }
  } catch (error) {
    console.error('❌ Failed to load username from Firestore:', error);
    setUserName(null);
    setIsFirstInteraction(true);
  } finally {
    setIsLoadingGreeting(false);
  }
};

  // ✅ Start loading when firestoreService changes
  if (firestoreService) {
    loadUserName();
  }

  return () => {
    isMounted = false;
    if (checkInterval) clearInterval(checkInterval);
  };
}, [firestoreService]);

  
  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion);
    if (inlineInputRef.current) {
      inlineInputRef.current.focus();
    }
  };
  useEffect(() => {
  // ✅ If user leaves 'chat' mode, end voice call
  if (currentMode !== 'chat' && isVoiceMode) {
    console.log(`🔴 User navigated to ${currentMode}, ending voice call...`);
    stopVoiceMode();
  }
}, [currentMode, isVoiceMode]);
const handleModeSelect = (tool) => {
  console.log('🔀 Navigating to mode:', tool.id);
  
  // Session is auto-saved, just navigate
  setCurrentMode(tool.id);
  
if (isMobile) {
  setSidebarOpen(false);
} else {
  setSidebarCollapsed(true);
}
};

  // Tool management
  const toggleToolVisibility = (toolId) => {
    setAvailableTools(prev => prev.map(tool =>
      tool.id === toolId ? { ...tool, visible: !tool.visible } : tool
    ));
  };
  
  const handleDragStart = (e, toolId) => {
    setDraggedTool(toolId);
    e.dataTransfer.effectAllowed = 'move';
  };
  
  const handleDragEnd = () => {
    setDraggedTool(null);
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  
  const handleDrop = (e, targetToolId) => {
    e.preventDefault();
    if (!draggedTool || draggedTool === targetToolId) return;
    
    const draggedIndex = availableTools.findIndex(t => t.id === draggedTool);
    const targetIndex = availableTools.findIndex(t => t.id === targetToolId);
    
    const newTools = [...availableTools];
    const [removed] = newTools.splice(draggedIndex, 1);
    newTools.splice(targetIndex, 0, removed);
    
    setAvailableTools(newTools);
  };
  
const handleSaveToolkit = async () => {
  setIsSavingToolkit(true);
  
  try {
    // ✅ Apply temp changes to main state
    setAvailableTools(tempToolkitTools);
    
    // ✅ Save to Firestore
    if (firestoreService?.isReady?.()) {
      const serializableTools = tempToolkitTools.map(tool => ({
        id: tool.id,
        name: tool.name,
        visible: tool.visible,
        description: tool.description,
      }));

      await firestoreService.updateUserData({
        'settings.toolkitSettings': serializableTools,
        'settings.toolkitUpdatedAt': new Date().toISOString()
      });
      
      console.log('✅ Toolkit saved to Firestore:', serializableTools);
    }
    
    // Close modal
    setToolkitFadingOut(true);
    setTimeout(() => {
      setShowToolkitEditor(false);
      setToolkitFadingOut(false);
      setIsSavingToolkit(false);
    }, 300);
    
  } catch (error) {
    console.error('❌ Failed to save toolkit:', error);
    setIsSavingToolkit(false);
  }
};
useEffect(() => {
  if (showToolkitEditor) {
    setTempToolkitTools(availableTools);
  }
}, [showToolkitEditor, availableTools]);
  const [tempToolkitTools, setTempToolkitTools] = useState(availableTools);

  // Memory management
  const getMemoryUsageInfo = () => {
    const total = 100;
    const used = userMemories.length;
    const percentage = (used / total) * 100;
    return { total, used, percentage };
  };
  
  const loadMemories = async () => {
    try {
      if (memoryService) {
        const memories = await memoryService.getAllMemories();
        setUserMemories(memories);
        setShowMemories(true);
      }
    } catch (error) {
      console.error('Failed to load memories:', error);
    }
  };
  /**
 * Check if user message is confirming podcast from stored URL
 * Call this BEFORE sending message to Azure
 */
const checkPodcastConfirmation = async (userMessage) => {
  if (!window.lastFetchedContent) return null;
  
  if (isPodcastConfirmation(userMessage)) {
    const { url, title, content, snippet, isYouTube, timestamp } = window.lastFetchedContent;
    
    // Check if content is fresh (within 5 minutes)
    if (Date.now() - timestamp > 300000) {
      console.log('⏰ Stored content expired');
      delete window.lastFetchedContent;
      return null;
    }
    
    console.log('✅ User confirmed podcast creation for:', url);
    
    // Clear stored content
    delete window.lastFetchedContent;
    
    // Extract duration from confirmation message
    const durationMatch = userMessage.match(/(\d+)\s*min(?:ute)?s?/i);
    const duration = durationMatch ? parseInt(durationMatch[1]) : 3;
    
    // Build topic
    const podcastTopic = isYouTube
      ? `YouTube video: ${title}. ${snippet || content?.substring(0, 300)}`
      : `Article titled "${title}". ${snippet || content?.substring(0, 300)}`;
    
    // Extract YouTube ID if applicable
    let youtubeId = null;
    if (isYouTube) {
      youtubeId = extractYouTubeId(url);
      console.log('🎬 YouTube ID extracted:', youtubeId);
    }
    
    return {
      shouldCreatePodcast: true,
      topic: podcastTopic,
      duration,
      sourceUrl: url,
      youtubeId,
      isYouTube,
      title
    };
  }
  
  return null;
};
  // ========================================
  // MAIN RENDER
  // ========================================
  
  return (
    <div className={`nexus-app-container ${isTransitioning ? 'transitioning' : ''}`} style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      height: '100vh',
      width: '100%',
      background: 'linear-gradient(170deg, #fefefed8 0%, #fefefec3 60%, #e0e7fcb2 100%)',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden'
    }}>
<SurveyPopup
  isOpen={showSurvey}
  onClose={handleSurveyClose}
  userEmail={auth.currentUser?.email}
  userName={userName}
  firestoreService={firestoreService}
/>


          {/* Onboarding Modal */}
    <OnboardingModal
      isOpen={showOnboarding}
      onComplete={handleOnboardingComplete}
      availableTools={availableTools}
        firestoreService={firestoreService}  
      onToolsSelected={(tools) => setAvailableTools(tools)}
    />

{/* SIDEBAR OVERLAY — ADD THIS RIGHT HERE */}
{sidebarOpen && (
  <div
    className="nexus-sidebar-overlay"
    onClick={() => setSidebarOpen(false)}
  />
)}

{/* SIDEBAR */}
{renderSidebar()}

<div className="nexus-main-content">
    {currentMode !== 'chat' && renderGlobalMobileNav()}
    {currentMode === 'chat' && renderChatMode()}
    {currentMode === 'chats' && renderChatsMode()}
    {currentMode === 'planner' && renderPlannerMode()}
        {currentMode === 'podcast' && renderPodcastMode()}
        {currentMode === 'study' && renderStudyMode()}
        {currentMode === 'journal' && renderJournalMode()}
                {currentMode === 'landing' && renderLandingMode()}
        {currentMode === 'fitness' && (
  <FitnessTool 
    firestoreService={firestoreService}
    userName={userName}
    AZURE_OPENAI_ENDPOINT={AZURE_OPENAI_ENDPOINT}
    AZURE_OPENAI_API_KEY={AZURE_OPENAI_API_KEY}
    AZURE_OPENAI_DEPLOYMENT={AZURE_OPENAI_DEPLOYMENT}
  />
)}
</div>

      {/* ✅ ADD THIS RIGHT HERE - AFTER THE MODES, BEFORE OVERLAY */}
      
      {/* VOICE ORB MODAL */}
      {showOrbModal && isVoiceMode && (
        <VoiceOrbModal
          isVisible={showOrbModal}
          onClose={() => {
            setShowOrbModal(false);
            stopVoiceMode();
          }}
onMinimize={() => {
  // ✅ SYNC MUTE STATE WHEN SWITCHING TO CHAT
  if (voiceManager) {
    setMicMuted(voiceManager.isMuted);
    console.log('🔄 Synced mute on Orb minimize:', voiceManager.isMuted);
  }
  setShowOrbModal(false);
}}          waveformData={waveformData}
          voiceStatus={voiceStatus}
          selectedVoiceHost={selectedVoiceHost}
          micMuted={micMuted}
          voiceWaveformColor={voiceWaveformColor}
          voiceManager={voiceManager}
          messages={messages}
          onSendMessage={(textMessage) => {
            console.log('📱 Orb sending message:', textMessage);
            handleSendMessage(textMessage);
          }}
        />
      )}

      {sidebarOpen && isMobile && (
        <div className="nexus-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      {showSignOutConfirm && (
  <div className="delete-popup-overlay" onClick={() => setShowSignOutConfirm(false)}>
    <div className="delete-popup" onClick={(e) => e.stopPropagation()}>
      <h3 className="delete-popup-title">Sign out?</h3>
      <p className="delete-popup-text">
        Are you sure you want to log out? You'll be signed out of Preptune as {auth.currentUser?.email || 'user'}.
      </p>
      <div className="delete-popup-buttons">
        <button
          onClick={() => setShowSignOutConfirm(false)}
          className="white-btn"
        >
          Cancel
        </button>
        <button
          onClick={confirmSignOut}
          className="white-btn-danger"
        >
          Sign out
        </button>
      </div>
    </div>
  </div>
)}
{showToolkitEditor && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: toolkitFadingOut ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0.5)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'flex-end',
    animation: toolkitFadingOut ? 'fadeOut 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards' : 'fadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    transition: 'background 0.3s ease'
  }}>
    <div style={{
      width: '100%',
      height: '70vh',
      background: 'white',
      borderRadius: '24px 24px 0 0',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      zIndex: 10000,
      animation: toolkitFadingOut ? 'slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards' : 'slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    }}>
      
      {/* Header */}
      <div style={{
        padding: '20px 20px 16px 20px',
        borderBottom: '1px solid #e5e7eb',
        background: "#fafafa",
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      }}>
        <div style={{ textAlign: 'left', flex: 1 }}>
          <h2 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1f2937',
            margin: 0,
            marginBottom: '4px'
          }}>
            Customize your toolkit
          </h2>
 <p
  style={{
    fontSize: '13px',
    color: '#9ca3af',
    margin: 0,
    lineHeight: '1.4'
  }}
>
  Personalize your experience by picking what works best for you —{' '}
  <span style={{ color: '#3b82f6' }}>
    more tools will be added soon.
  </span>
</p>

        </div>
        <button
          onClick={() => {
            setToolkitFadingOut(true);
            setTimeout(() => {
              setShowToolkitEditor(false);
              setToolkitFadingOut(false);
              // ✅ RESET TEMP TOOLS TO ORIGINAL STATE ON CANCEL
              setTempToolkitTools(availableTools);
            }, 300);
          }}
          disabled={isSavingToolkit}
          style={{
            background: "white",
            border: "1px solid #e5e7eb",
            borderRadius: "50%",
            width: '30px',
            height: '30px',
            cursor: isSavingToolkit ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.2s',
            flexShrink: 0,
            marginLeft: '8px',
            opacity: isSavingToolkit ? 0.5 : 1
          }}
          onMouseEnter={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = '#f3f4f6';
              e.target.style.borderColor = '#d1d5db';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = 'white';
              e.target.style.borderColor = '#e5e7eb';
            }
          }}
        >
          <X size={17} color="#807f7e" />
        </button>
      </div>

      {/* Tools Grid */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '24px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
        gap: '16px',
        alignContent: 'start',
        opacity: isSavingToolkit ? 0.6 : 1,
        pointerEvents: isSavingToolkit ? 'none' : 'auto',
        transition: 'opacity 0.2s ease'
      }}>
        {/* ✅ USE TEMP STATE INSTEAD OF AVAILABLETOOLS */}
        {tempToolkitTools.map((tool) => {
          // Define colors for each tool
          let containerBgColor = '#f0f9ff';
          let containerBorderColor = '#e0f2fe';
          let iconColor = '#0369a1';
          let hiddenBgColor = '#f9fafb';
          let hiddenBorderColor = '#f3f4f6';
          let hiddenIconColor = '#9ca3af';

          // Set specific colors based on tool type
          if (tool.id === 'journal') {
            containerBgColor = '#0bf58c37';
            containerBorderColor = '#0bf58c5e';
            iconColor = 'black';
            hiddenIconColor = '#9ca3af';
          } else if (tool.id === 'podcast') {
            containerBgColor = '#8ea8ff36';
            containerBorderColor = '#8ea8ff60';
            iconColor = 'black';
          } else if (tool.id === 'planner') {
            containerBgColor = '#95d8ff5e';
            containerBorderColor = '#95d8ff8f';
            iconColor = 'black';
          } else if (tool.id === 'study') {
            containerBgColor = '#ffded8bd';
            containerBorderColor = '#ffded8de';
            iconColor = 'black';
          }

          return (
            <div
              key={tool.id}
              draggable
              onDragStart={(e) => handleDragStart(e, tool.id)}
              onDragEnd={handleDragEnd}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, tool.id)}
              style={{
                position: 'relative',
                cursor: 'grab',
                opacity: 1,
                transition: 'all 0.2s',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                paddingTop: '12px'
              }}
              onMouseDown={(e) => {
                if (e.target.closest('button')) {
                  e.preventDefault();
                }
              }}
            >
              {/* Hide/Show Button - Red X or Green Plus */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  // ✅ COUNT VISIBLE TOOLS FROM TEMP STATE
                  const visibleCount = tempToolkitTools.filter(t => t.visible).length;
                  
                  // Only allow hiding if more than 1 tool is visible
                  if (tool.visible && visibleCount <= 1) {
                    alert('You must keep at least one tool visible.');
                    return;
                  }
                  
                  // ✅ TOGGLE VISIBILITY IN TEMP STATE ONLY
                  setTempToolkitTools(prev =>
                    prev.map(t =>
                      t.id === tool.id ? { ...t, visible: !t.visible } : t
                    )
                  );
                }}
                disabled={isSavingToolkit}
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '16px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: tool.visible ? '#c7c7c7ff' : '#22c55e',
                  border: '2px solid white',
                  cursor: isSavingToolkit ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  transition: 'all 0.2s',
                  padding: 0,
                  minWidth: '20px',
                  opacity: isSavingToolkit ? 0.5 : 1
                }}
                title={tool.visible && tempToolkitTools.filter(t => t.visible).length <= 1 ? 'Keep at least one tool' : (tool.visible ? 'Hide tool' : 'Show tool')}
              >
                {tool.visible ? (
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z" fill="white" fillRule="evenodd" clipRule="evenodd"></path></svg>
                ) : (
                  <Plus size={12} color="white" strokeWidth={3} />
                )}
              </button>

              {/* Icon Container */}
              <div style={{
                width: '38px',
                height: '38px',
                borderRadius: '50%',
                background: tool.visible ? containerBgColor : hiddenBgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                opacity: tool.visible ? 1 : 0.5,
                border: tool.visible ? `1px solid ${containerBorderColor}` : `1px solid ${hiddenBorderColor}`,
                color: tool.visible ? iconColor : hiddenIconColor
              }}>
                <div style={{ transform: 'scale(0.9)' }}>
                  {tool.svg}
                </div>
              </div>

              {/* Tool Name */}
              <span style={{
                fontSize: '12px',
                fontWeight: '500',
                color: tool.visible ? '#1f2937' : '#9ca3af',
                textAlign: 'center',
                lineHeight: '1.3',
                maxWidth: '80px',
                opacity: tool.visible ? 1 : 0.6
              }}>
                {tool.name}
              </span>

              {/* Hidden Badge */}
              {!tool.visible && (
                <span style={{
                  fontSize: '9px',
                  color: '#44adefff',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Hidden
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer Buttons */}
      <div style={{
        padding: '16px 24px',
        borderTop: '1px solid #e5e7eb',
        background: '#fafafa',
        display: 'flex',
        gap: '12px'
      }}>
        <button
          onClick={() => {
            setToolkitFadingOut(true);
            setTimeout(() => {
              setShowToolkitEditor(false);
              setToolkitFadingOut(false);
              // ✅ RESET TEMP TOOLS TO ORIGINAL STATE ON CANCEL
              setTempToolkitTools(availableTools);
            }, 300);
          }}
          disabled={isSavingToolkit}
          style={{
            flex: 1,
            padding: '10px',
            background: 'white',
            color: '#6b7280',
            border: '1px solid #e5e7eb',
            borderRadius: '24px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isSavingToolkit ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s',
            opacity: isSavingToolkit ? 0.5 : 1
          }}
          onMouseEnter={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = '#f9fafb';
              e.target.style.borderColor = '#d1d5db';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = 'white';
              e.target.style.borderColor = '#e5e7eb';
            }
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSaveToolkit}
          disabled={isSavingToolkit}
          style={{
            flex: 1,
            padding: '10px',
            background: isSavingToolkit ? '#9ca3af' : '#1a1a1a',
            color: 'white',
            border: 'none',
            borderRadius: '24px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isSavingToolkit ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = '#2d2d2d';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSavingToolkit) {
              e.target.style.background = '#1a1a1a';
            }
          }}
        >
          {isSavingToolkit ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        
        @keyframes slideUp {
          from { 
            transform: translateY(100%);
            opacity: 0;
          }
          to { 
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideDown {
          from { 
            transform: translateY(0);
            opacity: 1;
          }
          to { 
            transform: translateY(100%);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  </div>
)}

    </div>
  );
};

export default ChatMode;